/* eslint-disable prettier/prettier */

import { tokens } from '@/locales/tokens/index'

export const en = {
  [tokens.common.welcome]: 'Welcome',
  [tokens.common.welcomeLogin]: 'Welcome to Nabu',
  [tokens.common.welcomeLoginText]:
    'Nabu is the customs co-pilot that allows you to access, manage and efficiently execute your customs formalities and data.',
  [tokens.common.nabuLogo]: 'Nabu logo',
  [tokens.common.login]: 'Log in',
  [tokens.common.clear]: 'Clear',
  [tokens.common.theActionWasSuccessful]: 'The action was successful',
  [tokens.common.createdAt]: 'Created at',
  [tokens.common.created]: 'Created',
  [tokens.common.updatedAt]: 'Updated at',
  [tokens.common.notes]: 'Notes',
  [tokens.common.loginError]:
    'Oops, it seems that the email or password you entered is incorrect. Please double-check and try again.',
  [tokens.common.unknownError]: 'Unknown error',
  [tokens.common.clientOrganization]: 'Client Organization',
  [tokens.common.emailSendError]:
    'Oops, it seems that the email sending failed. Please try again.',
  [tokens.common.returnToLoginPage]: 'Return to the login page',
  [tokens.common.logout]: 'Log out',
  [tokens.common.impersonatingAs]: 'Signed in as <bold>{{name}}</bold>',
  [tokens.common.stopImpersonation]: 'End session',
  [tokens.common.impersonationTimeLeft]: '{{minutes}} min left',
  [tokens.common.impersonationExpired]: 'The “sign in as” session has expired.',
  [tokens.common.impersonationClosed]: 'The “sign in as” session was closed.',
  [tokens.common.impersonationOpening]: 'Opening the session…',
  [tokens.common.impersonationLinkInvalid]:
    'This link has expired or was already used. Start “Sign in as” again from the console.',
  [tokens.common.smartPreparationAnnouncement]:
    '<bold>Smart preparation</bold> is coming to Nabu: less manual data entry, more time for what matters.',
  [tokens.common.smartPreparationBadge]: 'New',
  [tokens.common.smartPreparationTry]: 'Try it',
  [tokens.common.smartPreparationLearnMore]: 'Learn more',
  [tokens.common.search]: 'Search',
  [tokens.common.unknownUser]: 'Unknown user',
  [tokens.common.noItemFound]: 'No item found',
  [tokens.common.noAccount]: "You don't have an account ?",
  [tokens.common.needAccountHelp]:
    "If you're having problems getting signing in, or if you want to create a new account :",
  [tokens.common.questionForgotPassword]: 'Forgot password ?',
  [tokens.common.forgotPassword]: 'Forgot password',
  [tokens.common.selectAGroup]: 'Select an agency',
  [tokens.common.selectAConfiguration]: 'Select a configuration',
  [tokens.common.enterNewPassword]: 'Set a new password',
  [tokens.common.passwordConfirmation]: 'Confirm the password',
  [tokens.common.anErrorOccurred]: 'An error occurred',
  [tokens.common.currentOwner]: 'Current owner',
  [tokens.common.currentGroup]: 'Current agency',
  [tokens.common.forgotPasswordText]:
    'Enter the e-mail address associated with your account',
  [tokens.common.oldPasswordRequired]: 'The old password is required',
  [tokens.common.newPasswordRequired]: 'A new password is required',
  [tokens.common.warningRulesForNewPassword]:
    'The password must contain at least one lower case letter, one upper case letter, one number, one special character (@, $, !, %, *, ?, &) and be between 8 and 16 characters long.',
  [tokens.common.emailSent]: 'An email has been sent',
  [tokens.common.exportTypeRequired]: 'An export type is required',
  [tokens.common.exportTypeUnknown]: 'Export type unknown',
  [tokens.common.updateDeclarationOwner]: 'Update declaration owner',
  [tokens.common.changeOwnerForCurrentDeclaration]:
    'Change owner for the current declaration',
  [tokens.common.declarationOwner]: 'Declaration owner',
  [tokens.common.contactUs]: 'Contact us',
  [tokens.common.yes]: 'Yes',
  [tokens.common.confirm]: 'Confirm',
  [tokens.common.import]: 'Import',
  [tokens.common.export]: 'Export',
  [tokens.common.transit]: 'Transit',
  [tokens.common.noOptions]: 'No options',
  [tokens.common.validate]: 'Validate',
  [tokens.common.delete]: 'Delete',
  [tokens.common.cancel]: 'Cancel',
  [tokens.common.selectUser]: 'Select user',
  [tokens.common.errorRenameModelName]: 'The model name could not be renamed',
  [tokens.common.continue]: 'Continue',
  [tokens.common.next]: 'Next',
  [tokens.common.back]: 'Back',
  [tokens.common.close]: 'Close',
  [tokens.common.create]: 'Create',
  [tokens.common.upload]: 'Upload',
  [tokens.common.sentDocuments]: 'Dossiers sent',
  [tokens.common.sentFolders]: 'Declarations sent',
  [tokens.common.tableConsolidated]: 'Consolidated table',
  [tokens.common.tableNotConsolidated]: 'Unconsolidated table',
  [tokens.common.numberofLinesSent]: 'Total number of lines sent:',
  [tokens.common.send]: 'Send',
  [tokens.common.add]: 'Add',
  [tokens.common.languageChanged]: 'Language changed',
  [tokens.common.manager]: 'Manager',
  [tokens.common.guest]: 'Guest',
  [tokens.common.admin]: 'Administrator',
  [tokens.common.user]: 'User',
  [tokens.common.superadmin]: 'Nabu Staff',
  [tokens.common.mail]: 'Email address',
  [tokens.common.email]: 'Email',
  [tokens.common.mailHook]: 'Email Hook',
  [tokens.common.regenerateMailHook]: 'Regenerate mail hook',
  [tokens.common.mailHookDescription]:
    "Nabu e-mail address connected to your team's trainer folder inbox",
  [tokens.common.copy]: 'copy',
  [tokens.common.holdToConfirmNudge]: 'Press and hold',
  [tokens.common.holdToConfirmHint]:
    'Hold the button, or the Space or Enter key, for about a second to confirm.',
  [tokens.common.confirmed]: 'Confirmed',
  [tokens.common.copied]: 'Copied',
  [tokens.common.copyFailed]: 'Failed',
  [tokens.common.role]: 'Role',
  [tokens.common.date]: 'Date',
  [tokens.common.name]: 'Name',
  [tokens.common.member]: 'Member',
  [tokens.common.members]: 'Members',
  [tokens.common.administrator]: 'Administrator',
  [tokens.common.administrators]: 'Administrators',
  [tokens.common.sendInvite]: 'Send an invitation',
  [tokens.common.inviteMember]: 'Invite a member',
  [tokens.common.inviteMembers]: 'Invite members',
  [tokens.common.inviteAdministrator]: 'Invite an administrator',
  [tokens.common.inviteAdministrators]: 'Invite administrators',
  [tokens.common.inviteSomeAdministrators]: 'Invite some administrators',
  [tokens.common.atLeastOneInvitedPeople]: 'Invite at least one person',
  [tokens.common.maxOneInvitedPeople]: 'Invite maximum one admin',
  [tokens.common.sendInvitation]: 'Send invitation',
  [tokens.common.deleteInvitation]: 'Delete the invitation',
  [tokens.common.socialName]: 'Company name',
  [tokens.common.registrationNumber]: 'Registration number',
  [tokens.common.country]: 'Country',
  [tokens.common.organization]: 'Organization',
  [tokens.common.organizationAndEstablishments]: 'Organization & Establishment',
  [tokens.common.somethingWentWrong]: 'Something went wrong...',
  [tokens.common.general]: 'General',
  [tokens.common.lastName]: 'Last name',
  [tokens.common.firstName]: 'First name',
  [tokens.common.function]: 'Role',
  [tokens.common.preferences]: 'Preferences',
  [tokens.common.password]: 'Password',
  [tokens.common.position]: 'Position',
  [tokens.common.language]: 'Language',
  [tokens.common.help]: 'Help',
  [tokens.common.active]: 'Active',
  [tokens.common.group]: 'Agency',
  [tokens.common.groups]: 'Agencies',
  [tokens.common.groupSettings]: 'Agency settings',
  [tokens.common.selectGroup]: 'Select an agency',
  [tokens.common.userSettings]: 'User settings',
  [tokens.common.collaborators]: 'Collaborator',
  [tokens.common.update]: 'Update',
  [tokens.common.actions]: 'Actions',
  [tokens.common.parameters]: 'Parameters',
  [tokens.common.external]: 'External',
  [tokens.common.required]: 'required',
  [tokens.common.validEmail]: 'Must be a valid email',
  [tokens.common.emailRequired]: 'Email is required',
  [tokens.common.passwordRequired]: 'Password is required',
  [tokens.common.matchPasswordsRequired]: 'Passwords must match',
  [tokens.common.passwordConfirmationRequired]: 'Please confirm your password',
  [tokens.common.firstNameRequired]: 'First name is required',
  [tokens.common.lastNameRequired]: 'Last name is required',
  [tokens.common.roleRequired]: 'Role is required',
  [tokens.common.languageRequired]: 'Language is required',
  [tokens.common.organizationRequired]: 'Organization is required',
  [tokens.common.groupRequired]: 'Agency is required',
  [tokens.common.socialNameRequired]: 'Social name is required',
  [tokens.common.registrationNumberRequired]: 'Registration number is required',
  [tokens.common.countryRequired]: 'Country is required',
  [tokens.common.affiliatedGroup]: 'Select the agencies to affiliate with',
  [tokens.common.share]: 'Share',
  [tokens.common.step]: 'Step',
  [tokens.common.none]: 'none',
  [tokens.common.registeredCustomsRepresentative]:
    'Registered Customs Representative',
  [tokens.common.customsManager]: 'Customs Manager',
  [tokens.common.customsTeamManager]: 'Customs Team Manager',
  [tokens.common.informationSystemsManager]: 'Information Systems Manager',
  [tokens.common.nabuAdministrator]: 'Nabu Administrator',
  [tokens.common.french]: 'French',
  [tokens.common.english]: 'English',
  [tokens.common.administrator]: 'Administrator',
  [tokens.common.basicInformation]: 'Basic information',
  [tokens.common.personalInformation]: 'Personal information',
  [tokens.common.companyInformation]: 'Company information',
  [tokens.common.organizationAndGroups]: 'Organization and Agencies',
  [tokens.common.establishmentsAndGroups]: 'Establishments & agencies',
  [tokens.common.settings]: 'Settings',
  [tokens.common.save]: 'Save',
  [tokens.common.saving]: 'Saving…',
  [tokens.common.saved]: 'Saved',
  [tokens.common.changePassword]: 'Change password',
  [tokens.common.oldPassword]: 'Old password',
  [tokens.common.newPassword]: 'New password',
  [tokens.common.passwordChangeSuccess]: 'Password change successful',
  [tokens.common.passwordChangeError]:
    'An error occurred while changing your password.',
  [tokens.common.fileName]: 'Declaration name',
  [tokens.common.generalInformation]: 'General Information',
  [tokens.common.offices]: 'Establishment',
  [tokens.common.edit]: 'Edit',
  [tokens.common.accessInformations]: 'Access informations',
  [tokens.common.deleteAccount]: 'Delete account',
  [tokens.common.deleteAccountWarning]:
    'Deleting your account and all your data is irreversible.',
  [tokens.common.name]: 'Name',
  [tokens.common.client]: 'Client',
  [tokens.common.date]: 'Date',
  [tokens.common.status]: 'Status',
  [tokens.common.actions]: 'Actions',
  [tokens.common.option10]: '10',
  [tokens.common.option20]: '20',
  [tokens.common.option50]: '50',
  [tokens.common.searchByCaseName]: 'Search by case name',
  [tokens.common.all]: 'All',
  [tokens.common.pending]: 'Pending',
  [tokens.common.from]: 'From',
  [tokens.common.to]: 'To',
  [tokens.common.view]: 'View',
  [tokens.common.folder]: 'Declaration',
  [tokens.common.customDeclaration]: 'Custom Declaration',
  [tokens.common.billOfLading]: 'Bill of Lading',
  [tokens.common.exported]: 'Exported',
  [tokens.common.toTreat]: 'To Process',
  [tokens.common.archived]: 'Archived',
  [tokens.common.inProgress]: 'In Progress',
  [tokens.common.category]: 'Category',
  [tokens.common.searchByName]: 'Search for a declaration',
  [tokens.common.layerName]: 'Model name',
  [tokens.common.modelName]: 'Customer model',
  [tokens.common.modelSearchPlaceholder]: 'Search for a model',
  [tokens.common.modelTabName]: 'Model name',
  [tokens.common.modelTabType]: 'Model type',
  [tokens.common.declarationType]: 'Decl. type',
  [tokens.common.flowTabExporter]: 'Sender',
  [tokens.common.flowTabCreatedBy]: 'Created by',
  [tokens.common.flowTabDate]: 'Creation date',
  [tokens.common.modelDeleteOneTitle]: 'Deleting one model',
  [tokens.common.modelDeleteOneText]:
    'Are you sure you want to delete this model?',
  [tokens.common.modelDeleteMultipleTitle]: 'Deleting multiple models',
  [tokens.common.modelDeleteMultipleText]:
    'Are you sure you want to delete these models?',
  [tokens.common.modelHasBeenDeleted]: 'The model has been deleted',
  [tokens.common.modelHasNotBeenDeleted]: 'The model was not deleted',
  [tokens.common.teamName]: 'Team name',
  [tokens.common.office]: 'Office',
  [tokens.common.loggedIn]: 'Welcome back! You have successfully logged in.',
  [tokens.common.permissionError]:
    "Sorry, you don't have permission to access this page.",
  [tokens.common.permissionAndAccess]: 'Permission/Access',
  [tokens.common.fieldNotFound]: 'Field not found',
  [tokens.common.failToSave]: 'Fail to save',
  [tokens.common.team]: 'Team',
  [tokens.common.profil]: 'Profil',
  [tokens.common.security]: 'Security',
  [tokens.common.metrics]: 'Performance monitoring',
  [tokens.common.copiedToClipBoard]: 'Copied to clipboard',
  [tokens.common.setup]: 'Configuration',
  [tokens.common.setups]: 'Configurations',
  [tokens.common.addSetup]: 'Add configuration',
  [tokens.common.noSetup]: 'No configuration available',
  [tokens.common.noOptionAvailable]: 'No option available',
  [tokens.common.noSetupGroup]: 'No configuration available for this agency',
  [tokens.common.editSetup]: 'Edit configuration',
  [tokens.common.createSetup]: 'Create configuration',
  [tokens.common.download]: 'Download',
  [tokens.common.file]: 'File',
  [tokens.common.files]: 'Files',
  [tokens.common.punctualCustomer]: 'Ponctual customer',
  [tokens.common.regularCustomer]: 'Regular customer',
  [tokens.common.creationOfNewFolder]: 'Creation of new declaration',
  [tokens.common.folderCreationInProgress]: 'Declaration creation in progress',
  [tokens.common.emailFrom]: 'Sent by',
  [tokens.common.workInProgress]: 'Pending declarations',
  [tokens.common.document]: 'Declaration',
  [tokens.common.classification]: 'Classification',
  [tokens.common.model]: 'Model',
  [tokens.common.models]: 'Models',
  [tokens.common.information]: 'Information',
  [tokens.common.exportConfiguration]: 'Configuration',
  [tokens.common.userSettings]: 'User settings',
  [tokens.common.confirmationRequired]: 'Confirmation required',
  [tokens.common.rowsPerPage]: 'Rows per page',
  [tokens.common.displayedRows]: '{{from}}-{{to}} of {{count}}',
  [tokens.common.details]: 'Details',
  [tokens.common.declaration]: 'Declaration',
  [tokens.common.backToHome]: 'Back to home',
  [tokens.common.message401]: '401 : Authorization required',
  [tokens.common.message404]: '404: The page you are looking for isn’t here',
  [tokens.common.message500]: '500: Internal Server Error',
  [tokens.common.titleErrorPage]: 'Unknown error',
  [tokens.common.messageErrorPage]:
    'It seems that an unexpected error has occurred, please try again.',
  [tokens.common.key]: 'Key',
  [tokens.common.configurations]: 'Configurations',
  [tokens.common.configuration]: 'Configuration',
  [tokens.common.userSettingsNoParameter]: 'No parameters available',
  [tokens.common.commonError]: 'An error occured',
  [tokens.common.author]: 'Submitter',
  [tokens.common.noFiles]: 'No files available',
  [tokens.common.notification]: 'Notification',
  [tokens.common.createdBy]: 'Created by',
  [tokens.common.sendBy]: 'Send by',
  [tokens.common.updateSucceeded]: 'Update succeeded',
  [tokens.common.updateFailed]: 'Update failed',
  [tokens.common.filesDropInputWrongFormat]: 'Unsupported file type!',
  [tokens.common.hintMessageFirstText]: 'Use',
  [tokens.common.hintMessageSecondText]: 'space',
  [tokens.common.hintMessageThirdText]: 'to add a keyword,',
  [tokens.common.hintMessageFourthText]: 'to search for an exact phrase.',
  [tokens.common.thisActionCannotBeUndone]: 'This action cannot be undone',
  [tokens.common.remove]: 'Remove',
  [tokens.common.unknown]: 'Unknown',
  [tokens.common.selectAction]: 'Choose an action',
  [tokens.common.deselect]: 'Deselect',
  [tokens.common.expandAll]: 'Expand all',
  [tokens.common.collapseAll]: 'Collapse all',
  [tokens.common.validated]: 'Validated',
  [tokens.common.week]: 'Week',
  [tokens.common.month]: 'Month',
  [tokens.common.seeDetails]: 'See details',
  [tokens.common.hideDetails]: 'Hide details',
  [tokens.common.start]: 'Start',
  [tokens.common.end]: 'End',
  [tokens.common.clearAll]: 'Clear all',
  [tokens.common.noCustomersSelected]: 'No customers selected',
  [tokens.common.articles]: 'Items',
  [tokens.common.commodityCodesFilled]: 'Commodity codes filled',
  [tokens.common.dossierDrawerPosition]: 'Folder {{index}} of {{total}}',
  [tokens.common.dossierDrawerPrevious]: 'Previous folder',
  [tokens.common.dossierDrawerNext]: 'Next folder',
  [tokens.common.dossierDrawerCopyReference]: 'Copy reference',
  [tokens.common.dossierDrawerOverview]: 'Overview',
  [tokens.common.dossierDrawerActivity]: 'Activity',
  [tokens.common.dossierDrawerPreparation]: 'Preparation',
  [tokens.common.dossierDrawerStepReceived]: 'Received',
  [tokens.common.dossierDrawerStepPrefilled]: 'Pre-filled',
  [tokens.common.dossierDrawerStepToTreat]: 'To process',
  [tokens.common.dossierDrawerStepCompleted]: 'Completed',
  [tokens.common.dossierDrawerParties]: 'Parties',
  [tokens.common.dossierDrawerDetails]: 'Details',
  [tokens.common.dossierDrawerComplete]: 'Complete',
  [tokens.common.dossierDrawerAddTag]: 'Add a tag',
  [tokens.common.dossierDrawerNoFiles]: 'No files',
  [tokens.common.dossierDrawerNoActivity]: 'No activity',
  [tokens.common.inlineEditSaveFailed]: 'Couldn\'t save “{{value}}”, so the last saved value is back.',
  [tokens.common.inlineEditRetry]: 'Try again',
  [tokens.common.inlineEditCancel]: 'Cancel editing',
  [tokens.common.inlineEditHintDisplay]: 'Activate to edit.',
  [tokens.common.inlineEditHintEdit]: 'Enter saves, Escape cancels.',
  [tokens.common.inlineEditHintEditMultiline]: 'Enter saves, Shift+Enter adds a line break, Escape cancels.',
  [tokens.common.inlineEditSaving]: 'Saving {{label}}',
  [tokens.common.inlineEditSaved]: '{{label}} saved',
  [tokens.common.dossierDrawerNameLabel]: 'Folder name',
  [tokens.common.dossierNameRequired]: 'The name can\'t be empty',
  [tokens.common.mode]: 'Mode',
  [tokens.common.delivered]: 'Delivered',
  [tokens.common.lastModified]: 'Last modified',
  [tokens.common.tags]: 'Tags',
  [tokens.common.type]: 'Type',
  [tokens.common.downloadArchive]: 'Download the archive',
  [tokens.common.downloadValueDetail]: 'Download the value detail',
  [tokens.common.viewDetail]: 'View detail',
  [tokens.common.show]: 'Show',
  [tokens.common.hide]: 'Hide',
  [tokens.common.noteSucccessfullySaved]: 'Note successfully saved',
  [tokens.common.errorOccuredWhileSavingNote]:
    'An error occurred while saving the note',
  [tokens.common.offline]:
    'Your network connection appears to be interrupted. Please check your internet access and try again.',
  [tokens.common.online]: 'Your network is restored!',
  [tokens.common.maintenanceTitle]: 'Scheduled maintenance',
  [tokens.common.maintenanceUntil]: 'Nabu is down for maintenance until {{date}} at {{time}}.',
  [tokens.common.maintenanceNoEnd]: 'Nabu is temporarily down for maintenance.',
  [tokens.common.maintenanceSessionKept]:
    'Your session is kept. No need to reload the page: Nabu will reopen on its own once maintenance is over.',
  [tokens.common.noTags]: 'No tags',
  [tokens.common.declarant]: 'Declarant',
  [tokens.common.editComment]: 'Edit comment',
  [tokens.common.deleteComment]: 'Delete comment',
  [tokens.common.addAComment]: 'Add a comment',
  [tokens.common.areYouSureYouWantToDeleteThisComment]:
    'Are you sure you want to delete this comment ?',
  [tokens.common.urgent]: 'Urgent',
  [tokens.common.sendUrgent]: 'Send urgent',
  [tokens.common.putFileErrorStatus]: 'Mettre le dossier en état d’erreur',
  [tokens.common.subscribers]: 'Subscribers',
  [tokens.common.typeAnEmailAndPressEnter]: 'Type an email and press Enter',
  [tokens.common.darkMode]: 'Dark mode',
  [tokens.common.lightMode]: 'Light mode',
  [tokens.common.theme]: 'Theme',

  [tokens.events.declarationReceivedBy]:
    'Declaration request received by {{source}}',
  [tokens.events.creationAndExtractionOfDeclaration]:
    'Creation and extraction of declaration {{reference}}',
  [tokens.events.missingDataIdentified]: 'Missing data identified',
  [tokens.events.missingDataAddedFromDataLibrary]:
    'Missing data added from Data Library',
  [tokens.events.informationRequested]: 'Information requested',
  [tokens.events.informationReceived]: 'Information received',
  [tokens.events.declarationValidationsCompleted]:
    'Declaration validations completed',
  [tokens.events.declarationFinalized]: 'Declaration {{reference}} finalized',
  [tokens.events.declarationFinalizedBy]:
    'Declaration {{reference}} finalized by {{accountName}}',
  [tokens.events.declarationSent]:
    'Declaration {{reference}} sent to {{clientDestinationName}}',
  [tokens.events.processingStopped]: 'Processing stopped',

  [tokens.batchImportHistory.historyDrawerTitle]: 'Declaration history',
  [tokens.batchImportHistory.historyOpenTooltip]: 'View declaration history',
  [tokens.batchImportHistory.historySearchPlaceholder]:
    'Search history…',
  [tokens.batchImportHistory.historySearchEmpty]:
    'No results for this search',
  [tokens.batchImportHistory.historyEmpty]: 'No history entries yet',
  [tokens.batchImportHistory.historyLoadError]: 'Unable to load history',
  [tokens.batchImportHistory.historyRetry]: 'Retry',
  [tokens.batchImportHistory.historyExpand]: 'Show details',
  [tokens.batchImportHistory.historyCollapse]: 'Hide details',
  [tokens.batchImportHistory.historyActorSystem]: 'System',
  [tokens.batchImportHistory.historyActorUnknownUser]: 'User',
  [tokens.batchImportHistory.historyFieldsCount]: '{{count}} field',
  [tokens.batchImportHistory.historyFieldsCount_other]: '{{count}} fields',
  [tokens.batchImportHistory.historyReplacedFields]: 'Replaced fields',
  [tokens.batchImportHistory.historyEmptyValue]: 'empty',
  [tokens.batchImportHistory.historyRowSuffix]: ' (row {{row}})',
  [tokens.batchImportHistory.historyActionDeclarationModified]:
    'Declaration modified',
  [tokens.batchImportHistory.historyActionDeclarationCreated]:
    'Declaration created',
  [tokens.batchImportHistory.historyActionDeclarationSent]: 'Declaration sent',
  [tokens.batchImportHistory.historyActionAutomationRun]: 'Table automation run',
  [tokens.batchImportHistory.historyActionExtractionRerun]: 'Extraction rerun',
  [tokens.batchImportHistory.historyActionClassificationRerun]:
    'Classification rerun',
  [tokens.batchImportHistory.historyActionMerge]: 'Merge completed',
  [tokens.batchImportHistory.historyActionMergeColumnsTitle]: 'Columns merged',
  [tokens.batchImportHistory.historyActionMergeBatchImportsTitle]:
    'Declarations merged',
  [tokens.batchImportHistory.historyActionMarkedError]: 'Declaration marked as error',
  [tokens.batchImportHistory.historyActionTagAdded]: 'Tag added',
  [tokens.batchImportHistory.historyActionClientChanged]: 'Client changed',
  [tokens.batchImportHistory.historyActionRowDeleted]: 'Article row deleted',
  [tokens.batchImportHistory.historyActionFileAdded]: 'File added',
  [tokens.batchImportHistory.historyFilesCount]: '{{count}} file',
  [tokens.batchImportHistory.historyFilesCount_other]: '{{count}} files',
  [tokens.batchImportHistory.historyDeletedRowValues]: 'Row content',
  [tokens.batchImportHistory.historyRowLabel]: 'row {{row}}',
  [tokens.batchImportHistory.historyDocumentsCount]: '{{count}} document',
  [tokens.batchImportHistory.historyDocumentsCount_other]: '{{count}} documents',
  [tokens.batchImportHistory.historyMergeColumns]: '{{count}} column merged',
  [tokens.batchImportHistory.historyMergeColumns_other]:
    '{{count}} columns merged',
  [tokens.batchImportHistory.historyMergeBatchImports]: '{{count}} declaration merged',
  [tokens.batchImportHistory.historyMergeBatchImports_other]:
    '{{count}} declarations merged',
  [tokens.batchImportHistory.historyMarkedErrorManual]: 'Manually marked as error',
  [tokens.batchImportHistory.historyMarkedErrorUploadFailed]:
    'Document upload failed',
  [tokens.batchImportHistory.historyMarkedErrorMissingSuffix]: 'missing',
  [tokens.batchImportHistory.historyFilterAll]: 'All',
  [tokens.batchImportHistory.historyFilterCorrections]: 'Corrections',
  [tokens.batchImportHistory.historyUndoCorrection]: 'Undo this correction',
  [tokens.batchImportHistory.historyRedoCorrection]: 'Redo',
  [tokens.batchImportHistory.historyRevertedAt]: 'undone at {{time}}',
  [tokens.batchImportHistory.historyCorrectionSet]: 'Value corrected',
  [tokens.batchImportHistory.historyCorrectionClear]: 'Value cleared',
  [tokens.batchImportHistory.historyCorrectionValidate]: 'Declaration validated',
  [tokens.batchImportHistory.historyCorrectionReviewConfirmed]:
    'Check confirmed',
  [tokens.batchImportHistory.historyCorrectionReviewReopened]: 'Issue reopened',
  [tokens.batchImportHistory.historyCorrectionAddTuple]: 'Occurrence added',
  [tokens.batchImportHistory.historyCorrectionRemoveTuple]:
    'Occurrence removed',
  [tokens.batchImportHistory.historyCorrectionClearColumn]: 'Column cleared',
  [tokens.batchImportHistory.historyCorrectionSetColumn]: 'Column filled',
  [tokens.batchImportHistory.historyCorrectionAddLine]: 'Article added',
  [tokens.batchImportHistory.historyCorrectionRemoveLine]: 'Article removed',
  [tokens.batchImportHistory.historyCorrectionUnvalidate]: 'Revision opened',
  [tokens.batchImportHistory.historyCorrectionAbandonRevision]:
    'Revision abandoned: back to the submitted version',

  [tokens.configuration.configurationNameWarning]:
    'Name of configuration is required',
  [tokens.configuration.addAField]: 'Add a field',
  [tokens.configuration.typeTransportWarning]: 'Type of export is required',
  [tokens.configuration.nameTransportWarning]: 'Name of software is required',
  [tokens.configuration.addressTransportWarning]:
    'Url or ftp address is required',
  [tokens.configuration.portTransportWarning]: 'Port is required',
  [tokens.configuration.emailAuthenticationTransportWarning]:
    'Email for authentication is required',
  [tokens.configuration.passwordAuthenticationTransportWarning]:
    'Password is required',
  [tokens.configuration.configurationSaved]: 'Configuration saved',
  [tokens.configuration.configurationName]: 'Configuration name',
  [tokens.configuration.softwareName]: 'Software name',
  [tokens.configuration.typeTransport]: 'Transport method',
  [tokens.configuration.addressTransport]: 'API URL or SFTP',
  [tokens.configuration.portTransport]: 'Port',
  [tokens.configuration.emailAuthenticationTransport]: 'Email',
  [tokens.configuration.passwordAuthenticationTransport]: 'Password',
  [tokens.configuration.pleaseChooseAGroupAndAConfiguration]:
    'Please choose an agency and configuration',
  [tokens.configuration.pleaseChooseAConfiguration]:
    'Please choose a configuration',
  [tokens.configuration.noSettingsFoundForConfiguration]:
    'No settings found for the selected configuration',
  [tokens.configuration.noSettingsAvailableForConfiguration]:
    'No settings available for the selected configuration',
  [tokens.configuration.availableSettingKeys]: 'Available setting keys',
  [tokens.configuration.youHaveUnsavedConfigurationChanges]:
    'You have unsaved configuration changes',
  [tokens.configuration.cannotRemoveLastTupleItem]:
    'At least one item must be kept.',

  [tokens.upload.dropText]: 'Drop your files here',
  [tokens.upload.declarationType]: 'Declaration type',
  [tokens.upload.exportService]: 'Customs software',
  [tokens.upload.model]: 'Model',
  [tokens.upload.emailHookText]: 'or send your documents to',
  [tokens.upload.atLeastOneFileRequired]: 'At least one file is required',
  [tokens.upload.warningOnNumberFilesMinimum]: 'At least one file is required',
  [tokens.upload.warningOnNumberFilesMaximum]: 'Only one file is expected',
  [tokens.upload.requiredFiles]: 'Files are required',
  [tokens.upload.requiredCustomerType]: 'Customer type is required',
  [tokens.upload.requiredRecordName]: 'Declaration name is required',
  [tokens.upload.warningOnRecordNameLength]:
    'Record name must be at most 255 characters long',
  [tokens.upload.requiredExportConfiguration]: 'Declarations software required',
  [tokens.upload.requiredDeclarationType]: 'Declaration type required',
  [tokens.upload.requiredModelConfiguration]: 'Model required',
  [tokens.upload.requiredGroup]: 'Agency is required',
  [tokens.upload.noModelFound]: 'No model found',
  [tokens.upload.modelWarning]:
    'Warning: Changing the model may result in some existing data in your declaration being overwritten.',
  [tokens.upload.agenticLabel]: 'Agentic',
  [tokens.upload.nfRequired]: 'REQUIRED',
  [tokens.upload.wizardStepFilesLabel]: 'Files',
  [tokens.upload.wizardStepFilesSubtitle]: 'Drop the batch of documents to process.',
  [tokens.upload.wizardStepFolderLabel]: 'Declaration',
  [tokens.upload.wizardStepFolderSubtitle]:
    'Name, assignment, client and tags.',
  [tokens.upload.wizardPreparationSectionTitle]: 'Preparation',
  [tokens.upload.wizardPreparationModeStandardTitle]: 'Classic preparation',
  [tokens.upload.wizardPreparationModeStandardDescription]:
    'Algorithmic reading of documents. Fields are pre-filled; you validate each screen.',
  [tokens.upload.wizardPreparationModeIntelligentTitle]: 'Smart preparation',
  [tokens.upload.wizardPreparationModeIntelligentDescription]:
    'Nabu prepares your declaration: it organizes it, completes it, resolves anomalies and submits the result to you.',
  [tokens.upload.wizardPreparationModeNewBadge]: 'New',
  [tokens.upload.wizardFilesStepGuidance]:
    'Quick create, or use “Options” to name and assign the declaration.',
  [tokens.upload.wizardFilesStepGuidanceClassic]:
    'Continue to options to fill in the declaration.',
  [tokens.upload.wizardStepCounter]: 'Step {{step}} of {{total}}',
  [tokens.upload.wizardCompleteRequiredFields]:
    'Complete the highlighted fields.',
  [tokens.upload.wizardAddAtLeastOneFile]: 'Add at least one file to continue.',
  [tokens.upload.wizardSubmitting]:
    'Uploading files, do not close this window.',
  [tokens.upload.wizardCreating]: 'Creating…',
  [tokens.upload.wizardCreated]: 'Folder created',
  [tokens.upload.wizardDropTitle]: 'Drag your files here',
  [tokens.upload.wizardDropTitleActive]: 'Drop to add',
  [tokens.upload.wizardDropSubtitle]:
    'or click to browse · PDF, images, XLSX · 20 MB max',
  [tokens.upload.wizardAddFiles]: 'Add files',
  [tokens.upload.wizardRemoveFile]: 'Remove this file from the declaration',
  [tokens.upload.wizardFilesCount]: '{{count}} file',
  [tokens.upload.wizardFilesCount_other]: '{{count}} files',
  [tokens.upload.wizardFolderNamePlaceholder]: 'E.g. Delmas batch 88431',
  [tokens.upload.wizardFolderNameSuggested]:
    'Pre-filled from the first file name, editable.',
  [tokens.upload.wizardAgencyLabel]: 'Agency / team',
  [tokens.upload.wizardAgencyHint]:
    'Organization or agency: determines available declaration types and models. In intelligent preparation, the agency you use most for your declarations. Otherwise, your organization.',
  [tokens.upload.wizardAgencyOrganizationBadge]: 'Organization',
  [tokens.upload.wizardAgencyClearToOrganization]: 'Back to organization',
  [tokens.upload.wizardNoAgencyOption]: 'No agency accessible',
  [tokens.upload.wizardTypePlaceholder]: 'Choose a type',
  [tokens.upload.wizardTypePrefilledHint]: 'Pre-filled, editable.',
  [tokens.upload.wizardTypeTooltip]:
    'If left unset, the direction (import/export) is detected automatically from the documents. You can change it later via the badge under the declaration title.',
  [tokens.upload.wizardChooseGroupFirst]: 'Choose an agency first.',
  [tokens.upload.wizardWorkflowLabel]: 'Model',
  [tokens.upload.wizardWorkflowHint]: 'Ready-made configuration.',
  [tokens.upload.wizardWorkflowTooltip]:
    'Pre-fills recurring fields at creation. Values extracted from documents will not be overwritten.',
  [tokens.upload.wizardWorkflowPlaceholder]: 'No model',
  [tokens.upload.wizardNoWorkflowForCombination]:
    'No model for this combination. Processed manually.',
  [tokens.upload.wizardClientHint]: 'Name or reference.',
  [tokens.upload.wizardClientSearchPlaceholder]: 'Search for a client',
  [tokens.upload.wizardNoClientOption]: 'No client',
  [tokens.upload.wizardNoClientFound]: 'No client found',
  [tokens.upload.wizardNoWorkflowFound]: 'No model found',
  [tokens.upload.wizardOptionsLoading]: 'Loading…',
  [tokens.upload.wizardTagsHint]: 'To find the declaration in the filters.',
  [tokens.upload.wizardTagsPlaceholder]: 'Add tags',
  [tokens.upload.wizardOptionsButton]: 'Options',
  [tokens.upload.wizardQuickCreateButton]: 'Quick create',
  [tokens.upload.wizardQuickCreateButtonInAgency]: 'Quick create in {{agency}}',
  [tokens.upload.wizardQuickCreateTooltip]:
    'Creates the declaration immediately in {{agency}}.',
  [tokens.upload.wizardCreateFolderButton]: 'Create declaration',

  [tokens.documents.creationWindowRecent]: 'Dossiers created in the last {{days}} days',
  [tokens.documents.creationWindowAll]: 'Full history',
  [tokens.documents.creationWindowShowAll]: 'Show full history',
  [tokens.documents.creationWindowShowRecent]: 'Back to the last {{days}} days',
  [tokens.documents.collaborators]: 'Collaborators',
  [tokens.documents.statusExported]: 'Sent',
  [tokens.documents.createNewFlowFromThisDeclaration]:
    'Create a new workflow from this declaration',
  [tokens.documents.statusToRead]: 'To Read',
  [tokens.documents.statusToTreat]: 'To Process',
  [tokens.documents.statusToSend]: 'To send',
  [tokens.documents.statusError]: 'Error',
  [tokens.documents.statusAbandoned]: 'Abandoned',
  [tokens.documents.statusExportFailed]: 'Sending failed',
  [tokens.documents.batchImportErrorTitle]: 'Declaration in error',
  [tokens.documents.batchImportAbandonedTitle]: 'Abandoned declaration',
  [tokens.documents.batchImportAbandonedWhatToDo]:
    'If the declaration still needs to be made, create it again with the same files.',
  [tokens.documents.batchImportErrorReasonProcessingTimeout]:
    'Automatic processing did not complete within the 15-minute limit.',
  [tokens.documents.batchImportErrorReasonWorkflowLost]: 'Processing stopped before finishing.',
  [tokens.documents.batchImportErrorReasonWorkflowStuck]: 'Processing got stuck.',
  [tokens.documents.batchImportErrorReasonFilesTimeout]: 'No file was received within the expected time.',
  [tokens.documents.batchImportErrorReasonHumanTimeout]:
    'The declaration was waiting for an action to resume, and the delay ran out.',
  [tokens.documents.batchImportErrorReasonNoUsableDocument]:
    'No usable document was found in the declaration.',
  [tokens.documents.batchImportErrorReasonStepFailed]:
    'A processing step failed.',
  [tokens.documents.batchImportErrorReasonNoTypedDocument]:
    'None of the documents was recognised. The file cannot be processed automatically.',
  [tokens.documents.batchImportErrorReasonNoGroupConfiguration]:
    'No configuration is available for this group. Contact your administrator.',
  [tokens.documents.batchImportErrorReasonBlockingDiagnostic]:
    'A document prevents the declaration from being prepared.',
  [tokens.documents.batchImportErrorReasonEmptyDeclaration]:
    'No usable data was found in the documents to fill the declaration. The file cannot be processed automatically.',
  [tokens.documents.batchImportErrorReasonRepeatedBlock]:
    'The same problem occurred again after the retry. Contact support.',
  [tokens.documents.batchImportErrorReasonUnknown]: 'Processing did not complete.',
  [tokens.documents.batchImportErrorStoppedAt]:
    'Stopped at {{time}}, on the {{step}} step.',
  [tokens.documents.batchImportErrorStoppedAtStep]:
    'Stopped on the {{step}} step.',
  [tokens.documents.batchImportErrorStoppedAtTime]:
    'Stopped at {{time}}.',
  [tokens.documents.batchImportErrorEarlierStepsSucceeded]:
    'Earlier steps had succeeded.',
  [tokens.documents.batchImportErrorStepAwaitingUploads]: 'Upload',
  [tokens.documents.batchImportErrorStepFileProcessing]: 'Document reading',
  [tokens.documents.batchImportErrorStepExtraction]: 'Extraction',
  [tokens.documents.batchImportErrorStepMapping]: 'Formatting',
  [tokens.documents.batchImportErrorWhatToDo]: 'What now?',
  [tokens.documents.batchImportErrorWhatToDoFilesMissing]:
    'No file arrived for this declaration. Create it again with the documents attached.',
  [tokens.documents.batchImportErrorContactSupport]:
    'Contact support and give the reference above.',
  [tokens.documents.batchImportErrorContactButton]: 'Contact us',
  [tokens.documents.batchImportErrorSupportMessage]:
    'Hello, my declaration stopped with an error and I would like it resumed.',
  [tokens.documents.batchImportErrorRecreate]: 'You can also create the declaration again with the same files.',
  [tokens.documents.batchImportErrorRetryButton]: 'Retry',
  [tokens.documents.batchImportErrorRetryFailed]:
    'The retry failed. Try again or contact support.',
  [tokens.documents.batchImportErrorNotified]: 'Our technical team has been notified.',
  [tokens.documents.statusSent]: 'Sent',
  [tokens.documents.visualizeDocuments]: 'View documents',
  [tokens.documents.downloadDeclarationXML]:
    'Download the declaration in XML format',
  [tokens.documents.downloadDetailValue]: 'Download the value details',
  [tokens.documents.downloadOrginalDocuments]:
    'Download the original documents',
  [tokens.documents.declarationExportNotFound]:
    'The declaration export could not be found.',
  [tokens.documents.valueDetailExportNotFound]:
    'The value detail is not available for this declaration.',
  [tokens.documents.typeDocument]: 'Document type',
  [tokens.documents.nameDocument]: 'Document name',
  [tokens.documents.statusExtraction]: 'Extraction',
  [tokens.documents.statusInProgress]: 'In Progress',
  [tokens.documents.statusArchived]: 'Archived',
  [tokens.documents.statusUploaded]: 'Uploaded',
  [tokens.documents.statusUnknown]: 'Unknown',
  [tokens.documents.removeRecordTitle]: 'Delete a record',
  [tokens.documents.removeRecordsTitle]: 'Delete some records',
  [tokens.documents.removeRecordText]:
    'Are you sure you want to delete {{count}} dossier? This action cannot be undone.',
  [tokens.documents.removeRecordsText]:
    'Are you sure you want to delete {{count}} dossiers? This action cannot be undone.',
  [tokens.documents.deleteFolderTitle]: 'Delete “{{name}}”?',
  [tokens.documents.deleteFolderUnnamedTitle]: 'Delete this folder?',
  [tokens.documents.deleteFoldersTitle]: 'Delete {{count}} folders?',
  [tokens.documents.deleteFolderText]:
    'The folder and its attachments will be deleted. This action cannot be undone.',
  [tokens.documents.deleteFoldersText]:
    '{{names}} will be deleted along with their attachments. This action cannot be undone.',
  [tokens.documents.deleteFoldersUnnamedText]:
    'These folders and their attachments will be deleted. This action cannot be undone.',
  [tokens.documents.deleteFoldersOthers]: '{{count}} other',
  [tokens.documents.deleteFoldersOthers_other]: '{{count}} others',
  [tokens.documents.deleteFolderQuotedName]: '“{{name}}”',
  [tokens.documents.deleteFolderConfirm]: 'Delete',
  [tokens.documents.removePendingRecordTitle]: 'Delete a pending declaration',
  [tokens.documents.removePendingRecordsTitle]:
    'Delete some pending declarations',
  [tokens.documents.removePendingRecordText]:
    'Do you really want to delete this pending declaration?',
  [tokens.documents.removePendingRecordsText]:
    'Do you really want to delete those pending declarations?',
  [tokens.documents.documentHasBeenDeleted]: 'Declaration has been deleted',
  [tokens.documents.documentHasBeenDeleted_other]:
    'Declarations have been deleted',
  [tokens.documents.documentHasNotBeenDeleted]:
    'Declaration has not been deleted',
  [tokens.documents.documentHasNotBeenDeleted_other]:
    'Declarations have not been deleted',
  [tokens.documents.documentHasBeenUpdated]: 'Declaration has been updated',
  [tokens.documents.noDocumentFound]: 'No declarations found',
  [tokens.documents.starting]: 'Starting',
  [tokens.documents.bulkSelectedCount]: 'dossier selected',
  [tokens.documents.bulkSelectedCount_other]: 'dossiers selected',
  [tokens.documents.bulkDuplicate]: 'Duplicate',
  [tokens.documents.bulkApplyTag]: 'Apply a tag',
  [tokens.documents.bulkDownloadDocuments]: 'Download documents',
  [tokens.documents.bulkDelete]: 'Delete',
  [tokens.documents.foldersDuplicated]: '{{count}} dossier duplicated',
  [tokens.documents.foldersDuplicated_other]: '{{count}} dossiers duplicated',
  [tokens.documents.foldersNotDuplicated]: 'Failed to duplicate the dossier',
  [tokens.documents.foldersNotDuplicated_other]:
    'Failed to duplicate the dossiers',
  [tokens.documents.tagsAppliedToFolders]:
    'Tags were applied to {{count}} dossier',
  [tokens.documents.tagsAppliedToFolders_other]:
    'Tags were applied to {{count}} dossiers',
  [tokens.documents.bulkDownloadStarted]: 'Download started',
  [tokens.documents.bulkDownloadError]:
    'Unable to download the selected documents',
  [tokens.documents.bulkDownloadOutputFiles]: 'Download output files',
  [tokens.documents.bulkDownloadOutputFilesPartial]:
    '{{count}} dossier without a generated declaration was skipped',
  [tokens.documents.bulkDownloadOutputFilesPartial_other]:
    '{{count}} dossiers without a generated declaration were skipped',
  [tokens.documents.bulkDownloadOutputFilesNone]:
    'None of the selected dossiers has a generated declaration',
  [tokens.documents.bulkDownloadOutputFilesError]:
    'Unable to download the output files of the selected dossiers',
  [tokens.documents.attachmentCount]: '{{count}} att.',
  [tokens.documents.revisionInProgress]: 'In revision',

  [tokens.export.confirmExportTitle]: 'Confirm to export',
  [tokens.export.confirmExportText]: 'Do you really want to send this record?',
  [tokens.export.confirmExport]: 'Send',
  [tokens.export.successToExport]: 'The record was successfully sent',
  [tokens.export.notExtracted]: 'Not extracted',

  [tokens.teams.teamName]: 'Name of the team',
  [tokens.teams.removeFromGroup]: 'Remove from agency',
  [tokens.teams.youHaveNoTeam]: 'You do not have a team',
  [tokens.teams.createATeam]: 'Create a team',
  [tokens.teams.noRole]: 'No role',

  [tokens.nav.account]: 'Account',
  [tokens.nav.settings]: 'Settings',
  [tokens.nav.managementConsole]: 'Management Console',
  [tokens.nav.analytics]: 'Analytics',
  [tokens.nav.auth]: 'Auth',
  [tokens.nav.browse]: 'Browse',
  [tokens.nav.contact]: 'Contact',
  [tokens.nav.create]: 'Create',
  [tokens.nav.customers]: 'Customers',
  [tokens.nav.dashboard]: 'Dashboard',
  [tokens.nav.gobackToDeclaration]: 'Back to current declarations',
  [tokens.nav.backoffice]: 'Backoffice',
  [tokens.nav.database]: 'Database',
  [tokens.nav.customerFlow]: 'Data centers',
  [tokens.nav.customer]: 'Customer',
  [tokens.nav.data]: 'Data',
  [tokens.nav.models]: 'Models',
  [tokens.nav.referentials]: 'Referentials',
  [tokens.nav.automation]: 'Automation',
  [tokens.nav.workflows]: 'Workflows',
  [tokens.nav.details]: 'Details',
  [tokens.nav.edit]: 'Edit',
  [tokens.nav.error]: 'Error',
  [tokens.nav.feed]: 'Feed',
  [tokens.nav.fileManager]: 'File Manager',
  [tokens.nav.forgotPassword]: 'Forgot Password',
  [tokens.nav.list]: 'List',
  [tokens.nav.login]: 'Login',
  [tokens.nav.mcpConsent]: 'MCP authorization',
  [tokens.nav.impersonate]: 'Sign in as',
  [tokens.nav.mail]: 'Mail',
  [tokens.nav.management]: 'Management',
  [tokens.nav.orderList]: 'Orders',
  [tokens.nav.overview]: 'Overview',
  [tokens.nav.organizations]: 'Organizations',
  [tokens.nav.pages]: 'Pages',
  [tokens.nav.postCreate]: 'Post Create',
  [tokens.nav.postDetails]: 'Post Details',
  [tokens.nav.postList]: 'Post List',
  [tokens.nav.pricing]: 'Pricing',
  [tokens.nav.productList]: 'Products',
  [tokens.nav.fieldList]: 'Dossiers',
  [tokens.nav.fieldToRead]: 'To Read',
  [tokens.nav.fieldToManage]: 'To Manage',
  [tokens.nav.pendingField]: 'Pending',
  [tokens.nav.fieldExported]: 'Sent',
  [tokens.nav.fieldDeleted]: 'Deleted',
  [tokens.nav.pendingDocuments]: 'Pending dossiers',
  [tokens.nav.sentDocuments]: 'Sent dossiers',
  [tokens.nav.removedDocuments]: 'Removed dossiers',
  [tokens.nav.profile]: 'Profile',
  [tokens.nav.register]: 'Register',
  [tokens.nav.resetPassword]: 'Reset Password',
  [tokens.nav.connectors]: 'Connectors',
  [tokens.nav.users]: 'Users',
  [tokens.nav.expandSideNav]: 'Expand navigation',
  [tokens.nav.collapseSideNav]: 'Collapse navigation',
  [tokens.nav.accountMenuTooltip]: 'Account menu',

  [tokens.activity.lastActivity]: 'Recent activity',
  [tokens.activity.subTitleLastActivity]: 'Based on the selected period',
  [tokens.activity.seeSentDocuments]: 'See dossiers sent',
  [tokens.activity.seeDocumentsToManage]: 'See declarations',
  [tokens.activity.seeDocuments]: 'See declarations',
  [tokens.activity.exportedDocuments]: 'Sent declarations',

  [tokens.dashboard.all]: 'All',
  [tokens.dashboard.pending]: 'Pending',
  [tokens.dashboard.inProgress]: 'In progress',
  [tokens.dashboard.completed]: 'Completed',
  [tokens.dashboard.error]: 'Error',
  [tokens.dashboard.abandoned]: 'Abandoned',
  [tokens.dashboard.canceled]: 'Canceled',
  [tokens.dashboard.rejected]: 'Rejected',
  [tokens.dashboard.returned]: 'Returned',
  [tokens.dashboard.uploading]: 'Uploading',
  [tokens.dashboard.extracting]: 'Extracting',
  [tokens.dashboard.batchImport]: 'Declarations',
  [tokens.dashboard.pendingRecords]: 'Pending declarations',
  [tokens.dashboard.recordsToManage]: 'Documents to manage',
  [tokens.dashboard.exportedRecords]: 'Sent declarations',
  [tokens.dashboard.seeRecords]: 'See records',
  [tokens.dashboard.seeExportedRecords]: 'See sent records',
  [tokens.dashboard.createOrganization]: 'Create an organization',
  [tokens.dashboard.organizationCreated]:
    'The organization was successfully established',
  [tokens.dashboard.createOffice]: 'Create an office',
  [tokens.dashboard.officeCreated]: 'The office was successfully established',
  [tokens.dashboard.officeDeleted]: 'The office was successfully deleted',
  [tokens.dashboard.userCreated]: 'The user has been successfully created',
  [tokens.dashboard.deleteOrganization]: 'Delete the organization',
  [tokens.dashboard.deleteUser]: 'Remove user',
  [tokens.dashboard.userUpdated]: 'The user has been successfully changed',
  [tokens.dashboard.organizationAndGroups]: 'Organization and Agencies',
  [tokens.dashboard.selectGroups]: 'Select agencies to affiliate',
  [tokens.dashboard.inviteCollaborators]: 'Invite collaborators',
  [tokens.dashboard.externalCollaborator]: 'External collaborator',
  [tokens.dashboard.removeCollaborator]: 'Remove collaborator',
  [tokens.dashboard.removeOrganizationTitle]: 'Delete an organization',
  [tokens.dashboard.removeOrganizationText]:
    'Do you really want to delete this organization?',
  [tokens.dashboard.removeUserTitle]: 'Delete an user',
  [tokens.dashboard.removeUserText]: 'Do you really want to delete this user?',
  [tokens.dashboard.sendInvitationEmailTitle]: 'Send an invitation',
  [tokens.dashboard.sendInvitationEmailText]:
    'Are you sure you want to send this user an invitation?',
  [tokens.dashboard.manageDocuments]: 'Manage declaration',
  [tokens.dashboard.dropFilesHere]: 'Drop your files here',
  [tokens.dashboard.useNewFolderButton]: 'or use the "New Declaration" button',
  [tokens.dashboard.newFolderButton]: 'New declaration',
  [tokens.dashboard.folderInformation]: 'Declaration information',
  [tokens.dashboard.folderName]: 'Declaration Name',
  [tokens.dashboard.customer]: 'Customer',
  [tokens.dashboard.exportService]: 'Customs software',
  [tokens.dashboard.typeDeclarationService]: 'Declaration type',
  [tokens.dashboard.addNewCustomer]: 'Add a new customer',
  [tokens.dashboard.customerName]: 'Customer name',
  [tokens.dashboard.createNewCustomer]: 'Create new customer',
  [tokens.dashboard.punctualCustomer]: 'Ponctual Customer',
  [tokens.dashboard.regularCustomer]: 'Regular customer',
  [tokens.dashboard.theEmailWasCopiedToYourClipboard]:
    'The email was copied to your clipboard !',
  [tokens.dashboard.fastTrackFirstText]: 'Fast track',
  [tokens.dashboard.fastTrackSecondText]:
    '(skip the classification step if your only document is an invoice or an export accompanying document)',
  [tokens.dashboard.fastTrackTooltipText]: 'Select a declaration type',
  [tokens.dashboard.isCurrentlyInAnErrorState]:
    'is currently in an error state',
  [tokens.dashboard.declarationInErrorState]: 'Declaration in error state',
  [tokens.dashboard.itsLastReportedStateWas]: "It's last reported state was",
  [tokens.dashboard.ourTechnicalTeamHasBeenNotified]:
    'Our technical team has been notified',
  [tokens.dashboard.pleaseContactCustomerServiceForFurtherInformation]:
    'Please contact customer service for further information',
  [tokens.dashboard.created]: 'Created',
  [tokens.dashboard.clientOrganization]: 'Client organization',
  [tokens.dashboard.reference]: 'File reference Nabu',
  [tokens.dashboard.customerReference]: 'File reference Customer',
  [tokens.dashboard.noReference]: 'No file reference',
  [tokens.dashboard.type]: 'Type',
  [tokens.dashboard.timing]: 'Timing',
  [tokens.dashboard.clientName]: 'Client',
  [tokens.dashboard.status]: 'Status',
  [tokens.dashboard.noDeclarationsFound]: 'No declarations found',
  [tokens.dashboard.searchForADeclaration]: 'Search for a declaration',
  [tokens.dashboard.searchNameMaxLengthHint]:
    'Search is limited to {{max}} characters.',
  [tokens.dashboard.tracking]: 'Tracking',
  [tokens.dashboard.pastDue]: 'Past due',
  [tokens.dashboard.importer]: 'Importer',
  [tokens.dashboard.exporter]: 'Exporter',
  [tokens.dashboard.noExporterIndicated]: 'No exporter',
  [tokens.dashboard.noImporterIndicated]: 'No importer',
  [tokens.dashboard.emailSender]: 'Email sender',
  [tokens.dashboard.emailSubject]: 'Email subject',
  [tokens.dashboard.emailSendingDate]: 'Sending date',
  [tokens.dashboard.details]: 'Details',
  [tokens.dashboard.viewDetails]: 'View details',
  [tokens.dashboard.openInfoPanel]: 'Open info panel',
  [tokens.dashboard.tags]: 'Tags',
  [tokens.dashboard.tag]: 'Tag',
  [tokens.dashboard.noTags]: 'No tags',
  [tokens.dashboard.addTag]: 'Add tag',
  [tokens.dashboard.createTag]: 'Create tag',
  [tokens.dashboard.tagName]: 'Tag name',
  [tokens.dashboard.source]: 'Source',
  [tokens.dashboard.description]: 'Description',
  [tokens.dashboard.group]: 'Agency',
  [tokens.dashboard.declarant]: 'Declarant',
  [tokens.dashboard.filter]: 'Filter',
  [tokens.dashboard.clearAll]: 'Clear all',
  [tokens.dashboard.addFilter]: 'ADD FILTER',
  [tokens.dashboard.allFilterActive]: 'All filters active',
  [tokens.dashboard.allTypes]: 'Types: all',
  [tokens.dashboard.user]: 'User',
  [tokens.dashboard.sendDate]: 'Send date',
  [tokens.dashboard.apply]: 'Apply',
  [tokens.dashboard.search]: 'Search',
  [tokens.dashboard.noResults]: 'No results found',
  [tokens.dashboard.lastDay]: '1 day ago',
  [tokens.dashboard.last3Days]: '3 days ago',
  [tokens.dashboard.lastWeek]: '1 week ago',
  [tokens.dashboard.lastMonth]: '1 month ago',
  [tokens.dashboard.last3Months]: '3 months ago',
  [tokens.dashboard.lastYear]: '1 year ago',
  [tokens.dashboard.customDateRange]: 'Custom date range',
  [tokens.dashboard.saveSearch]: 'Save search',
  [tokens.dashboard.savedSearches]: 'Saved searches',
  [tokens.dashboard.searchName]: 'Search name',
  [tokens.dashboard.noSavedSearches]: 'No saved searches',
  [tokens.dashboard.unknown]: 'Unknown',
  [tokens.dashboard.from]: 'From',
  [tokens.dashboard.to]: 'To',

  [tokens.dashboardV2.kicker]: 'Home · {{date}}',
  [tokens.dashboardV2.greeting]: 'Hello {{name}}',
  [tokens.dashboardV2.searchPlaceholder]: 'Search a file',
  [tokens.dashboardV2.searchNoResults]: 'No file for "{{query}}"',
  [tokens.dashboardV2.searchLoading]: 'Loading…',
  [tokens.dashboardV2.exportTitle]: 'Export all dashboard data (CSV)',
  [tokens.dashboardV2.customizeStart]: 'Customize block layout',
  [tokens.dashboardV2.customizeStop]: 'Finish customizing',

  [tokens.dashboardV2.kpiToProcessLabel]: 'To process',
  [tokens.dashboardV2.kpiToProcessSub]: 'files awaiting action',
  [tokens.dashboardV2.kpiErrorLabel]: 'In error',
  [tokens.dashboardV2.kpiSentLabel]: 'Sent this month',
  [tokens.dashboardV2.kpiSentSub]: 'vs. same period last month',
  [tokens.dashboardV2.kpiSentPrevious]:
    '{{period}}: {{formattedCount}} file sent.',
  [tokens.dashboardV2.kpiSentPrevious_other]:
    '{{period}}: {{formattedCount}} files sent.',
  [tokens.dashboardV2.kpiSentPreviousNone]: '{{period}}: no files sent.',
  [tokens.dashboardV2.kpiSentFewer]: 'That is {{diff}} fewer ({{pct}}).',
  [tokens.dashboardV2.kpiSentMore]: 'That is {{diff}} more ({{pct}}).',
  [tokens.dashboardV2.kpiSentSame]: 'Same as this month.',
  [tokens.dashboardV2.kpiTrendFrom]: '{{date}}: {{formattedCount}} file.',
  [tokens.dashboardV2.kpiTrendFrom_other]: '{{date}}: {{formattedCount}} files.',
  [tokens.dashboardV2.kpiTrendToday]: 'Today: {{formattedCount}}, {{pct}}.',
  [tokens.dashboardV2.kpiTrendTodaySame]: 'Today: {{formattedCount}}, unchanged.',
  [tokens.dashboardV2.kpiTrendTodayOnly]: 'Today: {{formattedCount}}.',
  [tokens.dashboardV2.seeDossiers]: 'See files',

  [tokens.dashboardV2.activityTitle]: 'Latest activity',
  [tokens.dashboardV2.activitySubtitle]: 'Your last 10 files',
  [tokens.dashboardV2.seeAll]: 'See all',
  [tokens.dashboardV2.filterAll]: 'All',
  [tokens.dashboardV2.filterToProcess]: 'To process',
  [tokens.dashboardV2.filterSent]: 'Sent',
  [tokens.dashboardV2.filterError]: 'In error',
  [tokens.dashboardV2.colName]: 'File name',
  [tokens.dashboardV2.colType]: 'Type',
  [tokens.dashboardV2.colStatus]: 'Status',
  [tokens.dashboardV2.colDate]: 'Date',
  [tokens.dashboardV2.emptyCategory]: 'No file in this category',
  [tokens.dashboardV2.staleTooltip]: 'Waiting for {{duration}}',
  [tokens.dashboardV2.staleBadgeMinutes]: '+{{count}} min',
  [tokens.dashboardV2.staleBadgeHours]: '+{{count}} h',
  [tokens.dashboardV2.staleBadgeDays]: '+{{count}} d',
  [tokens.dashboardV2.staleBadgeWeeks]: '+{{count}} w',
  [tokens.dashboardV2.staleBadgeMonths]: '+{{count}} mo',

  [tokens.dashboardV2.aiTitle]: 'What AI did for you',
  [tokens.dashboardV2.aiSubtitle]: 'This month',
  [tokens.dashboardV2.aiHeadlineSuffix]: 'AI actions performed',
  [tokens.dashboardV2.aiHeadlineSub]: 'out of {{count}} declarations',
  [tokens.dashboardV2.aiCreditsFooter]: '{{count}} credits used',
  [tokens.dashboardV2.aiEmptyTitle]: 'No automation configured',
  [tokens.dashboardV2.aiEmptyBody]:
    'Set up an automation to pre-fill your item lines from your supplier files.',
  [tokens.dashboardV2.aiEmptyCta]: 'Create an automation',
  [tokens.dashboardV2.aiRowPrefilled]: 'Pre-filled item lines',
  [tokens.dashboardV2.aiRowPrefilledMeta]:
    'out of {{total}} · {{corrected}} corrected manually',
  [tokens.dashboardV2.aiRowAnomalies]: 'Anomalies raised automatically',
  [tokens.dashboardV2.aiRowAnomaliesMeta]: 'including {{blocking}} blocking',
  [tokens.dashboardV2.aiRowSuggestions]: 'Suggestions accepted',
  [tokens.dashboardV2.aiRowSuggestionsMeta]:
    'out of {{total}} proposed · {{pct}}%',
  [tokens.dashboardV2.aiRowFields]: 'Fields completed from documents',
  [tokens.dashboardV2.aiRowFieldsMeta]: '{{count}} documents extracted',

  [tokens.dashboardV2.teamTitle]: 'Team activity',
  [tokens.dashboardV2.teamSubtitle]:
    '{{agency}} agency · {{count}} declarants · {{processed}} files processed {{period}}',
  [tokens.dashboardV2.teamSubtitleStats]:
    '· {{count}} declarants · {{processed}} files processed {{period}}',
  [tokens.dashboardV2.teamRangeWeek]: 'This week',
  [tokens.dashboardV2.teamRangeMonth]: 'This month',
  [tokens.dashboardV2.teamLateBadge]: '{{count}} late',
  [tokens.dashboardV2.teamOverloadBadge]: '{{count}} overloaded',
  [tokens.dashboardV2.teamAgencySelect]: 'Agency',
  [tokens.dashboardV2.teamEmpty]: 'No declarants in this agency.',
  [tokens.dashboardV2.teamError]: 'Unable to load team activity.',
  [tokens.dashboardV2.teamUnknownMember]: 'Unnamed',
  [tokens.dashboardV2.colDeclarant]: 'Declarant',
  [tokens.dashboardV2.colProcessed]: 'Processed',
  [tokens.dashboardV2.colInProgress]: 'In progress',
  [tokens.dashboardV2.colLate]: 'Late',
  [tokens.dashboardV2.colRate]: 'Rate / day',
  [tokens.dashboardV2.colLoad]: 'Load',
  [tokens.dashboardV2.lateTooltip]:
    'A late file is an unsent file created more than four hours ago.',
  [tokens.dashboardV2.rateTooltip]:
    'Average files processed per working day. Target: {{target}} per declarant. It measures their processing pace.',
  [tokens.dashboardV2.loadTooltip]:
    'Files in progress compared to a capacity of {{capacity}}. Above 100%, the declarant is handling more files than they can properly follow and is overloaded.',

  [tokens.dashboardV2.fluxTitle]: 'Volume & flow',
  [tokens.dashboardV2.fluxSubtitle]:
    '12 rolling months · Import / Export / Transit breakdown',
  [tokens.dashboardV2.fluxEmpty]: 'No volume over the last 12 months.',
  [tokens.dashboardV2.fluxError]: 'Unable to load volume by flow.',
  [tokens.dashboardV2.fluxMonthlyLabel]: 'Monthly evolution',
  [tokens.dashboardV2.fluxAllFlows]: 'All flows',
  [tokens.dashboardV2.fluxBreakdownLabel]: '12-month breakdown',
  [tokens.dashboardV2.fluxTotalLabel]: 'Total',
  [tokens.dashboardV2.fluxTotalUnit]: 'declarations',
  [tokens.dashboardV2.fluxTooltipDeclarations]: 'Declarations:',
  [tokens.dashboardV2.typeImport]: 'Import',
  [tokens.dashboardV2.typeExport]: 'Export',
  [tokens.dashboardV2.typeTransit]: 'Transit',

  [tokens.dashboardV2.cplxTitle]: 'Performance by complexity',
  [tokens.dashboardV2.cplxSubtitle]: 'Benchmark {{base}}s + {{perLine}}s / line',
  [tokens.dashboardV2.cplxTierSmall]: 'Small',
  [tokens.dashboardV2.cplxTierMedium]: 'Medium',
  [tokens.dashboardV2.cplxTierLarge]: 'Large',
  [tokens.dashboardV2.cplxColDossiers]: 'Files',
  [tokens.dashboardV2.cplxColBenchmark]: 'Benchmark',
  [tokens.dashboardV2.cplxColMeasured]: 'Nabu measured',
  [tokens.dashboardV2.cplxColGain]: 'Gain',
  [tokens.dashboardV2.cplxMeasuredSub]: '{{sampled}}/{{total}} measured',
  [tokens.dashboardV2.cplxAvgTimeLabel]: 'Average time per file',
  [tokens.dashboardV2.cplxLegendBenchmark]: 'Benchmark',
  [tokens.dashboardV2.cplxLegendMeasured]: 'Nabu measured',
  [tokens.dashboardV2.cplxTooltipBenchmark]: 'Benchmark {{lines}} lines:',
  [tokens.dashboardV2.cplxTooltipMeasured]: 'Nabu:',

  [tokens.dashboardV2.editBannerText]:
    'Drag a block onto the edge of another to share the row (up to 3), or between two rows to isolate it. The eye hides a block.',
  [tokens.dashboardV2.resetCta]: 'Reset',
  [tokens.dashboardV2.doneCta]: 'Done',
  [tokens.dashboardV2.newRowLabel]: 'New row',
  [tokens.dashboardV2.dropNewRowBottom]: 'Drop here for a new row at the bottom',
  [tokens.dashboardV2.hideBlock]: 'Hide this block',
  [tokens.dashboardV2.showBlock]: 'Show this block',
  [tokens.dashboardV2.dragHandleTitle]: 'Drag to move this block',

  [tokens.dashboardV2.sectionKpi]: "Today's indicators",
  [tokens.dashboardV2.sectionActivity]: 'Latest activity',
  [tokens.dashboardV2.sectionAi]: 'What AI did for you',
  [tokens.dashboardV2.sectionTeam]: 'Team activity',
  [tokens.dashboardV2.sectionFlux]: 'Volume & flow',
  [tokens.dashboardV2.sectionComplexity]: 'Performance by complexity',

  [tokens.backoffice.createUser]: 'Create User',
  [tokens.backoffice.deleteUser]: 'User successfully deleted',
  [tokens.backoffice.successSendEmailMessage]:
    'Invitation email sent successfully',
  [tokens.backoffice.users]: 'Users',
  [tokens.backoffice.importLayer]: 'Import a Layer',
  [tokens.backoffice.chooseLayerName]: 'Choose a layer name',
  [tokens.backoffice.selectDocumentType]: 'Document type',
  [tokens.backoffice.onlyFirstPage]: 'Only the first page will be used.',
  [tokens.backoffice.acceptedFormats]: 'Accepted formats',
  [tokens.backoffice.maxSize]: 'Maximum size',
  [tokens.backoffice.exportConfig]: 'Export Configuration',
  [tokens.backoffice.layerNameIsRequired]: 'Layer name is required',
  [tokens.backoffice.documentTypeIsRequired]: 'Document type is required',
  [tokens.backoffice.exportConfigurationIsRequired]:
    'Configuration is required',
  [tokens.backoffice.deleteOrganization]:
    "L'organisation supprimée avec succès",

  [tokens.organizations.organizationsTitle]: 'Organizations',
  [tokens.organizations.organizationTitle]: 'Organization',

  [tokens.declarationProgress.title]: 'Nabu is preparing your file',
  [tokens.declarationProgress.subtitleReady]:
    'You will be able to complete the declaration once it is ready.',
  [tokens.declarationProgress.subtitleWaitingHuman]:
    'A step is waiting for your input.',
  [tokens.declarationProgress.groupDocuments]: 'Your documents',
  [tokens.declarationProgress.groupData]: 'Data extraction',
  [tokens.declarationProgress.groupDeclaration]: 'Your declaration',
  [tokens.declarationProgress.stateDone]: 'Completed',
  [tokens.declarationProgress.stateRunning]: 'In progress…',
  [tokens.declarationProgress.stateBlocked]: 'Waiting for you',
  [tokens.declarationProgress.statePending]: 'Pending…',
  [tokens.declarationProgress.stepAwaitingUploadsLabel]: 'Receiving files',
  [tokens.declarationProgress.stepAwaitingUploadsHint]:
    'Upload and unzip in progress…',
  [tokens.declarationProgress.stepFileProcessingLabel]: 'Reading pages',
  [tokens.declarationProgress.stepFileProcessingHint]:
    'Deskewing, OCR and document recognition…',
  [tokens.declarationProgress.stepAwaitingClassificationLabel]:
    'Document type for each file',
  [tokens.declarationProgress.stepAwaitingClassificationHint]:
    'A document is waiting to be classified.',
  [tokens.declarationProgress.stepExtractionLabel]: 'Data extraction',
  [tokens.declarationProgress.stepExtractionHint]:
    'Reading documents and matching them together…',
  [tokens.declarationProgress.stepAwaitingReviewLabel]: 'Document review',
  [tokens.declarationProgress.stepAwaitingReviewHint]:
    'A reading was flagged as unreliable and needs a check.',
  [tokens.declarationProgress.stepAwaitingConfigurationLabel]:
    'Declaration type',
  [tokens.declarationProgress.stepAwaitingConfigurationHint]:
    'The file is waiting for its configuration.',
  [tokens.declarationProgress.stepMappingLabel]: 'Generating the declaration',
  [tokens.declarationProgress.stepMappingHint]:
    'Deductions, reference data and form filling…',
  [tokens.declarationProgress.stepInstructionRoutineLabel]: 'Applying instructions',
  [tokens.declarationProgress.stepInstructionRoutineHint]:
    'The Nabu Assistant is applying your automatic instructions to the declaration…',
  [tokens.declarationProgress.stepAwaitingDeclarationLabel]:
    'Declaration ready',
  [tokens.declarationProgress.stepAwaitingDeclarationHint]:
    'Ready to be completed.',
  [tokens.declarationProgress.resumeTitle]: 'Choose the declaration type',
  [tokens.declarationProgress.resumeHint]:
    'Nabu could not work out this file’s declaration type. Choose one to resume the generation.',
  [tokens.declarationProgress.resumeAction]: 'Generate the declaration',
  [tokens.declarationProgress.resumeError]: 'Resuming failed.',
  [tokens.declarationProgress.detailFiles]: 'Files received: {{count}}',
  [tokens.declarationProgress.stepAssemblyLabel]: 'Data assembly',
  [tokens.declarationProgress.stepAssemblyHint]: 'Matching the documents for the chosen type…',
  [tokens.declarationProgress.detailAssembly]: 'Consignments: {{count}} · reference: {{backbone}}',
  [tokens.declarationProgress.detailAssemblyPlanner]: 'decided by Nabu (confidence {{confidence}}%)',
  [tokens.declarationProgress.detailPages]: 'Pages read: {{processed}} / {{total}}',
  [tokens.declarationProgress.detailDocuments]: '{{count}} documents: {{types}}',
  [tokens.declarationProgress.detailRead]: 'Documents read: {{read}} / {{total}}',
  [tokens.declarationProgress.detailBlocked]: 'To check: {{document}} ({{reason}})',
  [tokens.declarationProgress.detailChosenAutomatically]: 'deduced from the documents',
  [tokens.declarationProgress.detailParties]: 'Sellers: {{sellers}} · Buyers: {{buyers}}',
  [tokens.declarationProgress.decType_import]: 'Import',
  [tokens.declarationProgress.decType_export]: 'Export',
  [tokens.declarationProgress.decType_ens]: 'Safety and security (ENS)',
  [tokens.declarationProgress.decType_transit]: 'Transit',

  [tokens.declarationValidationProgress.sectionRequired]: 'Required fields',
  [tokens.declarationValidationProgress.sectionBlocking]: 'Blocking checks',

  [tokens.tariffClassification.statusValid]: 'Valid',
  [tokens.tariffClassification.statusIncomplete]: 'Incomplete',
  [tokens.tariffClassification.statusUnknown]: 'Unknown',
  [tokens.tariffClassification.statusMissing]: 'To classify',
  [tokens.tariffClassification.authorAuto]: 'Auto',
  [tokens.tariffClassification.received]: 'received {{code}}',
  [tokens.tariffClassification.residual]: 'residual branch',
  [tokens.tariffClassification.apply]: 'Apply {{code}}',
  [tokens.tariffClassification.cancel]: 'Cancel',
  [tokens.tariffClassification.close]: 'Close',
  [tokens.tariffClassification.productName]: 'Tarifill',
  [tokens.tariffClassification.colArticles]: 'Items',
  [tokens.tariffClassification.bannerTitle]: 'Complete {{count}} codes with the “other” branch',
  [tokens.tariffClassification.bannerTitle_one]: 'Complete 1 code with the “other” branch',
  [tokens.tariffClassification.bannerBody]: 'Allowed chapters: {{chapters}} (demo list).',
  [tokens.tariffClassification.preview]: 'Check and complete',
  [tokens.tariffClassification.dialogTitle]: 'Complete {{count}} codes to Other',
  [tokens.tariffClassification.dialogTitle_one]: 'Complete 1 code to Other',
  [tokens.tariffClassification.dialogIntro]: 'Each received code is completed to the residual “Other” branch under its prefix. Check the description before confirming.',
  [tokens.tariffClassification.colReceived]: 'Received',
  [tokens.tariffClassification.colCompleted]: 'Declared after completion',
  [tokens.tariffClassification.colLabel]: 'Description',
  [tokens.tariffClassification.skippedOutOfScope]: '{{count}} codes outside the allowed chapters are left for you to choose.',
  [tokens.tariffClassification.skippedOutOfScope_one]: '1 code outside the allowed chapters is left for you to choose.',
  [tokens.tariffClassification.skippedAmbiguous]: '{{count}} codes without a single “Other” branch are left for you to choose.',
  [tokens.tariffClassification.skippedAmbiguous_one]: '1 code without a single “Other” branch is left for you to choose.',
  [tokens.tariffClassification.autoNote]: 'Codes stay marked “Auto” with their received code, and can be undone.',
  [tokens.tariffClassification.confirm]: 'Complete {{count}} codes',
  [tokens.tariffClassification.confirm_one]: 'Complete 1 code',
  [tokens.tariffClassification.done]: '{{count}} codes completed to Other',
  [tokens.tariffClassification.done_one]: '1 code completed to Other',
  [tokens.tariffClassification.undo]: 'Undo',
  [tokens.tariffClassification.reasonAuto]: 'Tarifill: completed to Other',
  [tokens.tariffClassification.reasonUser]: 'Tarifill: code chosen',
  [tokens.tariffClassification.reasonUndo]: 'Tarifill: back to the received code',
  [tokens.tariffClassification.tourStepIntroTitle]: 'Tarifill, tariff classification',
  [tokens.tariffClassification.tourStepIntroBody]: 'Tarifill helps you declare a complete, valid commodity code for every article. Dock the window left or right, or let it float over the grid. Follow the example step by step, on your file.',
  [tokens.tariffClassification.tourStepPreviewTitle]: 'Complete to “Other” in one go',
  [tokens.tariffClassification.tourStepPreviewBody]: 'This box appears when incomplete codes can be completed to their “Other” branch, in the chapters allowed for your organisation (low risk: mechanics, plastics…).',
  [tokens.tariffClassification.tourStepPreviewButtonTitle]: 'Check and complete',
  [tokens.tariffClassification.tourStepPreviewButtonBody]: 'Nothing changes until you agree: the preview shows each completion before applying it. Let’s open it.',
  [tokens.tariffClassification.tourStepPreviewTitleTitle]: 'The preview',
  [tokens.tariffClassification.tourStepPreviewTitleBody]: 'How many codes will be completed, and in which allowed chapters.',
  [tokens.tariffClassification.tourStepPreviewTableTitle]: 'One row per received code',
  [tokens.tariffClassification.tourStepPreviewTableBody]: '“Received”: the code as it arrived. “Declared after completion”: the 10-digit code. “Description”: what it covers. “Items”: how many items carry it.',
  [tokens.tariffClassification.tourStepPreviewCheckboxTitle]: 'Leave a code out',
  [tokens.tariffClassification.tourStepPreviewCheckboxBody]: 'Untick a row to leave it out: it will not be completed and stays to do.',
  [tokens.tariffClassification.tourStepPreviewCompletedTitle]: 'The added digits',
  [tokens.tariffClassification.tourStepPreviewCompletedBody]: 'The digits Tarifill adds are highlighted: you see at a glance what changes.',
  [tokens.tariffClassification.tourStepPreviewLabelTitle]: 'Check the description',
  [tokens.tariffClassification.tourStepPreviewLabelBody]: 'The code’s description and its path in the nomenclature: read them before confirming.',
  [tokens.tariffClassification.tourStepPreviewSkippedTitle]: 'What stays with you',
  [tokens.tariffClassification.tourStepPreviewSkippedBody]: 'Codes outside the allowed chapters, or without a single “Other” branch, are not completed: they stay in “To do” for you to choose.',
  [tokens.tariffClassification.tourStepPreviewAutoTitle]: 'Always traceable',
  [tokens.tariffClassification.tourStepPreviewAutoBody]: 'Completed codes are marked ✦ in the grid and “Auto” in Corrected, with the received code. You can undo them until the declaration is sent.',
  [tokens.tariffClassification.tourStepPreviewConfirmTitle]: 'Confirm',
  [tokens.tariffClassification.tourStepPreviewConfirmBody]: 'One click completes every ticked code in a single step, visible in the history. A message then offers “Undo”.',
  [tokens.tariffClassification.tourStepCardTitle]: 'One article, one card',
  [tokens.tariffClassification.tourStepCardBody]: 'The description, the received code and its state. Open, the card tells what exists and what is missing. Here is an article from your file with several continuations.',
  [tokens.tariffClassification.tourStepFiltersTitle]: 'Find an article',
  [tokens.tariffClassification.tourStepFiltersBody]: 'Search by article number, code or words of the description, filter by state or chapter. Articles to handle come first, in batches of 20.',
  [tokens.tariffClassification.tourStepReviewTitle]: 'Process in series',
  [tokens.tariffClassification.tourStepReviewBody]: 'On a large file, the articles to complete grouped by code and product, from the keyboard: 1 to 9 applies a continuation and moves on, ← → changes group, Esc returns to the list.',
  [tokens.tariffClassification.tourStepDirectoryTargetTitle]: 'Who we search for',
  [tokens.tariffClassification.tourStepDirectoryTargetBody]: 'The article the chosen code will apply to.',
  [tokens.tariffClassification.tourStepDirectorySearchTitle]: 'Search',
  [tokens.tariffClassification.tourStepDirectorySearchBody]: 'Digits (“7318 15”) or word beginnings (“steel screw”), accents ignored. The file’s codes come first.',
  [tokens.tariffClassification.tourStepDirectoryScopeTitle]: 'The whole nomenclature, or our articles',
  [tokens.tariffClassification.tourStepDirectoryScopeBody]: '“Whole nomenclature” to search or browse codes; “Our articles” to see the file’s codes, grouped.',
  [tokens.tariffClassification.tourStepGridTitle]: 'In the grid',
  [tokens.tariffClassification.tourStepGridBody]: 'In the code cell, a badge shows where the code stands: Complete, Incomplete (several possible continuations), Unknown (not in the nomenclature) or Auto (only one possible continuation: a click on the badge applies it). ✦ flags a code assumed by a machine, to check. Hover for what to do. A click in the cell opens Tarifill.',
  [tokens.tariffClassification.tourStepHelpTitle]: 'Replay this tour',
  [tokens.tariffClassification.tourStepHelpBody]: 'This button replays the tour at any time.',
  [tokens.tariffClassification.clearSearch]: 'Clear the search',
  [tokens.tariffClassification.openTaric]: 'See on TARIC',
  [tokens.tariffClassification.openTaricTooltip]: 'TARIC sheet for {{code}} (European Commission): its EU measures for the item’s origin',
  [tokens.tariffClassification.openRitaTooltip]: 'RITA (douane.gouv.fr) opens with {{code}} prefilled: run the search to also see national measures',
  [tokens.tariffClassification.incompleteCount]: '{{count}} incomplete codes',
  [tokens.tariffClassification.incompleteCount_one]: '1 incomplete code',
  [tokens.tariffClassification.openInOtherWindow]: 'Open in another window',
  [tokens.tariffClassification.openedInOtherWindow]: 'Tarifill is open in another window: a click in the code cell opens the item there.',
  [tokens.tariffClassification.otherWindowDisabled]: 'Tarifill is not enabled for your account.',
  [tokens.tariffClassification.measureStateConditional]: 'Conditional',
  [tokens.tariffClassification.measureStateInapplicable]: 'Not applicable',
  [tokens.tariffClassification.browsePosition]: '{{position}} of {{count}}',
  [tokens.tariffClassification.browsePrevious]: 'Previous item (↑)',
  [tokens.tariffClassification.browseNext]: 'Next item (↓)',
  [tokens.tariffClassification.toCheck]: 'To check',
  [tokens.tariffClassification.cellComplete]: 'Complete',
  [tokens.tariffClassification.cellAuto]: 'Auto',
  [tokens.tariffClassification.cellCompleteHint]: 'Complete TARIC code. Click to open it in Tarifill.',
  [tokens.tariffClassification.cellAutoHint]: 'Only one possible continuation: {{code}}. Click to complete.',
  [tokens.tariffClassification.cellIncompleteHint]: '{{count}} possible continuations. Click to choose in Tarifill.',
  [tokens.tariffClassification.cellUnknownHint]: 'No level of this code exists. Click to look for it in Tarifill.',
  [tokens.tariffClassification.verifDecisionsTitle]: '{{count}} classification decisions to make',
  [tokens.tariffClassification.verifDecisionsTitle_one]: '1 classification decision to make',
  [tokens.tariffClassification.verifCompleteTitle]: 'Tariff classification complete',
  [tokens.tariffClassification.verifOpenTarifill]: 'Open Tarifill',
  [tokens.tariffClassification.verifContextLead]: 'Tariff classification:',
  [tokens.tariffClassification.verifContextLines]: 'lines classified',
  [tokens.tariffClassification.verifContextRest]: '· still to decide:',
  [tokens.tariffClassification.verifGroupChoice]: 'Code choice',
  [tokens.tariffClassification.verifGroupAuto]: 'Only one possible continuation',
  [tokens.tariffClassification.verifPillChoice]: 'Choose the code in Tarifill',
  [tokens.tariffClassification.verifPillAuto]: 'Check the suggested continuation in Tarifill',
  [tokens.tariffClassification.verifAnalysis]: 'Analysis details',
  [tokens.tariffClassification.verifRead]: 'Codes read',
  [tokens.tariffClassification.verifReadValue]: '{{count}} codes, normalised format',
  [tokens.tariffClassification.verifReadValue_one]: '1 code, normalised format',
  [tokens.tariffClassification.verifValidStart]: 'Valid code start',
  [tokens.tariffClassification.verifValidStartValue]: '{{count}} of {{total}}',
  [tokens.tariffClassification.verifAuto]: 'Single continuation found',
  [tokens.tariffClassification.verifAutoValue]: '{{count}} items',
  [tokens.tariffClassification.verifAutoValue_one]: '1 item',
  [tokens.tariffClassification.completedByTarifill]: 'Completed by Tarifill with the “other” branch',
  [tokens.tariffClassification.receivedShort]: 'received',
  [tokens.tariffClassification.noDesignation]: 'No description',
  [tokens.tariffClassification.directoryLink]: 'Directory',
  [tokens.tariffClassification.treeLoading]: 'Loading the chapter…',
  [tokens.tariffClassification.treeFailed]: 'The chapter could not be loaded.',
  [tokens.tariffClassification.tourStepDirectoryTreeTitle]: 'The tree',
  [tokens.tariffClassification.tourStepDirectoryTreeBody]: 'Without a search, the nomenclature as on RITA, opened on the article’s code: declarable codes in green, and a pill with the number of the file’s articles under each level. Choose a code, then “Apply”.',
  [tokens.tariffClassification.measuresDemoNote]: 'Fictitious measures, duties and RITA data, in the shape planned by TEC-1834: the back end does not expose them yet.',
  [tokens.tariffClassification.groupSplit]: 'Same received code for {{count}} different products: classify them separately.',
  [tokens.tariffClassification.moreDesignations]: '+{{count}} more',
  [tokens.tariffClassification.reviewStart]: 'Review one by one',
  [tokens.tariffClassification.reviewPosition]: 'Group {{position}} of {{count}}',
  [tokens.tariffClassification.reviewDone]: 'Every group in the selection is done.',
  [tokens.tariffClassification.reviewProgress]: '{{done}} of {{total}} done',
  [tokens.tariffClassification.reviewExit]: 'Leave review',
  [tokens.tariffClassification.reviewPrevious]: 'Previous',
  [tokens.tariffClassification.reviewSkip]: 'Skip',
  [tokens.tariffClassification.reviewHintPick]: 'apply a code',
  [tokens.tariffClassification.reviewHintMove]: 'move between groups',
  [tokens.tariffClassification.keyEscape]: 'Esc',
  [tokens.tariffClassification.filterChapter]: 'Chapter',
  [tokens.tariffClassification.filterAllChapters]: 'All chapters',
  [tokens.tariffClassification.chapterOption]: 'Chapter {{chapter}} · {{count}} items',
  [tokens.tariffClassification.showNext]: 'Show {{count}} more ({{remaining}} left)',
  [tokens.tariffClassification.levelChapter]: 'Chapter',
  [tokens.tariffClassification.levelHeading]: 'Heading',
  [tokens.tariffClassification.levelSubheading]: 'HS subheading',
  [tokens.tariffClassification.levelCn]: 'Combined Nomenclature',
  [tokens.tariffClassification.levelTaric]: 'TARIC',
  [tokens.tariffClassification.askAssistant]: 'Ask the assistant',
  [tokens.tariffClassification.openRita]: 'See on RITA',
  [tokens.tariffClassification.assistantPromptReceived]: 'Help me classify {{count}} items received with code {{code}}.',
  [tokens.tariffClassification.assistantPromptReceived_one]: 'Help me classify an item received with code {{code}}.',
  [tokens.tariffClassification.assistantPromptMissing]: 'Help me classify {{count}} items received without a code.',
  [tokens.tariffClassification.assistantPromptMissing_one]: 'Help me classify an item received without a code.',
  [tokens.tariffClassification.assistantPromptDesignations]: 'Descriptions: {{list}}.',
  [tokens.tariffClassification.assistantPromptOrigin]: 'Origin: {{origin}}.',
  [tokens.tariffClassification.assistantPromptBranches]: 'Possible branches in the nomenclature: {{list}}.',
  [tokens.tariffClassification.assistantPromptAsk]: 'Suggest the most likely 10-digit commodity code, explain your reasoning and tell me what to check before declaring it.',
  [tokens.tariffClassification.missingDigits]: '{{count}} digits missing',
  [tokens.tariffClassification.missingDigits_one]: '1 digit missing',
  [tokens.tariffClassification.notInNomenclature]: 'not in the nomenclature',
  [tokens.tariffClassification.pickCandidate]: 'Pick the code, it applies to the {{count}} items',
  [tokens.tariffClassification.pickCandidate_one]: 'Pick the item’s code',
  [tokens.tariffClassification.help]: 'How it works',
  [tokens.tariffClassification.tourTitle]: 'Discover Tarifill',
  [tokens.tariffClassification.openTarifill]: 'Tariff classification for the file: Tarifill flags incomplete or unknown commodity codes, suggests nomenclature branches and keeps track of every correction.',
  [tokens.tariffClassification.groupArticles]: '{{count}} items',
  [tokens.tariffClassification.groupArticles_one]: '1 item',
  [tokens.tariffClassification.noCode]: 'No code',
  [tokens.tariffClassification.searchInDirectory]: 'Search the directory',
  [tokens.tariffClassification.directoryPlaceholder]: 'Any code or keyword',
  [tokens.tariffClassification.directoryScopeAll]: 'The whole nomenclature',
  [tokens.tariffClassification.directoryExtend]: 'Also search the other chapters',
  [tokens.tariffClassification.directoryNoResult]: 'No code matches.',
  [tokens.tariffClassification.directoryResults]: '{{count}} results',
  [tokens.tariffClassification.directoryResults_one]: '1 result',
  [tokens.tariffClassification.determinedDerived]: 'Inferred',
  [tokens.tariffClassification.determinedMasterData]: 'Master data',
  [tokens.tariffClassification.determinedDefault]: 'Rule',
  [tokens.tariffClassification.determinationTitle]: 'Determined by Nabu',
  [tokens.tariffClassification.determinationDerived]: 'This code is not printed as such on the documents: Nabu inferred it.',
  [tokens.tariffClassification.determinationMasterData]: 'Taken from the client master data {{name}}.',
  [tokens.tariffClassification.determinationMasterDataUnnamed]: 'Taken from the client master data.',
  [tokens.tariffClassification.determinationDefault]: 'Set by a rule, as the documents carry no code.',
  [tokens.tariffClassification.stateReady]: 'Ready',
  [tokens.tariffClassification.statePartial]: 'To complete',
  [tokens.tariffClassification.stateUnknown]: 'Not found',
  [tokens.tariffClassification.filterAll]: 'All',
  [tokens.tariffClassification.filterPartial]: 'To complete',
  [tokens.tariffClassification.filterReady]: 'Ready',
  [tokens.tariffClassification.filterUnknown]: 'Not found',
  [tokens.tariffClassification.readyArticles]: 'articles ready',
  [tokens.tariffClassification.readyArticles_one]: 'article ready',
  [tokens.tariffClassification.listSearchPlaceholder]: 'Article, code or description',
  [tokens.tariffClassification.listEmpty]: 'No article matches.',
  [tokens.tariffClassification.articleNumber]: 'Article {{index}}',
  [tokens.tariffClassification.articleShort]: 'no. {{index}}',
  [tokens.tariffClassification.receivedCode]: 'Received code',
  [tokens.tariffClassification.noCodeShort]: 'none',
  [tokens.tariffClassification.originShort]: 'origin {{origin}}',
  [tokens.tariffClassification.partialIntro]: '{{prefix}} exists. The last level is missing: {{count}} possible continuations.',
  [tokens.tariffClassification.partialIntro_one]: '{{prefix}} exists. The last level is missing: only one continuation is possible.',
  [tokens.tariffClassification.partialPrefixOf]: '{{prefix}} (received code {{received}})',
  [tokens.tariffClassification.unknownIntro]: 'No level of {{code}} exists in the nomenclature. Look for the right code in the directory.',
  [tokens.tariffClassification.missingIntro]: 'This article has no code. Look for it in the directory.',
  [tokens.tariffClassification.nextLevels]: '{{count}} continuations',
  [tokens.tariffClassification.nextLevels_one]: '1 continuation',
  [tokens.tariffClassification.costAfterComplete]: 'The estimated cost and the measures show once the code is complete.',
  [tokens.tariffClassification.openDirectoryFor]: 'View in the directory',
  [tokens.tariffClassification.openDetail]: 'Article sheet',
  [tokens.tariffClassification.openTreeHere]: 'open the tree here',
  [tokens.tariffClassification.backToArticles]: 'Articles',
  [tokens.tariffClassification.pathTitle]: 'Path in the nomenclature',
  [tokens.tariffClassification.costTitle]: 'Estimated import cost',
  [tokens.tariffClassification.costNormal]: 'Standard rate',
  [tokens.tariffClassification.costPreference]: 'Preference {{origin}}',
  [tokens.tariffClassification.costSituation]: 'Customs situation',
  [tokens.tariffClassification.costOrigin]: 'Country of origin',
  [tokens.tariffClassification.costTerritory]: 'Territory',
  [tokens.tariffClassification.costTerritoryValue]: 'Mainland France (CONTI)',
  [tokens.tariffClassification.costPreferentialOrigin]: 'Preferential origin',
  [tokens.tariffClassification.costNomenclature]: 'Clearance nomenclature',
  [tokens.tariffClassification.costAdditionalCodes]: 'Additional codes',
  [tokens.tariffClassification.costValueData]: 'Value data',
  [tokens.tariffClassification.costInvoiced]: 'Invoiced value',
  [tokens.tariffClassification.costCustomsValue]: 'Customs value',
  [tokens.tariffClassification.costVatValue]: 'VAT value',
  [tokens.tariffClassification.costCif]: 'CIF basis',
  [tokens.tariffClassification.costCifNo]: 'No, freight not apportioned',
  [tokens.tariffClassification.costNetMass]: 'Net mass',
  [tokens.tariffClassification.costColCode]: 'Code',
  [tokens.tariffClassification.costColTax]: 'Pre-calculated taxation',
  [tokens.tariffClassification.costColRate]: 'Rate',
  [tokens.tariffClassification.costColAmount]: 'Amount',
  [tokens.tariffClassification.costDuty]: 'Customs duties',
  [tokens.tariffClassification.costDutyThirdCountry]: 'TARIC · third country',
  [tokens.tariffClassification.costDutyPreference]: 'TARIC · preference {{agreement}}',
  [tokens.tariffClassification.costVat]: 'Import VAT',
  [tokens.tariffClassification.costVatBasis]: 'RITA · on the VAT value',
  [tokens.tariffClassification.costTotal]: 'Estimated cost',
  [tokens.tariffClassification.costNoValue]: 'Amounts not computed: the customs value is unknown (currency without exchange rate or missing amount).',
  [tokens.tariffClassification.costRatesAt]: 'rates in force on {{date}}',
  [tokens.tariffClassification.costCompareRita]: 'Compare on RITA',
  [tokens.tariffClassification.measuresSectionTitle]: 'Measures and documents',
  [tokens.tariffClassification.measuresCount]: '{{count}} measures',
  [tokens.tariffClassification.measuresCount_one]: '1 measure',
  [tokens.tariffClassification.documentsCount]: '{{count}} documents',
  [tokens.tariffClassification.documentsCount_one]: '1 document',
  [tokens.tariffClassification.measureSourceTaric]: 'TARIC',
  [tokens.tariffClassification.measureSourceRita]: 'France · RITA',
  [tokens.tariffClassification.measureNationalCode]: 'National additional code to choose',
  [tokens.tariffClassification.measureVat]: 'Import VAT',
  [tokens.tariffClassification.documentToProvide]: 'Document to provide:',
  [tokens.tariffClassification.documentRequired]: '{{document}}.',
  [tokens.tariffClassification.proofOptional]: '{{document}}, only if the preference is claimed.',
  [tokens.tariffClassification.proofRequired]: '{{document}}. Required: the preference is claimed.',
  [tokens.tariffClassification.directoryFor]: 'For',
  [tokens.tariffClassification.directoryScopeOurs]: 'Our articles · {{count}}',
  [tokens.tariffClassification.directoryOursPlaceholder]: 'Article, code or label in the file',
  [tokens.tariffClassification.directoryOursEmpty]: 'No article in the file matches.',
  [tokens.tariffClassification.directoryChooseArticle]: 'Choose an article…',
  [tokens.tariffClassification.inDossier]: 'In the file',
  [tokens.tariffClassification.dossierArticles]: 'Articles in the file',
  [tokens.tariffClassification.viewInTree]: 'View in the tree',
  [tokens.tariffClassification.completeInTree]: 'Complete in the tree',
  [tokens.tariffClassification.usedByArticles]: 'Used by {{count}} articles in the file',
  [tokens.tariffClassification.usedByArticles_one]: 'Used by 1 article in the file',
  [tokens.tariffClassification.chapterCode]: 'Chapter {{chapter}}',
  [tokens.tariffClassification.treeSearched]: 'Searched nomenclature:',
  [tokens.tariffClassification.treeNone]: 'none',
  [tokens.tariffClassification.tourStepCardApplyTitle]: 'Apply',
  [tokens.tariffClassification.tourStepCardApplyBody]: 'The chosen code goes into the article’s cell, as one step in the history. “Undo” restores the previous code.',
  [tokens.tariffClassification.tourStepCardCostTitle]: 'Cost and measures',
  [tokens.tariffClassification.tourStepCardCostBody]: 'A complete code shows the estimated import cost (duties and VAT, with or without preference) and the measures and documents it triggers. Never a fake figure: what cannot be computed stays as x xxx,xx €.',
  [tokens.tariffClassification.tourStepCardOptionsTitle]: 'Choose the continuation',
  [tokens.tariffClassification.tourStepCardOptionsBody]: 'Each continuation with its official label. “Residual branch” marks “other”, pre-selected in low-risk chapters. The flags open the code on TARIC (EU measures) or RITA (French measures).',
  [tokens.tariffClassification.tourStepCardPathTitle]: 'The recognised levels',
  [tokens.tariffClassification.tourStepCardPathBody]: 'Each ticked level exists in the nomenclature; a click opens the directory at that level. The orange chip counts the possible continuations. The book opens the directory for the article, the i its sheet.',
  [tokens.tariffClassification.tourStepDetailBrowseTitle]: 'An article’s sheet',
  [tokens.tariffClassification.tourStepDetailBrowseBody]: 'One page per article. The ↑ ↓ arrows, or the keyboard’s, move to the neighbouring article without going back to the list; the grid follows. “Articles” returns to the list.',
  [tokens.tariffClassification.tourStepDetailCodeTitle]: 'The code, large',
  [tokens.tariffClassification.tourStepDetailCodeBody]: 'The declared code, its state, where it comes from (derived, master data, rule) and the received code if it changed.',
  [tokens.tariffClassification.tourStepDetailPathTitle]: 'The full path',
  [tokens.tariffClassification.tourStepDetailPathBody]: 'From chapter to code, each level with its label. A click opens the directory at that level.',
  [tokens.tariffClassification.tourStepDirectoryButtonTitle]: 'The directory',
  [tokens.tariffClassification.tourStepDirectoryButtonBody]: 'This button opens the directory for the whole file; from a card or a sheet, it opens for the article.',
  [tokens.tariffClassification.tourStepSummaryTitle]: 'Where the file stands',
  [tokens.tariffClassification.tourStepSummaryBody]: 'How many articles are ready, and a bar: one mark per article, green when ready, orange when to complete, red when not found.',
  [tokens.declarationKeyboard.shortcutSourceDocument]: 'Source document (fullscreen)',
  [tokens.declarationKeyboard.shortcutDauRecap]: 'SAD recap',
  [tokens.declarationKeyboard.shortcutShowHints]: 'Open / close shortcuts',
  [tokens.declarationKeyboard.hintsDialogTitle]: 'Keyboard shortcuts',
  [tokens.declarationKeyboard.panelSubtitle]: 'Closes on next click or with Esc',
  [tokens.declarationKeyboard.panelSearchPlaceholder]: 'Search shortcuts',
  [tokens.declarationKeyboard.panelSearchEmpty]: 'No shortcut for “{{query}}”',
  [tokens.declarationKeyboard.panelContextBadge]: 'Current context',
  [tokens.declarationKeyboard.panelClose]: 'Close (Esc)',
  [tokens.declarationKeyboard.panelFooterToggle]: '<key/> open / close',
  [tokens.declarationKeyboard.shortcutStepNavigation]: 'Previous / next tab',
  [tokens.declarationKeyboard.shortcutFocusSearch]: 'Search for a field',
  [tokens.declarationKeyboard.shortcutOpenSettings]: 'Settings',
  [tokens.declarationKeyboard.shortcutCopyNabuNumber]: 'Copy the Nabu number',
  [tokens.declarationKeyboard.shortcutOpenHistory]: 'Declaration history',
  [tokens.declarationKeyboard.shortcutMoveCell]: 'Neighbouring cell',
  [tokens.declarationKeyboard.shortcutEditCell]: 'Edit the cell',
  [tokens.declarationKeyboard.shortcutLeaveCell]: 'Leave the cell',
  [tokens.declarationKeyboard.keyEnter]: 'Enter',
  [tokens.declarationKeyboard.keyEscape]: 'Esc',
  [tokens.declarationKeyboard.keySpace]: 'Space',
  [tokens.declarationKeyboard.shortcutToggleArticleGrid]: 'Turn table navigation on or off',
  [tokens.declarationKeyboard.shortcutOpenTarifill]: 'Open or close Tarifill',
  [tokens.declarationKeyboard.categoryNavigate]: 'Move around · {{command}} + key',
  [tokens.declarationKeyboard.categoryOpen]: 'Open and act · {{commandShift}} + initial',
  [tokens.declarationKeyboard.categoryEdit]: 'Edit',
  [tokens.declarationKeyboard.categoryAssistant]: 'Nabu Assistant',
  [tokens.declarationKeyboard.categoryGrid]: 'In the table',
  [tokens.declarationKeyboard.categoryDocument]: 'In the source document',
  [tokens.declarationKeyboard.shortcutSourceDocumentSwitch]: 'Previous or next document',
  [tokens.declarationKeyboard.shortcutSourceDocumentPage]: 'Previous or next page',
  [tokens.declarationKeyboard.shortcutSourceDocumentZoom]: 'Zoom in or out',
  [tokens.declarationKeyboard.shortcutSourceDocumentResetZoom]: 'Back to 100%',
  [tokens.declarationKeyboard.shortcutSourceDocumentRotate]: 'Rotate the page right or left',
  [tokens.declarationKeyboard.shortcutSourceDocumentSearch]: 'Search the document',
  [tokens.declarationKeyboard.shortcutSourceDocumentPan]: 'Hold and drag to move around',
  [tokens.declarationKeyboard.copyNabuNumberTooltip]: 'Copy the Nabu number',

  [tokens.declarationUi.saving]: 'Saving…',
  [tokens.declarationUi.stateGenerated]: 'To prepare',
  [tokens.declarationUi.stateInReview]: 'In correction',
  [tokens.declarationUi.stateReady]: 'Validated, waiting for the other declarations to be sent',
  [tokens.declarationUi.stateSent]: 'Submitted',
  [tokens.declarationUi.stateAccepted]: 'Accepted',
  [tokens.declarationUi.stateRejected]: 'Rejected',
  [tokens.declarationUi.stateSuperseded]: 'Superseded',
  [tokens.declarationUi.fieldRequiredError]: 'Required field is empty',
  [tokens.declarationUi.catalogLoading]: 'Loading…',
  [tokens.declarationUi.fieldMaxLengthError]:
    '{{max}} characters maximum, {{count}} entered',
  [tokens.declarationUi.fieldRejected]: '“{{value}}” not saved: {{reason}}',
  [tokens.declarationUi.sourceManualTooltip]:
    'Entered manually by an operator on this screen.',
  [tokens.declarationUi.sourceRoutineTooltip]:
    'Written by the “{{routine}}” routine, instruction “{{instruction}}”.',
  [tokens.declarationUi.sourceComputed]: 'Calculated',
  [tokens.declarationUi.sourceDerived]: 'Derived',
  [tokens.declarationUi.sourceMasterData]: 'Client master data',
  [tokens.declarationUi.sourceDefault]: 'Default value',
  [tokens.declarationUi.sourceManual]: 'Entered',
  [tokens.declarationUi.sourceConsolidated]: 'Consolidated',
  [tokens.declarationUi.sourceRemote]: 'Customs response',
  [tokens.declarationUi.sourceSetting]: 'Setting',
  [tokens.declarationUi.sourceSettingFlux]: 'Model setting “{{name}}”',
  [tokens.declarationUi.sourceSettingFluxUnnamed]: 'Model setting',
  [tokens.declarationUi.sourceSettingGroup]: 'Agency setting',
  [tokens.declarationUi.sourceSettingUser]: 'User setting',
  [tokens.declarationUi.sourcePieceSaid]: 'The document said “{{value}}”',
  [tokens.declarationUi.evidenceExtracted]: 'Read value',

  [tokens.declarationUi.title]: 'Declaration',
  [tokens.declarationUi.loading]: 'Loading declaration…',
  [tokens.declarationUi.notFound]: 'This file has no agentic declaration.',
  [tokens.declarationUi.error]: 'The declaration could not be loaded.',
  [tokens.declarationUi.interfaceClassic]: 'Documents on the left',
  [tokens.declarationUi.interfaceSections]: 'Sections',
  [tokens.declarationUi.showDocument]: 'Show document',
  [tokens.declarationUi.showOrigin]: 'Show the source',
  [tokens.declarationUi.hideDocument]: 'Hide document',
  [tokens.declarationUi.validate]: 'Validate declaration',
  [tokens.declarationUi.validateAndSend]: 'Validate and send',
  [tokens.declarationUi.validated]: 'Declaration validated',
  [tokens.declarationUi.blockedHint]: 'Fix blocking issues to validate',
  [tokens.declarationUi.progressRequired]: 'required fields',
  [tokens.declarationUi.sectionCountRequired]:
    '{{filled}} of {{total}} required fields in this section',
  [tokens.declarationUi.sectionCountRequired_one]:
    '{{filled}} of {{total}} required field in this section',
  [tokens.declarationUi.sectionCountOptional]:
    ' · {{optional}} optional fields empty, which do not block validation',
  [tokens.declarationUi.sectionCountOptional_one]:
    ' · {{optional}} optional field empty, which does not block validation',
  [tokens.declarationUi.progressFilled]: 'filled',
  [tokens.declarationUi.anomalies]: 'Points to review',
  [tokens.declarationUi.severityBlocking]: 'Blocking',
  [tokens.declarationUi.severityInfo]: 'Info',
  [tokens.declarationUi.seeDetail]: 'View details',
  [tokens.declarationUi.hideDetail]: 'Hide',
  [tokens.declarationUi.seeInfos]: 'Show info items',
  [tokens.declarationUi.hideInfos]: 'Hide info items',
  [tokens.declarationUi.linesConcerned]: 'Lines affected',
  [tokens.declarationUi.totalMismatchTitle]:
    'The document total and the sum of the lines don’t match',
  [tokens.declarationUi.totalMismatchTitleReference]:
    'The selected total and the sum of the lines don’t match',
  [tokens.declarationUi.totalMismatchValues]:
    'Document: {{reference}} · Sum of lines ({{count}}): {{lines}} · Difference: {{gap}}',
  [tokens.declarationUi.totalMismatchValuesReference]:
    'Selected total: {{reference}} · Sum of lines ({{count}}): {{lines}} · Difference: {{gap}}',
  [tokens.declarationUi.totalLinesMissingTitle]:
    'The document states a total, but no line has a value',
  [tokens.declarationUi.totalLinesMissingValues]:
    'Document: {{reference}} · Lines filled in: 0 of {{count}}',
  [tokens.declarationUi.totalNoticeHint]:
    'For information only: sending is not blocked. Check the item values or the document total.',
  [tokens.declarationUi.lineCount]: 'Number of lines',
  [tokens.declarationUi.goToLine]: 'Go to line',
  [tokens.declarationUi.completion]: 'Completion · required fields',
  [tokens.declarationUi.searchField]: 'Search for a field',
  [tokens.declarationUi.onlyBlocking]: 'Missing required fields',
  [tokens.declarationUi.expandAll]: 'Expand sections to complete',
  [tokens.declarationUi.nothingToExpand]: 'No section to complete',
  [tokens.declarationUi.collapseAll]: 'Collapse all sections',
  [tokens.declarationUi.expandRubrique]: 'Expand section',
  [tokens.declarationUi.collapseRubrique]: 'Collapse section',
  [tokens.declarationUi.mailThread]: 'Email thread',
  [tokens.declarationUi.emailSource]: 'Source email',
  [tokens.declarationUi.collapseRail]: 'Collapse panel',
  [tokens.declarationUi.expandRail]: 'Expand panel',
  [tokens.declarationUi.noMatch]: 'No matching data.',
  [tokens.declarationUi.noFieldsInStep]: 'No fields in this step.',
  [tokens.declarationUi.fieldSearchRecent]: 'Recent searches',
  [tokens.declarationUi.fieldSearchToComplete]: 'To complete',
  [tokens.declarationUi.fieldSearchToCompleteHint]: 'Show only empty required fields and fields with errors',
  [tokens.declarationUi.fieldSearchMissing]: 'Missing',
  [tokens.declarationUi.fieldSearchInError]: 'Error',
  [tokens.declarationUi.fieldSearchSynonymsProcedure]: 'regime procedure customs procedure code CPC 4000 4200 1000 1040',
  [tokens.declarationUi.fieldSearchSynonymsIncoterm]: 'incoterm delivery terms EXW FCA FAS FOB CFR CIF CPT CIP DAP DPU DDP',
  [tokens.declarationUi.fieldSearchSynonymsCustomsOffice]: 'customs office office of exit office of export',
  [tokens.declarationUi.fieldSearchSynonymsIdentification]: 'EORI identification number VAT ID',
  [tokens.declarationUi.fieldSearchSynonymsSupportingDocument]: 'supporting document certificate licence invoice N380 N935 N325 EUR.1',
  [tokens.declarationUi.fieldSearchSynonymsPreviousDocument]: 'previous document',
  [tokens.declarationUi.fieldSearchSynonymsContainer]: 'container equipment',
  [tokens.declarationUi.fieldSearchSynonymsTransport]: 'transport means mode of transport vessel truck aircraft flight registration',
  [tokens.declarationUi.fieldSearchSynonymsLocationOfGoods]: 'location of goods goods location',
  [tokens.declarationUi.fieldSearchSynonymsConsignee]: 'consignee recipient',
  [tokens.declarationUi.fieldSearchSynonymsExporter]: 'exporter shipper',
  [tokens.declarationUi.fieldSearchSynonymsImporter]: 'importer',
  [tokens.declarationUi.fieldSearchSynonymsRepresentative]: 'representative agent customs broker',
  [tokens.declarationUi.fieldSearchSynonymsDeclarant]: 'declarant',
  [tokens.declarationUi.fieldSearchSynonymsReference]: 'reference LRN UCR local reference number',
  [tokens.declarationUi.fieldSearchSynonymsDeclarationType]: 'declaration type',
  [tokens.declarationUi.fieldSearchSynonymsOrigin]: 'origin country of origin',
  [tokens.declarationUi.keyboardNext]: 'next field',
  [tokens.declarationUi.keyboardCommit]: 'confirm',
  [tokens.declarationUi.fields]: 'Fields',
  [tokens.declarationUi.add]: 'Add',
  [tokens.declarationUi.remove]: 'Remove',
  [tokens.declarationUi.noOccurrence]: 'No occurrence',
  [tokens.declarationUi.sourceDocument]: 'Source document',
  [tokens.declarationUi.control]: 'Checks & validation',
  [tokens.declarationUi.notOnDocument]: 'no printed total found · comparison unavailable',
  [tokens.declarationUi.notIdentified]: 'not identified',
  [tokens.declarationUi.clear]: 'Clear',
  [tokens.declarationUi.howObtained]: 'How this value was obtained',
  [tokens.declarationUi.noAnomaly]: 'No issues: the declaration is ready.',
  [tokens.declarationUi.fix]: 'Fix this issue',
  [tokens.declarationUi.guidedReview]: 'Guided review',
  [tokens.declarationUi.locate]: 'Locate',
  [tokens.declarationUi.previous]: 'Previous',
  [tokens.declarationUi.next]: 'Next',
  [tokens.declarationUi.close]: 'Close',
  [tokens.declarationUi.totals]: 'Totals',
  [tokens.declarationUi.documentTotal]: 'Document total',
  [tokens.declarationUi.linesTotal]: 'Sum of lines',
  [tokens.declarationUi.verdictEqual]: 'Match',
  [tokens.declarationUi.verdictDiffers]: 'Difference',
  [tokens.declarationUi.verdictMissing]: 'No total on documents',
  [tokens.declarationUi.verdictLinesMissing]: 'Lines not filled',
  [tokens.declarationUi.totalEmpty]: 'No line carries this quantity, and no document prints it',
  [tokens.declarationUi.referenceManual]: 'Entered',
  [tokens.declarationUi.referenceLines]: 'Sum of lines kept',
  [tokens.declarationUi.referenceReading]: 'Kept',
  [tokens.declarationUi.alsoReadOn]: 'also read on',
  [tokens.declarationUi.enterTotal]: 'Enter the total',
  [tokens.declarationUi.editTotal]: 'Edit the total',
  [tokens.declarationUi.enterPlaceholder]: 'Enter',
  [tokens.declarationUi.readOn]: 'Read on',
  [tokens.declarationUi.computedSum]: 'Sum of the totals of {{count}} documents',
  [tokens.declarationUi.readShort]: 'read',
  [tokens.declarationUi.pageShort]: 'p. {{page}}',
  [tokens.declarationUi.notDeclared]: 'not declared',
  [tokens.declarationUi.verdictGap]: 'Gap of {{value}}',
  [tokens.declarationUi.offerKeepLines]: 'Keep the sum of lines ({{value}})',
  [tokens.declarationUi.offerKeepReading]: 'Keep {{value}} ({{piece}})',
  [tokens.declarationUi.offerClearReference]: 'Back to the read total',
  [tokens.declarationUi.distributeTotal]: 'Distribute over items',
  [tokens.declarationUi.distributeTitle]: 'Distribute the total over items',
  [tokens.declarationUi.distributeSummary]: 'Distribute {{amount}} over {{count}} items.',
  [tokens.declarationUi.distributeSummary_one]: 'Distribute {{amount}} over {{count}} item.',
  [tokens.declarationUi.distributeEvenly]: 'In equal shares',
  [tokens.declarationUi.distributeProrata]: 'In proportion to',
  [tokens.declarationUi.distributePackages]: '{{amount}} on the first item, the other items are set to 0: no document prints its share of the packages.',
  [tokens.declarationUi.distributePackagesPerDocument]: 'Each document on its first item',
  [tokens.declarationUi.distributePackagesPerDocumentHint]: 'Each document’s share, 0 on its other items',
  [tokens.declarationUi.distributePackagesFirstLine]: 'All on the first item',
  [tokens.declarationUi.distributePackagesFirstLineHint]: '{{amount}} on the first item, 0 on the others',
  [tokens.declarationUi.distributeOverwrite]: 'The {{count}} existing values will be replaced.',
  [tokens.declarationUi.distributeOverwrite_one]: 'The existing value will be replaced.',
  [tokens.declarationUi.distributeConfirm]: 'Distribute',
  [tokens.declarationUi.distributeInvoice]: 'Distribute over this document',
  [tokens.declarationUi.distributeInvoiceUndo]: 'Undo the distribution over this document',
  [tokens.declarationUi.distributeMenuTitle]:
    'Distribute {{amount}} over the {{count}} items of {{invoice}}',
  [tokens.declarationUi.distributeMenuTitle_one]:
    'Distribute {{amount}} over the item of {{invoice}}',
  [tokens.declarationUi.distributeEqualOption]: 'In equal shares',
  [tokens.declarationUi.distributeEqualHint]: 'The same share for each item',
  [tokens.declarationUi.distributeProrataOption]: 'Pro rata: {{label}}',
  [tokens.declarationUi.distributeProrataHint]: 'According to each item’s value in this column',
  [tokens.declarationUi.distributeFirstLineOption]: 'All on the first item',
  [tokens.declarationUi.distributeFirstLineHint]: 'The invoice’s other items are set to 0',
  [tokens.declarationUi.revertConfirmText]: 'Undoing “{{title}}” also undoes:',
  [tokens.declarationUi.revertConfirmTextGeneric]: 'Undoing this action also undoes:',
  [tokens.declarationUi.revertDialogTitleGeneric]: 'Undo an action',
  [tokens.declarationUi.revertKeep]: 'Keep',
  [tokens.declarationUi.revertConfirm]: 'Undo the {{count}} actions',
  [tokens.declarationUi.undoLast]: 'Undo',
  [tokens.declarationUi.redoLast]: 'Redo',
  [tokens.declarationUi.sourceDistributed]: 'Distributed',
  [tokens.declarationUi.articlesFilled]: '{{filled}}/{{total}} items filled',
  [tokens.declarationUi.articles]: 'Items',
  [tokens.declarationUi.columns]: 'Columns',
  [tokens.declarationUi.allColumns]: 'All columns',
  [tokens.declarationUi.usefulColumns]: 'Filled columns',
  [tokens.declarationUi.addLine]: 'Add line item',
  [tokens.declarationUi.addColumn]: 'Add a column',
  [tokens.declarationUi.addColumnSpecific]: 'Add a specific column',
  [tokens.declarationUi.searchArticles]: 'Search items',
  [tokens.declarationUi.ocrPasteHint]: '{{count}} values copied. Click a cell in the table.',
  [tokens.declarationUi.ocrPasteSame]: 'All in this cell',
  [tokens.declarationUi.ocrPasteDown]: 'One value per cell, downward',
  [tokens.declarationUi.ocrPasteRight]: 'One value per cell, to the right',
  [tokens.declarationUi.ocrPasteDismiss]: 'Close',
  [tokens.declarationUi.ocrPasteTruncated]: '{{count}} values did not fit in a cell.',
  [tokens.declarationUi.noLineMatch]: 'No item matches the search.',
  [tokens.declarationUi.linesGroupCount]: '{{count}} items',
  [tokens.declarationUi.linesGroupCount_one]: '{{count}} item',
  [tokens.declarationUi.linesGroupOther]: 'Other items',
  [tokens.declarationUi.linesGroupUnknownPiece]: 'Unknown document',
  [tokens.declarationUi.linesGroupCollapse]: 'Collapse invoice',
  [tokens.declarationUi.linesGroupExpand]: 'Expand invoice',
  [tokens.declarationUi.linesGroupCollapsePiece]: 'Collapse document',
  [tokens.declarationUi.linesGroupExpandPiece]: 'Expand document',
  [tokens.declarationUi.linesGroupsToolbar]: 'Invoices',
  [tokens.declarationUi.linesGroupsToolbarPieces]: 'Documents',
  [tokens.declarationUi.linesGroupsCollapseAll]: 'Collapse all',
  [tokens.declarationUi.linesGroupsExpandAll]: 'Expand all',
  [tokens.declarationUi.invoiceTotalsTitle]: 'Totals by invoice',
  [tokens.declarationUi.invoiceTotalsTitlePieces]: 'Totals by document',
  [tokens.declarationUi.invoiceTotalsLines]: 'Sum of article lines: {{value}}',
  [tokens.declarationUi.invoiceTotalsNotPrinted]: 'Sum of article lines, no figure of its own',
  [tokens.declarationUi.filterColumns]: 'Filter {{count}} columns…',
  [tokens.declarationUi.columnTypeText]: 'Text',
  [tokens.declarationUi.columnTypeNumber]: 'Number',
  [tokens.declarationUi.columnTypeInteger]: 'Integer',
  [tokens.declarationUi.columnTypeDate]: 'Date',
  [tokens.declarationUi.columnTypeDateTime]: 'Date/time',
  [tokens.declarationUi.columnTypeBoolean]: 'Boolean',
  [tokens.declarationUi.columnTypeCode]: 'Code',
  [tokens.declarationUi.noColumnMatch]: 'No matching column',
  [tokens.declarationUi.removeColumn]: 'Remove column',
  [tokens.declarationUi.setColumn]: 'Apply a value to the whole column',
  [tokens.declarationUi.setColumnTitle]: '“{{label}}” on all {{count}} items',
  [tokens.declarationUi.setColumnTitle_one]: '“{{label}}” on the item',
  [tokens.declarationUi.setColumnReplaces]: '{{count}} existing values will be replaced',
  [tokens.declarationUi.setColumnReplaces_one]: '1 existing value will be replaced',
  [tokens.declarationUi.setColumnApply]: 'Apply',
  [tokens.declarationUi.reorderColumn]: 'Reorder column',
  [tokens.declarationUi.pinColumn]: 'Freeze column',
  [tokens.declarationUi.unpinColumn]: 'Unfreeze column',
  [tokens.declarationUi.noLines]: 'No item lines.',
  [tokens.declarationUi.documents]: 'Documents',
  [tokens.declarationUi.piecePages]: 'p. {{range}}',
  [tokens.declarationUi.pieceSheet]: 'sheet {{index}}',
  [tokens.declarationUi.pieceFilePages]: '{{count}} p.',
  [tokens.declarationUi.pieceFileSheets]: '{{count}} sheets',
  [tokens.declarationUi.pieceDated]: 'dated {{date}}',
  [tokens.declarationUi.pieceNumberNotRead]: 'No. not read',
  [tokens.declarationUi.pieceNotUsed]: 'Not used in the declaration',
  [tokens.declarationUi.pieceEmail]: 'Email',
  [tokens.declarationUi.previousPiece]: 'Previous document',
  [tokens.declarationUi.nextPiece]: 'Next document',
  [tokens.declarationUi.pieceNavHint]: 'Previous / next document, in this order',
  [tokens.declarationUi.previousPage]: 'Previous page',
  [tokens.declarationUi.nextPage]: 'Next page',
  [tokens.declarationUi.scrollToTop]: 'Top of document',
  [tokens.declarationUi.scrollToBottom]: 'Bottom of document',
  [tokens.declarationUi.resizeForm]: 'Resize form',
  [tokens.declarationUi.zoomIn]: 'Zoom in',
  [tokens.declarationUi.zoomOut]: 'Zoom out',
  [tokens.declarationUi.resetZoom]: 'Actual size',
  [tokens.declarationUi.rotateLeft]: 'Rotate page left',
  [tokens.declarationUi.rotateRight]: 'Rotate page right',
  [tokens.declarationUi.fitPage]: 'Fit page',
  [tokens.declarationUi.showThumbnails]: 'Show thumbnails',
  [tokens.declarationUi.hideThumbnails]: 'Hide thumbnails',
  [tokens.declarationUi.searchInDocument]: 'Search the document',
  [tokens.declarationUi.searchPlaceholder]: 'Search this document…',
  [tokens.declarationUi.searchLoading]: 'Reading text…',
  [tokens.declarationUi.searchNoResult]: 'No results',
  [tokens.declarationUi.searchPrevious]: 'Previous result',
  [tokens.declarationUi.searchNext]: 'Next result',
  [tokens.declarationUi.searchClose]: 'Close search',
  [tokens.declarationUi.openOriginal]: 'Open original file',
  [tokens.declarationUi.noDocument]: 'No document.',
  [tokens.declarationUi.previewUnavailable]: 'Preview unavailable',
  [tokens.declarationUi.loadingPreview]: 'Loading…',
  [tokens.declarationUi.citation]: 'Citation',
  [tokens.declarationUi.origin]: 'Source',
  [tokens.declarationUi.openCalendar]: 'Open calendar',
  [tokens.declarationUi.empty]: 'Empty',
  [tokens.declarationUi.required]: 'Required',
  [tokens.declarationUi.outOfForm]: 'Read outside the form',
  [tokens.declarationUi.conflictReload]:
    'The declaration changed while you were editing. The screen was reloaded: continue your correction.',
  [tokens.declarationUi.rejected]: 'Correction rejected',
  [tokens.declarationUi.operationSum]: 'Sum',
  [tokens.declarationUi.operationProduct]: 'Product',
  [tokens.declarationUi.operationProrata]: 'Prorata',
  [tokens.declarationUi.operationRequalification]: 'Requalification',
  [tokens.declarationUi.computedFromReadings]:
    '{{operation}} of {{count}} reading(s): {{terms}}',
  [tokens.declarationUi.pageNumber]: 'page {{page}}',
  [tokens.declarationUi.prepareDeclarationTitle]: 'Control panel',
  [tokens.declarationUi.reviewIntro]: 'Fill in the missing fields, then check the discrepancies against the documents. Each correction is saved automatically.',
  [tokens.declarationUi.reviewUnblocked]: 'Blocking checks are cleared. Validation remains an explicit action.',
  [tokens.declarationUi.reviewGroupBlocking]: 'To complete',
  [tokens.declarationUi.reviewGroupToCheck]: 'To check',
  [tokens.declarationUi.reviewGroupInfo]: 'Information',
  [tokens.declarationUi.reviewGroupDecided]: 'Recorded decisions',
  [tokens.declarationUi.reviewIssueCount]: '{{count}} points',
  [tokens.declarationUi.reviewIssueCount_one]: '{{count}} point',
  [tokens.declarationUi.reviewLines]: 'Items: {{lines}}',
  [tokens.declarationUi.reviewComplete]: 'Complete ({{count}})',
  [tokens.declarationUi.reviewCheckValues]: 'Check values',
  [tokens.declarationUi.reviewShowReadings]: 'Show readings',
  [tokens.declarationUi.reviewHideReadings]: 'Collapse',
  [tokens.declarationUi.reviewPieceFallback]: 'Document {{index}}',
  [tokens.declarationUi.reviewPageUnavailable]: 'The exact page of the conflicting readings is not available. Check the documents in the file.',
  [tokens.declarationUi.reviewVerified]: 'Checked',
  [tokens.declarationUi.reviewReopen]: 'Reopen this point',
  [tokens.declarationUi.reviewTabToProcess]: 'To process',
  [tokens.declarationUi.labelValue]: '{{label}}: {{value}}',
  [tokens.declarationUi.quoted]: '“{{text}}”',
  [tokens.declarationUi.clearColumnTooltip]: 'Clear the “{{column}}” column on all {{count}} items',
  [tokens.declarationUi.clearColumnTooltip_one]: 'Clear the “{{column}}” column on the item',
  [tokens.declarationUi.clearColumn]: 'Clear column',
  [tokens.declarationUi.removeArticle]: 'Delete item',
  [tokens.declarationUi.manualCorrectionNote]: 'Original reading: {{value}} · value corrected manually',
  [tokens.declarationUi.totalsFamilyBilling]: 'Billing',
  [tokens.declarationUi.totalsFamilyPackaging]: 'Packaging',
  [tokens.declarationUi.addTuple]: 'Add',
  [tokens.declarationUi.removeTuple]: 'Remove',
  [tokens.declarationUi.prepareDeclarationButton]: 'Checks',
  [tokens.declarationUi.prepareWindowPin]: 'Pin to the page',
  [tokens.declarationUi.prepareWindowPinLeft]: 'Pin to the left',
  [tokens.declarationUi.prepareWindowPinRight]: 'Pin to the right',
  [tokens.declarationUi.prepareWindowUnpin]: 'Unpin',
  [tokens.declarationUi.pinPreferencesHint]:
    'Pin this window to work alongside it. To choose where it opens every time, set it in your preferences.',
  [tokens.declarationUi.pinPreferencesHintAction]: 'Open preferences',
  [tokens.declarationUi.pinPreferencesHintClose]: 'Close',
  [tokens.declarationUi.pinPreferencesHintDocked]:
    'Window pinned for this session. To have it open here every time, set it in your preferences.',
  [tokens.declarationUi.pinPreferencesHintDockedFromPreferences]:
    'This window opens here because of your preferences: change them at any time.',
  [tokens.declarationUi.prepareWindowClose]: 'Close',
  [tokens.declarationUi.prepareWindowResize]: 'Resize the panel',
  [tokens.declarationUi.consolidate]: 'Consolidate',
  [tokens.declarationUi.consolidateArticles]: 'Consolidate items',
  [tokens.declarationUi.unconsolidate]: 'Undo consolidation',
  [tokens.declarationUi.consolidationTitle]: 'Group items by',
  [tokens.declarationUi.confirm]: 'Confirm',
  [tokens.declarationUi.cancel]: 'Cancel',
  [tokens.declarationUi.linesTab]: 'Lines ({{count}})',
  [tokens.declarationUi.articlesTab]: 'Items ({{count}})',
  [tokens.declarationUi.showSourceLines]: 'Show the {{count}} source lines',
  [tokens.declarationUi.showConsolidatedArticles]: 'Show the {{count}} consolidated items',
  [tokens.declarationUi.mergedLines]: '{{count}} lines',
  [tokens.declarationUi.unkeyedLines]: '{{count}} lines stay on their own (missing key)',
  [tokens.declarationUi.unkeyedLines_one]: '{{count}} line stays on its own (missing key)',
  [tokens.declarationUi.sourceLinesTitle]: 'Lines {{numbers}}',
  [tokens.declarationUi.expandArticleLines]: 'Expand lines',
  [tokens.declarationUi.collapseArticleLines]: 'Collapse lines',
  [tokens.declarationUi.expandAllArticles]: 'Expand all',
  [tokens.declarationUi.collapseAllArticles]: 'Collapse all',
  [tokens.declarationUi.expandAllSourceLines]: 'Expand source lines',
  [tokens.declarationUi.collapseAllSourceLines]: 'Collapse source lines',
  [tokens.declarationUi.validatedDeliveryPending]: 'Declaration validated. It will be sent once every declaration of the file is validated.',
  [tokens.declarationUi.deliveryRunning]: 'Sending…',
  [tokens.declarationUi.deliverySucceeded]: 'Sent on {{date}}',
  [tokens.declarationUi.updatedAgo]: 'Edited {{relative}}',
  [tokens.declarationUi.updatedAtTooltip]: 'Last edited: {{date}}',
  [tokens.declarationUi.deliveryFailed]: 'Sending failed: {{reason}}',
  [tokens.declarationUi.deliveryEntry]: 'Submission {{index}}',
  [tokens.declarationUi.declarationsValidatedCount]: '{{validated}} / {{total}} validated',
  [tokens.declarationUi.sendRecapTitle]: 'Sending {{total}} declarations:',
  [tokens.declarationUi.commentsTitle]: 'Comments',
  [tokens.declarationUi.commentsButtonUnread]: 'Comments: {{count}} unread',
  [tokens.declarationUi.commentsEmptyTitle]: 'Start the conversation',
  [tokens.declarationUi.commentsEmptyHint]: 'Everyone working on this file sees these messages. Turn on Urgent to also alert the Nabu team.',
  [tokens.declarationUi.commentsPlaceholder]: 'Write to the team…',
  [tokens.declarationUi.commentsSend]: 'Send',
  [tokens.declarationUi.commentsSendUrgent]: 'Send as urgent',
  [tokens.declarationUi.commentsUrgentLabel]: 'Urgent',
  [tokens.declarationUi.commentsUrgentHint]: 'The Nabu team will be alerted immediately.',
  [tokens.declarationUi.commentsNewlineHint]: '⇧↵ new line',
  [tokens.declarationUi.commentsEditHint]: '↵ save · Esc cancel',
  [tokens.declarationUi.commentsUnknownAuthor]: 'Unknown user',
  [tokens.declarationUi.commentsEdited]: 'edited',
  [tokens.declarationUi.commentsEdit]: 'Edit',
  [tokens.declarationUi.commentsDelete]: 'Delete',
  [tokens.declarationUi.commentsDeleteConfirm]: 'Delete for everyone?',
  [tokens.declarationUi.commentsSave]: 'Save',
  [tokens.declarationUi.commentsCancel]: 'Cancel',
  [tokens.declarationUi.commentsError]: 'The comment couldn\'t be saved. Please try again.',
  [tokens.declarationUi.commentsSending]: 'Sending…',
  [tokens.declarationUi.commentsSendFailed]: 'Not sent.',
  [tokens.declarationUi.commentsRetry]: 'Retry',
  [tokens.declarationUi.commentsDiscard]: 'Discard',
  [tokens.declarationUi.commentsToday]: 'Today',
  [tokens.declarationUi.commentsYesterday]: 'Yesterday',
  [tokens.declarationUi.commentsNew]: 'New',
  [tokens.declarationUi.commentsClose]: 'Close',
  [tokens.declarationUi.dossierTabDetails]: 'File',
  [tokens.declarationUi.dossierProperties]: 'Properties',
  [tokens.declarationUi.dossierActions]: 'Actions',
  [tokens.declarationUi.dossierOwner]: 'Owner',
  [tokens.declarationUi.dossierOwnerError]: 'The owner couldn\'t be changed.',
  [tokens.declarationUi.dossierModel]: 'Model',
  [tokens.declarationUi.dossierType]: 'Type',
  [tokens.declarationUi.dossierClient]: 'Client',
  [tokens.declarationUi.dossierTags]: 'Tags',
  [tokens.declarationUi.dossierTagsError]: 'The tags couldn\'t be saved.',
  [tokens.declarationUi.dossierNoModel]: 'No model',
  [tokens.declarationUi.dossierModelChange]: 'Change model',
  [tokens.declarationUi.dossierModelRemove]: 'Remove model',
  [tokens.declarationUi.dossierModelApply]: 'Apply',
  [tokens.declarationUi.dossierModelKeepsCorrections]: 'Fields set by the model will be updated. Your corrections are kept; to go back, choose the previous model again.',
  [tokens.declarationUi.dossierModelApplied]: 'Model applied: {{changed}} field(s) updated, {{kept}} correction(s) kept.',
  [tokens.declarationUi.dossierModelError]: 'The model couldn\'t be applied.',
  [tokens.declarationUi.dossierTypeChange]: 'Change declaration type',
  [tokens.declarationUi.dossierTypeFromTo]: 'The type changes from {{from}} to {{to}}.',
  [tokens.declarationUi.dossierTypeWarning]: 'The declaration is regenerated without reading the documents again. Your corrections won\'t be carried over, and the model will be removed.',
  [tokens.declarationUi.dossierTypeApply]: 'Change and regenerate',
  [tokens.declarationUi.dossierTypeError]: 'The type couldn\'t be changed.',
  [tokens.declarationUi.dossierAddFile]: 'Add a file',
  [tokens.declarationUi.dossierAddFileHint]: 'A PDF, an image (PNG, JPEG) or a spreadsheet (XLSX, XLS, XLSM, CSV). Only this file is read: documents already read are not read again.',
  [tokens.declarationUi.dossierAddFileChoose]: 'Choose a file',
  [tokens.declarationUi.dossierAddFileUnsupported]: 'This file type isn\'t accepted. Archives and emails go through creating a folder.',
  [tokens.declarationUi.dossierAddFileWarning]: 'The declaration is regenerated with this file. Your corrections won\'t be carried over.',
  [tokens.declarationUi.dossierAddFileApply]: 'Add and regenerate',
  [tokens.declarationUi.dossierAddFileError]: 'The file couldn\'t be added.',
  [tokens.declarationUi.relaunchStarted]: 'Regeneration started.',
  [tokens.declarationUi.relaunchReading]: 'Reading in progress: the declaration is being regenerated. It stays read-only until then.',
  [tokens.declarationUi.reviseAction]: 'Revise the declaration',
  [tokens.declarationUi.reviseDialogTitle]: 'Revise the submitted declaration',
  [tokens.declarationUi.reviseDialogText]: 'The declaration becomes editable again. Once corrected, validating it will send the whole file again.',
  [tokens.declarationUi.reviseReasonLabel]: 'Reason (optional)',
  [tokens.declarationUi.reviseConfirm]: 'Reopen the declaration',
  [tokens.declarationUi.reviseError]: 'The declaration could not be reopened.',
  [tokens.declarationUi.revisionOpenBanner]: 'Revision in progress: this submitted declaration is editable again. Validating it will send the whole file again.',
  [tokens.declarationUi.dossierApplyAutomation]: 'Apply an automation',
  [tokens.declarationUi.automationTitle]: 'Apply an automation',
  [tokens.declarationUi.automationChoose]: 'Client master data',
  [tokens.declarationUi.automationPreview]: 'See the proposals',
  [tokens.declarationUi.automationArticle]: 'Item {{number}}',
  [tokens.declarationUi.automationOverwritesCorrection]: 'Correction overwritten',
  [tokens.declarationUi.automationIgnored]: '{{count}} proposal(s) outside the form ignored.',
  [tokens.declarationUi.automationRejected]: 'Refused: {{count}}',
  [tokens.declarationUi.automationNothing]: 'This automation has nothing to change on this declaration.',
  [tokens.declarationUi.automationApply]: 'Apply ({{count}})',
  [tokens.declarationUi.automationApplied]: 'Automation applied: {{count}} field(s) set.',
  [tokens.declarationUi.automationConflict]: 'The declaration changed in the meantime: run the preview again.',
  [tokens.declarationUi.automationRunError]: 'The automation couldn\'t be run.',
  [tokens.declarationUi.automationApplyError]: 'The automation couldn\'t be applied.',
  [tokens.declarationUi.automationNone]: 'No active automation for this file.',
  [tokens.declarationUi.commentsDetach]: 'Open comments in a window, next to the form',

  [tokens.declarationEvents.eventValidate]: 'Declaration validation',
  [tokens.declarationEvents.routineActor]:
    'Routine “{{routine}}”, instruction “{{instruction}}”',
  [tokens.declarationEvents.eventReviewIssue]: 'Review decision',
  [tokens.declarationEvents.eventAddTuple]: 'Add occurrence',
  [tokens.declarationEvents.eventRemoveTuple]: 'Remove occurrence',
  [tokens.declarationEvents.eventAddLine]: 'Add item line',
  [tokens.declarationEvents.eventRemoveLine]: 'Remove item line',
  [tokens.declarationEvents.eventModifyOccurrence]: 'Modify occurrence',
  [tokens.declarationEvents.eventClearColumn]: '{{label}} · entire column cleared',
  [tokens.declarationEvents.eventSetColumn]: '{{label}} · {{value}} on the entire column',
  [tokens.declarationEvents.eventClear]: '{{label}} · cleared',
  [tokens.declarationEvents.eventSetValue]: '{{label}}: {{value}}',
  [tokens.declarationEvents.reasonInvalidFormat]:
    'this value does not match the expected format (type, length or bounds)',
  [tokens.declarationEvents.reasonNotInCatalog]:
    'this value is not in the official list for this field',
  [tokens.declarationEvents.reasonStaleIssue]:
    'this item changed: discard this decision, then review the new values',
  [tokens.declarationEvents.reasonReasonRequired]: 'a justification is required',
  [tokens.declarationEvents.reasonLocked]: 'this field is locked',
  [tokens.declarationEvents.reasonUnknownPath]: 'this field is no longer part of the form',
  [tokens.declarationEvents.reasonMissingTuple]:
    'add an occurrence before filling this field',
  [tokens.declarationEvents.reasonFallback]:
    'this correction no longer matches the form; reload values before retrying',
  [tokens.declarationEvents.applyRejectedCorrections]:
    'Some corrections were rejected; the others are saved.',
  [tokens.declarationEvents.applyConflict]:
    'The declaration was changed elsewhere. Your corrections are kept. Review the new version before reapplying them.',
  [tokens.declarationEvents.applySaveRetryable]:
    'Could not save. Your corrections are kept on this screen.',
  [tokens.declarationEvents.applySaveNotRetryable]:
    'The server rejected this request. Retrying will not help. Report it; your values remain displayed.',
  [tokens.declarationEvents.applyServerReason]:
    'Reason given by the server: {{detail}}',
  [tokens.declarationEvents.applyInsufficientCredits]:
    'Not enough credits to validate this file: {{required}} required, {{balance}} available. Your corrections are saved; top up your credits, then retry.',
  [tokens.declarationEvents.applySubscriptionRequired]:
    'No active subscription: activate it to validate this file, then retry. Your corrections are saved.',
  [tokens.declarationEvents.applySessionExpired]:
    'Your session has expired: sign in again. The corrections listed below were not saved.',
  [tokens.declarationEvents.applyForbidden]:
    'You do not have access to this file: the server rejected the request.',
  [tokens.declarationEvents.applyNotFound]:
    'This declaration cannot be found: it may have been replaced. Reload the page.',
  [tokens.declarationEvents.applyContactAdmin]:
    'Contact an administrator of your organization to manage the subscription and credits.',
  [tokens.declarationEvents.rechargeCredits]:
    'Top up credits',
  [tokens.declarationEvents.openSubscription]:
    'View subscription',
  [tokens.declarationEvents.retryReapply]: 'Reapply',
  [tokens.declarationEvents.retry]: 'Retry',
  [tokens.declarationEvents.discardCorrections]: 'Discard these corrections',
  [tokens.declarationEvents.eventConsolidate]: 'Consolidated by {{keys}}',
  [tokens.declarationEvents.eventUnconsolidate]: 'Consolidation undone',
  [tokens.declarationEvents.reasonUnknownKey]: 'this column cannot be used for grouping',
  [tokens.declarationEvents.reasonRequiredKeyMissing]: 'a mandatory grouping key was unchecked',
  [tokens.declarationEvents.reasonNoKeys]: 'choose at least one grouping column',
  [tokens.declarationEvents.historyUnconsolidated]: 'Consolidation cancelled',
  [tokens.declarationEvents.reasonRejectedWithDetail]: 'value rejected: {{detail}}',
  [tokens.declarationEvents.eventSetTotalReferenceManual]: '{{total}} · reference entered: {{value}}',
  [tokens.declarationEvents.eventSetTotalReferenceLines]: '{{total}} · reference: sum of lines kept',
  [tokens.declarationEvents.eventSetTotalReferenceReading]: '{{total}} · reference: reading of {{documentId}} kept',
  [tokens.declarationEvents.eventClearTotalReference]: '{{total}} · reference cleared',
  [tokens.declarationEvents.reasonUnknownTotal]: 'this total does not exist in the reconciliation',
  [tokens.declarationEvents.reasonInvalidValue]: 'this value is not a valid number',
  [tokens.declarationEvents.reasonNoLines]: 'no line carries this figure',
  [tokens.declarationEvents.reasonUnknownReading]: 'this reading is no longer available',
  [tokens.declarationEvents.eventDistributeTotal]: '{{total}} · distributed over items',
  [tokens.declarationEvents.reasonWrongTotal]: 'this total cannot be distributed over items',
  [tokens.declarationEvents.reasonNoReference]: 'no total to distribute',
  [tokens.declarationEvents.reasonUnknownWeight]: 'the distribution key does not exist',
  [tokens.declarationEvents.reasonIncompleteWeights]: 'the distribution key is missing on items {{articles}}',
  [tokens.declarationEvents.gestureDistribute]: 'Distribution · {{total}}',
  [tokens.declarationEvents.gestureClearColumn]: 'Column cleared · {{label}}',
  [tokens.declarationEvents.gestureSetColumn]: 'Column filled · {{label}}',
  [tokens.declarationEvents.gestureApplySettings]: 'Model applied · {{count}} field(s)',
  [tokens.declarationEvents.gestureApplyAutomation]: 'Automation applied · {{count}} field(s)',
  [tokens.declarationEvents.gestureAddLines]: '{{count}} items added',
  [tokens.declarationEvents.gestureValue]: 'Value corrected · {{label}}',
  [tokens.declarationEvents.gestureValueCleared]: 'Value cleared · {{label}}',
  [tokens.declarationEvents.gestureValues]: '{{count}} values corrected',
  [tokens.declarationEvents.gestureTotalReference]: 'Total reference · {{total}}',
  [tokens.declarationEvents.gestureTotalReferenceCleared]: 'Back to the read total · {{total}}',
  [tokens.declarationEvents.gestureRevert]: 'Undo · {{title}}',
  [tokens.declarationEvents.gestureRevertMore]: ' (+{{count}} actions)',
  [tokens.declarationEvents.gestureRevertMore_one]: ' (+1 action)',
  [tokens.declarationEvents.gestureLine]: '{{label}} (line {{row}})',
  [tokens.declarationEvents.gestureGeneric]: 'Declaration changed',
  [tokens.declarationEvents.gestureUnvalidate]: 'Revision opened',
  [tokens.declarationEvents.gestureAbandonRevision]: 'Revision abandoned: back to the submitted version',
  [tokens.declarationEvents.eventRevert]: 'Undo of an action',
  [tokens.declarationEvents.reasonStaleRevert]: 'the history changed in the meantime: reopen it and try again',
  [tokens.declarationEvents.reasonBarrier]: 'a later action cannot be undone: it is no longer possible to go back before it',
  [tokens.declarationEvents.reasonAlreadyReverted]: 'this action has already been undone',
  [tokens.declarationEvents.reasonNotRevertible]: 'this action cannot be undone',
  [tokens.declarationEvents.reasonUnknownGesture]: 'this action no longer exists',
  [tokens.declarationEvents.reasonAmbiguousTuple]: 'several occurrences on items {{articles}}: which one holds the value?',
  [tokens.declarationEvents.reasonLockedArticles]: 'locked cell on items {{articles}}',
  [tokens.declarationEvents.reasonUnknownLine]: 'this line does not exist',
  [tokens.declarationEvents.reasonUnknownTuple]: 'this occurrence does not exist',
  [tokens.declarationEvents.reasonUnknownCategory]: 'this group does not exist',
  [tokens.declarationEvents.reasonWrongLevel]: 'this field is not at this level',
  [tokens.declarationEvents.reasonEmptyValue]: 'the value is empty',
  [tokens.declarationEvents.reasonUnknownEvent]: 'this correction is not recognized',
  [tokens.declarationEvents.assistantEventArticle]: '{{label}} (item {{row}})',
  [tokens.declarationEvents.assistantEventClear]: 'Clear {{label}}',
  [tokens.declarationEvents.assistantEventSetColumn]: 'Put {{value}} in the whole {{label}} column',
  [tokens.declarationEvents.assistantEventClearColumn]: 'Clear the whole {{label}} column',
  [tokens.declarationEvents.assistantEventCopyColumn]: 'Copy the {{from}} column into {{to}}',
  [tokens.declarationEvents.assistantEventWhere]:
    '{{action}}, {{scope}}',
  [tokens.declarationEvents.assistantEventSetColumnWhere]:
    'Put {{value}} in the {{label}} column, {{scope}}',
  [tokens.declarationEvents.assistantEventClearColumnWhere]:
    'Clear the {{label}} column, {{scope}}',
  [tokens.declarationEvents.assistantEventCopyColumnUnchanged]:
    'No {{from}}, left unchanged: items {{rows}}',
  [tokens.declarationEvents.assistantEventCopyColumnUnchanged_one]:
    'No {{from}}, left unchanged: item {{rows}}',
  [tokens.declarationEvents.assistantEventScopeEquals]:
    'on items where {{label}} = {{value}}',
  [tokens.declarationEvents.assistantEventScopeIn]:
    'on items where {{label}} is {{values}}',
  [tokens.declarationEvents.assistantEventScopeEmpty]:
    'on items where {{label}} is empty',
  [tokens.declarationEvents.assistantEventScopeFilled]:
    'on items where {{label}} is filled',
  [tokens.declarationEvents.assistantEventMapColumn]:
    'Replace in the {{to}} column: {{pairs}}',
  [tokens.declarationEvents.assistantEventMapColumnFrom]:
    'Fill the {{to}} column from {{from}}: {{pairs}}',
  [tokens.declarationEvents.assistantEventMapColumnUnchanged]:
    'Not in the table, left unchanged: items {{rows}}',
  [tokens.declarationEvents.assistantEventMapColumnUnchanged_one]:
    'Not in the table, left unchanged: item {{rows}}',
  [tokens.declarationEvents.assistantEventComputeColumn]:
    'Compute the {{to}} column = {{formula}}',
  [tokens.declarationEvents.assistantEventComputeColumnUnchanged]:
    'No number to compute with, left unchanged: items {{rows}}',
  [tokens.declarationEvents.assistantEventComputeColumnUnchanged_one]:
    'No number to compute with, left unchanged: item {{rows}}',
  [tokens.declarationEvents.assistantEventFormatColumnPadEnd]:
    'Pad the {{label}} column to {{length}} characters with “{{padWith}}” at the end',
  [tokens.declarationEvents.assistantEventFormatColumnPadStart]:
    'Pad the {{label}} column to {{length}} characters with “{{padWith}}” at the start',
  [tokens.declarationEvents.assistantEventFormatColumnTruncate]:
    'Keep the first {{length}} characters of the {{label}} column',
  [tokens.declarationEvents.assistantEventFormatColumnUnchanged]:
    'Empty or already at {{length}} characters, left unchanged: items {{rows}}',
  [tokens.declarationEvents.assistantEventFormatColumnUnchanged_one]:
    'Empty or already at {{length}} characters, left unchanged: item {{rows}}',
  [tokens.declarationEvents.assistantEventAddLine]: 'Add an item',
  [tokens.declarationEvents.assistantEventAddLineValues]: 'Add an item: {{values}}',
  [tokens.declarationEvents.assistantEventRemoveLine]: 'Remove item {{row}}',
  [tokens.declarationEvents.assistantEventDistributeEqual]:
    'Distribute the {{total}} total over all items, in equal parts',
  [tokens.declarationEvents.assistantEventDistributeBy]:
    'Distribute the {{total}} total over all items, in proportion to {{weight}}',
  [tokens.declarationEvents.assistantEventDistributePackages]:
    'Put the packages on the first item of each document, 0 on the others',
  [tokens.declarationEvents.assistantEventScopeDocument]:
    'on the items of document {{document}}',
  [tokens.declarationEvents.assistantEventDistributeAmount]:
    'amount entered: {{value}}',
  [tokens.declarationEvents.assistantEventDistributeFirstLine]:
    'Put the {{total}} total on the first item, 0 on the others',
  [tokens.declarationEvents.assistantEventDistributeFirstLinePerDocument]:
    'Put each document\'s {{total}} total on its first item, 0 on the others',
  [tokens.declarationEvents.assistantEventDistributeEqualScoped]:
    'Spread the {{total}} total in equal shares',
  [tokens.declarationEvents.assistantEventDistributeByScoped]:
    'Spread the {{total}} total pro rata of {{weight}}',
  [tokens.declarationEvents.assistantEventDistributeFromValue]:
    'Figure spread: {{value}}, entered',
  [tokens.declarationEvents.assistantEventDistributeFromDocument]:
    'Figure spread: {{value}}, share of {{document}}',
  [tokens.declarationEvents.assistantEventDistributeFromReference]:
    'Figure spread: {{value}}, the total\'s chosen figure',
  [tokens.declarationEvents.assistantEventConsolidate]: 'Group the items by {{keys}}',
  [tokens.declarationEvents.assistantEventUnconsolidate]: 'Undo the grouping of items',
  [tokens.declarationEvents.assistantEventTotalManual]: 'Keep for {{total}}: {{value}} (entered)',
  [tokens.declarationEvents.assistantEventTotalLines]: 'Keep for {{total}}: the sum of the lines',
  [tokens.declarationEvents.assistantEventTotalReading]: 'Keep for {{total}}: the reading of {{document}}',
  [tokens.declarationEvents.assistantEventTotalRead]: 'Go back to the read total for {{total}}',
  [tokens.declarationEvents.assistantEventRevert]:
    'Undo the change made on {{date}} at {{time}} ({{count}} changes)',
  [tokens.declarationEvents.assistantEventRevert_one]:
    'Undo the change made on {{date}} at {{time}} ({{count}} change)',
  [tokens.declarationEvents.assistantEventRevertUnknown]: 'Undo a change made by the assistant',
  [tokens.declarationEvents.assistantEventRevertDependents]:
    '{{action}} and {{count}} changes that depend on it',
  [tokens.declarationEvents.assistantEventRevertDependents_one]:
    '{{action}} and {{count}} change that depends on it',
  [tokens.declarationEvents.assistantValueTrue]: 'yes',
  [tokens.declarationEvents.assistantValueFalse]: 'no',
  [tokens.declarationEvents.assistantSuggestionBlocked]:
    'Why is the declaration blocked?',
  [tokens.declarationEvents.assistantSuggestionMissing]:
    'Fill in {{fields}} from the documents',
  [tokens.declarationEvents.assistantSuggestionMissingUnnamed]:
    'Fill in the missing mandatory fields from the documents',
  [tokens.declarationEvents.assistantSuggestionLines]:
    'Complete the {{column}} column on the {{count}} items where it is empty',
  [tokens.declarationEvents.assistantSuggestionLines_one]:
    'Complete the {{column}} column on the item where it is empty',
  [tokens.declarationEvents.assistantSuggestionLinesColumns]:
    'Complete the {{columns}} columns on the items where they are empty',
  [tokens.declarationEvents.assistantSuggestionFormat]:
    'Fix the values in the wrong format: {{fields}}',
  [tokens.declarationEvents.assistantSuggestionConflict]:
    'The documents disagree on {{fields}}: which values should be kept?',
  [tokens.declarationEvents.assistantSuggestionConflict_one]:
    'The documents disagree on {{fields}}: which value should be kept?',
  [tokens.declarationEvents.assistantSuggestionConflictUnnamed]:
    'The documents disagree: which values should be kept?',
  [tokens.declarationEvents.assistantSuggestionGap]:
    'Explain the gaps on {{totals}}',
  [tokens.declarationEvents.assistantSuggestionGap_one]:
    'Explain the gap on {{totals}}',
  [tokens.declarationEvents.assistantSuggestionDistribute]:
    'Distribute {{totals}} over the items',
  [tokens.declarationEvents.assistantSuggestionWeights]:
    'Check that the weights match across the documents',
  [tokens.declarationEvents.assistantSuggestionTotals]:
    'Check the declaration totals',
  [tokens.declarationEvents.assistantSuggestionHistory]:
    'Summarize the folder history',
  [tokens.declarationEvents.assistantSuggestionSummary]:
    'Summarize this folder',
  [tokens.declarationEvents.assistantSuggestionNamesTwo]:
    '{{first}} and {{second}}',
  [tokens.declarationEvents.assistantSuggestionNamesMore]:
    '{{first}}, {{second}} and {{count}} others',
  [tokens.declarationEvents.assistantSuggestionNamesMore_one]:
    '{{first}}, {{second}} and {{count}} other',
  [tokens.declarationEvents.assistantSuggestionNamesOneMore]:
    '{{first}} and {{count}} others',
  [tokens.declarationEvents.assistantSuggestionNamesOneMore_one]:
    '{{first}} and {{count}} other',

  [tokens.extraction.index]: 'Index',
  [tokens.extraction.selectAnErrorState]: 'Select an error state',
  [tokens.extraction.exportDeclaration]: 'Export declaration',
  [tokens.extraction.dauRecapButtonLabel]: 'SAD',
  [tokens.extraction.dauRecapButtonTooltip]:
    'Format the declaration as a SAD.',
  [tokens.extraction.dauRecapNoArticlesTooltip]: 'No articles to summarize',
  [tokens.extraction.dauRecapUnavailableSchemaTooltip]:
    'Summary not available for this declaration type',
  [tokens.extraction.dauRecapPrintButton]: 'Print',
  [tokens.extraction.dauRecapCloseButton]: 'Close',
  [tokens.extraction.dauRecapModalSubtitle]:
    'Single Administrative Document · {{articleCount}} article{{articlePlural}} · {{pageCount}} page{{pagePlural}}',
  [tokens.extraction.dauRecapCloseHint]: 'to close',
  [tokens.extraction.dauRecapPreviousPage]: 'Previous page',
  [tokens.extraction.dauRecapNextPage]: 'Next page',
  [tokens.extraction.dauRecapZoomOut]: 'Zoom out',
  [tokens.extraction.dauRecapZoomIn]: 'Zoom in',
  [tokens.extraction.validateThisDataset]:
    'Validate this dataset ({{current}}/{{total}})',
  [tokens.extraction.validateDatasetSuccess]:
    'Dataset validated ({{current}}/{{total}})',
  [tokens.extraction.dataset]: 'Dataset',
  [tokens.extraction.validateDatasetModalTitle]:
    'Validate dataset {{current}}/{{total}}?',
  [tokens.extraction.validateDatasetModalDescription]:
    'This dataset will be validated. You can then move on to the next dataset.',
  [tokens.extraction.datasetsValidatedProgress]:
    '{{validated}}/{{total}} datasets validated',
  [tokens.extraction.datasetsRemainingProgress]:
    '{{remaining}} remaining',
  [tokens.extraction.datasetsAllValidatedReady]:
    'All validated, ready to send',
  [tokens.extraction.goToNextDataset]:
    'Go to next dataset',
  [tokens.extraction.datasetValidationGuidanceBanner]:
    'Dataset {{validated}}/{{total}} validated. {{remaining}} dataset(s) remaining. You have been redirected to dataset {{next}}.',
  [tokens.extraction.multiDatasetSendRecapTitle]:
    'Sending {{total}} datasets:',
  [tokens.extraction.agentRationale]: 'Generated by agent',
  [tokens.extraction.agentRationaleTooltip]: 'Instructions left by the agent',
  [tokens.extraction.showSidebar]: 'Show sidebar',
  [tokens.extraction.hideSidebar]: 'Hide sidebar',
  [tokens.extraction.enlargeViewer]: 'Hide the form panel to expand the viewer',
  [tokens.extraction.shrinkViewer]: 'Show the form panel again',
  [tokens.extraction.enlargeTableOverlay]: 'Show table in full screen',
  [tokens.extraction.shrinkTableOverlay]: 'Exit full screen',
  [tokens.extraction.enlargeTableWidth]: 'Expand table width',
  [tokens.extraction.shrinkTableWidth]: 'Reduce table width',
  [tokens.extraction.enlargeTable]: 'Hide the viewer and expand the table',
  [tokens.extraction.shrinkTable]: 'Show the viewer again',
  [tokens.extraction.scrollToDocumentTop]: 'Back to top of document',
  [tokens.extraction.scrollToDocumentBottom]: 'Go to bottom of document',
  [tokens.extraction.suggestedColumnIsMissing]: 'Suggested column is missing',
  [tokens.extraction.thereAreOverlappingFields]:
    'There are {{count}} fields occupying this same area in the page.',
  [tokens.extraction.clickHereToSeeFurtherEditingOptions]:
    'Click to see further editing options.',
  [tokens.extraction.default]: 'Default',
  [tokens.extraction.anUnusedDocumentWasFound]:
    'Unused document found : {{code}}',
  [tokens.extraction.validateTheMerge]: 'Validate the merge',
  [tokens.extraction.rowTotalAmountIsMissing]: 'Row total amount is missing',
  [tokens.extraction.additionalCodeNotValid]:
    'Invalid additional code found : {{code}}',
  [tokens.extraction.noTaxComponentSelected]: 'No tax measure selected',
  [tokens.extraction.rowsToValidate]: '{{count}} row to validate',
  [tokens.extraction.rowsToValidate_other]: '{{count}} rows to validate',
  [tokens.extraction.noDutyComponentSelected]: 'No duty measure selected',
  [tokens.extraction.selectedLines]: '{{count}} line selected',
  [tokens.extraction.selectedLines_other]: '{{count}} lines selected',
  [tokens.extraction.selectedLines_zero]: '{{count}} lines selected',
  [tokens.extraction.additionalCodeIsMissingACertificate]:
    'Additional code is missing a certificate : {{code}}',
  [tokens.extraction.countryOfOriginUnknown]: 'Country of origin unknown',
  [tokens.extraction.countryOfDestinationUnknown]:
    'Destination country unknown',
  [tokens.extraction.noErrorState]: 'Dossier not in error state',
  [tokens.extraction.valueRequiredToSpread]: 'Value required to spread',
  [tokens.extraction.columnEmpty]: 'Column empty',
  [tokens.extraction.documentColumnIsEmpty]:
    'All cells in the column "{{columnName}}" for document "{{documentName}}" are empty',
  [tokens.extraction.valuesMissing]: 'No values',
  [tokens.extraction.theDocumentTotalAndTheTableTotalAreDifferent]:
    'The total indicated in the document and the sum of the table cells are not equal.',
  [tokens.extraction.theDocumentTotalAndTheTableTotalAreEqual]:
    'The total indicated in the document and the sum of the table cells are equal.',
  [tokens.extraction.countryUnknown]: 'Country unknown',
  [tokens.extraction.failedToRetrieveTaricCodeDataForCode]:
    'Failed to retrieve TARIC data for code {{code}}',
  [tokens.extraction.findAColumn]: 'Find a column',
  [tokens.extraction.changeColumnName]: 'Change column name',
  [tokens.extraction.closeDebug]: 'Close debug',
  [tokens.extraction.legalInformationAboutCode]:
    'Legal information about code {{code}}',
  [tokens.extraction.legalInformationAboutMeasure]:
    'Legal information about measure {{measure}}',
  [tokens.extraction.legalInformation]: 'Legal information',
  [tokens.extraction.datasourceOrigin]: 'Data sourced from',
  [tokens.extraction.propertiesInheritedFromCode]:
    'Code information inherited from',
  [tokens.extraction.fields]: 'Fields',
  [tokens.extraction.totaux]: 'Totals',
  [tokens.extraction.assistant]: 'Assistant',
  [tokens.extraction.articles]: 'Articles',
  [tokens.extraction.rows]: 'Rows',
  [tokens.extraction.errors]: 'Errors',
  [tokens.extraction.mergeValidationExplanation]:
    'Here you can check the correspondence between the packing list lines (source) and the invoice lines (destination). Lines with discrepancies are highlighted in color.<br>Click on a line to display the corresponding sources and correct the associations before continuing with the merge.',
  [tokens.extraction.mergeValidationCaseOneExplanation]:
    '<b>No associated source</b> : This invoice line is not linked to any item in the packing list. Select one or more lines from the source table to associate.<br><b>Suggested action:</b> Select a line from the packing list manually.',
  [tokens.extraction.mergeValidationCaseTwoExplanation]:
    '<b>Multiple associated sources</b> : Multiple packing slip items are currently linked to this invoice line. Verify the correspondence and keep only one valid source line.<br><b>Suggested action:</b> Deselect the extra sources.',
  [tokens.extraction.mergeValidationCaseThreeExplanation]:
    '<b>Source used multiple times</b> : The same packing line is associated with multiple invoice lines. Each source can only be linked to a single destination.<br><b>Suggested action:</b> Adjust the associations to keep only one link per source.',
  [tokens.extraction.mergeValidationCaseFourExplanation]:
    '<b>Invalid multiple associations</b> : Several packing and invoice lines are cross-linked. These matches cannot be merged automatically.<br><b>Suggested action:</b> Manually correct the associations to ensure a 1:1 match.',
  [tokens.extraction.mergeSourceDuplicateExplanation]:
    'A row in the source table will map to multiple rows in the destination table, which may create incorrect data in the destination table. Row ',
  [tokens.extraction.mergeSourceDuplicateExplanation2]:
    'in the source table maps to rows ',
  [tokens.extraction.mergeDestinationDuplicateExplanation]:
    'Multiple rows in the source table will map to the same row in the destination table, which creates ambiguous merge data. Rows',
  [tokens.extraction.readyToMerge]: 'Ready to merge',
  [tokens.extraction.mergeSuccess]: 'The lines have been successfully merged.',
  [tokens.extraction.mergeError]:
    'The merge could not be completed. Check the lines indicated and correct any errors before restarting the operation.',
  [tokens.extraction.mapToRow]: ' map to row ',
  [tokens.extraction.inTheDestinationTable]: ' in the destination table.',
  [tokens.extraction.mergeDestinationUnmapped]:
    'One or more rows in the destination table - rows',
  [tokens.extraction.and]: 'and',
  [tokens.extraction.mergeImpossible]: 'Merge impossible.',
  [tokens.extraction.willNotReceiveAnyDataFromTheMerge]:
    ' will not receive any data from the merge.',
  [tokens.extraction.packages]: 'Packages',
  [tokens.extraction.totalDeclaredValue]: 'Total declared value',
  [tokens.extraction.productCodes]: 'Product codes',
  [tokens.extraction.chooseClassification]: 'Choose a classification',
  [tokens.extraction.exceptions]: 'Exceptions',
  [tokens.extraction.downloadRowsAsExcelWorksheet]:
    'Download rows as Excel worksheet',
  [tokens.extraction.convertRowsToFees]: 'Convert rows to fees',
  [tokens.extraction.convertRowsToRefunds]: 'Convert rows to refunds',
  [tokens.extraction.createNewDeclarationFromRows]:
    'Create new declaration from rows',
  [tokens.extraction.noExceptionsFound]: 'No exceptions found',
  [tokens.extraction.noDescriptionFound]: 'No description found',
  [tokens.extraction.noConditionsFound]: 'No conditions found',
  [tokens.extraction.updateDeclarationExportType]:
    'Update declaration export type',
  [tokens.extraction.changeExportTypeForCurrentDeclaration]:
    'Update the type for this declaration',
  [tokens.extraction.noColumnsFound]: 'No columns found',
  [tokens.extraction.whyMergeKeysNeeded]:
    'In order to merge, we need to have columns that are shared between the source table and the destination table.',
  [tokens.extraction.noClassification]: 'Not classified',
  [tokens.extraction.legalContext]: 'Legal context',
  [tokens.extraction.informations]: 'Informations',
  [tokens.extraction.products]: 'Products',
  [tokens.extraction.editCells]: 'Edit cells',
  [tokens.extraction.editGrid]: 'Edit grid — Ctrl+Alt',
  [tokens.extraction.deleteTable]: 'Delete table',
  [tokens.extraction.articlesTable]: 'Articles table',
  [tokens.extraction.showArticlesTable]: 'Show articles table',
  [tokens.extraction.hideArticlesTable]: 'Hide articles table',
  [tokens.extraction.anyColumnsToMatchNotPresentWillBeCreated]:
    'Any <b>Columns to match</b> not present in the Articles table will be created.',
  [tokens.extraction.whenCopyingARowFromSourceOnlyCopyValuesWillBeCopied]:
    'When copying a row from the packing list to the invoice table, only the values for the <b>Columns to copy</b> in the row will be copied.',
  [tokens.extraction.chooseTheTableYouWantToMergeIntoTheMainArticlesTable]:
    'Choose the table you want to merge into the Articles table',
  [tokens.extraction.deleteTablePage]: 'Delete table on current page',
  [tokens.extraction.deleteAllTablePages]: 'Delete tables on all pages',
  [tokens.extraction.missingProduct]: 'Missing product',
  [tokens.extraction.certificateCode]: 'Certificate code',
  [tokens.extraction.informationOnCodesAndDuties]:
    'Information on codes and duties',
  [tokens.extraction.mergeOptions]: 'Merge options',
  [tokens.extraction.addInformation]: 'Add information',
  [tokens.extraction.convertRowsToAdditions]: 'Convert rows to additions',
  [tokens.extraction.deleteArticleRowTitle]: 'Delete this article?',
  [tokens.extraction.deleteArticleRowMessage]:
    'Row {{row}}: this deletion is permanent. The declaration totals will be recalculated.',
  [tokens.extraction.deleteArticleRowTooltip]: 'Delete this row',
  [tokens.extraction.convertRowsToDeductions]: 'Convert rows to deductions',
  [tokens.extraction.addElement]: 'Add element',
  [tokens.extraction.customInformation]: 'Customs information',
  [tokens.extraction.documentInformation]: 'Declaration',
  [tokens.extraction.shippingInformation]: 'Shipping information',
  [tokens.extraction.transactionDetails]: 'Transaction details',
  [tokens.extraction.findField]: 'Find field',
  [tokens.extraction.cellTooSmall]: 'Cell too small',
  [tokens.extraction.cellNotValid]: 'Cell not valid',
  [tokens.extraction.groupByHSCode]: 'Group by HS Code',
  [tokens.extraction.doYouWantToGroupTokensByHSCode]:
    'Do you want to group by HS Code ?',
  [tokens.extraction.yes]: 'Yes',
  [tokens.extraction.no]: 'No',
  [tokens.extraction.addData]: 'Add data',
  [tokens.extraction.addRow]: 'Add row',
  [tokens.extraction.tableRows]: 'Table rows',
  [tokens.extraction.deleteRow]: 'Delete row',
  [tokens.extraction.invoices]: 'Invoices',
  [tokens.extraction['commercial-invoice']]: 'Invoice',
  [tokens.extraction.packings]: 'Packings',
  [tokens.extraction['packing-list']]: 'Packing',
  [tokens.extraction['packing-list-description']]:
    'Combined data from all packing lists',
  [tokens.extraction['hscodes-list']]: 'HS Codes',
  [tokens.extraction['hscodes-list-description']]:
    'Combined data from all HS Code lists',
  [tokens.extraction['bill-of-lading']]: 'Bill of lading',
  [tokens.extraction['bill-of-lading-description']]:
    'Combined data from all bill of lading lists',
  [tokens.extraction['delivery-note']]: 'Delivery note',
  [tokens.extraction['delivery-note-description']]:
    'Combined data from all delivery note lists',
  [tokens.extraction['articles-table-description']]:
    'Export articles based on commercial invoice',
  [tokens.extraction.createNewFieldHere]: 'Create a new field at this location',
  [tokens.extraction.showOtherFieldsHere]: 'Show other fields at this location',
  [tokens.extraction.convertSelectionToTable]: 'Convert field into a table',
  [tokens.extraction.drawingHintField]: 'Field',
  [tokens.extraction.drawingHintArticleGrid]: 'Article grid',
  [tokens.extraction.drawingHintArticleColumn]: 'Article column',
  [tokens.extraction.drawingHintPageAlreadyHasArticleGrid]:
    'Grid already present on this page',
  [tokens.extraction.drawingRejectedAgenticField]:
    'On a document with no positioned fields, draw an article grid (wide rectangle, over 70% of page width).',
  [tokens.extraction.drawingRejectedPageAlreadyHasArticleGrid]:
    'An article grid already exists on this document page.',
  [tokens.extraction.validateRequiresFieldSelection]:
    'Select a field before validating.',
  [tokens.extraction.convertTableToSelection]: 'Convert table into a field',
  [tokens.extraction.mergeTables]: 'Merge',
  [tokens.extraction.sourceTable]: 'Source table',
  [tokens.extraction.columnsToMatch]: 'Columns to match',
  [tokens.extraction.columnsToCopy]: 'Columns to copy',
  [tokens.extraction.validation]: 'Validation',
  [tokens.extraction.columnToMatchExplanation]:
    'A row in the packing list table will be copied to a row in the table if they have the same values for every <b>Column to match</b>.',
  [tokens.extraction.extraction]: 'Extraction',
  [tokens.extraction.nothingToShow]: 'Nothing to show',
  [tokens.extraction.table]: 'Table',
  [tokens.extraction.field]: 'Field',
  [tokens.extraction.tables]: 'Tables',
  [tokens.extraction.grids]: 'Grids',
  [tokens.extraction.grid]: 'Grid',
  [tokens.extraction.excelGridModeTooltip]:
    'Draw the table on the sheet (at least 70% of the width in columns)',
  [tokens.extraction.excelGridModeInstructions]:
    'Grid mode: on the Excel sheet, click and drag to outline the table. The selection must span at least 70% of the sheet width (in columns). You can then fine-tune the rectangle using the orange handles.',
  [tokens.extraction.excelCellsModeTooltip]:
    'Select cells and fields on the Excel sheet',
  [tokens.extraction.gridModeTooltip]: 'Adjust the table grid on the document',
  [tokens.extraction.gridModeInstructions]:
    'Grid mode: resize the frame and move row delimiters on the document.',
  [tokens.extraction.cellsModeTooltip]:
    'Select and edit cells in the grid on the document',
  [tokens.extraction.cells]: 'Cells',
  [tokens.extraction.displayTheTable]: 'Display the table',
  [tokens.extraction.save]: 'Save',
  [tokens.extraction.noOtherFormatsAvailable]: 'No other formats available',
  [tokens.extraction.downloadTestFile]: 'Download test file',
  [tokens.extraction.exportTo]: 'Send to',
  [tokens.extraction.newField]: 'New field',
  [tokens.extraction.convertIntoField]: 'Convert into field',
  [tokens.extraction.convertIntoTable]: 'Convert into table',
  [tokens.extraction.newTable]: 'New table',
  [tokens.extraction.on]: 'out of',
  [tokens.extraction.duplicate]: 'Make a copy',
  [tokens.extraction.completedFields]: 'Completed fields',
  [tokens.extraction.workComplete]: 'Work complete',
  [tokens.extraction.mustBeString]: 'Must be a string',
  [tokens.extraction.mustBeNumber]: 'Must be a number',
  [tokens.extraction.areYouSureYouWantToCopyDeclaration]:
    'Are you sure you want to make a copy of this declaration',
  [tokens.extraction.thereWasAnErrorCopyingTheDeclaration]:
    'There was an error copying the declaration',
  [tokens.extraction.mustMatchFormatDateTime]: 'Must match date / time format',
  [tokens.extraction.mustMatchFormatDate]: 'Must match date format',
  [tokens.extraction.mustNotHaveMoreThanCharacters]:
    'Must NOT have more than {{ count }} characters',
  [tokens.extraction.mustNotHaveFewerThanCharacters]:
    'Must not have fewer than {{ count }} characters',
  [tokens.extraction.pleaseEnterBetweenXAndYCharacters]:
    'Please enter between {{min}} and {{max}} characters.',
  [tokens.extraction.pleaseEnterExactlyXCharacters]:
    'Please enter exactly {{count}} characters.',
  [tokens.extraction.pleaseEnterAWholeNumber]: 'Please enter a whole number',
  [tokens.extraction.updatingData]: 'Updating data',
  [tokens.extraction.mustBeInAlpha2]:
    'Must be in alpha-2 format. For example, France ⇒ FR.',
  [tokens.extraction.doitTreAuFormatAlpha2ExemplePourFranceFr]:
    'Must be in alpha-2 format. For example, France ⇒ FR.',
  [tokens.extraction.pleaseEnterExactly10CharactersInFormat]:
    'Please enter exactly 10 characters in the format DD/MM/YYYY',
  [tokens.extraction.pleaseEnterANumber]: 'Please enter a number',
  [tokens.extraction.pleaseEnterAMaximumOf]:
    'Please enter a maximum of {{count}} characters',
  [tokens.extraction.pleaseSelectFromTheGivenValues]:
    'Please select from the given values',
  [tokens.extraction.pleaseEnterAValueThatConsistsOfLetters]:
    'Please enter a value that consists of letters (uppercase or lowercase), numbers, and hyphens, and has a maximum length of 35 characters',
  [tokens.extraction.pleaseEnterAValidSiretNumber]:
    'Please enter a SIRET number',
  [tokens.extraction['18LettersAndNumbersMaximum']]:
    '18 letters and numbers maximum',
  [tokens.extraction.mustBeInteger]: 'Must be a number',
  [tokens.extraction.loadingExtractionInformation]:
    'Nabu extracts data from your documents',
  [tokens.extraction.emailAttachments]: '{{count}} attachment',
  [tokens.extraction.emailAttachments_other]: '{{count}} attachments',
  [tokens.extraction.loadingBackToDashboard]:
    'You can return to your dashboard in the meantime',
  [tokens.extraction.notAccessibleForOrganization]:
    'This document is not accessible for this organisation. Please sign in with the corresponding account.',
  [tokens.extraction.createTable]: 'Create table',
  [tokens.extraction.deleteColumn]: 'Delete column',
  [tokens.extraction.doYouWantToDeleteTable]:
    'Are you sure you want to delete the table of all pages ? All extracted and manually added data for all tables will be lost.',
  [tokens.extraction.doYouWantToDeleteTableOnCurrentPage]:
    'Are you sure you want to delete the table of this page ? All extracted and manually added data for the table will be lost.',
  [tokens.extraction.editTable]: 'Edit the table',
  [tokens.extraction.editCells]: 'Edit cells',
  [tokens.extraction.editField]: 'Edit field',
  [tokens.extraction.deleteTableOnlyInThePage]: 'Delete the table on this page',
  [tokens.extraction.deleteTableInAllPage]: 'Delete table on all pages',
  [tokens.extraction.doYouWantToDeleteColumn]:
    'Are you sure you want to delete this column ? All extracted and manually added data for the column will be lost.',
  [tokens.extraction.doYouWantToDeleteColumnAndDeconsolidate]:
    'Are you sure you want to delete this column? All data in the column - extracted and added manually - will be lost, and items will no longer be consolidated.',
  [tokens.extraction.doYouWantToEditColumnAndDeconsolidate]:
    'Are you sure you want to edit this row? Articles will no longer be consolidated',
  [tokens.extraction.doYouWantToDeleteRow]:
    'Are you sure you want to delete this row ? All extracted and manually added data for the row will be lost.',
  [tokens.extraction.doYouWantToDeleteGroupedColumns]:
    'Important - this column is part of a column group. All other columns in this group will also be deleted, and all data for the all grouped columns will be lost. Are you sure you want to delete this column ?',
  [tokens.extraction.missingValuesInColumn]:
    '{{count}} missing value(s) in the "{{column}}" column to perform this calculation',
  [tokens.extraction.columnMissing]:
    'The values in column "{{column}}" are missing to perform this calculation',
  [tokens.extraction.addOriginOfArticles]: 'the origin of items',
  [tokens.extraction.addHSCodeOfArticles]: 'the HS Code',
  [tokens.extraction.addCodePrefOfArticles]: 'the preferential tariff code',
  [tokens.extraction.addOriginCountryCode]: 'the country of origin code',
  [tokens.extraction.codePreferenceModalTitle]: 'Code Preferences',
  [tokens.extraction.preferenceCode]: 'Preference code',
  [tokens.extraction.currency]: 'currency',
  [tokens.extraction.codePreferenceCopy]:
    'The field code has been copied successfully',
  [tokens.extraction.ofItems]: 'of items',
  [tokens.extraction.add]: 'Add',
  [tokens.extraction.emptyTable]: 'The table is empty',
  [tokens.extraction.emptyTableHintLine1]:
    'Click the column labels at the top of the grid,',
  [tokens.extraction.emptyTableHintLine2]:
    'then choose a classification for each column to populate the table.',
  [tokens.extraction.addToTable]: 'Add to the table',
  [tokens.extraction.addColumn]: 'Add a column',
  [tokens.extraction.declarationState]: 'Declaration status',
  [tokens.extraction.returnToDeclarations]: 'Go back to active declarations',
  [tokens.extraction.updateDeclaration]: 'Update current declaration',
  [tokens.extraction.declarationUploading]: 'Your declaration is loading',
  [tokens.extraction.declarationUploaded]:
    'Your declaration was loaded successfully',
  [tokens.extraction.youWillBeRedirectedToModelCreation]:
    'You will be redirected to model creation in 10 seconds',
  [tokens.extraction.youWillBeRedirectedToTheDashboard]:
    'You will be redirected to the dashboard in 10 seconds',
  [tokens.extraction.declarationUploadFailed]: 'Your declaration upload failed',
  [tokens.extraction.failedToLoadOptions]: 'Failed to load options',
  [tokens.extraction.checkDeclarationAndRetry]:
    'Please check your declaration and retry',
  [tokens.extraction.checkDeclaration]: 'Please check your declaration',
  [tokens.extraction.retryExport]: 'Retry sending',
  [tokens.extraction.exportRetryDialogMessage]:
    'Sending this declaration has failed. You can retry sending now.',
  [tokens.extraction.exportFailedMessage]:
    'Sending this declaration has failed.',
  [tokens.extraction.exportRetryInitiated]:
    'The sending retry has been initiated successfully.',
  [tokens.extraction.warningOriginX]:
    'Origin x is being moved inside the cells area',
  [tokens.extraction.warningOriginY]:
    'Origin y is being moved inside the cells area',
  [tokens.extraction.warningTouchingCellsOnX]:
    'width is shrinking too much - touching existing cells',
  [tokens.extraction.warningTouchingCellsOnY]:
    'height is shrinking too much - touching existing cells',
  [tokens.extraction.warningBottomRowTooSmall]: 'bottom row is too small',
  [tokens.extraction.warningTopRowTooSmall]: 'top row is too small',
  [tokens.extraction.warningTableLeavesPage]: 'table leaves the page',
  [tokens.extraction.consolidate]: 'Consolidate',
  [tokens.extraction.consolidated]: 'Consolidated',
  [tokens.extraction.deconsolidate]: 'Undo consolidate',
  [tokens.extraction.clickOnTheButtonToUndoConsolidation]:
    'The table has been consolidated - click on the button below to undo the consolidation.',
  [tokens.extraction.selectTheColumnsToBeUsedForConsolidation]:
    'Select the columns to be used for consolidation',
  [tokens.extraction.sendingConfirmation]: 'Sending confirmation',
  [tokens.extraction.createModelInfo]:
    'This allows you to save the information from this declaration so that you can reuse it. When creating a new declaration, simply select a model from the list to apply the saved settings.',
  [tokens.extraction.sendingFileQuestion]:
    'Are you sure you want to send this declaration?',
  [tokens.extraction.saveModelQuestion]:
    'Would you like to create a new model from this declaration?',
  [tokens.extraction.consolidateAndVerify]: 'Consolidate and review',
  [tokens.extraction.consolidateAndSend]: 'Consolidate and send',
  [tokens.extraction.consolidateAndSendOptions]:
    'Other consolidation and send options',
  [tokens.extraction.sendWithoutConsolidating]: 'Send without consolidating',
  [tokens.extraction.declarationQualityQuestion]:
    'How did this declaration go?',
  [tokens.extraction.declarationQualityVeryDissatisfied]: 'Very dissatisfied',
  [tokens.extraction.declarationQualityVerySatisfied]: 'Very satisfied',
  [tokens.extraction.declarationQualityAddRemark]: 'Add a remark (optional)',
  [tokens.extraction.declarationQualityRemarkPlaceholder]:
    'Share your remarks about this extraction…',
  [tokens.extraction.createNewModel]: 'Create a new model',
  [tokens.extraction.redirectCreateModel]: 'Redirect to model creation',
  [tokens.extraction.modelFieldsAreFixed]:
    'The fields below are not editable - you can only add or remove fields from a model',
  [tokens.extraction.selectAllFields]: 'Select all fields',
  [tokens.extraction.modelDetail]: 'Model detail',
  [tokens.extraction.modelCreation]: 'Model creation',
  [tokens.extraction.modelCreated]: 'Model created',
  [tokens.extraction.modelCreationFailed]: 'Model creation failed',
  [tokens.extraction.noModelApplied]: 'No model applied',
  [tokens.extraction.glideHeaderSum]: 'Sum',
  [tokens.extraction.glideHeaderArticleNumber]: 'Number of items',
  [tokens.extraction.checkFieldModalFirstTextWarning]: 'Warning !',
  [tokens.extraction.checkFieldModalFirstText]:
    'Updating this field will replace all values ​​for "',
  [tokens.extraction.checkFieldModalFirstTextEnding]: '" in your table.',
  [tokens.extraction.checkFieldModalSecondText]:
    'All your current values ​​will be lost!',
  [tokens.extraction.checkFieldModalFieldUpdated]: 'Field updated',
  [tokens.extraction.unknownTaricCode]: 'Unknown TARIC code : {{code}}',
  [tokens.extraction.checkFieldModalConsolidatedTitle]:
    'Consolidation of articles',
  [tokens.extraction.checkFieldModalConsolidatedFirstText]:
    'You will send your declaration without having consolidated the articles.',
  [tokens.extraction.consolidationRequired]:
    'Consolidation is required before a declaration can be validated.',
  [tokens.extraction.checkFieldModalConsolidatedSecondText]:
    'Would you like to modify your declaration or send it without consolidating?',
  [tokens.extraction.checkFieldModalConsolidatedUpdatedButton]:
    'Go back to the declaration',
  [tokens.extraction.checkFieldModalConsolidatedSendButton]:
    'Send without consolidating',
  [tokens.extraction.checkFieldModalDependenciesWarning]: 'Warning !',
  [tokens.extraction.resetLabelBox]: 'Reset',
  [tokens.extraction.productDescription]: 'Product description',
  [tokens.extraction.noAdditionalCodesAvailableForThisTaricCode]:
    'No additional codes available for this TARIC code',
  [tokens.extraction.addAnAdditionalCode]: 'Add an additional code',
  [tokens.extraction.additionalCodes]: 'Additional codes',
  [tokens.extraction.noResult]: 'No result',
  [tokens.extraction.previousResult]: 'Previous result',
  [tokens.extraction.nextResult]: 'Next result',
  [tokens.extraction.searchByKeywords]: 'Search by keywords',
  [tokens.extraction.currentChoice]: 'Current choice',
  [tokens.extraction.selectItem]: 'Select',
  [tokens.extraction.itemDescription]: 'Article description',
  [tokens.extraction.searchAnotherHsCode]: 'Search another code',
  [tokens.extraction.moreDetails]: '+ details',
  [tokens.extraction.seeLess]: '- details',
  [tokens.extraction.previousRow]: 'Previous row',
  [tokens.extraction.nextRow]: 'Next row',
  [tokens.extraction.row]: 'Row',
  [tokens.extraction.mustBeEqualToOneOfTheAllowedValues]:
    'Must be equal to one of the allowed values',
  [tokens.extraction.editDescription]: 'Edit description',
  [tokens.extraction.replaceDescriptionByTaricCodeDescription]:
    'Substitute the Taric code description',
  [tokens.extraction.applyValueToAllRows]: 'Apply value to all rows',
  [tokens.extraction.revertToInitialCode]: 'Revert to initial code',
  [tokens.extraction.noAdditionalCodesSelected]: 'No additional codes selected',
  [tokens.extraction.additionalCodesSelected]:
    '{{count}} additional code selected',
  [tokens.extraction.additionalCodesSelected_other]:
    '{{count}} additional codes selected',
  [tokens.extraction.copyValueToEntireColumn]:
    "Copy this cell's value to the entire column",
  [tokens.extraction.copyValueToEntireColumnShortcut]:
    'Duplicate on current invoice (Ctrl+Shift+C)',
  [tokens.extraction.copyToCurrentDocumentColumn]:
    'Duplicate on current invoice',
  [tokens.extraction.copyToAllDocumentsColumn]:
    'Duplicate on all invoices',
  [tokens.extraction.copyToCurrentDocumentColumnShortcut]:
    'Duplicate on current invoice (Ctrl+Shift+C)',
  [tokens.extraction.copyToColumnOptions]: 'Duplication options',
  [tokens.extraction.areYouSureYouWantToCopyThisCellValueToAllColumns]:
    "Are you sure you want to copy this cell's value to all columns in the table ?",
  [tokens.extraction.areYouSureYouWantToCopyThisCellValueToCurrentDocumentColumn]:
    'Are you sure you want to replace the column values on the current invoice?',
  [tokens.extraction.areYouSureYouWantToCopyThisCellValueToAllDocumentsColumns]:
    'Are you sure you want to replace the column values on all invoices in the declaration?',
  [tokens.extraction.taricCodeNotFound]: 'TARIC code not found',
  [tokens.extraction.noArticleDescription]: 'No article description available',
  [tokens.extraction.updateDeclarationModel]: 'Update declaration model',
  [tokens.extraction.removeModel]: 'Remove model',
  [tokens.extraction.changeModel]: 'Change model',
  [tokens.extraction.changeModelForCurrentDeclaration]:
    'Change the model currently applied to this declaration.',
  [tokens.extraction.applyItemToDeclaration]:
    'Apply these codes to the declaration',
  [tokens.extraction.redoClassificationStep]: 'Redo Classification step',
  [tokens.extraction.noDuty]: 'No duty found',
  [tokens.extraction.hoverOverAResultToSeeDetails]:
    'Place your mouse over a result to see details',
  [tokens.extraction.searchAdditionalCodesByKeyword]:
    'Search additional codes by keyword',
  [tokens.extraction.basicValidations]: 'Basic validations',
  [tokens.extraction.showAnomalies]: 'Show errors',
  [tokens.extraction.clickToViewValidationErrors]:
    'Click to view errors to fix',
  [tokens.extraction.validationErrorsToFix]: '{{count}} error to fix',
  [tokens.extraction.validationErrorsToFix_other]: '{{count}} errors to fix',
  [tokens.extraction.goToValidationField]: 'Go to field « {{field}} »',
  [tokens.extraction.validationFieldError]: 'Error on field « {{field}} »',
  [tokens.extraction.anomaliesBeforeSend]:
    '{{count}} error to fix before sending',
  [tokens.extraction.anomaliesBeforeSend_other]:
    '{{count}} errors to fix before sending',
  [tokens.extraction.validationSummary]:
    '{{validated}} / {{total}} fields validated · {{remaining}} required fields remaining:',
  [tokens.extraction.showErrorsOnlySections]: 'Show errors',
  [tokens.extraction.clearErrorsOnlyFilter]: 'Show all sections',
  [tokens.extraction.otherErrorFields]: 'Other fields',
  [tokens.extraction.coherenceChecks]: 'Coherence checks',
  [tokens.extraction.pressCtrlJToGoToNextCoherenceError]:
    'Press Ctrl + J to go to the next coherence error',
  [tokens.extraction.additionalCode]: 'Additional code',
  [tokens.extraction.sendMessage]: 'Send message',
  [tokens.extraction.newMessage]: 'New message',
  [tokens.extraction.setBatchImportError]: 'Put dossier in error state',
  [tokens.extraction.internalErrorState]: 'Internal error state',
  [tokens.extraction
    .puttingThisDossierInErrorStateTellsExternalUsersNabuCannotProcessIt]:
    'Warning - putting this dossier in an Error state tells external users that Nabu cannot process it',
  [tokens.extraction.error]: 'Error',
  [tokens.extraction.tabHasNoData]:
    'This section of the declaration form has no data, probably due to a technical issue. Please contact customer service by clicking on the icon at the bottom right of your screen.',
  [tokens.extraction.countries]: 'Countries',
  [tokens.extraction.includedCountries]: 'Included countries',
  [tokens.extraction.excludedCountries]: 'Excluded countries',
  [tokens.extraction.renvois]: 'Legal references',
  [tokens.extraction.referenceAbbrev_tax]: 'TAX',
  [tokens.extraction.referenceAbbrev_certificate]: 'CRT',
  [tokens.extraction.referenceAbbrev_preference]: 'PRF',
  [tokens.extraction.referenceAbbrev_location]: 'LOC',
  [tokens.extraction.referenceAbbrev_additionalcode]: 'ADD',
  [tokens.extraction.taxCode]: 'Tax code',
  [tokens.extraction.duty]: 'Duty',
  [tokens.extraction.tax]: 'Tax',
  [tokens.extraction.prefTarif]: 'Tariff pref',
  [tokens.extraction.tariffProvision]: 'Tariff provision',
  [tokens.extraction.tariffProvision_short]: 'Tariff-prov',
  [tokens.extraction.legalReferences]: 'Legal references',
  [tokens.extraction.unknown]: 'Unknown',
  [tokens.extraction.consolidationOptions]: 'Consolidation options',
  [tokens.extraction.hscode]: 'HS Code',
  [tokens.extraction.countryOfOrigin]: 'Country of origin',
  [tokens.extraction.description]: 'Description',
  [tokens.extraction.numberOfUnits]: 'Number of units',
  [tokens.extraction.numberOfPackages]: 'Number of packages',
  [tokens.extraction.netWeight]: 'Net weight',
  [tokens.extraction.grossWeight]: 'Gross weight',
  [tokens.extraction.containerCode]: 'Container number',
  [tokens.extraction.codeDescriptionNotFound]: 'Code description not found',
  [tokens.extraction.noTablesWithMergeableColumns]:
    'No tables with mergeable columns',
  [tokens.extraction.noCertificateRequired]: 'No certificate required',
  [tokens.extraction.informationAbout]:
    'Information about {{ itemName }} : {{ code }}',
  [tokens.extraction.thisCodeHasMissingInformation]:
    'This code has missing information',
  [tokens.extraction.thisDeclarationIsNotInAnErrorState]:
    'This declaration is not in an error state',
  [tokens.extraction.is]: 'is',
  [tokens.extraction.if]: 'if',
  [tokens.extraction.then]: 'then',
  [tokens.extraction.shouldBe]: 'should be',
  [tokens.extraction.equalTo]: 'equal to',
  [tokens.extraction.lessThan]: 'less than',
  [tokens.extraction.lessThanOrEqualTo]: 'less than or equal to',
  [tokens.extraction.notIn]: 'not in',
  [tokens.extraction.filled]: 'filled',
  [tokens.extraction.greaterThan]: 'greater than',
  [tokens.extraction.greaterThanOrEqualTo]: 'greater than or equal to',
  [tokens.extraction.in]: 'in',
  [tokens.extraction.notEqualTo]: 'not equal to',
  [tokens.extraction.totalDocument]: 'total document',
  [tokens.extraction.calculatedDocument]: 'calculated document',
  [tokens.extraction.documentTotals]: 'Document totals',
  [tokens.extraction.amountTotal]: 'Amount total',
  [tokens.extraction.grossWeightTotal]: 'Gross weight total',
  [tokens.extraction.netWeightTotal]: 'Net weight total',
  [tokens.extraction.numberOfPosition]: 'Number of position',
  [tokens.extraction.spread]: 'Spread',
  [tokens.extraction.spreadOverAllLines]: 'Spread over all lines',
  [tokens.extraction.spreadDialogTitle]: 'Spread values for {{name}}',
  [tokens.extraction.spreadDialogContent]:
    'Spread the value {{value}} over all lines of articles table for the {{name}} column.',
  [tokens.extraction.spreadSuccess]: 'Spreading completed successfully.',
  [tokens.extraction.documentTotalNotFound]:
    'No value sourced for "{{columnName}}" was found in "{{documentName}}". Fill in the value manually or select it in the document and classify it as "{{columnName}}".',
  [tokens.extraction.documentTotalNotFoundSingle]:
    'No value sourced for "{{columnName}}" was found in the document. Fill in the value manually or select it in the document and classify it as "{{columnName}}".',
  [tokens.extraction.notFound]: 'Not found',
  [tokens.extraction.clearColumnValuesForDocument]:
    'Clear the values of "{{columnName}}" over all the rows in "{{documentTitle}}".',
  [tokens.extraction.documentCellsClearedSuccessfully]:
    'Document cells cleared successfully.',
  [tokens.extraction.errorClearingDocumentCells]:
    'Error clearing document cells',
  [tokens.extraction.spreadOverDocumentLinesSelect]:
    'Spread the value "{{value}}" across the rows of "{{documentTitle}}" for the column "{{columnName}}". You will need to choose a spreading strategy.',
  [tokens.extraction.spreadOverDocumentLinesSelectSingle]:
    'Spread the value "{{value}}" across all document rows for the column "{{columnName}}". You will need to choose a spreading strategy.',
  [tokens.extraction.spreadOverDocumentLinesAutoSingle]:
    'Spread the value "{{value}}" across all document rows for the column "{{columnName}}". The strategy "{{strategyName}}" will be used.',
  [tokens.extraction.spreadOverDocumentLinesAuto]:
    'Spread the value "{{value}}" across the rows of "{{documentTitle}}" for the column "{{columnName}}". The strategy "{{strategyName}}" will be used.',
  [tokens.extraction.spreadOverAllLinesSelect]:
    'Spread the value "{{value}}" across all rows of the declaration. You will need to choose a spreading strategy.',
  [tokens.extraction.spreadOverAllLinesAuto]:
    'Spread the value "{{value}}" across all rows of the declaration. The strategy "{{strategyName}}" will be used.',
  [tokens.extraction.noPostProcessFound]: 'No spreading strategy found',
  [tokens.extraction.source]: 'Source',
  [tokens.extraction.sourceTooltip]: 'Value extracted from the source document.',
  [tokens.extraction.packageTypeNotSourced]: 'Package type not sourced',
  [tokens.extraction.weightUnitNotSourced]: 'Weight unit not sourced',
  [tokens.extraction.packageTypeNotSourced]: 'Package type not sourced',
  [tokens.extraction.currencyNotSourced]: 'Currency not sourced',
  [tokens.extraction.thisActionWillClearAllCellsInTheDocumentColumn]:
    'This action will clear all cells in the column "{{columnName}}" for the document "{{documentTitle}}". This action cannot be undone. Do you want to continue ?',
  [tokens.extraction.declaration]: 'Declaration',
  [tokens.extraction.declarationTooltip]: 'Value from the article table.',
  [tokens.extraction.notSourced]: 'Master value',
  [tokens.extraction.spreadError]:
    'The spreading of totals could not be applied.',
  [tokens.extraction.document]: 'Document',
  [tokens.extraction.totalNotFound]:
    'The total <strong>{{label}}</strong> was not identified in the document(s). You may need to add the column "{{label}}" to the articles table.',
  [tokens.extraction.errorCells]:
    'Information in the cells of the article table is missing to calculate the total. Please fill in these cells to display the total.',
  [tokens.extraction.errorMissingDocumentTitle]: 'Missing documents',
  [tokens.extraction.errorMissingDocumentContent]:
    'The file cannot be processed as it stands: certain mandatory documents are missing (e.g., commercial invoice, packing list, certificate of origin). Please provide all the documents required for customs declaration.',
  [tokens.extraction.errorDocumentaryInconsistenciesTitle]:
    'Document inconsistencies',
  [tokens.extraction.errorDocumentaryInconsistenciesContent]:
    'Inconsistencies have been found between the documents provided (e.g., differences in quantities, values, or descriptions of goods). Please check and submit documents that are consistent and coherent.',
  [tokens.extraction.errorNonCompliantDocumentTitle]:
    'Illegible or non-compliant documents',
  [tokens.extraction.downloadOriginalFilesForThisDossier]:
    'Download original files for this dossier',
  [tokens.extraction.noClientOrganization]: 'No client organization',
  [tokens.extraction.errorNonCompliantDocumentContent]:
    'Some of the documents submitted are illegible, incomplete, or non-compliant. Please provide legible, complete, and official versions to enable the file to be processed correctly.',
  [tokens.extraction.searchForAField]: 'Search for a field',
  [tokens.extraction.keyboardShortcutTab]: 'Tab',
  [tokens.extraction.keyboardShortcutEnter]: 'Enter',
  [tokens.extraction.keyboardShortcutNextField]: 'next field',
  [tokens.extraction.keyboardShortcutValidate]: 'validate',
  [tokens.extraction.selectedField]: 'Field selected',
  [tokens.extraction.stepKeyboardShortcutTab]: 'Tab',
  [tokens.extraction.stepKeyboardShortcutEnter]: 'Enter',
  [tokens.extraction.stepKeyboardShortcutNextField]: 'validate and next field',
  [tokens.extraction.stepKeyboardShortcutValidate]: 'validate',
  [tokens.extraction.stepKeyboardShortcutEscape]: 'Esc',
  [tokens.extraction.stepKeyboardShortcutCancel]: 'cancel',
  [tokens.extraction.stepKeyboardShortcutSearch]: 'search',
  [tokens.extraction.stepKeyboardShortcutQuickActions]: 'quick actions',
  [tokens.extraction.summaryTableArticles]: 'Table articles',
  [tokens.extraction.additionSummaryTitle]: 'Additions',
  [tokens.extraction.deductionSummaryTitle]: 'Deductions',
  [tokens.extraction.statisticalValueSummaryTitle]: 'Statistical value',
  [tokens.extraction.totauxSummaryTitle]: 'Totals',
  [tokens.extraction.totauxSummaryInfo]:
    'Aggregated dossier amounts: value of goods, fees, weights and statistical value.',
  [tokens.extraction.totalsRubriqueFacturation]: 'Billing',
  [tokens.extraction.totalsRubriqueColisage]: 'Packaging',
  [tokens.extraction.totalsArticlesBadge]: 'item',
  [tokens.extraction.totalsArticlesBadge_other]: 'items',
  [tokens.extraction.statisticalValueSummaryInfo]:
    'Value of the goods at the point of exit from French territory, calculated according to the incoterm.',
  [tokens.extraction.statisticalValueAutoBadge]: 'Auto',
  [tokens.extraction.statisticalValueManualBadge]: 'Manual',
  [tokens.extraction.statisticalValueIncotermLabel]:
    'Dossier incoterm: {{code}}',
  [tokens.extraction.statisticalValueIncotermFolderLabel]:
    'Dossier incoterm:',
  [tokens.extraction.statisticalValueIncotermNotSet]: 'No incoterm specified',
  [tokens.extraction.statisticalValueIncotermNotSetHelp]:
    'Fill in the dossier incoterm to apply automatic calculation rules.',
  [tokens.extraction.statisticalValueIncotermFcaDescription]:
    '{{code}}: goods value + transport up to the French border (addition).',
  [tokens.extraction.statisticalValueIncotermFobDescription]:
    '{{code}}: goods value without international transport.',
  [tokens.extraction.statisticalValueIncotermCifDescription]:
    '{{code}}: goods value including transport up to the border.',
  [tokens.extraction.statisticalValueManualEntry]: 'Manual entry',
  [tokens.extraction.statisticalValueManualEntryHelpOff]:
    'Value calculated automatically according to the incoterm.',
  [tokens.extraction.statisticalValueManualEntryHelpOn]:
    'Free value. Switch back to auto to recalculate.',
  [tokens.extraction.statisticalValueManualInputPlaceholder]:
    '{{value}} (calculated value)',
  [tokens.extraction.statisticalValueManualCalculatedHint]:
    'Calculated value ({{description}}): {{value}} {{currency}}. Click to reuse it, or enter another.',
  [tokens.extraction.statisticalValueManualReuseCalculatedValue]:
    'Reuse the calculated value',
  [tokens.extraction.statisticalValueTransportAbroad]: 'Transport abroad',
  [tokens.extraction.statisticalValueTransportAbroadHelp]:
    'Portion beyond the border, excluded from the addition.',
  [tokens.extraction.statisticalValueBreakdownArticles]: 'Items amount',
  [tokens.extraction.statisticalValueBreakdownTransport]:
    'Transport up to the French border',
  [tokens.extraction.statisticalValueBreakdownMiscFees]: 'Miscellaneous fees',
  [tokens.extraction.noStatisticalValueDocumentsFound]:
    'No statistical value documents found',
  [tokens.extraction.conversionSourcedFrom]:
    'Conversion sourced from {{source}} on {{date}}',
  [tokens.extraction.fieldsList]: 'Fields list',
  [tokens.extraction.runTableAutomations]: 'Run Table automations',
  [tokens.extraction.runReferentialAutomations]: 'Run referential automation',
  [tokens.extraction.referentialAutomationDrawerTitle]: 'Referential automation',
  [tokens.extraction.referentialAutomationDrawerSubtitle]:
    'Preview and apply an automation',
  [tokens.extraction.referentialAutomationPreviewHint]:
    'No values are written until you validate the preview',
  [tokens.extraction.referentialAutomationSelectLabel]: 'Automation to run',
  [tokens.extraction.referentialAutomationSourceLabel]: 'Referential: {{name}}',
  [tokens.extraction.referentialAutomationReadyTitle]: 'Ready to compare',
  [tokens.extraction.referentialAutomationReadyDescription]:
    'Run the automation to see, line by line, the values that will be completed or replaced from "{{name}}".',
  [tokens.extraction.referentialAutomationLaunch]: 'Run automation',
  [tokens.extraction.referentialAutomationApply]: 'Apply',
  [tokens.extraction.referentialAutomationApplySummary]:
    '{{count}} row(s) will be modified',
  [tokens.extraction.referentialAutomationApplySuccess]:
    'Automation applied successfully',
  [tokens.extraction.referentialAutomationApplyError]:
    'Error while applying the automation',
  [tokens.extraction.referentialAutomationRunError]:
    'Error while running the automation',
  [tokens.extraction.referentialAutomationNoReferentials]:
    'No referential automation available for this declaration',
  [tokens.extraction.referentialAutomationRowUpdateBadge]: 'To be updated',
  [tokens.extraction.referentialAutomationWillChangeLabel]: 'will change',
  [tokens.extraction.referentialAutomationWillChangeLabel_one]: 'will change',
  [tokens.extraction.referentialAutomationEmptyCell]: 'empty',
  [tokens.extraction.runMergeAutomations]: 'Run Merge automations',
  [tokens.extraction.duplicateThisDossier]: 'Duplicate this dossier',
  [tokens.extraction.renameThisDossier]: 'Rename this dossier',
  [tokens.extraction.renameDossierTitle]: 'Rename dossier',
  [tokens.extraction.manageTags]: 'Manage tags',
  [tokens.extraction.bugTagDuplicateTitle]: 'Mark as BUG',
  [tokens.extraction.bugTagDuplicateMessage]:
    'Do you want to duplicate this dossier to continue the declaration on a copy ? The current dossier will keep the BUG tag.',
  [tokens.extraction.bugTagDuplicateYes]: 'Yes, duplicate',
  [tokens.extraction.bugTagDuplicateNo]: 'No, tag only',
  [tokens.extraction.duplicatingFolder]: 'Duplicating declaration…',
  [tokens.extraction.folderDuplicatedSuccessfully]:
    'The dossier has been duplicated successfully.',
  [tokens.extraction.openDuplicatedFolder]: 'Open duplicated dossier',
  [tokens.extraction.viewingDuplicatedFolder]:
    'You are now viewing the duplicated declaration.',
  [tokens.extraction.editLockConflictTitle]: 'Declaration already being edited',
  [tokens.extraction.editLockConflictMessage]:
    '{{lockedBy}} has been editing this declaration since {{lockedAt}}. You can view in read-only mode or take over editing.',
  [tokens.extraction.editLockLostTitle]: 'Edit lock lost',
  [tokens.extraction.editLockLostMessage]:
    '{{takenOverBy}} has taken over editing this declaration. Your changes can no longer be saved.',
  [tokens.extraction.editLockLockRequiredTitle]: 'Edit lock required',
  [tokens.extraction.editLockLockRequiredMessage]:
    'An edit lock is required to modify this declaration. Retry or take over editing.',
  [tokens.extraction.editLockLockedBy]: 'Locked by {{lockedBy}}',
  [tokens.extraction.editLockTakeOver]: 'Take over editing',
  [tokens.extraction.editLockBackToList]: 'Back to list',
  [tokens.extraction.editLockUnknownUser]: 'another user',
  [tokens.extraction.editLockBannerEditing]: 'You are editing this declaration',
  [tokens.extraction.editLockBannerReadOnlyConflict]:
    'Read-only: {{lockedBy}} is editing this declaration',
  [tokens.extraction.editLockBannerReadOnlyLost]:
    'Read-only: {{takenOverBy}} has taken over editing',
  [tokens.extraction.editLockConflictTitle]: 'Declaration already being edited',
  [tokens.extraction.editLockConflictMessage]:
    '<bold>{{lockedBy}}</bold> has been editing this declaration since {{lockedSince}}. You can view it in read-only mode or take over editing.',
  [tokens.extraction.editLockSinceToday]: '{{time}} today',
  [tokens.extraction.editLockSinceYesterday]: '{{time}} yesterday',
  [tokens.extraction.editLockSinceOnDate]: '{{time}} on {{date}}',
  [tokens.extraction.editLockReadOnlyBadgeHint]: 'Click to take over editing',
  [tokens.extraction.editLockLostTitle]: 'Edit lock lost',
  [tokens.extraction.editLockLostMessage]:
    '<bold>{{takenOverBy}}</bold> has taken over editing this declaration. Your changes can no longer be saved.',
  [tokens.extraction.editLockLockRequiredTitle]: 'Edit lock required',
  [tokens.extraction.editLockLockRequiredMessage]:
    'An edit lock is required to modify this declaration. Retry or take over editing.',
  [tokens.extraction.editLockLockedBy]: 'Locked by {{lockedBy}}',
  [tokens.extraction.editLockTakeOver]: 'Take over editing',
  [tokens.extraction.editLockBackToList]: 'Back to list',
  [tokens.extraction.editLockUnknownUser]: 'another user',
  [tokens.extraction.editLockBadgeEditing]: 'Edit',
  [tokens.extraction.editLockBadgeReadOnly]: 'Read',
  [tokens.extraction.editLockBannerEditing]: 'You are editing this declaration',
  [tokens.extraction.editLockBannerReadOnlyConflict]:
    'Read-only: {{lockedBy}} is editing this declaration',
  [tokens.extraction.editLockBannerReadOnlyLost]:
    'Read-only: {{takenOverBy}} has taken over editing',
  [tokens.extraction.editLockEditorTooltip]: '{{name}} is editing this declaration',
  [tokens.extraction.editLockConflictTitle]: 'Declaration already being edited',
  [tokens.extraction.editLockConflictMessage]:
    '<bold>{{lockedBy}}</bold> has been editing this declaration since {{lockedSince}}. You can view it in read-only mode or take over editing.',
  [tokens.extraction.editLockSinceToday]: '{{time}} today',
  [tokens.extraction.editLockSinceYesterday]: '{{time}} yesterday',
  [tokens.extraction.editLockSinceOnDate]: '{{time}} on {{date}}',
  [tokens.extraction.editLockReadOnlyBadgeHint]: 'Click to take over editing',
  [tokens.extraction.editLockLostTitle]: 'Edit lock lost',
  [tokens.extraction.editLockLostMessage]:
    '<bold>{{takenOverBy}}</bold> has taken over editing this declaration. Your changes can no longer be saved.',
  [tokens.extraction.editLockLockRequiredTitle]: 'Edit lock required',
  [tokens.extraction.editLockLockRequiredMessage]:
    'An edit lock is required to modify this declaration. Retry or take over editing.',
  [tokens.extraction.editLockLockedBy]: 'Locked by {{lockedBy}}',
  [tokens.extraction.editLockTakeOver]: 'Take over editing',
  [tokens.extraction.editLockBackToList]: 'Back to list',
  [tokens.extraction.editLockUnknownUser]: 'another user',
  [tokens.extraction.editLockBadgeEditing]: 'Edit',
  [tokens.extraction.editLockBadgeReadOnly]: 'Read',
  [tokens.extraction.editLockBannerEditing]: 'You are editing this declaration',
  [tokens.extraction.editLockBannerReadOnlyConflict]:
    'Read-only: {{lockedBy}} is editing this declaration',
  [tokens.extraction.editLockBannerReadOnlyLost]:
    'Read-only: {{takenOverBy}} has taken over editing',
  [tokens.extraction.editLockEditorTooltip]: '{{name}} is editing this declaration',
  [tokens.extraction.createAModelFromThisDossier]:
    'Create a model from this dossier',
  [tokens.extraction.createANewClientOrganizationFromThisDossier]:
    'Create a new Client Organization from this dossier',
  [tokens.extraction.tableAutomations]: 'Table Automations',
  [tokens.extraction.tableAutomationMatchesFound]:
    'Table Automation matches found',
  [tokens.extraction.payloads]: 'Payloads',
  [tokens.extraction.noTableAutomationsFound]: 'No Table Automations found',
  [tokens.extraction.noAutomationGroupsFound]: 'No Automation Groups found',
  [tokens.extraction.noTableInDocument]:
    'We were unable to define an item table in the document. Please define the item table manually.',
  [tokens.extraction.allFieldsValidated]:
    'All fields in this section have been validated.',
  [tokens.extraction.fieldsInError]:
    '{{errorsCount}} fields in error in this section.',
  [tokens.extraction.fieldsValidationProgress]:
    '{{validatedFields}} fields validated out of a total of {{totalFields}} in this section.',
  [tokens.extraction.totalFieldsToValidate]:
    'A total of {{totalFields}} fields to validate in this section.',
  [tokens.extraction.sectionCompleted]:
    'All required fields in this section are filled.',
  [tokens.extraction.sectionCompletionProgress]:
    '{{filledFields}}/{{totalFields}} required fields filled in this section.',
  [tokens.extraction.dossierReferenceCopiedToClipboard]:
    'Dossier Reference Copied To Clipboard',
  [tokens.extraction.comments]: 'Comments',
  [tokens.extraction.addAComment]: 'Add a comment',
  [tokens.extraction.commentsForThisDeclaration]:
    'Comments for this declaration',
  [tokens.extraction.downloadDeclarationOutputFile]: 'Download the output file',
  [tokens.extraction.settingsDrawerTreatment]: 'Treatment',
  [tokens.extraction.settingsDrawerFolder]: 'Declaration',
  [tokens.extraction.settingsDrawerComments]: 'Comments',
  [tokens.extraction.settingsDrawerTags]: 'Tags',
  [tokens.extraction.settingsDrawerLayout]: 'Layout',
  [tokens.extraction.settingsDrawerOpenComments]: 'Open comments',
  [tokens.extraction.settingsDrawerInvertDocumentPanel]:
    'Invert document / panel',
  [tokens.extraction.settingsDrawerLayoutBalanced]: 'Balanced',
  [tokens.extraction.settingsDrawerLayoutDocument]: 'Document',
  [tokens.extraction.settingsDrawerLayoutPanel]: 'Panel',
  [tokens.extraction.settingsDrawerLayoutDocumentTable]: 'Document + Table',
  [tokens.extraction.rossumExtractionNoCompatibleLayer]:
    'No Rossum extraction mode (external_rossum) is available for one or more documents in this declaration.',
  [tokens.extraction.updateExtractionModelTitle]: 'Extraction model',
  [tokens.extraction.selectExtractionModel]: 'Extraction model',
  [tokens.extraction.extractionModelRegenerateAlertToNew]:
    'Warning: you are about to regenerate the extraction with <bold>the new model</bold>. Do you want to confirm?',
  [tokens.extraction.extractionModelRegenerateAlertToLegacy]:
    'Warning: you are about to regenerate the extraction with <bold>the older model</bold>. Do you want to confirm?',
  [tokens.extraction.newInterfaceToggleLabel]: 'New interface',
  [tokens.extraction.newInterfaceBetaBadge]: 'BETA',
  [tokens.extraction.newInterfacePlaceholder]:
    'The new interface will be available here soon.',
  [tokens.extraction.betaStepHeadersTitle]: 'Headers',
  [tokens.extraction.betaStepHeadersSubtitle]: 'Identification & parties',
  [tokens.extraction.betaStepArticlesTitle]: 'Items',
  [tokens.extraction.betaStepArticlesSubtitle]: 'Declaration lines',
  [tokens.extraction.betaStepDeliveryTitle]: 'Delivery & Transport',
  [tokens.extraction.betaStepDeliverySubtitle]: 'Packaging & weights',
  [tokens.extraction.betaStepRegulationTitle]: 'Regulation & Customs',
  [tokens.extraction.betaStepRegulationSubtitle]: 'Regime & procedure',
  [tokens.extraction.betaStepControlTitle]: 'Control & Submit',
  [tokens.extraction.betaStepTotalsTitle]: 'Totals',
  [tokens.extraction.betaStepControlSubtitle]: 'Invoicing & statistical value',
  [tokens.extraction.betaActionAssistant]: 'Assistant',
  [tokens.extraction.betaActionAssistantTooltip]:
    'Ask about this declaration or request a field correction, a comment or tags, applied after your confirmation.',
  [tokens.extraction.betaActionSourceDocument]: 'Source document',
  [tokens.extraction.betaActionSourceDocumentTooltip]:
    'Open the source document to compare with the declaration.',
  [tokens.extraction.betaActionArticlesTable]: 'Items table',
  [tokens.extraction.betaActionStartReview]: 'Start review',
  [tokens.extraction.betaActionStartReviewTooltip]:
    'Review anomalies and suggestions one by one, with automatic focus on the relevant field.',
  [tokens.extraction.betaStatusCritical]: 'Critical',
  [tokens.extraction.betaStatusWarning]: 'Warnings',
  [tokens.extraction.betaStatusSuggestion]: 'Suggestions',
  [tokens.extraction.betaReviewProgress]: '{{current}}/{{total}} {{anomalyLabel}}',
  [tokens.extraction.betaReviewCounter]: '{{current}} / {{total}}',
  [tokens.extraction.betaReviewPrevious]: 'Previous anomaly',
  [tokens.extraction.betaReviewNext]: 'Next anomaly',
  [tokens.extraction.betaReviewOpenTable]: 'Open table',
  [tokens.extraction.betaReviewVerified]: 'Verified',
  [tokens.extraction.betaReviewClose]: 'Close review',
  [tokens.extraction.betaReviewNavigate]: 'Go to field',
  [tokens.extraction.betaReviewPanelTitle]: 'Declaration review',
  [tokens.extraction.betaReviewPanelSubtitle]:
    'Fix anomalies and review suggestions.',
  [tokens.extraction.betaReviewPanelStartReviewHint]:
    'Review {{count}} anomaly one by one',
  [tokens.extraction.betaReviewPanelStartReviewHint_other]:
    'Review all {{count}} anomalies one by one',
  [tokens.extraction.betaReviewPanelSectionBlocking]: 'BLOCKING FOR EXPORT',
  [tokens.extraction.betaReviewPanelSectionToVerify]: 'TO VERIFY',
  [tokens.extraction.betaReviewPanelExportBlockedFooter]:
    'Export is blocked until every critical anomaly is resolved.',
  [tokens.extraction.betaReviewPanelTabAnomalies]: 'Anomalies ({{count}})',
  [tokens.extraction.betaReviewPanelTabSuggestions]: 'Suggestions ({{count}})',
  [tokens.extraction.betaReviewPanelNoAnomalies]: 'No remaining anomalies.',
  [tokens.extraction.betaReviewPanelNoSuggestions]: 'No AI suggestions yet.',
  [tokens.extraction.betaStatusSummary]: '{{critical}} critical · {{warning}} gaps',
  [tokens.extraction.betaStatusSuggestionCount]: '{{count}} suggestions',
  [tokens.extraction.betaExportBlockedTitle]: 'Critical anomalies to fix',
  [tokens.extraction.betaExportBlockedDescription]:
    '{{count}} critical inconsistency is blocking declaration send.',
  [tokens.extraction.betaExportBlockedDescription_other]:
    '{{count}} critical inconsistencies are blocking declaration send.',
  [tokens.extraction.betaExportBlockedReview]: 'View anomalies',
  [tokens.extraction.betaExportBlockedClose]: 'Dismiss alert',
  [tokens.extraction.betaSuggestionsBannerTitle]: 'AI suggestions',
  [tokens.extraction.betaSuggestionsBannerSubtitle]: 'to accept or ignore',
  [tokens.extraction.betaSuggestionsBannerHide]: 'Hide',
  [tokens.extraction.betaSuggestionAccept]: 'Accept',
  [tokens.extraction.betaSuggestionIgnore]: 'Ignore',
  [tokens.extraction.betaSuggestionConfidence_high]: 'High confidence',
  [tokens.extraction.betaSuggestionConfidence_medium]: 'Medium confidence',
  [tokens.extraction.betaSuggestionConfidence_low]: 'Low confidence',
  [tokens.extraction.betaStepArticlesPlaceholder]:
    'The items table will open in a dedicated window.',
  [tokens.extraction.betaStepControlPlaceholder]:
    'Totals and controls will be displayed here.',
  [tokens.extraction.betaStepEmptyContent]:
    'No content available for this step.',
  [tokens.extraction.macroCheckAmount]: 'Amount',
  [tokens.extraction.macroCheckPackages]: 'Number of packages',
  [tokens.extraction.macroCheckGrossMass]: 'Gross mass',
  [tokens.extraction.macroCheckNetMass]: 'Net mass',
  [tokens.extraction.macroCheckOk]: 'OK',
  [tokens.extraction.macroCheckLineSum]: 'Sum of article lines:',
  [tokens.extraction.macroCheckSourceUnavailable]: 'Not extracted',
  [tokens.extraction.macroCheckTooltipAmount]:
    'Compares the sum of the Amount column (all lines, including fees and discounts) with the invoiced amount from invoices whose lines are in the table.',
  [tokens.extraction.macroCheckTooltipPackages]:
    'Compares the sum of packages allocated to lines with the package count declared on documents in the same perimeter. Fee and discount lines have no packages.',
  [tokens.extraction.macroCheckTooltipGrossMass]:
    'Compares the sum of allocated gross masses with the gross mass declared on documents in the same perimeter. Fee and discount lines have no mass.',
  [tokens.extraction.macroCheckTooltipNetMass]:
    'Compares the sum of allocated net masses with the net mass declared on documents in the same perimeter. Fee and discount lines have no mass.',
  [tokens.extraction.macroCheckFilterAmount]: 'Lines with an amount issue',
  [tokens.extraction.macroCheckFilterPackages]: 'Lines without packages',
  [tokens.extraction.macroCheckFilterGrossMass]: 'Lines without gross mass',
  [tokens.extraction.macroCheckFilterNetMass]: 'Lines without net mass',
  [tokens.extraction.stepDocumentWindowTitle]: 'Source document',
  [tokens.extraction.stepArticlesWindowTitle]: 'Items table',
  [tokens.extraction.stepArticlesWindowOpenHint]:
    'The items table is open in a floating window.',
  [tokens.extraction.stepSourceDocumentPin]: 'Pin document to page',
  [tokens.extraction.stepSourceDocumentUnpin]: 'Unpin document',
  [tokens.extraction.stepSourceDocumentFullscreen]: 'Display full screen',
  [tokens.extraction.stepSourceDocumentOpenInOtherWindow]:
    'Open the source document in another window',
  [tokens.extraction.stepSourceDocumentOpenedInOtherWindow]:
    'Source document already open in another window',
  [tokens.extraction.stepSourceDocumentSecondScreenTitle]: 'Show the document on your second screen',
  [tokens.extraction.stepSourceDocumentSecondScreenBody]:
    "Nabu can open the source document directly on your other screen. Your browser will ask for permission to “manage windows on all your displays”: accept it and you won't be asked again.",
  [tokens.extraction.stepSourceDocumentSecondScreenContinue]: 'Continue',
  [tokens.extraction.stepSourceDocumentSecondScreenTab]: 'Open in a tab',
  [tokens.extraction.stepSourceDocumentExitFullscreen]: 'Exit full screen',
  [tokens.extraction.stepSourceDocumentClose]: 'Close document',
  [tokens.extraction.stepSourceDocumentResizeHandle]: 'Resize source document panel',
  [tokens.extraction.stepSourceDocumentTextCopied]: 'Text copied',
  [tokens.extraction.stepSourceDocumentTextCopyFailed]: 'Unable to copy text',
  [tokens.extraction.stepArticlesValuesPasted]: 'Values pasted',
  [tokens.extraction.stepArticlesValuesPasteFailed]: 'Unable to paste values',
  [tokens.extraction.stepSourceDocumentPdfCopyHint]:
    'Select the area to copy, then paste it ({{command}}).',
  [tokens.extraction.stepSourceDocumentExcelCopyHint]:
    'Select one or more cells, then copy ({{command}}).',
  [tokens.extraction.stepAssistantWindowTitle]: 'Nabu Assistant',
  [tokens.extraction.stepAssistantHeading]: 'What should be done on this file?',
  [tokens.extraction.stepAssistantDescription]:
    'Ask about the folder: what blocks it, totals, missing fields, where a value comes from. I can also correct fields, add a comment or tags, always after your confirmation.',
  [tokens.extraction.stepAssistantSuggestedActionsLabel]: 'SUGGESTIONS',
  [tokens.extraction.stepAssistantPlaceholder]:
    'Hello, I am your declaration assistant. Ask me a question or choose a suggestion to continue your data entry.',
  [tokens.extraction.stepAssistantInputPlaceholder]:
    'Ask a question or request a correction…',
  [tokens.extraction.stepAssistantSend]: 'Send',
  [tokens.extraction.stepAssistantAddAttachment]: 'Add attachment',
  [tokens.extraction.stepAssistantVoiceInput]: 'Voice input',
  [tokens.extraction.stepAssistantVoiceStop]: 'Stop dictation',
  [tokens.extraction.stepAssistantVoiceTranscribing]:
    'Transcribing…',
  [tokens.extraction.stepAssistantVoiceMicrophoneDenied]:
    'The microphone is not available. Allow it in your browser.',
  [tokens.extraction.stepAssistantVoiceTooLong]:
    'Dictation too long: it was stopped and transcribed up to that point.',
  [tokens.extraction.stepAssistantVoiceFailed]:
    'The dictation could not be transcribed. Please try again.',
  [tokens.extraction.stepAssistantRefresh]: 'Reset conversation',
  [tokens.extraction.stepAssistantPin]: 'Pin assistant to page',
  [tokens.extraction.stepAssistantUnpin]: 'Detach assistant',
  [tokens.extraction.stepAssistantClose]: 'Close assistant',
  [tokens.extraction.stepAssistantResizeHandle]: 'Resize assistant panel',
  [tokens.extraction.stepAssistantSuggestedActionBlocked]:
    'Why is the declaration blocked?',
  [tokens.extraction.stepAssistantSuggestedActionTotals]:
    'Check the declaration totals',
  [tokens.extraction.stepAssistantSuggestedActionMissing]:
    'Which mandatory fields are missing?',
  [tokens.extraction.stepAssistantSuggestedActionHistory]:
    'Summarize the folder history',
  [tokens.extraction.stepAssistantSkillsLabel]: 'INSTRUCTIONS',
  [tokens.extraction.stepAssistantNoSkillsPrefix]: 'No instructions yet.',
  [tokens.extraction.stepAssistantCreateSkill]: 'Create an instruction',
  [tokens.extraction.stepAssistantAddSkill]: 'Enable an instruction',
  [tokens.extraction.stepAssistantSendTooltip]: 'Send · Enter',
  [tokens.extraction.stepAssistantRemoveSkill]: 'Remove {{name}}',
  [tokens.extraction.stepAssistantSkillsHint]: 'Active instructions guide the Nabu Assistant in your next messages.',
  [tokens.extraction.stepAssistantApprove]: 'Confirm',
  [tokens.extraction.stepAssistantDeny]: 'Deny',
  [tokens.extraction.stepAssistantToolDone]: '{{action}}: done',
  [tokens.extraction.stepAssistantToolDenied]: '{{action}}: denied',
  [tokens.extraction.stepAssistantToolFailed]: '{{action}}: failed',
  [tokens.extraction.stepAssistantToolPartial]: '{{action}}: partly applied',
  [tokens.extraction.stepAssistantToolNotApplied]:
    '{{action}}: nothing was changed',
  [tokens.extraction.stepAssistantToolInProgress]: '{{action}}: in progress',
  [tokens.extraction.stepAssistantToolAddComment]:
    'Add a comment to the folder',
  [tokens.extraction.stepAssistantToolSetTags]: 'Replace the folder tags',
  [tokens.extraction.stepAssistantToolUpdateFields]:
    'Update declaration fields',
  [tokens.extraction.stepAssistantToolAddLines]: 'Add items to the declaration',
  [tokens.extraction.stepAssistantToolGetDossier]: 'Read the folder',
  [tokens.extraction.stepAssistantToolGetDossierDocuments]:
    'Read the folder documents',
  [tokens.extraction.stepAssistantToolGetDossierProgress]:
    'Read the folder progress',
  [tokens.extraction.stepAssistantToolGetDossierHistory]:
    'Read the folder history',
  [tokens.extraction.stepAssistantToolGetDossierErrorStatus]:
    'Read the folder errors',
  [tokens.extraction.stepAssistantToolGetDeclaration]: 'Read the declaration',
  [tokens.extraction.stepAssistantToolGetDeclarationValidation]:
    'Read the declaration validation',
  [tokens.extraction.stepAssistantToolGetDeclarationContent]:
    'Read the declaration content',
  [tokens.extraction.stepAssistantToolUnknown]: 'Assistant tool',
  [tokens.extraction.stepAssistantToolGetTags]: 'Read the tags',
  [tokens.extraction.stepAssistantToolGetDocumentFacts]:
    'Read the data of a document',
  [tokens.extraction.stepAssistantToolGetPageText]: 'Read the text of a page',
  [tokens.extraction.stepAssistantToolGetSpreadsheet]: 'Read the Excel sheet',
  [tokens.extraction.stepAssistantToolCompareDocuments]:
    'Compare the documents with the declaration',
  [tokens.extraction.stepAssistantToolGetDeclarationGestures]:
    'Read the declaration history',
  [tokens.extraction.stepAssistantToolGetExchangeRates]:
    'Look up exchange rates',
  [tokens.extraction.stepAssistantToolLookupCatalog]:
    'Look up catalog values',
  [tokens.extraction.stepAssistantToolGetDeclarationFields]:
    'Read the form fields',
  [tokens.extraction.stepAssistantToolExplainFieldValue]:
    'Trace where a value comes from',
  [tokens.extraction.stepAssistantToolFindClientHistory]:
    'Read the client’s history',
  [tokens.extraction.stepAssistantToolCalculate]: 'Calculate',
  [tokens.extraction.stepAssistantToolListInstructions]: 'View the instructions',
  [tokens.extraction.stepAssistantToolUpdateInstructionText]: 'Edit an instruction’s text',
  [tokens.extraction.stepAssistantToolSetInstructionAutomatic]: 'Change an instruction’s mode',
  [tokens.extraction.stepAssistantInstructionName]: 'Instruction “{{name}}”',
  [tokens.extraction.stepAssistantInstructionTextBefore]: 'Before: {{text}}',
  [tokens.extraction.stepAssistantInstructionTextAfter]: 'After: {{text}}',
  [tokens.extraction.stepAssistantInstructionBecomesAutomatic]: 'Becomes automatic: it can join a routine.',
  [tokens.extraction.stepAssistantInstructionBecomesOnDemand]: 'Becomes on demand: it is only used from the Assistant.',
  [tokens.extraction.stepAssistantApprovalShowAll]: 'Show all ({{count}})',
  [tokens.extraction.stepAssistantApprovalShowLess]: 'Show less',
  [tokens.extraction.stepAssistantWaitingForReply]:
    'Waiting for the assistant reply',
  [tokens.extraction.stepAssistantHistoryLoadError]:
    'Unable to load the conversation history.',
  [tokens.extraction.stepAssistantHistoryRetry]: 'Retry',
  [tokens.extraction.stepAssistantMessageTimeYesterday]: 'Yesterday, {{time}}',
  [tokens.extraction.stepAssistantMessageTimeOnDate]: '{{date}}, {{time}}',
  [tokens.extraction.stepAssistantReplyError]: "The assistant couldn't reply.",
  [tokens.extraction.stepAssistantQuotaReached]:
    'Your quota has been reached this month. Please contact an administrator.',
  [tokens.extraction.stepAssistantDisabled]:
    'The Nabu assistant is disabled for your organization. Please contact an administrator.',
  [tokens.extraction.stepAssistantThinking]: 'The Nabu Assistant is thinking…',
  [tokens.extraction.stepAssistantStepsOne]: '1 step',
  [tokens.extraction.stepAssistantStepsOther]: '{{count}} steps',
  [tokens.extraction.stepAssistantStepWrite]: 'Change',
  [tokens.extraction.stepFieldNotIdentified]: 'Not identified',
  [tokens.extraction.stepControlEnter]: 'Enter',
  [tokens.extraction.stepControlEmptyValue]: 'To fill in',
  [tokens.extraction.stepControlPanelValidation]: 'Control',
  [tokens.extraction.stepControlNoIssues]: 'No issues detected.',
  [tokens.extraction.stepControlSeverityCritical]: 'CRITICAL',
  [tokens.extraction.stepControlSeverityGap]: 'GAP',
  [tokens.extraction.stepControlAddTransportFees]: '+ Transport fees',
  [tokens.extraction.stepControlAdditionsDeductions]: '+ Additions & deductions',
  [tokens.extraction.stepControlTotalsPanelInfoTooltip]:
    'The total recorded on the documents is the reference. The sum of the article lines must match it.',
  [tokens.extraction.stepControlTotalsCardTotalOfDocument]: 'Document total',
  [tokens.extraction.stepControlTotalsCardLineSum]: 'Sum of article lines:',
  [tokens.extraction.stepControlTotalsCardIdentical]: 'Identical',
  [tokens.extraction.stepControlTotalsCardToFill]: '{{count}} to fill in',
  [tokens.extraction.stepControlTotalsCardSourceCountInvoices_one]:
    'Σ {{count}} invoice',
  [tokens.extraction.stepControlTotalsCardSourceCountInvoices_other]:
    'Σ {{count}} invoices',
  [tokens.extraction.stepControlTotalsCardSourceCountPackingLists_one]:
    'Σ {{count}} packing list',
  [tokens.extraction.stepControlTotalsCardSourceCountPackingLists_other]:
    'Σ {{count}} packing lists',
  [tokens.extraction.stepControlTotalsCardSumHint]:
    'The value above adds up these documents.',
  [tokens.extraction.stepControlTotalsCardDocTypeInvoice]: 'Invoice',
  [tokens.extraction.stepControlTotalsCardDocTypePackingList]: 'Packing list',
  [tokens.extraction.stepControlTotalsCardTooltipOk]:
    'Extracted from the source document: {{value}} {{unit}}, identical to the sum of the article lines.',
  [tokens.extraction.stepControlTotalsCardTooltipGap]:
    'Extracted from the source document: {{value}} {{unit}}. The sum of the article lines is {{lineValue}} {{unit}}.',
  [tokens.extraction.stepControlTotalsCardTooltipMissing]:
    'No value extracted from this document. Click to fill it in.',

  [tokens.extractionSteps['run-export']]: 'Run export',
  [tokens.extractionSteps['start-work']]: 'Start work',
  [tokens.extractionSteps['apply-specific-data']]: 'Apply specific data',
  [tokens.extractionSteps['publishing-page-messages']]:
    'Publishing page messages',
  [tokens.extractionSteps['start-extraction']]: 'Start extraction',
  [tokens.extractionSteps['apply-post-process']]: 'Apply post-process',
  [tokens.extractionSteps['batch-import-status-to-done']]:
    'Batch import status to done',
  [tokens.extractionSteps['parsing-ocr']]: 'Parsing OCR',
  [tokens.extractionSteps['get-fast-track-option']]: 'Get fast track option',
  [tokens.extractionSteps['handle-ocr']]: 'Handle OCR',
  [tokens.extractionSteps['collecting-configurations']]:
    'Collecting configurations',
  [tokens.extractionSteps['starting-work']]: 'Starting work',
  [tokens.extractionSteps['save-export-data']]: 'Save export data',
  [tokens.extractionSteps['update-batch-import-status']]:
    'Update batch import status',
  [tokens.extractionSteps['canceled-iteration']]: 'Canceled iteration',
  [tokens.extractionSteps['classification-done']]: 'Classification done',
  [tokens.extractionSteps['saving-pages']]: 'Saving pages',
  [tokens.extractionSteps['end-validation-work']]: 'End validation work',
  [tokens.extractionSteps['end-mapping-work']]: 'End mapping work',
  [tokens.extractionSteps['start-ocr-work']]: 'Start OCR work',
  [tokens.extractionSteps['create-files-in-database']]: 'Create files ',
  [tokens.extractionSteps['generate-export']]: 'Generate export',
  [tokens.extractionSteps['start-mapping-work']]: 'Start mapping work',
  [tokens.extractionSteps['segmentation-done']]: 'Segmentation',
  [tokens.extractionSteps['apply-segmentations']]: 'Apply segmentations',
  [tokens.extractionSteps['fetching-file']]: 'Fetching file',
  [tokens.extractionSteps['deskew']]: 'Deskew',

  [tokens.flows.sender]: 'Sender',
  [tokens.flows.receiver]: 'Receiver',
  [tokens.flows.modelType]: 'Model type',
  [tokens.flows.exportContext]: 'Export context',

  [tokens.segmentation.finishSegmentationStep]: 'Finish segmentation step',
  [tokens.segmentation.merge]: 'Merge',
  [tokens.segmentation.cut]: 'Cut',
  [tokens.segmentation.deletePage]: 'Delete page',
  [tokens.segmentation.keep]: 'Keep',

  [tokens.settings.noDocumentsFound]: 'No declaration found',
  [tokens.settings.docTitleProfile]: 'Profile',
  [tokens.settings.docTitleNotifications]: 'Notifications',
  [tokens.settings.docTitleSecurity]: 'Security',
  [tokens.settings.docTitleOrg]: 'Organization',
  [tokens.settings.docTitleFormCustomization]: 'Forms',
  [tokens.settings.formCustomizationPageTitle]: 'Forms',
  [tokens.settings.formCustomizationPageSubtitle]:
    'Reduce the Import form to the fields your declarants actually use, in the vocabulary of your customs software.',
  [tokens.settings.formCustomizationLoadError]:
    'Unable to load form customization.',
  [tokens.settings.formCustomizationMissingSchema]:
    'No Import schema is available for this organization.',
  [tokens.settings.formCustomizationConexTitle]: 'Conex',
  [tokens.settings.formCustomizationConexSubtitle]: 'Transfer In v4.0',
  [tokens.settings.formCustomizationConexDescription]:
    'Conex vocabulary labels, sections ordered like the Transfer In file, untransmitted fields hidden.',
  [tokens.settings.formCustomizationAkaneaTitle]: 'Akanéa',
  [tokens.settings.formCustomizationAkaneaSubtitle]: 'Douane .NET',
  [tokens.settings.formCustomizationAkaneaDescription]:
    'Akanéa vocabulary labels, parties grouped at the top, customs blocks collapsed at the end of entry.',
  [tokens.settings.formCustomizationLayoutName]: '{{name}} layout',
  [tokens.settings.formCustomizationApplyLayout]: 'Apply this template',
  [tokens.settings.formCustomizationAppliedBadge]: 'Applied',
  [tokens.settings.formCustomizationStartingModel]: 'Starting template',
  [tokens.settings.formCustomizationStartingModelSubtitle]:
    'Align data entry with your customs software. You can then reorganize everything to your liking.',
  [tokens.settings.formCustomizationNabuModelTitle]: 'Nabu standard template',
  [tokens.settings.formCustomizationNabuModelSubtitle]:
    'All Import schema fields, in Nabu order and vocabulary.',
  [tokens.settings.formCustomizationResetNabu]: 'Reset to standard',
  [tokens.settings.formCustomizationTabsContent]: 'Tab content',
  [tokens.settings.formCustomizationCollapseAll]: 'Collapse all',
  [tokens.settings.formCustomizationExpandAll]: 'Expand all',
  [tokens.settings.formCustomizationEdit]: 'Edit',
  [tokens.settings.formCustomizationTabTitleLabel]: 'Tab title',
  [tokens.settings.formCustomizationAddFieldAction]: 'Add',
  [tokens.settings.formCustomizationApplyConfirm]:
    'This layout replaces the current customization (labels, order, visibility, required fields). Continue?',
  [tokens.settings.formCustomizationApplyModalTitle]:
    'Layout {{name}} (all three tabs)',
  [tokens.settings.formCustomizationApplyModalConfirm]: 'Apply layout',
  [tokens.settings.formCustomizationResetConfirm]:
    'The original Nabu form will be restored. Continue?',
  [tokens.settings.formCustomizationTabHeaders]: 'Headers',
  [tokens.settings.formCustomizationTabDelivery]: 'Delivery & Transport',
  [tokens.settings.formCustomizationTabRegulation]: 'Regulation & Customs',
  [tokens.settings.formCustomizationVisibleSections]:
    '{{count}} visible section(s)',
  [tokens.settings.formCustomizationRenameTab]: 'Rename tab',
  [tokens.settings.formCustomizationSearchPlaceholder]:
    'Search a field...',
  [tokens.settings.formCustomizationFilterVisibility]: 'Visibility',
  [tokens.settings.formCustomizationFilterRequired]: 'Required',
  [tokens.settings.formCustomizationFilterAll]: 'All',
  [tokens.settings.formCustomizationFilterVisible]: 'Visible',
  [tokens.settings.formCustomizationFilterHidden]: 'Hidden',
  [tokens.settings.formCustomizationFilterRequiredOnly]: 'Required',
  [tokens.settings.formCustomizationFilterOptional]: 'Optional',
  [tokens.settings.formCustomizationShowRequiredBadge]: 'REQUIRED badge',
  [tokens.settings.formCustomizationPreview]: 'Preview',
  [tokens.settings.formCustomizationFieldsCount]: '{{visible}}/{{total}} fields',
  [tokens.settings.formCustomizationMoveSection]: 'Move to',
  [tokens.settings.formCustomizationSection]: 'Section',
  [tokens.settings.formCustomizationMoveField]: 'Move to',
  [tokens.settings.formCustomizationAddField]:
    '+ Add a field from the data model...',
  [tokens.settings.formCustomizationRequired]: 'Required',
  [tokens.settings.formCustomizationDefaultValue]: 'Default value',
  [tokens.settings.formCustomizationBehavior]: 'Behavior',
  [tokens.settings.formCustomizationBehaviorPrefilled]:
    'Prefilled, editable',
  [tokens.settings.formCustomizationBehaviorLocked]: 'Locked',
  [tokens.settings.formCustomizationBehaviorSuggested]: 'Suggested',
  [tokens.settings.formCustomizationDuplicate]: 'Duplicate',
  [tokens.settings.formCustomizationRemove]: 'Remove',
  [tokens.settings.formCustomizationHide]: 'Hide',
  [tokens.settings.formCustomizationShow]: 'Show',
  [tokens.settings.formCustomizationRequiredBadge]: 'REQUIRED',
  [tokens.settings.formCustomizationPreviewSelectPlaceholder]: 'Select…',
  [tokens.settings.formCustomizationLockedBadge]: 'Locked',
  [tokens.settings.formCustomizationSuggestedHint]: 'Suggestion: {{value}}',
  [tokens.settings.settingsUnsavedChanges]: 'Unsaved changes',
  [tokens.settings.settingsLeaveUnsavedTitle]: 'Leave without saving?',
  [tokens.settings.settingsLeaveUnsavedMessage]:
    'Your changes have not been saved. If you leave this page, they will be lost.',
  [tokens.settings.settingsLeaveUnsavedConfirm]: 'Leave without saving',
  [tokens.settings.formCustomizationSaved]: 'Customization saved',
  [tokens.settings.formCustomizationSaveError]:
    'Unable to save the customization.',
  [tokens.settings.formCustomizationAnomalyHiddenRequired]:
    '{{count}} required field(s) hidden: sending will be blocked without a value',
  [tokens.settings.formCustomizationAnomalyEmptySection]:
    'Visible section with no displayed field',
  [tokens.settings.formCustomizationAnomalyLockedNoDefault]:
    'Locked field without a default value',
  [tokens.settings.formCustomizationNoSections]:
    'No section matches the filters.',
  [tokens.settings.docTitleAgencies]: 'Agencies',
  [tokens.settings.docTitleMembers]: 'Users',
  [tokens.settings.docTitleRoles]: 'Roles and permissions',
  [tokens.settings.docTitleEmailTemplates]: 'Email templates',
  [tokens.settings.docTitleHelp]: 'Help center',
  [tokens.settings.docTitleAiAgents]: 'Nabu Assistant',
  [tokens.settings.sidebarKicker]: 'Settings',
  [tokens.settings.back]: 'Back',
  [tokens.settings.groupYourAccount]: 'Your account',
  [tokens.settings.groupOrganization]: 'Organization',
  [tokens.settings.groupModules]: 'Modules',
  [tokens.settings.groupSupport]: 'Support',
  [tokens.settings.navProfile]: 'Profile',
  [tokens.settings.navNotifications]: 'Notifications',
  [tokens.settings.navSecurity]: 'Security',
  [tokens.settings.navOrganization]: 'Organization',
  [tokens.settings.navAgencies]: 'Agencies',
  [tokens.settings.navMembers]: 'Users',
  [tokens.settings.navFormCustomization]: 'Forms',
  [tokens.settings.navRoles]: 'Roles and permissions',
  [tokens.settings.navEmailTemplates]: 'Email templates',
  [tokens.settings.navAiAgents]: 'Nabu Assistant',
  [tokens.settings.navHelpCenter]: 'Help center',
  [tokens.settings.helpBoxTitle]: 'Need help?',
  [tokens.settings.helpBoxBody]:
    'Read the Nabu documentation or contact support.',
  [tokens.settings.helpDocumentationLink]: 'Documentation',
  [tokens.settings.aiAgentsPageTitle]: 'Nabu Assistant',
  [tokens.settings.aiAgentsPageSubtitle]:
    'The instructions the Nabu Assistant applies for your organization.',
  [tokens.settings.aiAgentsLoadError]: 'Unable to load AI settings right now.',
  [tokens.settings.aiAgentsSkillsSectionTitle]: 'Instructions',
  [tokens.settings.aiAgentsSkillsSectionDescription]:
    'Define working methods. The Nabu Assistant consults them to guide its answers and actions.',
  [tokens.settings.aiAgentsNewSkillButton]: 'New instruction',
  [tokens.settings.aiAgentsCreateFirstSkillButton]: 'Create my first instruction',
  [tokens.settings.aiAgentsSkillsEmptyTitle]: 'No instruction defined',
  [tokens.settings.aiAgentsSkillsEmptyDescription]:
    'Add your first working methods so the Nabu Assistant can use them in its answers.',
  [tokens.settings.aiAgentsCreateSkillTitle]: 'New instruction',
  [tokens.settings.aiAgentsCreateSkillSubtitle]: 'The Nabu Assistant applies this method when you enable it in a conversation.',
  [tokens.settings.aiAgentsEditSkillTitle]: 'Edit instruction',
  [tokens.settings.aiAgentsSkillNameLabel]: 'Instruction name',
  [tokens.settings.aiAgentsSkillNameRequired]: 'Instruction name is required',
  [tokens.settings.aiAgentsSkillDescriptionLabel]: 'Description',
  [tokens.settings.aiAgentsSkillDescriptionPlaceholder]: 'What is this instruction for?',
  [tokens.settings.aiAgentsSkillIconLabel]: 'Icon',
  [tokens.settings.aiAgentsSkillWorkMethodLabel]: 'Working method',
  [tokens.settings.aiAgentsSkillWorkMethodPlaceholder]:
    'Describe step by step how the Nabu Assistant should proceed…',
  [tokens.settings.aiAgentsSkillWorkMethodTooltip]:
    'Describe the procedure step by step: the more precise, the more reliable the Nabu Assistant. E.g. check the tariff code, verify that weights and statistical value are consistent.',
  [tokens.settings.aiAgentsCreateSkillSubmit]: 'Create instruction',
  [tokens.settings.aiAgentsDeleteSkillTitle]: 'Delete instruction',
  [tokens.settings.aiAgentsDeleteSkillDescription]:
    'Are you sure you want to delete the instruction "{{name}}"?',
  [tokens.settings.aiAgentsSkillNabuBadge]: 'Nabu',
  [tokens.settings.aiAgentsSkillNabuTooltip]:
    'Provided by Nabu: available in the chat, not editable.',
  [tokens.settings.aiAgentsSkillDecTypesLabel]: 'Declaration types',
  [tokens.settings.aiAgentsSkillDecTypesHelper]:
    'None checked: the instruction applies to every type.',
  [tokens.settings.aiAgentsSkillDecTypesAll]: 'All types',
  [tokens.settings.aiAgentsSkillAutomaticLabel]: 'Automatic',
  [tokens.settings.aiAgentsSkillAutomaticHelper]:
    'An automatic instruction can join a routine. Otherwise, it is only used from the Assistant.',
  [tokens.settings.aiAgentsSkillAutomaticBadge]: 'Auto',
  [tokens.settings.aiAgentsRoutinesSectionTitle]: 'Routines',
  [tokens.settings.aiAgentsRoutinesSectionDescription]: 'A routine applies automatic instructions, in order, to the declarations of a client and a type, right after the intelligent preparation.',
  [tokens.settings.aiAgentsNewRoutineButton]: 'New routine',
  [tokens.settings.aiAgentsRoutinesEmptyTitle]: 'No routine yet',
  [tokens.settings.aiAgentsRoutinesEmptyDescription]: 'Create a routine to apply your automatic instructions to every declaration of a client.',
  [tokens.settings.aiAgentsRoutinesLoadError]: 'Unable to load routines right now.',
  [tokens.settings.aiAgentsCreateRoutineTitle]: 'New routine',
  [tokens.settings.aiAgentsEditRoutineTitle]: 'Edit routine',
  [tokens.settings.aiAgentsRoutineSubtitle]: 'Its instructions apply in order, after the intelligent preparation, before the declaration is shown.',
  [tokens.settings.aiAgentsRoutineNameLabel]: 'Routine name',
  [tokens.settings.aiAgentsRoutineClientLabel]: 'Client',
  [tokens.settings.aiAgentsRoutineClientHelper]: 'Empty: the routine applies to every client.',
  [tokens.settings.aiAgentsRoutineAllClients]: 'All clients',
  [tokens.settings.aiAgentsRoutineDecTypeLabel]: 'Declaration type',
  [tokens.settings.aiAgentsRoutineInstructionsLabel]: 'Instructions',
  [tokens.settings.aiAgentsRoutineInstructionsHelper]: 'Only automatic instructions can join a routine. Drag them to change their order.',
  [tokens.settings.aiAgentsRoutineAddInstruction]: 'Add an instruction',
  [tokens.settings.aiAgentsRoutineNoInstructionLeft]: 'No other automatic instruction applies to this type.',
  [tokens.settings.aiAgentsRoutineInstructionOtherType]: 'Does not apply to this declaration type: remove it.',
  [tokens.settings.aiAgentsRoutineInstructionUnavailable]: 'No longer available: remove it.',
  [tokens.settings.aiAgentsRoutineDragInstruction]: 'Move “{{name}}”',
  [tokens.settings.aiAgentsRoutineRemoveInstruction]: 'Remove from the routine',
  [tokens.settings.aiAgentsRoutineInstructionsCount]: '{{count}} instruction',
  [tokens.settings.aiAgentsRoutineInstructionsCount_other]: '{{count}} instructions',
  [tokens.settings.aiAgentsRoutineActive]: 'Active',
  [tokens.settings.aiAgentsRoutineInactive]: 'Inactive',
  [tokens.settings.aiAgentsCreateRoutineSubmit]: 'Create routine',
  [tokens.settings.aiAgentsDeleteRoutineTitle]: 'Delete routine',
  [tokens.settings.aiAgentsDeleteRoutineDescription]: 'Do you really want to delete the routine “{{name}}”? Its instructions are kept.',
  [tokens.settings.aiAgentsToastRoutineCreated]: 'Routine created',
  [tokens.settings.aiAgentsToastRoutineUpdated]: 'Routine updated',
  [tokens.settings.aiAgentsToastRoutineDeleted]: 'Routine deleted',
  [tokens.settings.aiAgentsRoutineConditionsTaken]: 'The routine “{{names}}” already applies to this client and type: deactivate it, or change the client or the type.',
  [tokens.settings.aiAgentsToastSkillInRoutine]: 'First remove this instruction from its routines: {{names}}.',
  [tokens.settings.aiAgentsBlockedByNabu]: 'Blocked by Nabu',
  [tokens.settings.aiAgentsBlockedByNabuTooltip]: 'Nabu blocked it: it no longer applies. Contact support to unblock it.',
  [tokens.settings.aiAgentsToastBlockedByNabu]: 'Blocked by Nabu: contact support to change it.',
  [tokens.settings.aiAgentsSkillScopeLabel]: 'Scope',
  [tokens.settings.aiAgentsSkillScopeHelper]:
    "An agency instruction applies to the agency, and to its sub-agencies if you include them; other agencies don't see it.",
  [tokens.settings.aiAgentsSkillAgencySubAgencies]: 'and its sub-agencies',
  [tokens.settings.aiAgentsSkillIconBook]: 'Book',
  [tokens.settings.aiAgentsSkillIconLightning]: 'Lightning',
  [tokens.settings.aiAgentsSkillIconGrid]: 'Grid',
  [tokens.settings.aiAgentsSkillIconDocument]: 'Document',
  [tokens.settings.aiAgentsSkillIconSearch]: 'Search',
  [tokens.settings.aiAgentsSkillIconLayers]: 'Layers',
  [tokens.settings.aiAgentsSkillIconShield]: 'Shield',
  [tokens.settings.aiAgentsSkillIconShuffle]: 'Shuffle',
  [tokens.settings.aiAgentsToastSkillCreated]: 'Instruction created',
  [tokens.settings.aiAgentsToastSkillUpdated]: 'Instruction updated',
  [tokens.settings.aiAgentsToastSkillDeleted]: 'Instruction deleted',
  [tokens.settings.aiAgentsToastSaveError]: 'Unable to save',
  [tokens.settings.previewNoticeLocalOnly]:
    'These toggles are only stored in this browser session. Server-side persistence will arrive in a future release.',
  [tokens.settings.previewNoticeInviteSoon]:
    'Inviting users from this screen is not available yet.',
  [tokens.settings.previewNoticeAgencyCreateSoon]:
    'Creating an agency from this screen is not available yet.',
  [tokens.settings.previewNoticeRolesReadOnly]:
    'This permission matrix is read-only until the dedicated API ships.',
  [tokens.settings.previewNoticeEmailTemplatesSoon]:
    'Editing email templates is not available yet.',
  [tokens.settings.previewNoticeHelpLinksSoon]:
    'Help and contact links will be wired up soon.',
  [tokens.settings.previewNoticeOrgConfigDemo]:
    'This tab demonstrates the field layout; saving does not yet change organization parameters on the server.',
  [tokens.settings.orgConfigDemoSaved]:
    'Saved locally (preview, not synced to the server).',
  [tokens.settings.profilePageTitle]: 'My account',
  [tokens.settings.profilePageSubtitle]:
    'Manage your personal information, preferences, and declaration settings.',
  [tokens.settings.profileSectionPersonal]: 'Personal information',
  [tokens.settings.profileSectionPersonalSubtitle]:
    'This information is visible to other users in your organization.',
  [tokens.settings.profileSectionPrefs]: 'Language & theme',
  [tokens.settings.profileSectionPrefsSubtitle]:
    'Language and interface appearance.',
  [tokens.settings.profileSectionDeclaration]: 'Declaration configuration',
  [tokens.settings.profileTabGeneral]: 'General',
  [tokens.settings.profileTabPreferences]: 'Preferences',
  [tokens.settings.profileTabConfiguration]: 'Configuration',
  [tokens.settings.profilePreferencesInterface]: 'Interface',
  [tokens.settings.profilePreferencesPreparation]: 'Declaration preparation',
  [tokens.settings.profilePreferencesPreparationClassic]: 'Classic preparation',
  [tokens.settings.profilePreferencesPreparationIntelligent]: 'Intelligent preparation',
  [tokens.settings.profilePreferencesBetaViews]: 'Beta interface layout - Intelligent preparation',
  [tokens.settings.profilePreferencesBetaViewsSubtitle]:
    'These layout settings only apply to the beta interface, each time a declaration opens in Intelligent preparation.',
  [tokens.settings.profilePreferencesSmartView]: 'Preferred view - Intelligent preparation',
  [tokens.settings.profilePreferencesSmartViewSubtitle]:
    'Interface version and layout applied each time a declaration opens in Intelligent preparation.',
  [tokens.settings.profilePreferencesSourceDocument]: 'Source document',
  [tokens.settings.profilePreferencesSourceDocumentDesc]:
    'Window for reading the declaration documents.',
  [tokens.settings.profilePreferencesControlPanel]: 'Checks',
  [tokens.settings.profilePreferencesControlPanelDesc]:
    'Gaps, anomalies and information before sending.',
  [tokens.settings.profilePreferencesAssistant]: 'Nabu Assistant',
  [tokens.settings.profilePreferencesAssistantDesc]:
    'Chat with the Nabu Assistant in the editor.',
  [tokens.settings.profilePreferencesHomeTab]: 'Home tab',
  [tokens.settings.profilePreferencesHomeTabDesc]:
    'Tab shown when a declaration opens.',
  [tokens.settings.profilePreferencesLoadState]: 'State on load',
  [tokens.settings.profilePreferencesPlacementHidden]: 'Closed (default)',
  [tokens.settings.profilePreferencesPlacementFloating]: 'Floating window',
  [tokens.settings.profilePreferencesPlacementLeft]: 'Pinned left',
  [tokens.settings.profilePreferencesPlacementRight]: 'Pinned right',
  [tokens.settings.profileSectionWorkMode]: 'Work mode',
  [tokens.settings.profileSectionWorkModeSubtitle]: 'Declaration preparation method.',
  [tokens.settings.profilePreferencesPreparationClassicDesc]:
    'Declaration fields are entered and checked manually.',
  [tokens.settings.profilePreferencesPreparationIntelligentDesc]:
    'Nabu AI pre-fills the declaration from the attached documents.',
  [tokens.settings.profilePreferencesInterfaceStandard]: 'Standard interface',
  [tokens.settings.profilePreferencesInterfaceBeta]: 'Interface',
  [tokens.settings.profilePreferencesInterfaceStandardDesc]: 'Current interface.',
  [tokens.settings.profilePreferencesInterfaceBetaDesc]:
    'Early access to new features. Choose the layout below.',
  [tokens.settings.profilePreferencesBetaBadge]: 'BETA',
  [tokens.settings.profilePreferencesPlacementClosed]: 'Closed',
  [tokens.settings.profilePreferencesDefaultTab]: 'Default tab',
  [tokens.settings.profilePreferencesSaved]: 'Preferences saved',
  [tokens.settings.profileConfigurationSectionSubtitle]:
    'Default settings applied to your declarations.',
  [tokens.settings.profileConfigurationTabPlaceholder]:
    'Detailed declaration configuration options will be available in a future release.',
  [tokens.settings.profileEmailLabel]: 'Email address',
  [tokens.settings.themeLabel]: 'Theme',
  [tokens.settings.themeLight]: 'Light',
  [tokens.settings.themeLightDesc]: 'White background, bright interface',
  [tokens.settings.themeDark]: 'Dark',
  [tokens.settings.themeDarkDesc]:
    'Dark background, easier on the eyes at night',
  [tokens.settings.themeSystem]: 'System',
  [tokens.settings.themeSystemDesc]:
    'Follows your device settings automatically',
  [tokens.settings.toastProfileUpdated]: 'Profile updated',
  [tokens.settings.toastProfileError]: 'Something went wrong',
  [tokens.settings.validationRequired]: 'Required',
  [tokens.settings.notificationsPageTitle]: 'Notifications',
  [tokens.settings.notificationsPageSubtitle]:
    'Choose when and how Nabu contacts you.',
  [tokens.settings.notificationsSectionEmail]: 'Email',
  [tokens.settings.notificationsMasterTitle]: 'All email notifications',
  [tokens.settings.notificationsMasterDesc]:
    'Enable or disable all alerts below at once.',
  [tokens.settings.notifAck]: 'Acknowledgement',
  [tokens.settings.notifAckDesc]: 'When a declaration is received by customs.',
  [tokens.settings.notifFinalized]: 'Finalization',
  [tokens.settings.notifFinalizedDesc]: 'When a declaration is completed.',
  [tokens.settings.notifDeclErr]: 'Declaration error',
  [tokens.settings.notifDeclErrDesc]: 'Rejection or administrative issue.',
  [tokens.settings.notifPipelineErr]: 'Pipeline error',
  [tokens.settings.notifPipelineErrDesc]: 'Ingestion or processing failure.',
  [tokens.settings.notifMasterStateAllOn]:
    'All notifications below are enabled.',
  [tokens.settings.notifMasterStatePartial]:
    'Some notifications are disabled. Enable all with one click.',
  [tokens.settings.notifMasterStateAllOff]: 'All notifications are disabled.',
  [tokens.settings.notifPipelineRowTitle]:
    'Error alert (pipeline_file_error, manual_file_error)',
  [tokens.settings.notifPipelineRowDesc]:
    'Notification when automatic ingestion or manual file processing fails.',
  [tokens.settings.securityPageTitle]: 'Security',
  [tokens.settings.securityPageSubtitle]:
    'Protect your account and control access.',
  [tokens.settings.securitySectionPasswordSubtitle]:
    'Change your password. Use 8 to 16 characters with uppercase, lowercase, numbers and special characters.',
  [tokens.settings.securityPasswordAside]:
    'For your safety, choose a long, unique password mixing letters, numbers and symbols. Nabu never stores your password in plain text.',
  [tokens.settings.securityUpdatePasswordButton]: 'Update password',
  [tokens.settings.orgPageTitle]: 'Organization',
  [tokens.settings.orgPageSubtitle]:
    'General settings, configuration, and organization automations.',
  [tokens.settings.orgTabGeneral]: 'General',
  [tokens.settings.orgTabConfiguration]: 'Configuration',
  [tokens.settings.orgTabPreferences]: 'Preferences',
  [tokens.settings.orgGeneralTitle]: 'General information',
  [tokens.settings.orgGeneralSubtitle]:
    'Information about your organization on Nabu.',
  [tokens.settings.orgFieldOrgName]: 'Organization name',
  [tokens.settings.orgFieldIdentifier]: 'Identifier',
  [tokens.settings.orgLoading]: 'Loading…',
  [tokens.settings.orgSaveDisabledHint]:
    'Changing the organization name requires Nabu support.',
  [tokens.settings.orgConfigChooseAgency]: 'Choose an agency',
  [tokens.settings.orgConfigChooseConfig]: 'Choose a configuration',
  [tokens.settings.orgConfigPlaceholder]:
    'Please select an agency and a configuration',
  [tokens.settings.orgConfigSectionTitle]: 'Organization configuration',
  [tokens.settings.orgConfigSectionSubtitle]:
    'Default values sent for this configuration.',
  [tokens.settings.orgPreferencesSoon]: 'Preferences — coming soon',
  [tokens.settings.agenciesPageTitle]: 'Agencies',
  [tokens.settings.agenciesPageSubtitle]:
    'Entities linked to your organization. Each agency groups its users, configurations, and automations.',
  [tokens.settings.agenciesNewButton]: 'New agency',
  [tokens.settings.agenciesSearchPlaceholder]: 'Search agencies…',
  [tokens.settings.agenciesLoading]: 'Loading…',
  [tokens.settings.agenciesEmpty]: 'No agencies found.',
  [tokens.settings.agenciesEmptySearch]: 'No agencies match your search.',
  [tokens.settings.agenciesEmptyOrgOnlyHint]:
    'Your organization has no child agencies yet. Declaration configurations and ingestion email addresses are managed at organization level.',
  [tokens.settings.agenciesEmptyOrgConfigurationLink]:
    'Open organization configuration',
  [tokens.settings.agenciesEmptyOrgEmailLink]: 'Open ingestion emails',
  [tokens.settings.agenciesMembersLabel]: 'Members',
  [tokens.settings.agenciesColType]: 'Type',
  [tokens.settings.agenciesColAgency]: 'Agency',
  [tokens.settings.agenciesColMembers]: 'Members',
  [tokens.settings.agenciesColAdministrator]: 'Administrator',
  [tokens.settings.agenciesInfoPopoverTitle]: 'Why organize as agencies?',
  [tokens.settings.agenciesInfoPopoverBody]:
    'An agency isolates customs configurations, users, and cases for a site or legal entity. Useful if you have several offices or brands under one Nabu account.',
  [tokens.settings.agenciesInfoHelpLink]: 'Learn more in the Help centre',
  [tokens.settings.agenciesViewGrid]: 'Grid view',
  [tokens.settings.agenciesViewList]: 'List view',
  [tokens.settings.agenciesAttachedTo]: 'Attached to {{name}}',
  [tokens.settings.agenciesAttachedToUnknown]: 'Attached to a parent agency',
  [tokens.settings.agenciesChildBadge]: 'Sub agency',
  [tokens.settings.agenciesChildTooltip]: 'Parent agency: {{name}}',
  [tokens.settings.agenciesTypeService]: 'Service',
  [tokens.settings.agenciesTypeTeam]: 'Team',
  [tokens.settings.agenciesTypeOffice]: 'Office',
  [tokens.settings.agenciesTypeOrganization]: 'Organization',
  [tokens.settings.agenciesTypeUndefined]: 'Undefined',
  [tokens.settings.membersPageTitle]: 'Users',
  [tokens.settings.membersPageSubtitle]: 'Manage members of your organization.',
  [tokens.settings.membersInvite]: 'Invite',
  [tokens.settings.membersSearchPlaceholder]: 'Search users…',
  [tokens.settings.membersLoading]: 'Loading…',
  [tokens.settings.membersEmpty]: 'No users found',
  [tokens.settings.membersColUser]: 'User',
  [tokens.settings.membersColEmail]: 'Email',
  [tokens.settings.membersColRole]: 'Role',
  [tokens.settings.membersYouBadge]: 'You',
  [tokens.settings.rolesPageTitle]: 'Roles and permissions',
  [tokens.settings.rolesPageSubtitle]:
    'Define access rights for each role in your organization.',
  [tokens.settings.rolesColPermission]: 'Permission',
  [tokens.settings.roleLabelAdmin]: 'Admin',
  [tokens.settings.roleLabelManager]: 'Manager',
  [tokens.settings.roleLabelOperator]: 'Operator',
  [tokens.settings.roleLabelReader]: 'Reader',
  [tokens.settings.roleLabelGuest]: 'Guest',
  [tokens.settings.emailTemplatesPageTitle]: 'Email templates',
  [tokens.settings.emailTemplatesPageSubtitle]:
    'Customize automated emails sent by Nabu to your team and clients.',
  [tokens.settings.emailTemplatesModify]: 'Edit',
  [tokens.settings.emailTemplatesFootnote]:
    'Templates keep communications consistent. Advanced editing is coming soon.',
  [tokens.settings.emailTplAckTitle]: 'Acknowledgement',
  [tokens.settings.emailTplAckDesc]:
    'Sent automatically when a declaration is taken in charge by customs.',
  [tokens.settings.emailTplFinalizedTitle]: 'Finalization confirmation',
  [tokens.settings.emailTplFinalizedDesc]:
    'Notifies the team when a declaration is accepted and closed.',
  [tokens.settings.emailTplDeclErrTitle]: 'Declaration error alert',
  [tokens.settings.emailTplDeclErrDesc]:
    'Immediate alert on rejection or administrative anomaly.',
  [tokens.settings.emailTplPipelineErrTitle]: 'Pipeline error alert',
  [tokens.settings.emailTplPipelineErrDesc]:
    'Notification when automatic ingestion or manual processing fails.',
  [tokens.settings.emailTplInviteTitle]: 'User invitation',
  [tokens.settings.emailTplInviteDesc]:
    'Email sent when inviting a new user to the organization.',
  [tokens.settings.helpPageTitle]: 'Help center',
  [tokens.settings.helpPageSubtitle]: 'Resources to use Nabu effectively.',
  [tokens.settings.helpCardDocTitle]: 'Documentation',
  [tokens.settings.helpCardDocDesc]: 'Guides covering all Nabu features.',
  [tokens.settings.helpCardDocAction]: 'Open',
  [tokens.settings.helpCardVideoTitle]: 'Video tutorials',
  [tokens.settings.helpCardVideoDesc]: 'Learn Nabu with step-by-step videos.',
  [tokens.settings.helpCardVideoAction]: 'Watch videos',
  [tokens.settings.helpCardChatTitle]: 'Support chat',
  [tokens.settings.helpCardChatDesc]: 'Ask our support team in real time.',
  [tokens.settings.helpCardChatAction]: 'Start',
  [tokens.settings.helpCardMailTitle]: 'Email support',
  [tokens.settings.helpCardMailDesc]: 'Send us a message; we reply within 24h.',
  [tokens.settings.helpCardMailAction]: 'Contact us',
  [tokens.settings.helpSearchPlaceholder]: 'Search an article…',
  [tokens.settings.helpHeroTitle]: 'How can we help you?',
  [tokens.settings.helpHeroSubtitle]:
    'Find answers, follow tutorials, or contact our support team.',
  [tokens.settings.helpFrequentSearches]: 'Frequent searches',
  [tokens.settings.helpPopularTitle]: 'Popular articles',
  [tokens.settings.helpBrowseByTheme]: 'Browse by theme',
  [tokens.settings.helpSearchResultsTitle]: 'Search results',
  [tokens.settings.helpArticlesCountLink]: '{{count}} article >',
  [tokens.settings.helpArticlesCountLink_other]: '{{count}} articles >',
  [tokens.settings.helpSupportCta]:
    'Can’t find your answer? Our team replies within 2 hours on business days.',
  [tokens.settings.helpSupportEmail]: 'Send an email',
  [tokens.settings.helpSupportChat]: 'Start a chat',
  [tokens.settings.helpCategoryAll]: 'All',
  [tokens.settings.helpCategoryDeclarationDouaniere]: 'Customs declaration',
  [tokens.settings.helpCategoryDeclarationDouaniereDesc]:
    'Create, validate and send your customs declarations.',
  [tokens.settings.helpCategoryExtractionDonnee]: 'Data extraction',
  [tokens.settings.helpCategoryExtractionDonneeDesc]:
    'How Nabu extracts data from your documents.',
  [tokens.settings.helpCategoryDocumentsDossiers]: 'Documents & declarations',
  [tokens.settings.helpCategoryDocumentsDossiersDesc]:
    'Manage your documents and declarations in Nabu.',
  [tokens.settings.helpCategoryClassificationDocumentaire]: 'Document classification',
  [tokens.settings.helpCategoryClassificationDocumentaireDesc]:
    'Automatically classify your documents.',
  [tokens.settings.helpCategoryAutomatisationMetier]: 'Business automation',
  [tokens.settings.helpCategoryAutomatisationMetierDesc]:
    'Automate your business processes with Nabu.',
  [tokens.settings.helpCategoryIntegrations]: 'Integrations',
  [tokens.settings.helpCategoryIntegrationsDesc]:
    'Connect Nabu to your tools and external systems.',
  [tokens.settings.helpArticlesCount]: '{{count}} article',
  [tokens.settings.helpArticlesCount_other]: '{{count}} articles',
  [tokens.settings.helpArticlesEmpty]: 'No articles found.',
  [tokens.settings.helpArticlesLoadError]: 'Unable to load help articles.',
  [tokens.settings.helpArticleLoadError]: 'Unable to load this article.',
  [tokens.settings.helpBackToList]: 'Back',
  [tokens.settings.helpBackToCategories]: 'Back to categories',
  [tokens.settings.helpPopularBadge]: 'Popular',
  [tokens.settings.helpFrequentSearchBadge]: 'Frequent search',
  [tokens.settings.helpFrequentSearchBadgeAria]: 'Search for « {{term}} »',
  [tokens.settings.helpReadingTime]: '{{minutes}} min read',
  [tokens.settings.helpReadingMinutesShort]: '{{minutes}} min',
  [tokens.settings.helpArticleViews]: '{{count}} views',
  [tokens.settings.helpArticleFeedbackQuestion]: 'Was this article helpful?',
  [tokens.settings.helpArticleFeedbackYes]: 'Yes',
  [tokens.settings.helpArticleFeedbackNo]: 'No',
  [tokens.settings.helpArticleFeedbackContactSupport]: 'Contact support',
  [tokens.settings.helpExpandArticle]: 'Expand',
  [tokens.settings.helpCollapseArticle]: 'Collapse',
  [tokens.settings.helpBugTitle]: 'Found a bug?',
  [tokens.settings.helpBugDesc]:
    'Report unexpected behaviour to help us improve Nabu.',
  [tokens.settings.helpBugAction]: 'Report an issue',
  [tokens.settings.permViewFolders]: 'View declarations',
  [tokens.settings.permCreateFolders]: 'Create declarations',
  [tokens.settings.permSendDeclarations]: 'Send declarations',
  [tokens.settings.permManageUsers]: 'Manage users',
  [tokens.settings.permManageOrg]: 'Manage organization',
  [tokens.settings.permManageIntegrations]: 'Manage integrations',
  [tokens.settings.docTitleProfile]: 'Profile',
  [tokens.settings.docTitleNotifications]: 'Notifications',
  [tokens.settings.docTitleSecurity]: 'Security',
  [tokens.settings.docTitleOrg]: 'Organization',
  [tokens.settings.docTitleAgencies]: 'Agencies',
  [tokens.settings.docTitleMembers]: 'Users',
  [tokens.settings.docTitleRoles]: 'Roles and permissions',
  [tokens.settings.docTitleEmailTemplates]: 'Email templates',
  [tokens.settings.docTitleHelp]: 'Help center',
  [tokens.settings.docTitleAiAgents]: 'Nabu Assistant',
  [tokens.settings.sidebarKicker]: 'Settings',
  [tokens.settings.back]: 'Back',
  [tokens.settings.groupYourAccount]: 'Your account',
  [tokens.settings.groupOrganization]: 'Organization',
  [tokens.settings.groupModules]: 'Modules',
  [tokens.settings.groupSupport]: 'Support',
  [tokens.settings.navProfile]: 'Profile',
  [tokens.settings.navNotifications]: 'Notifications',
  [tokens.settings.navSecurity]: 'Security',
  [tokens.settings.navOrganization]: 'Organization',
  [tokens.settings.navAgencies]: 'Agencies',
  [tokens.settings.navMembers]: 'Users',
  [tokens.settings.navFormCustomization]: 'Forms',
  [tokens.settings.navRoles]: 'Roles and permissions',
  [tokens.settings.navEmailTemplates]: 'Email templates',
  [tokens.settings.navAiAgents]: 'Nabu Assistant',
  [tokens.settings.navHelpCenter]: 'Help center',
  [tokens.settings.helpBoxTitle]: 'Need help?',
  [tokens.settings.helpBoxBody]:
    'Read the Nabu documentation or contact support.',
  [tokens.settings.helpDocumentationLink]: 'Documentation',
  [tokens.settings.aiAgentsPageTitle]: 'Nabu Assistant',
  [tokens.settings.aiAgentsPageSubtitle]:
    'The instructions the Nabu Assistant applies for your organization.',
  [tokens.settings.aiAgentsLoadError]: 'Unable to load AI settings right now.',
  [tokens.settings.aiAgentsSkillsSectionTitle]: 'Instructions',
  [tokens.settings.aiAgentsSkillsSectionDescription]:
    'Define working methods. The Nabu Assistant consults them to guide its answers and actions.',
  [tokens.settings.aiAgentsNewSkillButton]: 'New instruction',
  [tokens.settings.aiAgentsCreateFirstSkillButton]: 'Create my first instruction',
  [tokens.settings.aiAgentsSkillsEmptyTitle]: 'No instruction defined',
  [tokens.settings.aiAgentsSkillsEmptyDescription]:
    'Add your first working methods so the Nabu Assistant can use them in its answers.',
  [tokens.settings.aiAgentsCreateSkillTitle]: 'New instruction',
  [tokens.settings.aiAgentsCreateSkillSubtitle]: 'The Nabu Assistant applies this method when you enable it in a conversation.',
  [tokens.settings.aiAgentsEditSkillTitle]: 'Edit instruction',
  [tokens.settings.aiAgentsSkillNameLabel]: 'Instruction name',
  [tokens.settings.aiAgentsSkillNameRequired]: 'Instruction name is required',
  [tokens.settings.aiAgentsSkillDescriptionLabel]: 'Description',
  [tokens.settings.aiAgentsSkillDescriptionPlaceholder]: 'What is this instruction for?',
  [tokens.settings.aiAgentsSkillIconLabel]: 'Icon',
  [tokens.settings.aiAgentsSkillWorkMethodLabel]: 'Working method',
  [tokens.settings.aiAgentsSkillWorkMethodPlaceholder]:
    'Describe step by step how the Nabu Assistant should proceed…',
  [tokens.settings.aiAgentsSkillWorkMethodTooltip]:
    'Describe the procedure step by step: the more precise, the more reliable the Nabu Assistant. E.g. check the tariff code, verify that weights and statistical value are consistent.',
  [tokens.settings.aiAgentsCreateSkillSubmit]: 'Create instruction',
  [tokens.settings.aiAgentsDeleteSkillTitle]: 'Delete instruction',
  [tokens.settings.aiAgentsDeleteSkillDescription]:
    'Are you sure you want to delete the instruction "{{name}}"?',
  [tokens.settings.aiAgentsSkillIconBook]: 'Book',
  [tokens.settings.aiAgentsSkillIconLightning]: 'Lightning',
  [tokens.settings.aiAgentsSkillIconGrid]: 'Grid',
  [tokens.settings.aiAgentsSkillIconDocument]: 'Document',
  [tokens.settings.aiAgentsSkillIconSearch]: 'Search',
  [tokens.settings.aiAgentsSkillIconLayers]: 'Layers',
  [tokens.settings.aiAgentsSkillIconShield]: 'Shield',
  [tokens.settings.aiAgentsSkillIconShuffle]: 'Shuffle',
  [tokens.settings.aiAgentsToastSkillCreated]: 'Instruction created',
  [tokens.settings.aiAgentsToastSkillUpdated]: 'Instruction updated',
  [tokens.settings.aiAgentsToastSkillDeleted]: 'Instruction deleted',
  [tokens.settings.aiAgentsToastSaveError]: 'Unable to save',
  [tokens.settings.previewNoticeLocalOnly]:
    'These toggles are only stored in this browser session. Server-side persistence will arrive in a future release.',
  [tokens.settings.previewNoticeInviteSoon]:
    'Inviting users from this screen is not available yet.',
  [tokens.settings.previewNoticeAgencyCreateSoon]:
    'Creating an agency from this screen is not available yet.',
  [tokens.settings.previewNoticeRolesReadOnly]:
    'This permission matrix is read-only until the dedicated API ships.',
  [tokens.settings.previewNoticeEmailTemplatesSoon]:
    'Editing email templates is not available yet.',
  [tokens.settings.previewNoticeHelpLinksSoon]:
    'Help and contact links will be wired up soon.',
  [tokens.settings.previewNoticeOrgConfigDemo]:
    'This tab demonstrates the field layout; saving does not yet change organization parameters on the server.',
  [tokens.settings.orgConfigDemoSaved]:
    'Saved locally (preview, not synced to the server).',
  [tokens.settings.profilePageTitle]: 'My account',
  [tokens.settings.profilePageSubtitle]:
    'Manage your personal information, preferences, and declaration settings.',
  [tokens.settings.profileSectionPersonal]: 'Personal information',
  [tokens.settings.profileSectionPersonalSubtitle]:
    'This information is visible to other users in your organization.',
  [tokens.settings.profileSectionPrefs]: 'Language & theme',
  [tokens.settings.profileSectionPrefsSubtitle]:
    'Language and interface appearance.',
  [tokens.settings.profileSectionDeclaration]: 'Declaration configuration',
  [tokens.settings.profileTabGeneral]: 'General',
  [tokens.settings.profileTabPreferences]: 'Preferences',
  [tokens.settings.profileTabConfiguration]: 'Configuration',
  [tokens.settings.profilePreferencesInterface]: 'Interface',
  [tokens.settings.profilePreferencesPreparation]: 'Declaration preparation',
  [tokens.settings.profilePreferencesPreparationClassic]: 'Classic preparation',
  [tokens.settings.profilePreferencesPreparationIntelligent]: 'Intelligent preparation',
  [tokens.settings.profilePreferencesBetaViews]: 'Beta interface layout - Intelligent preparation',
  [tokens.settings.profilePreferencesBetaViewsSubtitle]:
    'These layout settings only apply to the beta interface, each time a declaration opens in Intelligent preparation.',
  [tokens.settings.profilePreferencesSmartView]: 'Preferred view - Intelligent preparation',
  [tokens.settings.profilePreferencesSmartViewSubtitle]:
    'Interface version and layout applied each time a declaration opens in Intelligent preparation.',
  [tokens.settings.profilePreferencesSourceDocument]: 'Source document',
  [tokens.settings.profilePreferencesSourceDocumentDesc]:
    'Window for reading the declaration documents.',
  [tokens.settings.profilePreferencesControlPanel]: 'Checks',
  [tokens.settings.profilePreferencesControlPanelDesc]:
    'Gaps, anomalies and information before sending.',
  [tokens.settings.profilePreferencesAssistant]: 'Nabu Assistant',
  [tokens.settings.profilePreferencesAssistantDesc]:
    'Chat with the Nabu Assistant in the editor.',
  [tokens.settings.profilePreferencesHomeTab]: 'Home tab',
  [tokens.settings.profilePreferencesHomeTabDesc]:
    'Tab shown when a declaration opens.',
  [tokens.settings.profilePreferencesLoadState]: 'State on load',
  [tokens.settings.profilePreferencesPlacementHidden]: 'Closed (default)',
  [tokens.settings.profilePreferencesPlacementFloating]: 'Floating window',
  [tokens.settings.profilePreferencesPlacementLeft]: 'Pinned left',
  [tokens.settings.profilePreferencesPlacementRight]: 'Pinned right',
  [tokens.settings.profileSectionWorkMode]: 'Work mode',
  [tokens.settings.profileSectionWorkModeSubtitle]: 'Declaration preparation method.',
  [tokens.settings.profilePreferencesPreparationClassicDesc]:
    'Declaration fields are entered and checked manually.',
  [tokens.settings.profilePreferencesPreparationIntelligentDesc]:
    'Nabu AI pre-fills the declaration from the attached documents.',
  [tokens.settings.profilePreferencesInterfaceStandard]: 'Standard interface',
  [tokens.settings.profilePreferencesInterfaceBeta]: 'Interface',
  [tokens.settings.profilePreferencesInterfaceStandardDesc]: 'Current interface.',
  [tokens.settings.profilePreferencesInterfaceBetaDesc]:
    'Early access to new features. Choose the layout below.',
  [tokens.settings.profilePreferencesBetaBadge]: 'BETA',
  [tokens.settings.profilePreferencesPlacementClosed]: 'Closed',
  [tokens.settings.profilePreferencesDefaultTab]: 'Default tab',
  [tokens.settings.profilePreferencesSaved]: 'Preferences saved',
  [tokens.settings.profileConfigurationSectionSubtitle]:
    'Default settings applied to your declarations.',
  [tokens.settings.profileConfigurationTabPlaceholder]:
    'Detailed declaration configuration options will be available in a future release.',
  [tokens.settings.profileEmailLabel]: 'Email address',
  [tokens.settings.themeLabel]: 'Theme',
  [tokens.settings.themeLight]: 'Light',
  [tokens.settings.themeLightDesc]: 'White background, bright interface',
  [tokens.settings.themeDark]: 'Dark',
  [tokens.settings.themeDarkDesc]:
    'Dark background, easier on the eyes at night',
  [tokens.settings.themeSystem]: 'System',
  [tokens.settings.themeSystemDesc]:
    'Follows your device settings automatically',
  [tokens.settings.toastProfileUpdated]: 'Profile updated',
  [tokens.settings.toastProfileError]: 'Something went wrong',
  [tokens.settings.validationRequired]: 'Required',
  [tokens.settings.notificationsPageTitle]: 'Notifications',
  [tokens.settings.notificationsPageSubtitle]:
    'Choose when and how Nabu contacts you.',
  [tokens.settings.notificationsSectionEmail]: 'Email',
  [tokens.settings.notificationsMasterTitle]: 'All email notifications',
  [tokens.settings.notificationsMasterDesc]:
    'Enable or disable all alerts below at once.',
  [tokens.settings.notifAck]: 'Acknowledgement',
  [tokens.settings.notifAckDesc]: 'When a declaration is received by customs.',
  [tokens.settings.notifFinalized]: 'Finalization',
  [tokens.settings.notifFinalizedDesc]: 'When a declaration is completed.',
  [tokens.settings.notifDeclErr]: 'Declaration error',
  [tokens.settings.notifDeclErrDesc]: 'Rejection or administrative issue.',
  [tokens.settings.notifPipelineErr]: 'Pipeline error',
  [tokens.settings.notifPipelineErrDesc]: 'Ingestion or processing failure.',
  [tokens.settings.notifMasterStateAllOn]:
    'All notifications below are enabled.',
  [tokens.settings.notifMasterStatePartial]:
    'Some notifications are disabled. Enable all with one click.',
  [tokens.settings.notifMasterStateAllOff]: 'All notifications are disabled.',
  [tokens.settings.notifPipelineRowTitle]:
    'Error alert (pipeline_file_error, manual_file_error)',
  [tokens.settings.notifPipelineRowDesc]:
    'Notification when automatic ingestion or manual file processing fails.',
  [tokens.settings.securityPageTitle]: 'Security',
  [tokens.settings.securityPageSubtitle]:
    'Protect your account and control access.',
  [tokens.settings.securitySectionPasswordSubtitle]:
    'Change your password. Use 8 to 16 characters with uppercase, lowercase, numbers and special characters.',
  [tokens.settings.securityPasswordAside]:
    'For your safety, choose a long, unique password mixing letters, numbers and symbols. Nabu never stores your password in plain text.',
  [tokens.settings.securityUpdatePasswordButton]: 'Update password',
  [tokens.settings.orgPageTitle]: 'Organization',
  [tokens.settings.orgPageSubtitle]:
    'General settings, configuration, and organization automations.',
  [tokens.settings.orgTabGeneral]: 'General',
  [tokens.settings.orgTabConfiguration]: 'Configuration',
  [tokens.settings.orgTabPreferences]: 'Preferences',
  [tokens.settings.orgGeneralTitle]: 'General information',
  [tokens.settings.orgGeneralSubtitle]:
    'Information about your organization on Nabu.',
  [tokens.settings.orgFieldOrgName]: 'Organization name',
  [tokens.settings.orgFieldIdentifier]: 'Identifier',
  [tokens.settings.orgLoading]: 'Loading…',
  [tokens.settings.orgSaveDisabledHint]:
    'Changing the organization name requires Nabu support.',
  [tokens.settings.orgConfigChooseAgency]: 'Choose an agency',
  [tokens.settings.orgConfigChooseConfig]: 'Choose a configuration',
  [tokens.settings.orgConfigPlaceholder]:
    'Please select an agency and a configuration',
  [tokens.settings.orgConfigSectionTitle]: 'Organization configuration',
  [tokens.settings.orgConfigSectionSubtitle]:
    'Default values sent for this configuration.',
  [tokens.settings.orgPreferencesSoon]: 'Preferences — coming soon',
  [tokens.settings.agenciesPageTitle]: 'Agencies',
  [tokens.settings.agenciesPageSubtitle]:
    'Entities linked to your organization. Each agency groups its users, configurations, and automations.',
  [tokens.settings.agenciesNewButton]: 'New agency',
  [tokens.settings.agenciesSearchPlaceholder]: 'Search agencies…',
  [tokens.settings.agenciesLoading]: 'Loading…',
  [tokens.settings.agenciesEmpty]: 'No agencies found.',
  [tokens.settings.agenciesEmptySearch]: 'No agencies match your search.',
  [tokens.settings.agenciesEmptyOrgOnlyHint]:
    'Your organization has no child agencies yet. Declaration configurations and ingestion email addresses are managed at organization level.',
  [tokens.settings.agenciesEmptyOrgConfigurationLink]:
    'Open organization configuration',
  [tokens.settings.agenciesEmptyOrgEmailLink]: 'Open ingestion emails',
  [tokens.settings.agenciesMembersLabel]: 'Users',
  [tokens.settings.agenciesColType]: 'Type',
  [tokens.settings.agenciesColAgency]: 'Agency',
  [tokens.settings.agenciesColMembers]: 'Users',
  [tokens.settings.agenciesColAdministrator]: 'Administrator',
  [tokens.settings.agenciesAdministratorLabel]: 'Administrator',
  [tokens.settings.agenciesAdministratorUnassigned]: 'Unassigned',
  [tokens.settings.agenciesInfoPopoverTitle]: 'Why organize as agencies?',
  [tokens.settings.agenciesInfoPopoverBody]:
    'An agency isolates customs configurations, users, and cases for a site or legal entity. Useful if you have several offices or brands under one Nabu account.',
  [tokens.settings.agenciesInfoHelpLink]: 'Learn more in the Help centre',
  [tokens.settings.agenciesViewGrid]: 'Grid view',
  [tokens.settings.agenciesViewList]: 'List view',
  [tokens.settings.agenciesAttachedTo]: 'Attached to {{name}}',
  [tokens.settings.agenciesAttachedToUnknown]: 'Attached to a parent agency',
  [tokens.settings.agenciesChildBadge]: 'Sub agency',
  [tokens.settings.agenciesChildTooltip]: 'Parent agency: {{name}}',
  [tokens.settings.agenciesTypeService]: 'Service',
  [tokens.settings.agenciesTypeTeam]: 'Team',
  [tokens.settings.agenciesTypeOffice]: 'Office',
  [tokens.settings.agenciesTypeOrganization]: 'Organization',
  [tokens.settings.agenciesTypeUndefined]: 'Undefined',
  [tokens.settings.membersPageTitle]: 'Users',
  [tokens.settings.membersPageSubtitle]: 'Manage members of your organization.',
  [tokens.settings.membersInvite]: 'Invite',
  [tokens.settings.membersSearchPlaceholder]: 'Search users…',
  [tokens.settings.membersLoading]: 'Loading…',
  [tokens.settings.membersEmpty]: 'No users found',
  [tokens.settings.membersColUser]: 'User',
  [tokens.settings.membersColEmail]: 'Email',
  [tokens.settings.membersColRole]: 'Role',
  [tokens.settings.membersYouBadge]: 'You',
  [tokens.settings.rolesPageTitle]: 'Roles and permissions',
  [tokens.settings.rolesPageSubtitle]:
    'Define access rights for each role in your organization.',
  [tokens.settings.rolesColPermission]: 'Permission',
  [tokens.settings.roleLabelAdmin]: 'Admin',
  [tokens.settings.roleLabelManager]: 'Manager',
  [tokens.settings.roleLabelOperator]: 'Operator',
  [tokens.settings.roleLabelReader]: 'Reader',
  [tokens.settings.roleLabelGuest]: 'Guest',
  [tokens.settings.emailTemplatesPageTitle]: 'Email templates',
  [tokens.settings.emailTemplatesPageSubtitle]:
    'Customize automated emails sent by Nabu to your team and clients.',
  [tokens.settings.emailTemplatesModify]: 'Edit',
  [tokens.settings.emailTemplatesFootnote]:
    'Templates keep communications consistent. Advanced editing is coming soon.',
  [tokens.settings.emailTplAckTitle]: 'Acknowledgement',
  [tokens.settings.emailTplAckDesc]:
    'Sent automatically when a declaration is taken in charge by customs.',
  [tokens.settings.emailTplFinalizedTitle]: 'Finalization confirmation',
  [tokens.settings.emailTplFinalizedDesc]:
    'Notifies the team when a declaration is accepted and closed.',
  [tokens.settings.emailTplDeclErrTitle]: 'Declaration error alert',
  [tokens.settings.emailTplDeclErrDesc]:
    'Immediate alert on rejection or administrative anomaly.',
  [tokens.settings.emailTplPipelineErrTitle]: 'Pipeline error alert',
  [tokens.settings.emailTplPipelineErrDesc]:
    'Notification when automatic ingestion or manual processing fails.',
  [tokens.settings.emailTplInviteTitle]: 'User invitation',
  [tokens.settings.emailTplInviteDesc]:
    'Email sent when inviting a new user to the organization.',
  [tokens.settings.helpPageTitle]: 'Help center',
  [tokens.settings.helpPageSubtitle]: 'Resources to use Nabu effectively.',
  [tokens.settings.helpCardDocTitle]: 'Documentation',
  [tokens.settings.helpCardDocDesc]: 'Guides covering all Nabu features.',
  [tokens.settings.helpCardDocAction]: 'Open',
  [tokens.settings.helpCardVideoTitle]: 'Video tutorials',
  [tokens.settings.helpCardVideoDesc]: 'Learn Nabu with step-by-step videos.',
  [tokens.settings.helpCardVideoAction]: 'Watch videos',
  [tokens.settings.helpCardChatTitle]: 'Support chat',
  [tokens.settings.helpCardChatDesc]: 'Ask our support team in real time.',
  [tokens.settings.helpCardChatAction]: 'Start',
  [tokens.settings.helpCardMailTitle]: 'Email support',
  [tokens.settings.helpCardMailDesc]: 'Send us a message; we reply within 24h.',
  [tokens.settings.helpCardMailAction]: 'Contact us',
  [tokens.settings.helpSearchPlaceholder]: 'Search an article…',
  [tokens.settings.helpHeroTitle]: 'How can we help you?',
  [tokens.settings.helpHeroSubtitle]:
    'Find answers, follow tutorials, or contact our support team.',
  [tokens.settings.helpFrequentSearches]: 'Frequent searches',
  [tokens.settings.helpPopularTitle]: 'Popular articles',
  [tokens.settings.helpBrowseByTheme]: 'Browse by theme',
  [tokens.settings.helpSearchResultsTitle]: 'Search results',
  [tokens.settings.helpArticlesCountLink]: '{{count}} article >',
  [tokens.settings.helpArticlesCountLink_other]: '{{count}} articles >',
  [tokens.settings.helpSupportCta]:
    'Can’t find your answer? Our team replies within 2 hours on business days.',
  [tokens.settings.helpSupportEmail]: 'Send an email',
  [tokens.settings.helpSupportChat]: 'Start a chat',
  [tokens.settings.helpCategoryAll]: 'All',
  [tokens.settings.helpCategoryDeclarationDouaniere]: 'Customs declaration',
  [tokens.settings.helpCategoryDeclarationDouaniereDesc]:
    'Create, validate and send your customs declarations.',
  [tokens.settings.helpCategoryExtractionDonnee]: 'Data extraction',
  [tokens.settings.helpCategoryExtractionDonneeDesc]:
    'How Nabu extracts data from your documents.',
  [tokens.settings.helpCategoryDocumentsDossiers]: 'Documents & declarations',
  [tokens.settings.helpCategoryDocumentsDossiersDesc]:
    'Manage your documents and declarations in Nabu.',
  [tokens.settings.helpCategoryClassificationDocumentaire]: 'Document classification',
  [tokens.settings.helpCategoryClassificationDocumentaireDesc]:
    'Automatically classify your documents.',
  [tokens.settings.helpCategoryAutomatisationMetier]: 'Business automation',
  [tokens.settings.helpCategoryAutomatisationMetierDesc]:
    'Automate your business processes with Nabu.',
  [tokens.settings.helpCategoryIntegrations]: 'Integrations',
  [tokens.settings.helpCategoryIntegrationsDesc]:
    'Connect Nabu to your tools and external systems.',
  [tokens.settings.helpArticlesCount]: '{{count}} article',
  [tokens.settings.helpArticlesCount_other]: '{{count}} articles',
  [tokens.settings.helpArticlesEmpty]: 'No articles found.',
  [tokens.settings.helpArticlesLoadError]: 'Unable to load help articles.',
  [tokens.settings.helpArticleLoadError]: 'Unable to load this article.',
  [tokens.settings.helpBackToList]: 'Back',
  [tokens.settings.helpBackToCategories]: 'Back to categories',
  [tokens.settings.helpPopularBadge]: 'Popular',
  [tokens.settings.helpFrequentSearchBadge]: 'Frequent search',
  [tokens.settings.helpFrequentSearchBadgeAria]: 'Search for « {{term}} »',
  [tokens.settings.helpReadingTime]: '{{minutes}} min read',
  [tokens.settings.helpReadingMinutesShort]: '{{minutes}} min',
  [tokens.settings.helpArticleViews]: '{{count}} views',
  [tokens.settings.helpArticleFeedbackQuestion]: 'Was this article helpful?',
  [tokens.settings.helpArticleFeedbackYes]: 'Yes',
  [tokens.settings.helpArticleFeedbackNo]: 'No',
  [tokens.settings.helpArticleFeedbackContactSupport]: 'Contact support',
  [tokens.settings.helpExpandArticle]: 'Expand',
  [tokens.settings.helpCollapseArticle]: 'Collapse',
  [tokens.settings.helpBugTitle]: 'Found a bug?',
  [tokens.settings.helpBugDesc]:
    'Report unexpected behaviour to help us improve Nabu.',
  [tokens.settings.helpBugAction]: 'Report an issue',
  [tokens.settings.permViewFolders]: 'View declarations',
  [tokens.settings.permCreateFolders]: 'Create declarations',
  [tokens.settings.permSendDeclarations]: 'Send declarations',
  [tokens.settings.permManageUsers]: 'Manage users',
  [tokens.settings.permManageOrg]: 'Manage organization',
  [tokens.settings.permManageIntegrations]: 'Manage integrations',
  [tokens.settings.docTitleSubscription]: 'Subscription',
  [tokens.settings.docTitleBilling]: 'Billing',
  [tokens.settings.navSubscription]: 'Subscription',
  [tokens.settings.navBilling]: 'Billing',
  [tokens.settings.subscriptionPageTitle]: 'Subscription',
  [tokens.settings.subscriptionPageSubtitle]:
    'Plan, billing cycle and credits.',
  [tokens.settings.subscriptionLoadError]:
    'Unable to load subscription information.',
  [tokens.settings.subscriptionPendingTitle]:
    'Choose your subscription to activate your credit allowance',
  [tokens.settings.subscriptionPendingBody]:
    'Your organization is ready. Select a plan and billing cycle, then activate your subscription to unlock credits.',
  [tokens.settings.subscriptionPendingCta]: 'Activate my subscription',
  [tokens.settings.subscriptionPendingPaymentTitle]:
    'Add a payment method to activate your subscription',
  [tokens.settings.subscriptionPendingPaymentBody]:
    'A card is required before activation. You can then finalize your subscription and receive your credits.',
  [tokens.settings.subscriptionPendingPaymentCta]: 'Add a payment method',
  [tokens.settings.subscriptionEmptyManualTitle]: 'Manual billing',
  [tokens.settings.subscriptionEmptyManualBody]:
    'Your organization is billed manually. Self-serve subscription management is not available. Contact your Nabu representative for any changes.',
  [tokens.settings.subscriptionEmptyNotConfiguredTitle]:
    'Subscription not configured',
  [tokens.settings.subscriptionEmptyNotConfiguredBody]:
    'No subscription is configured for your organization yet. Contact Nabu to activate your plan.',
  [tokens.settings.subscriptionCreditsBannerLowTitle]:
    'Credits running low',
  [tokens.settings.subscriptionCreditsBannerLowBody]:
    'You only have <strong>{{remaining}} credits</strong> left. Top up your account to avoid interrupting declaration processing.',
  [tokens.settings.subscriptionCreditsBannerExhaustedTitle]:
    'Credits exhausted',
  [tokens.settings.subscriptionCreditsBannerExhaustedBody]:
    'You only have <strong>{{remaining}} credits</strong> left. Top up your account to avoid interrupting declaration processing.',
  [tokens.settings.subscriptionCreditsBannerRecharge]: 'Top up credits',
  [tokens.settings.subscriptionCreditsBannerLater]: 'Later',
  [tokens.settings.subscriptionRecapTitle]: 'Summary',
  [tokens.settings.subscriptionRecapSubtitle]:
    'What will be charged at the next renewal.',
  [tokens.settings.subscriptionRecapSubtitlePending]:
    'Preview based on the selected plan, live after activation.',
  [tokens.settings.subscriptionRecapAmountMonthly]: 'Monthly amount',
  [tokens.settings.subscriptionRecapAmountAnnual]: 'Annual amount',
  [tokens.settings.subscriptionRecapPlanName]: '{{plan}} plan',
  [tokens.settings.subscriptionRecapAnnualSavingsBadge]: '− {{percent}}%',
  [tokens.settings.subscriptionRecapAnnualSavingsAmount]:
    '{{amount}} saved / year',
  [tokens.settings.subscriptionCustomPricingBadge]: 'Custom pricing',
  [tokens.settings.subscriptionRecapCredits]: 'Credits',
  [tokens.settings.subscriptionRecapCreditsUsed]: '{{percent}}% used',
  [tokens.settings.subscriptionRecapCreditsAvailable]: '{{remaining}} available',
  [tokens.settings.subscriptionRecapCreditsExtraPurchased]:
    'incl. {{count}} purchased',
  [tokens.settings.subscriptionRecapCreditsExtraGifted]:
    'incl. {{count}} gifted',
  [tokens.settings.subscriptionRecapCreditsEnvelopeUsed]:
    '{{percent}}% of allowance used',
  [tokens.settings.subscriptionRecapCreditsPending]: 'Not activated',
  [tokens.settings.subscriptionRecapCreditsPendingHint]:
    'Your allowance will be credited when you activate the subscription.',
  [tokens.settings.subscriptionRecapNextBilling]: 'Next billing date',
  [tokens.settings.subscriptionRecapNextBillingPending]: 'After activation',
  [tokens.settings.subscriptionRecapNextBillingPendingHint]:
    'The billing date will be set once the subscription is activated.',
  [tokens.settings.subscriptionRecapAutoCharge]: 'Automatic charge',
  [tokens.settings.subscriptionCreditsTitle]: 'Credits',
  [tokens.settings.subscriptionCreditsSubtitle]:
    'Your allowance renews at each billing date. Beyond that, extra credits are billed on usage.',
  [tokens.settings.subscriptionCreditsPendingTitle]:
    'Allowance not activated yet',
  [tokens.settings.subscriptionCreditsPendingBody]:
    'Activate your subscription to receive your credit allowance and start processing declarations.',
  [tokens.settings.subscriptionCreditsBuy]: '+ Buy credits',
  [tokens.settings.subscriptionCreditsConsumedLabel]: 'credits used',
  [tokens.settings.subscriptionCreditsAvailable]:
    '{{remaining}} credits available',
  [tokens.settings.subscriptionCreditsDeclarationsHint]:
    '≈ {{declarations}} declarations this month',
  [tokens.settings.subscriptionCreditsSourceSubscription]:
    'Subscription · {{count}}',
  [tokens.settings.subscriptionCreditsSourcePurchased]: 'Purchased · {{count}}',
  [tokens.settings.subscriptionCreditsSourceGifted]: 'Gifted · {{count}}',
  [tokens.settings.subscriptionCreditsEnvelopeLabel]: 'Monthly allowance',
  [tokens.settings.subscriptionCreditsEnvelopeConsumed]:
    '{{consumed}} / {{envelope}} used',
  [tokens.settings.subscriptionCreditsThresholdLow]: 'Running low',
  [tokens.settings.subscriptionCreditsThresholdExhausted]: 'Exhausted',
  [tokens.settings.subscriptionCreditsRemainingHint]:
    '{{remaining}} credits remaining, about {{declarations}} declarations this month.',
  [tokens.settings.subscriptionCreditsRateDeclaration]: '1 declaration',
  [tokens.settings.subscriptionCreditsRateArticle]: '1 item',
  [tokens.settings.subscriptionCreditsRateRollover]: 'Rollover',
  [tokens.settings.subscriptionCreditsRateCredits]: '{{count}} credits',
  [tokens.settings.subscriptionCreditsRolloverNone]: 'None',
  [tokens.settings.subscriptionCreditsRolloverMonths]:
    '{{count}}-month rollover',
  [tokens.settings.subscriptionCycleTitle]: 'Billing cycle',
  [tokens.settings.subscriptionCycleSubtitle]:
    'Choose to be billed every month or every year.',
  [tokens.settings.subscriptionCycleMonthly]: 'Monthly',
  [tokens.settings.subscriptionCycleMonthlyLine1]:
    'Charged on the 1st of each month.',
  [tokens.settings.subscriptionCycleMonthlyLine2]:
    'No commitment, cancel anytime.',
  [tokens.settings.subscriptionCycleAnnual]: 'Annual',
  [tokens.settings.subscriptionCycleAnnualBadge]: '− {{percent}}%',
  [tokens.settings.subscriptionCycleAnnualLine1]: 'Charged once a year.',
  [tokens.settings.subscriptionCycleAnnualLine2]:
    'Two months free, {{percent}}% savings.',
  [tokens.settings.subscriptionCycleEffectiveHint]:
    'Cycle changes take effect at the next renewal (no proration).',
  [tokens.settings.subscriptionPlansTitle]: 'Plan',
  [tokens.settings.subscriptionPlansSubtitle]:
    'Each plan includes a monthly credit allowance. A declaration consumes credits based on the plan.',
  [tokens.settings.subscriptionPlansSubtitlePending]:
    'Select the plan to activate. Enterprise requires contacting sales.',
  [tokens.settings.subscriptionPlansCompare]: 'Compare plans',
  [tokens.settings.subscriptionPlanPerMonth]: '/ month',
  [tokens.settings.subscriptionPlanPerYear]: '/ year',
  [tokens.settings.subscriptionPlanAnnualEquivalent]:
    'or {{amount}} / month billed annually',
  [tokens.settings.subscriptionPlanAnnualSavings]:
    '{{amount}} saved / year',
  [tokens.settings.subscriptionPlanEnvelopeBadge]:
    '{{credits}} credits included / month',
  [tokens.settings.subscriptionPlanCoverage]:
    '{{declarations}} declarations or {{articles}} items',
  [tokens.settings.subscriptionPlanImportExport]: 'IMPORT / EXPORT',
  [tokens.settings.subscriptionPlanCoverageDeclarations]:
    '{{count}} declarations',
  [tokens.settings.subscriptionPlanCoverageOr]: 'or',
  [tokens.settings.subscriptionPlanCoverageArticles]: '{{count}} items',
  [tokens.settings.subscriptionPlanRateDeclaration]:
    '1 declaration = {{count}} credits',
  [tokens.settings.subscriptionPlanRateArticle]:
    '1 item = {{count}} credits',
  [tokens.settings.subscriptionPlanRateLine]:
    '1 declaration = {{declaration}} credits · 1 item = {{article}} credits',
  [tokens.settings.subscriptionPlanExtraCredit]:
    'Extra credits: {{price}}/credit',
  [tokens.settings.subscriptionPlanMinGrowth]:
    'From 500 declarations / month',
  [tokens.settings.subscriptionPlanMinEnterprise]:
    'From 5K declarations / month',
  [tokens.settings.subscriptionPlanSetupFee]:
    'One-time setup fee: {{amount}}',
  [tokens.settings.subscriptionPlanCurrentBadge]: 'Current plan',
  [tokens.settings.subscriptionPlanRecommendedBadge]: 'Recommended',
  [tokens.settings.subscriptionPlanSelectedBadge]: 'Selected',
  [tokens.settings.subscriptionPlanCurrentCta]: 'Current plan',
  [tokens.settings.subscriptionPlanChooseCta]: 'Choose this plan',
  [tokens.settings.subscriptionPlanActivateCta]: 'Activate this plan',
  [tokens.settings.subscriptionPlanContactCta]: 'Contact us',
  [tokens.settings.subscriptionPlanFeatureStarterUsers]: 'Up to 3 users',
  [tokens.settings.subscriptionPlanFeatureStarterEmail]: 'Email support',
  [tokens.settings.subscriptionPlanFeatureStarterOnboarding]:
    'Self-serve onboarding',
  [tokens.settings.subscriptionPlanFeatureStarterArchive]: '1-year archiving',
  [tokens.settings.subscriptionPlanFeatureStarterCsv]: 'CSV export',
  [tokens.settings.subscriptionPlanFeatureStarterNoDashboard]:
    'No operations dashboard',
  [tokens.settings.subscriptionPlanFeatureStarterNoSla]:
    'No contractual SLA',
  [tokens.settings.subscriptionPlanFeatureStarterNoRollover]:
    'Credit rollover: none',
  [tokens.settings.subscriptionPlanFeatureGrowthIntro]:
    'Everything in Starter, plus:',
  [tokens.settings.subscriptionPlanFeatureGrowthUsers]: 'Unlimited users',
  [tokens.settings.subscriptionPlanFeatureGrowthDashboard]:
    'Operations dashboard',
  [tokens.settings.subscriptionPlanFeatureGrowthSla]: '99.0% SLA',
  [tokens.settings.subscriptionPlanFeatureGrowthSupport]:
    'Priority email + chat support',
  [tokens.settings.subscriptionPlanFeatureGrowthOnboarding]:
    'Guided onboarding',
  [tokens.settings.subscriptionPlanFeatureGrowthArchive]: '5-year archiving',
  [tokens.settings.subscriptionPlanFeatureGrowthConnectors]:
    'ERP / TMS connectors',
  [tokens.settings.subscriptionPlanFeatureGrowthApi]: 'API access',
  [tokens.settings.subscriptionPlanFeatureGrowthEdi]:
    'Real-time EDI validation',
  [tokens.settings.subscriptionPlanFeatureGrowthRollover]:
    'Credit rollover: 1 month',
  [tokens.settings.subscriptionPlanFeatureEnterpriseIntro]:
    'Everything in Growth, plus:',
  [tokens.settings.subscriptionPlanFeatureEnterpriseDashboard]:
    'Advanced dashboard',
  [tokens.settings.subscriptionPlanFeatureEnterpriseSla]:
    'Dedicated 99.9% SLA',
  [tokens.settings.subscriptionPlanFeatureEnterpriseAm]:
    'Dedicated account manager',
  [tokens.settings.subscriptionPlanFeatureEnterpriseOnboarding]:
    'Custom onboarding',
  [tokens.settings.subscriptionPlanFeatureEnterpriseSso]: 'SSO / SAML',
  [tokens.settings.subscriptionPlanFeatureEnterpriseCompliance]:
    'Advanced compliance (DGDDUI, GDPR+)',
  [tokens.settings.subscriptionPlanFeatureEnterpriseRouting]:
    'Multi-office customs routing',
  [tokens.settings.subscriptionPlanFeatureEnterpriseWorkflows]:
    'Custom workflows',
  [tokens.settings.subscriptionPlanFeatureEnterpriseRollover]:
    'Credit rollover: 3 months',
  [tokens.settings.subscriptionBuyCreditsTitle]: 'Buy credits',
  [tokens.settings.subscriptionBuyCreditsSubtitle]:
    'Choose a pack or enter a custom quantity. Credits are added to your allowance immediately.',
  [tokens.settings.subscriptionBuyCreditsPackLabel]: '{{credits}} credits',
  [tokens.settings.subscriptionBuyCreditsPackDecls]:
    '≈ {{count}} declarations',
  [tokens.settings.subscriptionBuyCreditsCustomLabel]: 'Custom quantity',
  [tokens.settings.subscriptionBuyCreditsCustomPlaceholder]:
    'Number of credits',
  [tokens.settings.subscriptionBuyCreditsPreview]:
    '{{quantity}} credits · {{amount}}',
  [tokens.settings.subscriptionBuyCreditsCancel]: 'Cancel',
  [tokens.settings.subscriptionBuyCreditsConfirm]: 'Confirm purchase',
  [tokens.settings.subscriptionToastCycleUpdated]:
    'Billing cycle updated.',
  [tokens.settings.subscriptionToastPlanUpdated]:
    'Plan updated.',
  [tokens.settings.subscriptionToastCreditsPurchased]:
    'Credits purchased successfully.',
  [tokens.settings.subscriptionToastActivated]:
    'Subscription activated. Your credit allowance is available.',
  [tokens.settings.subscriptionErrorGeneric]:
    'Something went wrong. Please try again.',
  [tokens.settings.subscriptionErrorContactRequired]:
    'Contact sales to activate the Enterprise plan.',
  [tokens.settings.subscriptionErrorActivationRequired]:
    'Activate your subscription first to perform this action.',
  [tokens.settings.subscriptionErrorPaymentMethodRequired]:
    'Add a payment method before activating your subscription.',
  [tokens.settings.subscriptionContactMailSubject]:
    'Request about my Nabu subscription',
  [tokens.settings.billingPageTitle]: 'Billing',
  [tokens.settings.billingPageSubtitle]:
    'Payment methods and billing history.',
  [tokens.settings.billingPageSubtitleAddPayment]:
    'Add a card so you can activate your subscription.',
  [tokens.settings.billingPageComingSoon]: 'This page is coming soon.',
  [tokens.settings.billingLoadError]:
    'Unable to load billing information.',
  [tokens.settings.billingAddPaymentTitle]: 'Payment method',
  [tokens.settings.billingAddPaymentBody]:
    'Save a payment card. Once saved, return to subscription to activate it.',
  [tokens.settings.billingAddPaymentPlaceholder]:
    'The Hyperline card form will be integrated here.',
  [tokens.settings.billingAddPaymentCancel]: 'Back',
  [tokens.settings.billingAddPaymentDone]:
    'Card added — back to subscription',
  [tokens.settings.billingAddPaymentBannerTitle]:
    'Add a card to activate your subscription',
  [tokens.settings.billingAddPaymentBannerBody]:
    'After saving your payment method, you will be redirected to Subscription to complete activation.',
  [tokens.settings.billingPaymentMethodsTitle]: 'Payment methods',
  [tokens.settings.billingPaymentMethodsSubtitle]:
    'The primary card is charged at each billing date.',
  [tokens.settings.billingInvoicesTitle]: 'Invoices',
  [tokens.settings.billingInvoicesSubtitle]: 'Billing history.',
  [tokens.settings.billingEmptyManualTitle]: 'Manual billing',
  [tokens.settings.billingEmptyManualBody]:
    'Your organization is billed manually. Self-serve payment methods and invoices are not available.',
  [tokens.settings.billingEmptyNotConfiguredTitle]:
    'Billing not configured',
  [tokens.settings.billingEmptyNotConfiguredBody]:
    'No billing account is configured for your organization. Check the Subscription page or contact Nabu.',
  [tokens.settings.billingEmptyGoSubscription]: 'View subscription',
  [tokens.settings.billingTokenDisabledTitle]: 'Billing unavailable',
  [tokens.settings.billingTokenErrorTitle]: 'Unable to load billing',
  [tokens.settings.billingTokenErrorBody]:
    'Please try again shortly. If the issue persists, contact support.',
  [tokens.settings.billingTokenRetry]: 'Retry',
  [tokens.settings.billingToastPaymentCreated]: 'Payment method added.',
  [tokens.settings.billingToastPaymentDeleted]: 'Payment method deleted.',
  [tokens.settings.billingToastPaymentDefault]: 'Primary card updated.',
  [tokens.settings.billingToastEmbedError]:
    'The card form hit an error. Please try again.',
  [tokens.settings.billingAddCardCta]: '+ Add a card',
  [tokens.settings.billingAddCardTitle]: 'Add a card',
  [tokens.settings.billingAddCardBody]:
    'Enter your card details. Card data is processed securely.',
  [tokens.settings.billingAddCardError]:
    'Unable to open the add-card form. Please try again.',
  [tokens.settings.billingAddCardSubmit]: 'Save card',
  [tokens.settings.billingAddCardConfirmError]:
    'Unable to save the card. Check the details and try again.',
  [tokens.settings.billingCardPrimaryBadge]: 'Primary',
  [tokens.settings.billingCardExpiry]: 'Expires {{exp}}',
  [tokens.settings.billingCardExpiryWithHolder]:
    '{{holder}} · expires {{exp}}',
  [tokens.settings.billingCardSetDefault]: 'Set as primary',
  [tokens.settings.billingCardDelete]: 'Delete card',
  [tokens.settings.billingDeleteCardTitle]: 'Delete this card?',
  [tokens.settings.billingDeleteCardBody]:
    'Card •••• {{last4}} will be removed from your payment methods.',
  [tokens.settings.billingDeleteCardConfirm]: 'Delete',
  [tokens.settings.billingPaymentMethodsLoadError]:
    'Unable to load payment methods.',
  [tokens.settings.billingPaymentMethodsEmptyTitle]: 'No payment method',
  [tokens.settings.billingPaymentMethodsEmptyBody]:
    'Add a card for subscription charges.',
  [tokens.settings.billingInvoicesLoadError]: 'Unable to load invoices.',
  [tokens.settings.billingInvoicesEmpty]: 'No invoices yet.',
  [tokens.settings.billingInvoiceColNumber]: 'No.',
  [tokens.settings.billingInvoiceColDate]: 'Date',
  [tokens.settings.billingInvoiceColPeriod]: 'Period',
  [tokens.settings.billingInvoiceColAmount]: 'Amount',
  [tokens.settings.billingInvoiceColStatus]: 'Status',
  [tokens.settings.billingInvoiceColAction]: 'Action',
  [tokens.settings.billingInvoiceStatusPaid]: 'Paid',
  [tokens.settings.billingInvoiceStatusPending]: 'Pending',
  [tokens.settings.billingInvoiceStatusFailed]: 'Failed',
  [tokens.settings.billingInvoiceDownload]: 'Download invoice',
  [tokens.settings.billingInvoiceDownloadSuccess]:
    'Invoice opened in a new tab.',
  [tokens.settings.billingInvoiceDownloadError]:
    'Unable to download the invoice.',
  [tokens.settings.billingErrorGeneric]: 'Something went wrong. Please try again.',
  [tokens.settings.billingErrorLastCardActive]:
    'You cannot delete the last card of an active subscription.',
  [tokens.settings.authzRolesSubtitle]: 'Four nested Nabu roles, from the most restricted to the widest. Create your own from one of them, then assign them agency by agency.',
  [tokens.settings.authzNabuRolesTitle]: 'Nabu roles',
  [tokens.settings.authzCustomRolesTitle]: 'Your roles',
  [tokens.settings.authzCreateRole]: 'Create a role',
  [tokens.settings.authzCreateRoleTitle]: 'Create a role',
  [tokens.settings.authzCreateRoleHint]: 'A role always starts from a Nabu role. You then adjust its capacities one by one.',
  [tokens.settings.authzCreateRoleName]: 'Role name',
  [tokens.settings.authzCreateRoleBase]: 'Based on',
  [tokens.settings.authzRoleOriginNabu]: 'Nabu role',
  [tokens.settings.authzMembersCount]: '{{count}} people',
  [tokens.settings.authzMembersCountOne]: '1 person',
  [tokens.settings.authzRoleNotFound]: 'This role does not exist or was deleted.',
  [tokens.settings.authzRoleName]: 'Role name',
  [tokens.settings.authzRoleReadOnlyNotice]: 'Nabu roles cannot be edited: Nabu maintains them for everyone. Duplicate it to adapt it to your organization.',
  [tokens.settings.authzImpactNone]: 'No permission changes.',
  [tokens.settings.authzSaveRole]: 'Save',
  [tokens.settings.authzDiscardChanges]: 'Discard changes',
  [tokens.settings.authzDeleteRole]: 'Delete the role',
  [tokens.settings.authzDeleteRoleBlocked]: 'First remove this role from the {{count}} person(s) who have it.',
  [tokens.settings.authzDeleteRoleConfirm]: 'The role “{{role}}” will be permanently deleted.',
  [tokens.settings.authzRightMissing]: '“{{action}}”: your access does not allow it here.',
  [tokens.settings.authzRightAskPeople]: 'Ask {{names}}.',
  [tokens.settings.authzRightAskAdmin]: 'Ask an administrator of your organization.',
  [tokens.settings.authzWhyMissing]: 'Missing: {{actions}}.',
  [tokens.settings.authzWhyNotGranted]: 'None of their access here grants it.',
  [tokens.settings.authzWhyAccessesHere]: 'Their access here: {{accesses}}.',
  [tokens.settings.authzWhyAccessInherited]: '{{role}}, inherited from {{agency}}',
  [tokens.settings.authzWhyNoAccessHere]: 'No access on this agency.',
  [tokens.settings.authzWhySmallestRole]: 'Smallest Nabu role granting it: {{role}}.',
  [tokens.settings.authzChangesPeople]: 'Who gains and who loses:',
  [tokens.settings.authzEffectGains]: '{{name}} will gain: {{actions}}.',
  [tokens.settings.authzEffectLoses]: '{{name}} will lose: {{actions}}.',
  [tokens.settings.authzEffectNone]: 'Their rights do not change: their other access already grants them.',
  [tokens.settings.authzChangeRoleTitle]: 'Change the role',
  [tokens.settings.authzChangeRoleConfirm]: '{{name}} will have the role {{role}} on all their access.',
  [tokens.settings.memberDetailTabAccess]: 'Access',
  [tokens.settings.authzAccessTitle]: 'Access',
  [tokens.settings.authzAccessSubtitle]: 'Each line grants a role on an agency — and its sub-agencies if you wish. Rights add up; nothing is taken away elsewhere.',
  [tokens.settings.authzAddAccess]: 'Add access',
  [tokens.settings.authzNoAccess]: '{{name}} has no access and sees nothing in this organization.',
  [tokens.settings.authzScopeWholeOrg]: 'Whole organization',
  [tokens.settings.authzScopeWithDescendants]: '{{name}} and its sub-agencies',
  [tokens.settings.authzScopeOnly]: '{{name}} only',
  [tokens.settings.authzValidFrom]: 'from {{date}}',
  [tokens.settings.authzValidUntil]: 'until {{date}}',
  [tokens.settings.authzValidBetween]: 'from {{from}} to {{until}}',
  [tokens.settings.authzExpired]: 'Expired',
  [tokens.settings.authzScheduled]: 'Upcoming',
  [tokens.settings.authzOriginMigration]: 'Carried over from the former role',
  [tokens.settings.authzOriginMigrationHint]: "Created automatically at switchover, from this member's former role and agencies.",
  [tokens.settings.authzRemoveAccess]: 'Remove this access',
  [tokens.settings.authzRemoveAccessConfirm]: '{{name}} will lose the role “{{role}}” on {{scope}}.',
  [tokens.settings.authzRightsPreviewTitle]: 'What {{name}} can do',
  [tokens.settings.authzRightsPreviewOn]: 'On',
  [tokens.settings.authzStateEnabled]: 'Granted',
  [tokens.settings.authzStatePartial]: 'Partial',
  [tokens.settings.authzStateDisabled]: 'Visible, greyed',
  [tokens.settings.authzStateHidden]: 'Hidden',
  [tokens.settings.authzStateLegend]: 'Greyed to act, hidden to destroy: a non-granted action button stays visible but inactive, with an explanation; delete and permission management do not appear at all.',
  [tokens.settings.authzNoRightsHere]: 'No rights on this agency.',
  [tokens.settings.authzAddAccessTitle]: 'Add access for {{name}}',
  [tokens.settings.authzAddAccessRole]: 'Role',
  [tokens.settings.authzRolesGroupNabu]: 'Nabu roles',
  [tokens.settings.authzRolesGroupCustom]: 'Your roles',
  [tokens.settings.authzAddAccessScope]: 'Scope',
  [tokens.settings.authzAddAccessScopeOrg]: 'Whole organization',
  [tokens.settings.authzAddAccessScopeAgencies]: 'One or more agencies',
  [tokens.settings.authzAddAccessIncludeDescendants]: 'Include sub-agencies',
  [tokens.settings.authzAddAccessTemporary]: 'Temporary access',
  [tokens.settings.authzAddAccessFrom]: 'From',
  [tokens.settings.authzAddAccessUntil]: 'Until',
  [tokens.settings.authzAddAccessDatesInvalid]: 'The end date is before the start date.',
  [tokens.settings.authzAddAccessPreview]: '{{name}} will have the role “{{role}}” on {{scope}}{{validity}}.',
  [tokens.settings.authzAddAccessPreviewAgencies]: '{{count}} agencies',
  [tokens.settings.authzAddAccessPreviewAgenciesWithDescendants]: '{{count}} agencies and their sub-agencies',
  [tokens.settings.authzAddAccessSelectAtLeastOne]: 'Choose a role and at least one agency.',
  [tokens.settings.authzAddAccessSave]: 'Add access',
  [tokens.settings.authzLegacyRoleLine]: 'Role applied today: {{role}} — the highest of their access, while the former access control is still in place.',
  [tokens.settings.authzTabCompare]: 'Compare roles',
  [tokens.settings.authzTabConfigure]: 'Configure a role',
  [tokens.settings.authzTabAttribution]: 'Assignment by agency',
  [tokens.settings.authzCopyName]: 'Copy of {{role}}',
  [tokens.settings.authzCompareHint]: 'Each Nabu role does everything the previous one does, plus what is highlighted. Open a row to see the actions in detail.',
  [tokens.settings.authzCompareCapacity]: 'Capacity',
  [tokens.settings.authzCompareLegendNew]: 'Added by this role',
  [tokens.settings.authzCompareLegendIncluded]: 'Included',
  [tokens.settings.authzCompareLegendPartial]: 'Partly, in your role',
  [tokens.settings.authzCompareLegendNone]: 'Not included',
  [tokens.settings.authzCompareRemoved]: 'removed',
  [tokens.settings.authzCompareExpand]: 'Show the actions of {{capacity}}',
  [tokens.settings.authzCompareTotals]: 'Capacities granted',
  [tokens.settings.authzCompareTotalFull]: '{{count}} of {{total}}',
  [tokens.settings.authzCompareTotalPartial]: '{{count}} + {{partial}} partly',
  [tokens.settings.authzRoleKindCustom]: 'Your role · from {{preset}}',
  [tokens.settings.authzDuplicate]: 'Duplicate',
  [tokens.settings.authzEdit]: 'Edit',
  [tokens.settings.authzCreateFromNabu]: 'Create a role from a Nabu role',
  [tokens.settings.authzCustomRolesUsage]: 'Your roles: {{count}} of {{max}}',
  [tokens.settings.authzCustomRolesLimitReached]: 'Maximum number of custom roles reached ({{max}}): delete one to create another.',
  [tokens.settings.authzLoadError]: "The organization's roles and accesses could not be loaded. Reload the page.",
  [tokens.settings.authzToastRoleCreated]: 'Role created.',
  [tokens.settings.authzToastRoleSaved]: 'Role saved.',
  [tokens.settings.authzToastRoleDeleted]: 'Role deleted.',
  [tokens.settings.authzToastAccessGiven]: 'Access granted.',
  [tokens.settings.authzToastAccessRemoved]: 'Access removed.',
  [tokens.settings.authzToastMemberRoleChanged]: 'Member role changed.',
  [tokens.settings.authzErrorRoleLimit]: 'Your organization has reached the maximum number of custom roles: delete one to create another.',
  [tokens.settings.authzErrorRoleInUse]: 'Members still have this role: change their role before deleting it.',
  [tokens.settings.authzErrorAccessAlreadyGranted]: 'This member already has this role on this agency.',
  [tokens.settings.authzErrorLastAdministrator]: 'Your organization must keep at least one person who manages roles.',
  [tokens.settings.authzErrorRoleInvalid]: 'This role could not be saved as is. Reload the page and try again.',
  [tokens.settings.authzErrorForbidden]: 'Your accesses do not allow this change.',
  [tokens.settings.authzErrorGeneric]: 'The change could not be saved. Try again.',
  [tokens.settings.authzConfigureChipsHint]: 'Nabu roles are read-only and stay up to date on their own. Your roles ({{count}} of {{max}}) are set box by box.',
  [tokens.settings.authzNewRoleChip]: 'New role',
  [tokens.settings.authzNewRoleBadge]: 'New · from {{preset}}',
  [tokens.settings.authzMatrixGranted]: '{{granted}} / {{total}} actions granted',
  [tokens.settings.authzMatrixGaps]: '{{count}} difference(s) from {{preset}}',
  [tokens.settings.authzMatrixRevert]: 'Back to {{preset}}',
  [tokens.settings.authzMatrixModule]: 'Module',
  [tokens.settings.authzMatrixRead]: 'Read',
  [tokens.settings.authzMatrixCreate]: 'Create',
  [tokens.settings.authzMatrixUpdate]: 'Edit',
  [tokens.settings.authzMatrixDelete]: 'Delete',
  [tokens.settings.authzMatrixAccess]: 'Access',
  [tokens.settings.authzMatrixNotApplicable]: 'Not applicable',
  [tokens.settings.authzMatrixDiffers]: 'Differs from {{preset}}',
  [tokens.settings.authzMatrixCellHint]: '{{action}} · part of “{{capacity}}”',
  [tokens.settings.authzMatrixCellOwnVersion]: "{{action}} · “{{capacity}}”: this role has its own version, which no longer follows Nabu's updates",
  [tokens.settings.authzMatrixOwnVersions]: "This role has its own version of {{capacities}}. These boxes no longer follow Nabu's updates; tick them all again to return to the Nabu version.",
  [tokens.settings.authzCreateRoleSave]: 'Create the role',
  [tokens.settings.authzGiveCopyTitle]: 'Give “{{role}}” to the people who have {{preset}}?',
  [tokens.settings.authzGiveCopyBody]: 'The people ticked move from {{preset}} to this role, on the same agencies and with the same dates. Otherwise the new role is used by no one.',
  [tokens.settings.authzAttributionHint]: 'Who has a role on each agency: directly, or through a parent agency with its sub-agencies.',
  [tokens.settings.authzAttributionAgencies]: 'Agencies',
  [tokens.settings.authzAttributionTitle]: 'Access to {{agency}}',
  [tokens.settings.authzAttributionGive]: 'Give access',
  [tokens.settings.authzAttributionEmpty]: 'No one has a role on {{agency}} yet.',
  [tokens.settings.authzAttributionDirect]: 'Given on this agency only',
  [tokens.settings.authzAttributionDirectWithDescendants]: 'Given on this agency and its sub-agencies',
  [tokens.settings.authzAttributionInherited]: 'Through {{agency}} and its sub-agencies',
  [tokens.settings.authzAttributionInheritedHint]: 'Given on {{agency}}: it is managed from {{agency}}',
  [tokens.settings.authzAttributionDialogTitle]: 'Give access on {{agency}}',
  [tokens.settings.authzAttributionMember]: 'Member',
  [tokens.settings.authzAttributionNoMember]: 'No member you can manage',
  [tokens.settings.authzAttributionPickMember]: 'Choose a member and a role.',
  [tokens.settings.authzGiveCopyCheckAll]: 'Select all',
  [tokens.settings.authzGiveCopyUncheckAll]: 'Deselect all',
  [tokens.settings.authzGiveCopyCount]: '{{count}} of {{total}}',
  [tokens.settings.authzChangesCount]: 'action changed',
  [tokens.settings.authzChangesCount_other]: 'actions changed',
  [tokens.settings.authzChangesTouches]: 'Affects {{count}} person',
  [tokens.settings.authzChangesTouches_other]: 'Affects {{count}} people',
  [tokens.settings.authzChangesNewRole]: 'New role from {{preset}}',
  [tokens.settings.authzChangesDetail]: 'What changes',
  [tokens.settings.inboxesIntro]: 'An email sent to one of these inboxes creates a folder with its attachments. Only allowed senders are accepted.',
  [tokens.settings.inboxNew]: 'New inbox',
  [tokens.settings.inboxesListTitle]: 'Inbox addresses',
  [tokens.settings.inboxesActiveCount]: '{{count}} active out of {{total}}',
  [tokens.settings.inboxesActiveCount_other]: '{{count}} active out of {{total}}',
  [tokens.settings.inboxesSearch]: 'Search',
  [tokens.settings.inboxesColAddress]: 'Address',
  [tokens.settings.inboxesColCreates]: 'Folder created',
  [tokens.settings.inboxesColAssignee]: 'Assigned to',
  [tokens.settings.inboxesEmptyTitle]: 'No inbox yet',
  [tokens.settings.inboxesNoMatch]: 'No inbox matches',
  [tokens.settings.inboxesEmptyHint]: 'Create an inbox and share its address with your customers.',
  [tokens.settings.inboxCopyAddress]: 'Copy address',
  [tokens.settings.inboxCopy]: 'Copy',
  [tokens.settings.inboxActive]: 'Active',
  [tokens.settings.inboxPaused]: 'Paused',
  [tokens.settings.inboxToggle]: 'Activate or pause',
  [tokens.settings.inboxUnassigned]: 'Unassigned',
  [tokens.settings.inboxClientFromDocuments]: 'the customer read from the documents',
  [tokens.settings.allowedSendersTitle]: 'Allowed senders',
  [tokens.settings.allowedSendersHint]: "Applies to all of the agency's inboxes.",
  [tokens.settings.allowedSendersPlaceholder]: 'name@client.com',
  [tokens.settings.allowedSendersAdd]: 'Add',
  [tokens.settings.allowedSendersInvalid]: 'Enter a full address (name@domain.com).',
  [tokens.settings.allowedSendersDuplicate]: 'Already in the list.',
  [tokens.settings.allowedSendersAddresses]: 'Addresses',
  [tokens.settings.allowedSendersRemove]: 'Remove',
  [tokens.settings.allowedSendersDefault]: 'Default',
  [tokens.settings.allowedSendersAgencyMembers]: 'Agency members ({{count}})',
  [tokens.settings.allowedSendersDefaultHint]: 'Agency members are allowed by default.',
  [tokens.settings.allowedSendersOnlyMembers]: 'Only agency members can write to its inboxes.',
  [tokens.settings.allowedSendersAdded]: '{{email}} is allowed',
  [tokens.settings.allowedSendersRemoved]: '{{email}} is no longer allowed',
  [tokens.settings.allowedSendersError]: 'The sender list could not be updated.',
  [tokens.settings.inboxRejectedTitle]: 'Recently refused',
  [tokens.settings.inboxRejectedTo]: '{{date}} · to {{inbox}}',
  [tokens.settings.inboxRejectedAllow]: 'Allow',
  [tokens.settings.inboxRejectedDismiss]: 'Dismiss',
  [tokens.settings.inboxRejectedCount]: '{{count}} email',
  [tokens.settings.inboxRejectedCount_other]: '{{count}} emails',
  [tokens.settings.inboxRejectedPaused]: 'inbox paused',
  [tokens.settings.inboxEditorNewTitle]: 'New inbox',
  [tokens.settings.inboxEditorEditTitle]: 'Edit inbox',
  [tokens.settings.inboxEditorAddress]: 'Inbox address',
  [tokens.settings.inboxEditorPrefixHint]: "Lowercase letters, digits and hyphens. Only the agency's allowed senders can write to it.",
  [tokens.settings.inboxEditorWhatItDoes]: 'What this address does',
  [tokens.settings.inboxEditorNotify]: 'Notify',
  [tokens.settings.inboxEditorNotifyHint]: 'These people receive an email for every folder created.',
  [tokens.settings.inboxEditorFieldType]: 'Folder type',
  [tokens.settings.inboxEditorFieldClient]: 'Customer',
  [tokens.settings.inboxEditorFieldClientPlaceholder]: 'Read from the documents',
  [tokens.settings.inboxEditorFieldAssignee]: 'Assigned to',
  [tokens.settings.inboxEditorPreparation]: 'Preparation',
  [tokens.settings.inboxEditorPrepSmart]: 'Smart preparation',
  [tokens.settings.inboxEditorPrepClassic]: 'Classic preparation',
  [tokens.settings.inboxEditorDelete]: 'Delete',
  [tokens.settings.inboxEditorCancel]: 'Cancel',
  [tokens.settings.inboxEditorCreate]: 'Create inbox',
  [tokens.settings.inboxEditorSave]: 'Save',
  [tokens.settings.inboxEditorClose]: 'Close',
  [tokens.settings.inboxStepMailTitle]: 'An email arrives',
  [tokens.settings.inboxStepMailBody]: "with its attachments, from one of the agency's allowed senders",
  [tokens.settings.inboxStepFolderTitle]: 'Nabu creates a folder',
  [tokens.settings.inboxStepFolderBody]: 'Of type <type>{{type}}</type>, with the flow <flow>{{flow}}</flow>, for <client>{{client}}</client>',
  [tokens.settings.inboxStepPrepTitle]: 'Preparation',
  [tokens.settings.inboxStepPrepBody]: 'This folder will be prepared with <prep>{{prep}}</prep>',
  [tokens.settings.inboxPrepSmartPhrase]: 'smart preparation',
  [tokens.settings.inboxPrepClassicPhrase]: 'classic preparation',
  [tokens.settings.inboxStepAssignTitle]: 'It is assigned',
  [tokens.settings.inboxStepAssignBody]: 'to <user>{{user}}</user>',
  [tokens.settings.inboxStepAssignNotified]: ', and {{count}} person is notified',
  [tokens.settings.inboxStepAssignNotified_other]: ', and {{count}} people are notified',
  [tokens.settings.inboxMissingType]: 'type to choose',
  [tokens.settings.inboxMissingFlow]: 'flow to choose',
  [tokens.settings.inboxMissingAssignee]: 'person to choose',
  [tokens.settings.inboxCreated]: 'Inbox created',
  [tokens.settings.inboxSaved]: 'Inbox saved',
  [tokens.settings.inboxDeleted]: 'Inbox deleted',
  [tokens.settings.inboxSaveError]: 'The inbox could not be saved.',
  [tokens.settings.inboxDeleteError]: 'The inbox could not be deleted.',
  [tokens.settings.inboxPrefixTaken]: 'This prefix is already used by another inbox.',
  [tokens.settings.inboxDeleteConfirm]: 'Delete the inbox {{address}}? Emails sent to this address will no longer create folders.',

  [tokens.floatinglabelform.save]: 'Save',
  [tokens.floatinglabelform.apply]: 'Apply',
  [tokens.floatinglabelform.text]: 'Text',

  [tokens.viewer.doYouWantToDeleteTheTable]: 'Do you want to delete the table',
  [tokens.viewer.apply]: 'Apply',
  [tokens.viewer.adjustTheDocument]: 'Adjust the document',
  [tokens.viewer.selectedLabel]: 'Selected label',
  [tokens.viewer.selectADocument]: 'Select a document',
  [tokens.viewer.applyAModel]: 'Apply model',
  [tokens.viewer.newColumn]: 'New column',
  [tokens.viewer.selectColumnTooltip]:
    'Click to select the entire column to move it. Shift+click a cell for the same action.',
  [tokens.viewer.selectColumnTooltipExcel]:
    'Click to select the entire column to move it.',
  [tokens.viewer.invoice]: 'Invoice',

  [tokens.classification.layers]: 'Layers',
  [tokens.classification.manualLayer]: 'Manual',
  [tokens.classification.searchClassificationType]:
    'Search for a classification type',
  [tokens.classification.outOf]: 'in',
  [tokens.classification.validate]: 'Validate',
  [tokens.classification.unknownDocument]: 'unknown document',
  [tokens.classification.unknownDocuments]: 'unknown documents',
  [tokens.classification.addExtractionMode]: 'Add extraction mode',
  [tokens.classification.ignoreDocument]: 'Ignore the document',
  [tokens.classification.includeDocument]: 'Include the document',
  [tokens.classification.fieldRequired]: 'Field is required',
  [tokens.classification.selectExtractionMode]: 'Extraction mode',
  [tokens.classification.onlyInvoicesAllowed]:
    'Only invoices or EAD are accepted',
  [tokens.classification.noLeadDocument]:
    'At least one export "lead document" is required',
  [tokens.classification.someDocumentsWithoutClassification]:
    'Some documents have no classification',
  [tokens.classification.hasNoExportConfiguration]:
    'The type of declaration is missing',
  [tokens.classification.document]: '{{count}} document',
  [tokens.classification.document_other]: '{{count}} documents',
  [tokens.classification.page]: '{{count}} page',
  [tokens.classification.page_other]: '{{count}} pages',
  [tokens.classification.MT700]: 'MT 700',
  [tokens.classification.weight_note]: 'Weight note',
  [tokens.classification.exchange_bill]: 'Bill of exchange',
  [tokens.classification.origin_certif]: 'Certificate of origin',
  [tokens.classification.multimodal_doc]: 'Multimodal transport document',
  [tokens.classification.flight_letter]: 'Air waybill',
  [tokens.classification.sea_waybill]: 'Sea waybill',
  [tokens.classification.road_document]: 'Road Transport Document',
  [tokens.classification.delivery_note]: 'Delivery note',
  [tokens.classification.insurance_policy]: 'Insurance policy',
  [tokens.classification.bill_of_lading]: 'Bill of lading',
  [tokens.classification.single_administrative_document]: 'SAD',
  [tokens.classification.commercial_invoice]: 'Commercial invoice',
  [tokens.classification.customs_instructions]: 'Customs instructions',
  [tokens.classification.packing_list]: 'Packing list',
  [tokens.classification.hscodes_list]: 'HS Codes list',
  [tokens.classification.t1]: 'T1 transit',
  [tokens.classification.t2]: 'T2 transit',
  [tokens.classification.t2l]: 'T2L / T2LF',
  [tokens.classification.ata]: 'ATA carnet',
  [tokens.classification.bae]: 'Release authorisation',
  [tokens.classification.invoice_summary]: 'Invoice summary',
  [tokens.classification.electronic_accompanying_document]: 'EAD',
  [tokens.classification.EAD]: 'Export accompaning document',
  [tokens.classification.conversation]: 'Conversation',
  [tokens.classification.terms_and_conditions]: 'Terms and conditions',
  [tokens.classification.model]: 'Applied model',
  [tokens.classification.setting_keys]: 'Applied setting keys',
  [tokens.classification.MT700_short]: 'MT 700',
  [tokens.classification.weight_note_short]: 'Weight note',
  [tokens.classification.exchange_bill_short]: 'BE',
  [tokens.classification.origin_certif_short]: 'Certificate of origin',
  [tokens.classification.multimodal_doc_short]: 'MTD',
  [tokens.classification.flight_letter_short]: 'Air waybill',
  [tokens.classification.sea_waybill_short]: 'Sea waybill',
  [tokens.classification.road_document_short]: 'RTD',
  [tokens.classification.delivery_note_short]: 'Delivery note',
  [tokens.classification.insurance_policy_short]: 'Insurance policy',
  [tokens.classification.bill_of_lading_short]: 'BL',
  [tokens.classification.single_administrative_document_short]: 'SAD',
  [tokens.classification.commercial_invoice_short]: 'Invoice',
  [tokens.classification.customs_instructions_short]: 'Customs instr.',
  [tokens.classification.packing_list_short]: 'PL',
  [tokens.classification.hscodes_list_short]: 'HS Codes',
  [tokens.classification.t1_short]: 'T1',
  [tokens.classification.t2_short]: 'T2',
  [tokens.classification.t2l_short]: 'T2L',
  [tokens.classification.ata_short]: 'ATA',
  [tokens.classification.bae_short]: 'BAE',
  [tokens.classification.invoice_summary_short]: 'Invoice summary',
  [tokens.classification.electronic_accompanying_document_short]: 'EAD',
  [tokens.classification.EAD_short]: 'EAD',
  [tokens.classification.conversation_short]: 'Conversation',
  [tokens.classification.email_short]: 'Email',

  [tokens.connector.addConnector]: 'Add connector',

  [tokens.filter.sortBy]: 'Sort By',
  [tokens.filter.searchOrganization]: 'Search an organization',
  [tokens.filter.searchUser]: 'Search an user',
  [tokens.filter.searchLayer]: 'Search a layer',
  [tokens.filter.lastUpdateNewest]: 'Last update (newest)',
  [tokens.filter.lastUpdateOldest]: 'Last update (oldest)',

  [tokens.customerFlow.customer]: 'Client',
  [tokens.customerFlow.model]: 'Model',
  [tokens.customerFlow.areYouSureYouWantToDeleteThisModel]:
    'Are you sure you want to delete this model?',
  [tokens.customerFlow.documentType]: 'Document type',
  [tokens.customerFlow.removeCustomerTitle]: 'Delete a customer',
  [tokens.customerFlow.removeCustomerText]:
    'Do you really want to delete this customer?',
  [tokens.customerFlow.customerHasBeenDeleted]: 'The customer has been deleted',
  [tokens.customerFlow.customerHasNotBeenDeleted]: 'Cannot delete the customer',
  [tokens.customerFlow.removeModelTitle]: 'Delete a model',
  [tokens.customerFlow.removeModelText]:
    'Do you really want to delete this model?',
  [tokens.customerFlow.modelHasBeenDeleted]: 'The model has been deleted',
  [tokens.customerFlow.modelHasNotBeenDeleted]: 'Cannot delete the model',
  [tokens.common.modelShareToOtherGroup]: 'Share this model with another agency',
  [tokens.common.modelShareToOtherGroupText]:
    'Add this model to models visible to other agencies in your organization.',
  [tokens.customerFlow.settingKeyDeleted]: 'The setting key has been deleted',
  [tokens.customerFlow.actionFailed]: 'Action failed',
  [tokens.customerFlow.settingKeyCreated]: 'The setting key has been created',
  [tokens.customerFlow.settingKeyUpdated]: 'The setting key has been updated',
  [tokens.customerFlow.sender]: 'Sender',
  [tokens.customerFlow.modelType]: 'Model type',
  [tokens.customerFlow.informations]: 'Informations',
  [tokens.customerFlow.documentModels]: 'Document models',
  [tokens.customerFlow.nameOfModel]: 'Name of the model',
  [tokens.customerFlow.issuesSettingsOptions]: 'Error loading keys',
  [tokens.customerFlow.noModelAvailable]: 'No model available',
  [tokens.customerFlow.unknownUser]: 'Unknown',
  [tokens.customerFlow.deleteThisModel]: 'Delete this model',
  [tokens.customerFlow.deleteModelSuccess]: 'Model deleted successfully',
  [tokens.customerFlow.deleteModelFailed]: 'Model delete failed',
  [tokens.customerFlow.duplicateThisModel]: 'Duplicate this model',
  [tokens.customerFlow.duplicateModelTitle]: 'Duplicate model',
  [tokens.customerFlow.duplicateModelText]:
    'A copy of "{{name}}" will be created in your agency. Shares will not be copied.',
  [tokens.customerFlow.duplicateModelNamePlaceholder]:
    'Leave empty for an automatic name (e.g. "{{name}} - (1)")',
  [tokens.customerFlow.duplicateModelNameTooShort]:
    'Name must be at least 3 characters',
  [tokens.customerFlow.duplicateModelConfirm]: 'Duplicate',
  [tokens.customerFlow.duplicateModelSuccess]: 'Model duplicated successfully',
  [tokens.customerFlow.duplicateModelFailed]: 'Failed to duplicate model',
  [tokens.customerFlow.bulkSelectedCount]: 'model selected',
  [tokens.customerFlow.bulkSelectedCount_other]: 'models selected',
  [tokens.customerFlow.bulkDuplicate]: 'Duplicate',
  [tokens.customerFlow.bulkDelete]: 'Delete',
  [tokens.customerFlow.modelsDuplicated]: '{{count}} model duplicated',
  [tokens.customerFlow.modelsDuplicated_other]: '{{count}} models duplicated',
  [tokens.customerFlow.modelsNotDuplicated]: 'Failed to duplicate the model',
  [tokens.customerFlow.modelsNotDuplicated_other]:
    'Failed to duplicate the models',

  [tokens.customerFlow.customersPageTitle]: 'Client organizations',
  [tokens.customerFlow.customersPageSubtitle]:
    'Centralized list of clients from all agencies. Filter to see clients from a specific agency.',
  [tokens.customerFlow.customersInfoPopoverTitle]: 'What are clients?',
  [tokens.customerFlow.customersInfoPopoverBody]:
    'Your clients are the organizations for which you file customs declarations. You can link them to an agency to restrict access and automate workflows.',
  [tokens.customerFlow.customersInfoHelpLink]: 'Learn more in the Help centre',
  [tokens.customerFlow.customersSearchPlaceholder]: 'Search for a client…',
  [tokens.customerFlow.allAgencies]: 'All agencies',
  [tokens.customerFlow.customersCount]: '{{count}} clients',
  [tokens.customerFlow.addCustomer]: 'Add a client',
  [tokens.customerFlow.addModel]: 'Create a model',
  [tokens.customerFlow.addModelAgency]: 'Agency',
  [tokens.customerFlow.addModelDeclarationType]: 'Declaration type',
  [tokens.customerFlow.addModelSubtitle]: 'A model pre-fills the chosen fields as soon as it is applied to a file.',
  [tokens.customerFlow.addModelIdentification]: 'Identification',
  [tokens.customerFlow.addModelName]: 'Model name',
  [tokens.customerFlow.addModelNamePlaceholder]: 'E.g. Export Delta E — Le Havre road',
  [tokens.customerFlow.addModelDeclarationTypeHint]: 'Sets which fields the model can fill.',
  [tokens.customerFlow.addModelDeclarationTypePlaceholder]: 'Choose a type',
  [tokens.customerFlow.addModelNoDeclarationType]: 'No declaration type is set up for this agency: choose another one.',
  [tokens.customerFlow.addModelNoDeclarationTypePlaceholder]: 'No type available',
  [tokens.customerFlow.addModelFields]: 'Model fields',
  [tokens.customerFlow.addModelFieldsCount]: 'Model fields · {{count}}',
  [tokens.customerFlow.addModelChooseTypeFirst]: 'Choose a declaration type to add fields.',
  [tokens.customerFlow.addModelSchemaError]: 'The fields of this declaration type could not be loaded.',
  [tokens.customerFlow.addModelAddField]: 'Add a field: incoterm, customs office, transport…',
  [tokens.customerFlow.addModelNoFieldFound]: 'No field found',
  [tokens.customerFlow.addModelEmptyTitle]: 'No field yet',
  [tokens.customerFlow.addModelEmptyBody]: 'Add the fields this model should pre-fill. The others will remain to be filled in the file.',
  [tokens.customerFlow.addModelRemoveField]: 'Remove the field {{name}}',
  [tokens.customerFlow.addModelRemoveRow]: 'Remove row {{index}}',
  [tokens.customerFlow.addModelAddRow]: 'Add a row',
  [tokens.customerFlow.addModelFieldRequired]: 'Enter a value or remove the field.',
  [tokens.customerFlow.addModelMissingName]: 'Give the model a name.',
  [tokens.customerFlow.addModelMissingDeclarationType]: 'Choose a declaration type.',
  [tokens.customerFlow.addModelMissingField]: 'Add at least one field.',
  [tokens.customerFlow.addModelEmptyFields]: '{{count}} field without a value: fill it in or remove it.',
  [tokens.customerFlow.addModelEmptyFields_other]: '{{count}} fields without a value: fill them in or remove them.',
  [tokens.customerFlow.addModelSubmit]: 'Create the model',
  [tokens.customerFlow.columnName]: 'Name',
  [tokens.customerFlow.columnAddress]: 'Address',
  [tokens.customerFlow.columnContact]: 'Contact',
  [tokens.customerFlow.columnAgency]: 'Agency',
  [tokens.customerFlow.columnCreatedAt]: 'Created on',
  [tokens.customerFlow.viewCustomerDetail]: 'View details',
  [tokens.customerFlow.agencyRequired]: 'Agency is required',
  [tokens.customerFlow.customerNameRequired]: 'Name is required',
  [tokens.customerFlow.backToCustomers]: 'Back to clients',
  [tokens.customerFlow.backToModels]: 'Back to models',
  [tokens.customerFlow.flowDetailDeclarationLabel]:
    'Declaration type: {{type}}',
  [tokens.customerFlow.flowDetailConfigSectionTitle]: 'Model configuration',
  [tokens.customerFlow.flowDetailConfigSectionSubtitle]:
    'Set the default values applied when using this model.',
  [tokens.customerFlow.tabGeneral]: 'General',
  [tokens.customerFlow.tabConfiguration]: 'Configuration',
  [tokens.customerFlow.tabReferentials]: 'Referentials',
  [tokens.customerFlow.noReferentialsForClient]:
    'No referentials are linked to this client',
  [tokens.customerFlow.customerDetailAgencyLabel]: 'Agency: {{name}}',
  [tokens.customerFlow.customerDetailNoAgency]:
    'No agency is associated with this client.',
  [tokens.customerFlow.customerDetailConfigInfoAlert]:
    'All configurations for this client organization will apply to every declaration request made for this client organization.',
  [tokens.customerFlow.customerDetailConfigSectionTitle]: 'Client configuration',
  [tokens.customerFlow.customerDetailConfigSectionSubtitle]:
    'Values inherited from agency or organization configuration. Turn off the toggle to override; you can also add client-specific fields.',
  [tokens.customerFlow.customerDetailConfigInheritanceTitle]:
    'Keep agency configuration',
  [tokens.customerFlow.customerDetailConfigInheritanceDescription]:
    'This client uses values defined at agency or organization level. Turn off to set client-specific values.',
  [tokens.customerFlow.configSourceClient]: 'Client',
  [tokens.customerFlow.configSourceAgency]: 'Agency',
  [tokens.customerFlow.configSourceOrganization]: 'Organization',

  [tokens.referentials.pageTitle]: 'Referentials',
  [tokens.referentials.pageSubtitle]:
    'A persistent business database for consulting, updating, and automating your declarations.',
  [tokens.referentials.detailPageTitle]: 'Referential',
  [tokens.referentials.searchPlaceholder]: 'Search referentials…',
  [tokens.referentials.allClients]: 'All clients',
  [tokens.referentials.independentOnly]: 'Independent',
  [tokens.referentials.allStatuses]: 'All statuses',
  [tokens.referentials.activeOnly]: 'Active',
  [tokens.referentials.inactiveOnly]: 'Inactive',
  [tokens.referentials.resultsCount]: '{{count}} referential',
  [tokens.referentials.resultsCount_other]: '{{count}} referentials',
  [tokens.referentials.newReferential]: 'New referential',
  [tokens.referentials.createModalTitle]: 'New referential',
  [tokens.referentials.createModalDescription]:
    'Import a file to get started, or create an empty base to fill in later.',
  [tokens.referentials.fieldNameLabel]: 'Referential name',
  [tokens.referentials.fieldNamePlaceholder]: 'E.g. Holdtrans, textile articles',
  [tokens.referentials.fieldDescriptionPlaceholder]:
    'What is this referential for? (optional)',
  [tokens.referentials.fieldDataFileLabel]: 'Data file',
  [tokens.referentials.uploadZoneTitle]:
    'Drag a file here, or click to browse',
  [tokens.referentials.uploadZoneFormats]: '.xlsx · .xls · .csv · 20 MB max',
  [tokens.referentials.fieldClientLabel]: 'Link to a client',
  [tokens.referentials.clientIndependentOption]: 'Independent (no client)',
  [tokens.referentials.fieldAgencyLabel]: 'Agency',
  [tokens.referentials.fieldAgencyTooltip]:
    'Link to an agency to associate the automations for this referential with the selected agency.',
  [tokens.referentials.fieldConfigurationLabel]: 'Configuration',
  [tokens.referentials.fieldConfigurationTooltip]:
    'Will be used as a matching condition for automations.',
  [tokens.referentials.fieldDataFileTooltip]:
    'Import your referential as .xlsx, .xls or .csv. The first row of your table is used as column headers; following rows are your data. All rows are included. You can still edit them manually or update the entire referential later.',
  [tokens.referentials.fieldClientTooltip]: 'Link your referential to a client.',
  [tokens.referentials.createReferentialButton]: 'Create referential',
  [tokens.referentials.createEmptyBaseLink]: 'Create an empty base without a file',
  [tokens.referentials.emptyBaseSelected]: 'Empty base selected',
  [tokens.referentials.fileTooLarge]: 'File exceeds the maximum size of 20 MB',
  [tokens.referentials.invalidFileType]:
    'Unsupported format. Use .xlsx, .xls or .csv',
  [tokens.referentials.columnReferential]: 'Referential',
  [tokens.referentials.columnDescription]: 'Description',
  [tokens.referentials.columnClient]: 'Client',
  [tokens.referentials.columnRows]: 'Rows',
  [tokens.referentials.columnAutomations]: 'Autos',
  [tokens.referentials.columnUpdatedAt]: 'Updated',
  [tokens.referentials.attachedToClient]: 'Client-linked',
  [tokens.referentials.independent]: 'Independent',
  [tokens.referentials.noReferentialsFound]: 'No referentials found',
  [tokens.referentials.referentialCreated]: 'Referential created successfully',
  [tokens.referentials.errorCreatingReferential]:
    'Error while creating the referential',
  [tokens.referentials.importFile]: 'Import a file',
  [tokens.referentials.emptyBase]: 'Empty base',
  [tokens.referentials.nameRequired]: 'Name is required',
  [tokens.referentials.configurationRequired]: 'Configuration is required',
  [tokens.referentials.agencyRequired]: 'Agency is required',
  [tokens.referentials.importOrEmptyRequired]:
    'Import a file or choose an empty base',
  [tokens.referentials.automationsTooltip]:
    '{{conditions}} condition(s) · {{actions}} action(s)',
  [tokens.referentials.automationsTooltipCondition]:
    'Condition · column {{column}}',
  [tokens.referentials.automationsTooltipAction]: 'Action · column {{column}}',
  [tokens.referentials.columnsTooltipTitle]: '{{count}} referential columns',
  [tokens.referentials.automationsTooltipTitle]: '{{count}} automation(s)',
  [tokens.referentials.automationReplacesLabel]: 'Replaces: {{fields}}',
  [tokens.referentials.backToList]: 'Back to list',
  [tokens.referentials.detailComingSoon]:
    'The editable detail view is coming in the next step.',
  [tokens.referentials.conditionsCount]: 'conditions',
  [tokens.referentials.actionsCount]: 'actions',
  [tokens.referentials.rowsUnknown]: '—',
  [tokens.referentials.rowsLoaded]: '{{count}} rows loaded',
  [tokens.referentials.openReferential]: 'Open',
  [tokens.referentials.deleteReferential]: 'Delete',
  [tokens.referentials.deleteReferentialConfirm]:
    'Delete referential "{{name}}"?',
  [tokens.referentials.referentialDeleted]: 'Referential deleted',
  [tokens.referentials.errorDeletingReferential]:
    'Error while deleting the referential',
  [tokens.referentials.backToAllReferentials]: 'All referentials',
  [tokens.referentials.refresh]: 'Refresh',
  [tokens.referentials.exportXlsx]: 'Export (.xlsx)',
  [tokens.referentials.rowsCount]: '{{count}} rows',
  [tokens.referentials.columnsCount]: '{{count}} columns',
  [tokens.referentials.lastUpdatedLabel]: 'Updated on {{date}}',
  [tokens.referentials.editName]: 'Edit name',
  [tokens.referentials.editDescription]: 'Edit description',
  [tokens.referentials.addDescription]: 'Add a description',
  [tokens.referentials.searchRowsPlaceholder]: 'Search an item…',
  [tokens.referentials.cellsFilledPercent]: '{{percent}}% of cells filled',
  [tokens.referentials.emptyCell]: 'empty',
  [tokens.referentials.emptyGridMessage]:
    'This referential does not contain any data yet.',
  [tokens.referentials.noAutomationYet]: 'No automation configured',
  [tokens.referentials.toggleActive]: 'Enable or disable the referential',
  [tokens.referentials.referentialUpdated]: 'Referential updated',
  [tokens.referentials.errorUpdatingReferential]:
    'Error while updating the referential',
  [tokens.referentials.errorExportingReferential]:
    'Error while exporting the referential',
  [tokens.referentials.columnUpdatedAt]: 'Updated',
  [tokens.referentials.addRow]: 'Add a row',
  [tokens.referentials.gridFooterHint]:
    'Click a cell to edit • check a row to duplicate, insert, or delete it • use « + » on the right to add a column',
  [tokens.referentials.rowActions]: 'Actions',
  [tokens.referentials.selectedRowsCount]: '{{count}} row(s) selected',
  [tokens.referentials.duplicateRow]: 'Duplicate row',
  [tokens.referentials.insertRowBelow]: 'Insert row below',
  [tokens.referentials.insertRowAbove]: 'Insert row above',
  [tokens.referentials.deleteRow]: 'Delete row',
  [tokens.referentials.clearRowSelection]: 'Clear row selection',
  [tokens.referentials.gridSaving]: 'Saving…',
  [tokens.referentials.gridSaved]: 'Changes saved',
  [tokens.referentials.gridSaveError]: 'Error while saving',
  [tokens.referentials.gridMissingTitle]:
    'The content of referential "{{name}}" cannot be found',
  [tokens.referentials.gridMissingDescription]:
    'Its data file is missing, so this referential cannot be opened. Delete it from the list, then create it again from your file.',
  [tokens.referentials.columnLinkSaved]: 'Column link saved',
  [tokens.referentials.columnLinkSaveError]: 'Error while saving the column link',
  [tokens.referentials.columnNameLabel]: 'Column name',
  [tokens.referentials.columnLinkLabel]: 'Link to a data field',
  [tokens.referentials.columnLinkPlaceholder]: 'Choose a field…',
  [tokens.referentials.columnLinkNoResults]: 'No fields found',
  [tokens.referentials.columnLinkHelper]:
    'Values in this column will feed the selected field during automations.',
  [tokens.referentials.removeColumn]: 'Remove column',
  [tokens.referentials.addColumn]: 'Add column',
  [tokens.referentials.addCardinalColumn]: 'Cardinal columns',
  [tokens.referentials.addCustomColumn]: 'Custom column',
  [tokens.referentials.customColumnOption]: 'New free-form column',
  [tokens.referentials.allCardinalColumnsUsed]: 'All cardinal columns are in use',
  [tokens.referentials.cardinalColumnBadge]: 'Cardinal column',
  [tokens.referentials.untitledColumn]: 'Untitled',
  [tokens.referentials.automationConditionsTitle]: 'Matching conditions',
  [tokens.referentials.automationActionsTitle]: 'Declaration actions',
  [tokens.referentials.automationAddCondition]: '+ Add a condition',
  [tokens.referentials.automationAddAction]: '+ Add an action',
  [tokens.referentials.automationConditionsHelper]:
    'Conditions are evaluated in order. Enrichment is applied only when all conditions are met.',
  [tokens.referentials.automationDeclarationColumnPlaceholder]: 'Declaration column',
  [tokens.referentials.automationReferentialColumnPlaceholder]: 'Referential column',
  [tokens.referentials.automationRelationPlaceholder]: 'Relation',
  [tokens.referentials.automationRelationEq]: 'equal to',
  [tokens.referentials.automationRelationLt]: 'less than',
  [tokens.referentials.automationRelationGt]: 'greater than',
  [tokens.referentials.automationRelationIncludes]: 'Includes',
  [tokens.referentials.automationActionReplace]: 'Replace',
  [tokens.referentials.automationActionFillIfEmpty]: 'Fill if empty',
  [tokens.referentials.automationRemoveCondition]: 'Remove condition',
  [tokens.referentials.automationRemoveAction]: 'Remove action',
  [tokens.referentials.automationSave]: 'Save',
  [tokens.referentials.automationSaved]: 'Automation saved',
  [tokens.referentials.automationSaveError]: 'Error while saving the automation',
  [tokens.referentials.deleteAutomation]: 'Delete',
  [tokens.referentials.deleteAutomationConfirm]:
    'Delete the automation for this referential? Conditions and actions will be cleared.',
  [tokens.referentials.automationDeleted]: 'Automation deleted',
  [tokens.referentials.automationDeleteError]: 'Error while deleting automation',
  [tokens.referentials.automationCreateSimplified]: '+ Create a simplified automation',
  [tokens.referentials.automationAutoRunLabel]: 'Enable automatically',
  [tokens.referentials.automationAutoRunTooltip]:
    'Run the automation as soon as a declaration is created',
  [tokens.referentials.automationActiveLabel]: 'Available',
  [tokens.referentials.automationInactiveLabel]: 'Unavailable',
  [tokens.referentials.toggleAutomationAvailable]:
    'Make automation available or unavailable on declarations',
  [tokens.referentials.importModalTitle]: 'Update by import',
  [tokens.referentials.importModalSubtitle]:
    'Import an Excel or CSV file to update this referential.',
  [tokens.referentials.importClickOrDrag]: 'Click or drag a file',
  [tokens.referentials.importModeComplete]: 'Complete existing',
  [tokens.referentials.importModeCompleteDesc]:
    'Adds new rows to the referential without changing existing ones.',
  [tokens.referentials.importModeReplace]: 'Replace all',
  [tokens.referentials.importModeReplaceDesc]:
    'Clears the referential and imports the file.',
  [tokens.referentials.importNext]: 'Next',
  [tokens.referentials.importBack]: 'Back',
  [tokens.referentials.importConfirm]: 'Import',
  [tokens.referentials.importDuplicateTitle]: 'How should duplicates be handled?',
  [tokens.referentials.importDuplicateHelper]:
    'When an imported row matches an existing row (same {{column}}).',
  [tokens.referentials.importDuplicateOverwrite]: 'Overwrite duplicates',
  [tokens.referentials.importDuplicateOverwriteDesc]:
    'The existing row is replaced by the one from the file.',
  [tokens.referentials.importDuplicateIgnore]: 'Ignore duplicates',
  [tokens.referentials.importDuplicateIgnoreDesc]:
    'The existing row is kept and the imported row is ignored.',
  [tokens.referentials.importDuplicateKeepBoth]: 'Keep both',
  [tokens.referentials.importDuplicateKeepBothDesc]:
    'The imported row is added as a new entry.',
  [tokens.referentials.importColumnMappingTitle]: 'Column mapping',
  [tokens.referentials.importDuplicateKeyLabel]: 'Identify duplicates by column:',
  [tokens.referentials.importFileSummary]: '{{rows}} rows · {{columns}} columns detected',
  [tokens.referentials.importEmptyFile]: 'The file contains no data rows.',
  [tokens.referentials.importInvalidFile]: 'Unable to read this file.',
  [tokens.referentials.importSuccessTitle]: 'Import successful',
  [tokens.referentials.importSuccessSummary]: '{{count}} rows were processed successfully.',
  [tokens.referentials.importStatsCreated]: '{{count}} rows created',
  [tokens.referentials.importStatsUpdated]: '{{count}} rows updated',
  [tokens.referentials.importStatsIgnored]: '{{count}} duplicates ignored',
  [tokens.referentials.importStatsKeptBoth]: '{{count}} duplicates kept',
  [tokens.referentials.importError]: 'Error while importing',
  [tokens.referentials.updateByImport]: 'Update by import',
  [tokens.referentials.importSkipColumn]: 'Skip',

  [tokens.customer.addNew]: 'Add new customer',
  [tokens.customer.address]: 'Address',
  [tokens.customer.addressRequired]: 'Address is required',
  [tokens.customer.basicInformation]: 'Basic informations',
  [tokens.customer.corporateName]: 'Corporate name',
  [tokens.customer.corporateNameRequired]: 'Corporate name is required',
  [tokens.customer.city]: 'City',
  [tokens.customer.cityRequired]: 'City is required',
  [tokens.customer.country]: 'Country',
  [tokens.customer.countryRequired]: 'Country is required',
  [tokens.customer.eoriNumber]: 'EOIR number',
  [tokens.customer.eoriNumberRequired]: 'EOIR number is required',
  [tokens.customer.identifiers]: 'Identifiers',
  [tokens.customer.postalCode]: 'Postal code',
  [tokens.customer.postalCodeRequired]: 'Postal code is required',
  [tokens.customer.rexNumber]: 'REX number',
  [tokens.customer.rexNumberRequired]: 'REX number is required',
  [tokens.customer.siretNumber]: 'SIRET number',
  [tokens.customer.siretNumberRequired]: 'SIRET number is required',
  [tokens.customer.societyType]: 'Society type',
  [tokens.customer.societyTypeRequired]: 'Society type is required',
  [tokens.customer.vatNumber]: 'VAT number',
  [tokens.customer.vatNumberRequired]: 'VAT number is required',
  [tokens.customer.otherSettings]: 'Other settings',
  [tokens.customer.settingValueRequired]: 'A value is required',

  [tokens.managementConsole.managementConsole]: 'Management Console',
  [tokens.managementConsole.userRequired]: 'User required',
  [tokens.managementConsole.targetUser]: 'Target user',
  [tokens.managementConsole.settings]: 'Settings',
  [tokens.managementConsole.emailAutomation]: 'Email automation',
  [tokens.managementConsole.emailAutomations]: 'Email automations',
  [tokens.managementConsole.declarationType]: 'Declaration type',
  [tokens.managementConsole.allowedsenders]: 'Allowed senders',
  [tokens.managementConsole.clientOrganizationsIntro]:
    'Client Organizations allow you to add automations for any declaration associated with a client. For example, you can add a workflow or prefill values for a particular client.',
  [tokens.managementConsole.emailAutomationDestinationAddress]:
    'Email automation destination address',
  [tokens.managementConsole.createEmailAutomation]: 'Create email automation',
  [tokens.managementConsole
    .theFollowingConfigurationWillBeAutomaticallyAppliedToAnyDeclarationRequestReceivedAt]:
    'The following configuration will be automatically applied to any declaration request sent to',
  [tokens.managementConsole
    .whitelistingAnEmailAddressAuthorizedThatEmailAccountToRequestDeclarationsOnBehalfOfYourGroup]:
    'Adding an email address to the allowed senders authorizes that email account to request declarations on behalf of your agency.',
  [tokens.managementConsole.emailPrefixRequired]: 'Email prefix required',
  [tokens.managementConsole.areYouSureYouWantToDeleteThisClientOrganization]:
    'Are you sure you want to delete this Client Organization',
  [tokens.managementConsole.areYouSureYouWantToDeleteThisAuthorizedSender]:
    'Are you sure you want to delete this authorized sender',
  [tokens.managementConsole.allowedSenderEmailRemoveSuccess]:
    'Allowed sender email removed successfully',
  [tokens.managementConsole.allowedSenderEmailRemoveFailed]:
    'Allowed sender email remove failed',
  [tokens.managementConsole.areYouSureYouWantToDeleteThisEmailAutomation]:
    'Are you sure you want to delete this email automation',
  [tokens.managementConsole.errorUpdatingEmailAutomation]:
    'Error updating email automation',
  [tokens.managementConsole.emailAutomationRemoveSuccess]:
    'Email automation was removed successfully',
  [tokens.managementConsole.emailAutomationRemoveFailed]:
    'Email automation remove failed',
  [tokens.managementConsole.clientOrganizationRemoveSuccess]:
    'Client organization was removed successfully',
  [tokens.managementConsole.clientOrganizationRemoveFailed]:
    'Client organization remove failed',
  [tokens.managementConsole.emailAutomationUpdatedSuccessfully]:
    'Email automation updated successfully',
  [tokens.managementConsole.createEmailAutomationFor]:
    'Create email automation for',
  [tokens.managementConsole.allowedSenderEmailAddress]:
    'Allowed sender email address',
  [tokens.managementConsole.createAllowedSender]:
    'Create allowed sender email address',
  [tokens.managementConsole.createAllowedSenderFor]:
    'Create allowed sender email address for',
  [tokens.managementConsole.noEmailAutomationsFound]:
    'No email automations found',
  [tokens.managementConsole.noAllowedSenderEmailAddressesFound]:
    'No allowed senders found',
  [tokens.managementConsole.emailAutomationAddress]: 'Email automation address',
  [tokens.managementConsole.emailAutomationsIntro]:
    'Email automations allow you to set up data attribution based on the email address where a declaration request is sent. For example, sending a declaration request by email to "my-automation@email-api.nabu.io" could automatically apply a workflow, associate the declaration with a client, or set the declaration type. Only sender accounts that are in your allowed list of email addresses can send declaration requests in this way.',
  [tokens.managementConsole.anyClientOrganizationSettingKeysWillBeApplied]:
    'Any configuration set for this Client Organization will be applied to all declaration requests linked to the Client Organization.',
  [tokens.managementConsole.anyGroupSettingKeysWillBeApplied]:
    'Any configuration set for this agency will be applied to all declaration requests linked to this agency.',
  [tokens.managementConsole.establishmentsAndGroups]: 'Establishments & Agencies',
  [tokens.managementConsole.metrics]: 'Performance monitoring',
  [tokens.managementConsole.member_one]: 'Member',
  [tokens.managementConsole.member_other]: 'Members',
  [tokens.managementConsole.emailAutomationTargetUser]:
    'Email automation target user',
  [tokens.managementConsole.emailAutomationIntelligentPreparation]:
    'Intelligent preparation',
  [tokens.managementConsole.emailAutomationIntelligentPreparationDescription]:
    'Declarations received at this address are prepared by Nabu AI.',
  [tokens.managementConsole.members]: 'Members',
  [tokens.managementConsole.general]: 'General',
  [tokens.managementConsole.organizationSettings]: 'Settings',
  [tokens.managementConsole.clientOrganizations]: 'Client organizations',
  [tokens.managementConsole.clientOrganizationName]: 'Client Organization name',
  [tokens.managementConsole.clientOrganizationNotes]:
    'Client Organization notes',
  [tokens.managementConsole.clientOrganization]: 'Client organization',
  [tokens.managementConsole.clientOrganizationCreated]:
    'Client organization created',
  [tokens.managementConsole.errorCreatingClientOrganization]:
    'Error creating Client Organization',
  [tokens.managementConsole.createClientOrganization]:
    'Create Client Organization',
  [tokens.managementConsole.createClientOrganizationFor]:
    'Create Client Organization for',
  [tokens.managementConsole.noClientOrganizationsFound]:
    'No client organizations found',
  [tokens.managementConsole
    .creatingAClientOrganizationAllowsYouToAutomateActionsWhenRequestsForTheClientOrganizationAreReceived]:
    'Creating a Client Organization allows you to automate actions when requests for the Client Organization are received.',
  [tokens.managementConsole.clientOrganizationsAssociatedToTheGroup]:
    'Client Organizations associated to the agency',
  //General section
  [tokens.managementConsole.companyInformation]: 'Company information',
  [tokens.managementConsole.companyNameRequired]: 'Company name required',
  [tokens.managementConsole.registrationNumberRequired]:
    'Registration number required',
  [tokens.managementConsole.registrationCountryRequired]:
    'Registration country required',
  [tokens.managementConsole.registrationNumberWarning]:
    'The registration number must have at least 6 digits',
  [tokens.managementConsole.registrationCountryWarning]:
    'The country must have exactly 3 letters',
  [tokens.managementConsole.darkMode]: 'Dark mode',
  [tokens.managementConsole.organizationUpdated]: 'Company updated',
  [tokens.managementConsole.warningToSaveTitle]:
    'Do you want to save modifications ? ',
  [tokens.managementConsole.warningToSaveConfirmButtonText]: 'Save',
  [tokens.managementConsole.warningToSaveCancelButtonText]:
    'Close tab without saving',
  //OrganizationSettings section
  [tokens.managementConsole.organizationSettingsUpdated]:
    'Company settings updated',
  [tokens.managementConsole.issuesSettingsOptions]: 'Error loading keys',
  [tokens.managementConsole.generalSettings]: 'General settings',
  [tokens.managementConsole.customsPreFilling]:
    'Pre-filling customs declarations',
  [tokens.managementConsole.lockedFieldTooltip]:
    'Information not editable by your teams',
  [tokens.managementConsole.unlockedFieldTooltip]:
    'Information editable by your teams',
  [tokens.managementConsole.inheritedFieldTooltip]:
    'Information inherited from the agency',
  [tokens.managementConsole
    .tableAutomationsSelectHelperText]: `In the "Row" column to the right, select the lines from the worksheet that you want to use - by clicking and dragging. You can select multiple ranges, as long as they don't overlap. When you're done, click the "Validate" button to go onto the next step.`,
  [tokens.managementConsole.establishmentAndGroup]: 'Establishment and agency',
  [tokens.managementConsole.administrator]: 'Administator',
  [tokens.managementConsole.tableAutomationGroupParameters]:
    'Automation Group parameters',

  //Establishment
  [tokens.managementConsole.establishment]: 'Establishment',
  [tokens.managementConsole.errorUpdatingSettings]:
    'Error when saving parameters',
  [tokens.managementConsole.resetSettings]: 'The parameters have been reset',
  [tokens.managementConsole.settingsHasBeenUpdated]: 'Settings updated',
  [tokens.managementConsole.impossibleToLockEmptyField]:
    'Impossible to lock an empty field',
  [tokens.managementConsole.settingOfGroup]: 'Agency setting',
  [tokens.managementConsole.invalidEmailPrefix]: 'Invalid email prefix',
  [tokens.managementConsole.mailhookCreated]: 'Mailhook created',
  [tokens.managementConsole.mailhookDeleted]: 'Mailhook deleted',
  [tokens.managementConsole
    .declarationsCreatedUsingThisEmailAutomationWillBeOwnedByTheTargetUser]:
    'Declarations created using this Email automation will be owned by the Target user',
  [tokens.managementConsole.errorCreatingMailhook]: 'Error creating mailhook',
  [tokens.managementConsole.errorDeletingMailhook]: 'Error deleting mailhook',
  [tokens.managementConsole.addMailhook]: 'Add mailhook',
  [tokens.managementConsole.emailPrefix]: 'Email prefix',
  [tokens.managementConsole.noTargetPrefixesFound]: 'No target prefixes found',
  [tokens.managementConsole.targetPrefixes]: 'Target prefixes',

  [tokens.managementConsole.mailhookWhitelist]: 'Whitelisted emails',
  [tokens.managementConsole.invalidEmail]: 'Invalid email',
  [tokens.managementConsole.emailWhitelisted]: 'Email whitelisted',
  [tokens.managementConsole.apiManagement]: 'API Management',
  [tokens.managementConsole.apiKeyId]: 'Key Id',
  [tokens.managementConsole.apiKeyNameRequired]: 'API Key name required',
  [tokens.managementConsole.unrecognizedFormat]: 'Unrecognized format',
  [tokens.managementConsole.invalidKey]: 'Invalid key',
  [tokens.managementConsole.keyDetected]: 'Key detected',
  [tokens.managementConsole.apiManagementIntro]:
    'API keys allow you to securely send requests to our API. Via this API, you can create declarations and other documents, read configuration data for your agency, and perform other tasks without any user interaction. See the <docsLink>API documentation</docsLink> for more details.',
  [tokens.managementConsole.publicKeyRequired]: 'Public key required',
  [tokens.managementConsole.apiKeyCreated]: 'API key created',
  [tokens.managementConsole.apiKeyName]: 'Key name',
  [tokens.managementConsole.apiKeyFingerprint]: 'Key fingerprint',
  [tokens.managementConsole.emailRemoved]: 'Email removed',
  [tokens.managementConsole.noApiKeysFound]: 'No API Keys found',
  [tokens.managementConsole.createApiKey]: 'Create API Key',
  [tokens.managementConsole.errorCreatingApiKey]: 'Error creating API Key',
  [tokens.managementConsole.creatingAnApiKey]:
    "Creating an API Key allows your infrastructure to access Nabu's API directly",
  [tokens.managementConsole.createApiKeyFor]: 'Create API Key for',
  [tokens.managementConsole.apiKeyPublicKey]: 'Public key',
  [tokens.managementConsole.errorWhitelistingEmail]: 'Error whitelisting email',
  [tokens.managementConsole.errorRemovingEmail]: 'Error removing email',
  [tokens.managementConsole.addEmail]: 'Add email',
  [tokens.managementConsole.noClient]: 'Did not find your client',
  [tokens.managementConsole.createClient]: 'Create client',
  [tokens.managementConsole.tableAutomation]: 'Table automation',
  [tokens.managementConsole.tableAutomations]: 'Table automations',
  [tokens.managementConsole.tableAutomationsIntro]:
    'Table automations allow you to set up line-level data attribution based on data provided in advance. For example, you could update Excel tables mapping incomplete HS Codes to completed HS Codes, indicating instructions for filling in dual-use information, or indicating measure components for given HS Codes.',
  [tokens.managementConsole.tableAutomationsRequiresNewSchema]:
    'Available only for configurations using the new declaration schema.',
  [tokens.managementConsole.tableAutomationsNewSchemaOnlyAlert]:
    'Table automations are not compatible with legacy configurations. Only configurations using the new declaration schema can be used.',
  [tokens.managementConsole.tableAutomationsEligibleConfigsOnly]:
    'Only configurations compatible with the new declaration schema are listed.',
  [tokens.managementConsole.createTableAutomationGroup]:
    'Create Table automation group',
  [tokens.managementConsole.sourceName]: 'Source name',
  [tokens.managementConsole.sourceType]: 'Source type',
  [tokens.managementConsole
    .creatingATableAutomationGroupAllowsYouToAutomateComplexLineLevelTableDataEntry]:
    'Creating a Table Automation group allows you to automate complex line-level table data entry',
  [tokens.managementConsole.onlyExcelFilesAreAccepted]:
    'Only Excel files are accepted',
  [tokens.managementConsole.dropText]: 'Drop your Excel file here',
  [tokens.managementConsole.dropSubtext]:
    'Drop an Excel file to view its cells',
  [tokens.managementConsole.noTableAutomationGroupsFound]:
    'No Table Automation groups found',
  [tokens.managementConsole.tableAutomationGroupName]:
    'Table Automation group name',
  [tokens.managementConsole.tableAutomationGroupNameRequired]:
    'Table Automation group name required',
  [tokens.managementConsole.enterAName]: 'Enter a name',
  [tokens.managementConsole.selectedConfiguration]: 'Selected configuration',
  [tokens.managementConsole.templateRequired]: 'Template required',
  [tokens.managementConsole.selectATemplate]: 'Select a template',
  [tokens.managementConsole.configuration]: 'Configuration',
  [tokens.managementConsole.fileToUpload]: 'File to upload',
  [tokens.managementConsole.ruleBuilder]: 'Rule builder',
  [tokens.managementConsole.rule]: 'Rule',
  [tokens.managementConsole.lineProperty]: 'Property',
  [tokens.managementConsole.column]: 'Column',
  [tokens.managementConsole.IS]: 'IS',
  [tokens.managementConsole.IF]: 'IF',
  [tokens.managementConsole.THEN]: 'THEN',
  [tokens.managementConsole.addCondition]: 'Add a new condition',
  [tokens.managementConsole.setReferenceRows]: 'Set reference rows',
  [tokens.managementConsole.removeAllRows]: 'Remove all rows',
  [tokens.managementConsole.removeSelectedRows]: 'Remove selected rows',
  [tokens.managementConsole.addToPayload]: 'Add to payload',
  [tokens.managementConsole.payload]: 'Payload',
  [tokens.managementConsole.relations]: 'Relations',
  [tokens.managementConsole.ifTheFollowingConditionsAreTrue]:
    'If the following conditions are true',
  [tokens.managementConsole.thenTheFollowingValuesWillBeApplied]:
    'then the following values will be applied',
  [tokens.managementConsole.validateRules]: 'Validate rules',
  [tokens.managementConsole.createTheAutomationGroup]:
    'Create the Automation Group',
  [tokens.managementConsole.automationGroupRules]: 'Automation Group rules',
  [tokens.managementConsole.areYouSureYouWantToDeleteTheTableAutomationGroup]:
    'Are you sure you want to delete the Automation group "{{ name }}" ?',
  [tokens.managementConsole.tableAutomationGroupRemoveSuccess]:
    'Automation group removed successfully',
  [tokens.managementConsole.referenceRows]: 'Reference rows',
  [tokens.managementConsole.tableAutomationGroupCreated]:
    'Automation group created successfully',
  [tokens.managementConsole.tableAutomationGroupUpdatedSuccessfully]:
    'Automation group updated successfully',
  [tokens.managementConsole.errorCreatingTableAutomationGroup]:
    'Error creating Table Automation group',

  [tokens.account.generalSettings]: 'General settings',
  [tokens.account.customsPreFilling]: 'Pre-filling customs declarations',
  [tokens.account.settingsHasBeenUpdated]: 'Settings updated',
  [tokens.account.errorUpdatingSettings]: 'Error when saving parameters',
  [tokens.account.resetSettings]: 'The parameters have been reset',

  [tokens.store.anErrorOccurred]: 'An error occurred',
  [tokens.store.unableToUpdateBoundingRectangle]:
    'Unable to update bounding rectangle',
  [tokens.store.targetExportFieldIsNotEmpty]: 'Target field is not empty',
  [tokens.store.targetExportFieldNotFound]: 'Target export field not found',
  [tokens.store.unableToCreateColumnSomeCellsAreInvalid]:
    'Unable to create column - some cells are invalid',
  [tokens.store.unableToCreateColumnTableAndColumnRowsMustBeIdentical]:
    'Unable to create column - table and column rows must be identical',
  [tokens.store.cannotDeleteLastRowOfPage]:
    'This is the last row of the table on this page, so it cannot be deleted. To remove it, delete the table on this page.',
  [tokens.store.thereIsAlreadyATableOnThisPage]:
    'An article grid already exists on this document page.',
  [tokens.store.unableToProjectCellsOntoNewTable]:
    'Unable to project cells onto new table',
  [tokens.store.unableToProjectEmptyRowOntoNewPage]:
    'Unable to project empty row onto new page',
  [tokens.store.newTableIsTooSmallToProjectCellsFromExistingTable]:
    'New table is too small to project cells from existing table',
  [tokens.store.referenceRowCellsTouchSourceGridEdge]:
    'Some cells touch the edge of the existing grid. Nudge them inward or widen the grid before adding a page',
  [tokens.store.tableHasNoRows]: 'Table has no rows',
  [tokens.store.unableToIdentifyTheCurrentRow]:
    'Unable to identify the table row where the mouse is currently placed',
  [tokens.store.cannotDragTableCellIntoADifferentRow]:
    'Cannot move table cell into a different row',
  [tokens.store.tableCellTooSmallOrInverted]:
    'Table cell is too small or has been inverted',
  [tokens.store.tableCellCannotGoOutOfItsRowVertically]:
    "Table cell cannot go out of it's row vertically",
  [tokens.store.tableCellGoesOutOfTableOnTheLeft]:
    'Table cell goes out of table on the left',
  [tokens.store.tableCellGoesOutOfTableOnTheRight]:
    'Table cell goes out of table on the right',
  [tokens.store.tableCellGoesOutOfTableOnTheTop]:
    'Table cell goes out of table on the top',
  [tokens.store.tableCellGoesOutOfTableOnTheBottom]:
    'Table cell goes out of table on the bottom',
  [tokens.store.missingMergeColumnsInSourceTable]:
    'Source table does not have all of the selected merge columns',
  [tokens.store.mergeKeysNotSpecificEnough]:
    'Multiple merge rows match the same target row',

  //Rich text
  [tokens.richText.bold]: 'Bold',
  [tokens.richText.italic]: 'Italic',
  [tokens.richText.underline]: 'Underline',
  [tokens.richText.strikethrough]: 'Strikethrough',
  [tokens.richText.subscript]: 'Subscript',
  [tokens.richText.superscript]: 'Superscript',
  [tokens.richText.textColor]: 'Text color',
  [tokens.richText.highlightColor]: 'Highlight color',
  [tokens.richText.removeFormatting]: 'Remove formatting',
  [tokens.richText.orderedList]: 'Numbered list',
  [tokens.richText.bulletedList]: 'Bulleted list',
  [tokens.richText.taskList]: 'Task list',
  [tokens.richText.undo]: 'Undo',
  [tokens.richText.redo]: 'Redo',
  [tokens.richText.heading]: 'Heading',
  [tokens.richText.blockquote]: 'Blockquote',
  [tokens.richText.code]: 'Inline code',
  [tokens.richText.codeBlock]: 'Code block',
  [tokens.richText.horizontalRule]: 'Horizontal rule',
  [tokens.richText.addTable]: 'Insert table',
  [tokens.richText.editLink]: 'Edit link',
  [tokens.richText.textAlign]: 'Text alignment',
  [tokens.richText.indent]: 'Increase indent',
  [tokens.richText.unindent]: 'Decrease indent',
  [tokens.richText.fontFamily]: 'Font family',
  [tokens.richText.fontSize]: 'Font size',
  [tokens.richText.imageUpload]: 'Insert image',
  [tokens.richText.cancelButton]: 'Cancel',
  [tokens.richText.removeColorButton]: 'Reset',
  [tokens.richText.removeColorButtonTooltipTitle]: 'Remove the color',
  [tokens.richText.empty]: 'Change to…',
  [tokens.richText.paragraph]: 'Normal text',
  [tokens.richText.left]: 'Left',
  [tokens.richText.right]: 'Right',
  [tokens.richText.center]: 'Center',
  [tokens.richText.justify]: 'Justify',

  [tokens.common.autoMode]: 'Automatic (system)',
  [tokens.common.german]: 'German',
  [tokens.common.helpAndSupport]: 'Help & support',
  [tokens.common.supportChat]: 'Chat with support',
  [tokens.common.supportChatUnread]: 'Unread messages: {{count}}',
  [tokens.common.supportChatMoveHint]: 'drag or use the arrow keys to move',
  [tokens.common.lastModifiedAt]: 'Last modified',
  [tokens.common.newVersionAvailableMessage]:
    'A new version is available. Refresh the page to get it.',
  [tokens.common.passwordChangedSuccessDescription]:
    'You can sign in with your new password.',
  [tokens.common.recoveryLinkInvalidTitle]: 'This link is no longer valid',
  [tokens.common.recoveryLinkInvalidDescription]:
    'It has expired, has already been used, or a more recent e-mail replaced it: only the latest link you received works.',
  [tokens.common.requestNewLink]: 'Get a new link',
  [tokens.common.passwordChangedSuccessTitle]: 'Password reset',
  [tokens.common.passwordResetEmailConfirmDescription]:
    'If an account is linked to this address, you will receive an email with a link to reset your password. Remember to check your spam folder.',
  [tokens.common.passwordResetEmailConfirmTitle]: 'Password reset email sent',
  [tokens.common.passwordRuleDigit]: 'At least one digit',
  [tokens.common.passwordRuleLength]: 'Between 8 and 16 characters',
  [tokens.common.passwordRuleLowercase]: 'At least one lowercase letter',
  [tokens.common.passwordRuleSpecial]:
    'At least one special character (@, $, !, %, *, ?, &)',
  [tokens.common.passwordRuleUppercase]: 'At least one uppercase letter',
  [tokens.common.refreshPageForNewVersion]: 'Refresh',
  [tokens.common.themePressToCycle]: 'Press to cycle theme',
  [tokens.dashboard.filterName]: 'Search name',
  [tokens.dashboard.noSavedFilters]: 'No saved searches',
  [tokens.dashboard.saveFilter]: 'Save search',
  [tokens.dashboard.customizeView]: 'Customize view',
  [tokens.dashboard.customizeViewTitle]: 'Customize view',
  [tokens.dashboard.customizeViewSubtitle]: 'Drag to reorder, toggle to show',
  [tokens.dashboard.columnRequired]: 'required',
  [tokens.dashboard.visibleColumnsCount]: '{{count}} columns displayed',
  [tokens.dashboard.sortAscending]: 'Sort ascending',
  [tokens.dashboard.sortDescending]: 'Sort descending',
  [tokens.dashboard.savedFilters]: 'Saved searches',
  [tokens.dashboard.toBeProcessed]: 'To process',
  [tokens.extraction.errorGenericContent]:
    'An error is preventing this declaration from being processed. Please check the uploaded files.<br>If the problem persists, contact our support team via <intercom>Intercom</intercom>.',
  [tokens.extraction.errorGenericTitle]: 'Declaration in error',
  [tokens.extraction.legacyExtractionModel]: 'Legacy extraction model',
  [tokens.extraction.newExtractionModel]: 'New extraction model',
  [tokens.extraction.relevanceScore]: 'Relevance score',
  [tokens.extraction.rossumExtraction]: 'Rossum extraction',
  [tokens.settings.agenciesChipAllLabel]: 'All agencies',
  [tokens.settings.agencyDetailBackToList]: 'Back to agencies',
  [tokens.settings.agencyDetailConfigSectionSubtitle]:
    'Configuration settings related to declarations for this agency.',
  [tokens.settings.agencyDetailConfigSectionTitle]: 'Configuration',
  [tokens.settings.agencyDetailGeneralIntro]:
    'Basic agency information. It appears in declarations and administrative exchanges.',
  [tokens.settings.agencyDetailLegalNameLabel]: 'Legal name',
  [tokens.settings.agencyDetailLegalNameRequired]: 'Legal name is required',
  [tokens.settings.agencyDetailMembersCountLine]:
    '{{count}} users linked to this agency.',
  [tokens.settings.agencyDetailRoleOwnerBadge]: 'Owner',
  [tokens.settings.agencyDetailSaveSuccess]: 'Agency updated',
  [tokens.settings.agencyDetailSettingsKeysInfo]:
    'The integration settings chosen here apply to this agency.',
  [tokens.settings.agencyDetailSubtitleLead]: 'Agency of',
  [tokens.settings.agencyDetailTabApi]: 'API management',
  [tokens.settings.agencyDetailTabClients]: 'Clients',
  [tokens.settings.agencyDetailTabConfiguration]: 'Configuration',
  [tokens.settings.agencyDetailTabEmail]: 'Inboxes',
  [tokens.settings.agencyDetailTabGeneral]: 'General',
  [tokens.settings.agencyDetailTabMembers]: 'Users',
  [tokens.settings.agencyDetailTabMetrics]: 'Metrics',
  [tokens.settings.agencyDetailTabTableAutomations]: 'Table automations',
  [tokens.settings.docTitleAgencyDetail]: 'Agency',
  [tokens.settings.docTitleMemberDetail]: 'User',
  [tokens.settings.memberDetailBackToList]: 'Back to users',
  [tokens.settings.memberDetailLabelAgencies]: 'Linked agencies',
  [tokens.settings.memberDetailLabelEmail]: 'Email',
  [tokens.settings.memberDetailLabelFullName]: 'Full name',
  [tokens.settings.memberDetailLabelPhone]: 'Phone',
  [tokens.settings.memberDetailLabelPosition]: 'Job title',
  [tokens.settings.memberDetailLabelRole]: 'Role',
  [tokens.settings.memberDetailNotAvailable]: 'Not available',
  [tokens.settings.memberDetailReportsSeeDocuments]: 'View declarations',
  [tokens.settings.memberDetailOverviewTitle]: 'Overview',
  [tokens.settings.memberDetailOverviewSubtitle]:
    'Summary of declarations completed by this user.',
  [tokens.settings.memberDetailOverviewDeclarationsLabel]: 'Declarations',
  [tokens.settings.memberDetailPeriodLast7Days]: 'Last 7 days',
  [tokens.settings.memberDetailPeriodLast30Days]: 'Last 30 days',
  [tokens.settings.memberDetailPeriodLast90Days]: 'Last 90 days',
  [tokens.settings.memberDetailPeriodLast12Months]: 'Last 12 months',
  [tokens.settings.memberDetailPeriodAll]: 'All history',
  [tokens.settings.memberDetailPeriodCustom]: 'Custom period',
  [tokens.settings.memberDetailStatusValidated]: 'Validated',
  [tokens.settings.memberDetailStatusPending]: 'Pending',
  [tokens.settings.memberDetailStatusError]: 'In error',
  [tokens.settings.memberDetailStatusAbandoned]: 'Abandoned',
  [tokens.settings.memberDetailStatusUnknown]: 'Unknown',
  [tokens.settings.memberDetailColReference]: 'Reference',
  [tokens.settings.memberDetailReportsSubtitle]:
    '{{count}} declarations completed by {{user}}',
  [tokens.settings.memberDetailReportsTitle]: 'Declaration history',
  [tokens.settings.memberDetailSectionAttachment]: 'Assignment & role',
  [tokens.settings.memberDetailSectionAttachmentSubtitle]:
    'Agencies and permissions for this user.',
  [tokens.settings.memberDetailSectionIdentity]: 'Identity',
  [tokens.settings.memberDetailSectionIdentitySubtitle]:
    'Personal information and contact details.',
  [tokens.settings.memberDetailStatDeclarations]: 'No. of declarations',
  [tokens.settings.memberDetailStatLastConnection]: 'Last sign-in',
  [tokens.settings.memberDetailStatMemberSince]: 'Member since',
  [tokens.settings.memberDetailTabInfo]: 'Information',
  [tokens.settings.memberDetailTabReports]: 'Reports',
  [tokens.settings.memberDetailToolbarEdit]: 'Edit',
  [tokens.settings.memberDetailToolbarMail]: 'Send email',
  [tokens.settings.membersAddUser]: 'Add user',
  [tokens.settings.membersAgencyNone]: '—',
  [tokens.settings.organizationMembersGroup]: 'Organization · {{name}}',
  [tokens.settings.membersBillingMailBody]:
    'Hello,\n\nWe would like to add additional seats to our Nabu plan (currently: {{used}}/{{max}}).\n\nThank you.',
  [tokens.settings.membersBillingMailSubject]:
    'Request for additional seats — Nabu',
  [tokens.settings.membersColAgencies]: 'Agencies',
  [tokens.settings.membersColAffiliation]: 'Affiliation',
  [tokens.settings.membersAffiliationOrganization]: 'Organization',
  [tokens.settings.membersColEnabled]: 'Enabled',
  [tokens.settings.membersColStatus]: 'Status',
  [tokens.settings.membersFilterAllRoles]: 'All roles',
  [tokens.settings.membersFilterAllStatuses]: 'All statuses',
  [tokens.settings.membersFilterStatusActive]: 'Active',
  [tokens.settings.membersFilterStatusInactive]: 'Inactive',
  [tokens.settings.membersInfoPopoverBody]:
    'Manage users in your organization. Invite new collaborators, assign them a role, and link them to one or more agencies. Users only see declarations from their agencies.',
  [tokens.settings.membersInfoPopoverTitle]: 'About users',
  [tokens.settings.membersMenuDeactivate]: 'Deactivate',
  [tokens.settings.membersMenuReactivate]: 'Reactivate',
  [tokens.settings.membersDeactivateTitle]: 'Deactivate {{name}}',
  [tokens.settings.membersDeactivateBody]:
    '{{name}} will no longer be able to sign in. Their access stays in place and comes back if they are reactivated.',
  [tokens.settings.membersReactivateTitle]: 'Reactivate {{name}}',
  [tokens.settings.membersReactivateBody]:
    '{{name}} will be able to sign in again, with the access they had.',
  [tokens.settings.membersDeactivateSuccess]: 'Member deactivated.',
  [tokens.settings.membersReactivateSuccess]: 'Member reactivated.',
  [tokens.settings.membersSetActiveForbidden]:
    "Your access does not allow you to change this member's activation.",
  [tokens.settings.membersSetActiveError]: "This member's activation could not be changed.",
  [tokens.settings.membersMenuDelete]: 'Delete',
  [tokens.settings.membersMenuEdit]: 'Edit',
  [tokens.settings.membersMenuTransferAgency]: 'Transfer agency',
  [tokens.settings.membersMenuManageAgencies]: 'Manage agency',
  [tokens.settings.manageAgenciesDialogTitle]: 'Manage agency',
  [tokens.settings.manageAgenciesDialogDescription]:
    'Select the agency {{name}} should be assigned to.',
  [tokens.settings.manageAgenciesSearchPlaceholder]: 'Search agencies…',
  [tokens.settings.manageAgenciesSave]: 'Save',
  [tokens.settings.manageAgenciesMinOneAgency]:
    'An agency must be selected.',
  [tokens.settings.manageAgenciesSuccess]: 'Agency assignment updated.',
  [tokens.settings.manageAgenciesAlreadyMember]:
    'This user is already a member of this agency.',
  [tokens.settings.manageAgenciesNoAgencies]:
    'No agencies available in this organization.',
  [tokens.settings.manageAgenciesNoSearchResults]: 'No agencies found.',
  [tokens.settings.manageAgenciesErrorForbidden]:
    'You do not have permission to update this assignment.',
  [tokens.settings.manageAgenciesErrorInvalid]:
    'The selected agencies are not valid for this organization.',
  [tokens.settings.manageAgenciesErrorGeneric]:
    'Unable to update agency assignment.',
  [tokens.settings.memberDetailAgencyFilterAll]: 'All agencies',
  [tokens.settings.memberDetailAgencyFilterLabel]: 'Filter by agency',
  [tokens.settings.membersMenuViewProfile]: 'View profile',
  [tokens.settings.membersRequestSeats]: 'Request more seats',
  [tokens.settings.membersSeatLimitHint]:
    'Limit reached: deactivate a user or upgrade your plan to add more.',
  [tokens.settings.membersSeatPlanScale]: 'Scale plan',
  [tokens.settings.membersSeatSummary]:
    '{{used}} / {{max}} seats used · {{plan}}',
  [tokens.settings.membersStatusActive]: 'Active',
  [tokens.settings.membersStatusInactive]: 'Inactive',
  [tokens.settings.membersViewGrid]: 'Grid view',
  [tokens.settings.membersViewList]: 'List view',
  [tokens.settings.orgPreferencesCardSubtitle]:
    'Rules applied across the entire organization.',
  [tokens.settings.orgPreferencesCardTitle]: 'Preferences',
  [tokens.settings.orgPreferencesLimitAgencyDescription]:
    'When enabled, a user can only access declarations for clients linked to their agency. Without this restriction, they access all organization declarations according to their role.',
  [tokens.settings.orgPreferencesLimitAgencyLabel]:
    'Limit users to their agency client declarations',
  [tokens.settings.profileUserConfigCardSubtitle]:
    'Values inherited from the organization configuration. Disable the toggle above to override them.',
  [tokens.settings.profileUserConfigCardTitle]: 'My configuration',
  [tokens.settings.profileUserConfigInheritanceDescription]:
    'Your declarations use values defined at the organization level. Disable to override specific fields for your account.',
  [tokens.settings.profileUserConfigInheritanceTitle]:
    'Keep organization configuration',
  [tokens.settings.roleLabelAgent]: 'Agent',
  [tokens.settings.roleLabelDeclarative]: 'Declarant',
  [tokens.settings.roleLabelSuperadmin]: 'Super admin',
  [tokens.whatsNew.carouselNewer]: 'Newer version',
  [tokens.whatsNew.carouselOlder]: 'Older version',
  [tokens.whatsNew.dialogSubtitle]: 'Discover the latest Nabu updates',
  [tokens.whatsNew.emptyState]: 'No updates at the moment.',
  [tokens.whatsNew.environmentPrefix]: 'Environment:',
  [tokens.whatsNew.featureCount]: '{{count}} update',
  [tokens.whatsNew.featureCount_other]: '{{count}} updates',
  [tokens.whatsNew.fixCount]: '{{count}} fix',
  [tokens.whatsNew.fixCount_other]: '{{count}} fixes',
  [tokens.whatsNew.footerContact]: 'Contact support',
  [tokens.whatsNew.footerQuestion]: 'Any questions?',
  [tokens.whatsNew.goToVersion]: 'Go to version {{version}}',
  [tokens.whatsNew.latest]: 'Latest',
  [tokens.whatsNew.menuTitle]: 'What’s new',
  [tokens.whatsNew.newBadge]: 'NEW',
  [tokens.whatsNew.releasePager]: '<bold>{{current}}</bold> / {{total}}',
  [tokens.whatsNew.sectionFeatures]: 'Updates',
  [tokens.whatsNew.sectionFixes]: 'Fixes',
  [tokens.whatsNew.understood]: 'Got it',
  [tokens.whatsNew.versionPill]: 'Version',

  [tokens.productTour.next]: 'Next',
  [tokens.productTour.previous]: 'Back',
  [tokens.productTour.finish]: 'Get started',
  [tokens.productTour.stepCounter]: '{{current}} / {{total}}',
  [tokens.productTour.launcher]: 'Guided tour',
  [tokens.productTour.eyebrow]: 'Guided tour',
  [tokens.productTour.skip]: 'Skip tour',
  [tokens.productTour.coachLabel]: 'Nabu guides you',
  [tokens.productTour.close]: 'Close',
  [tokens.productTour.start]: 'Start',
  [tokens.productTour.introStepsCount]: '{{total}} steps',
  [tokens.productTour.goToStep]: 'Go to step {{current}} of {{total}}',

  [tokens.notifications.title]: 'Notifications',
  [tokens.notifications.menuTitle]: 'Notifications',
  [tokens.notifications.markAllRead]: 'Mark all as read',
  [tokens.notifications.clearAll]: 'Clear all',
  [tokens.notifications.moreActions]: 'More actions',
  [tokens.notifications.group_today]: 'Today',
  [tokens.notifications.group_yesterday]: 'Yesterday',
  [tokens.notifications.group_earlier]: 'Earlier',
  [tokens.notifications.unreadCount]: '{{count}} unread',
  [tokens.notifications.empty]: 'No notifications',
  [tokens.notifications.loadMore]: 'Load more',
  [tokens.notifications.dossier]: 'Declaration',
  [tokens.notifications.dossierUnnamed]: 'Untitled declaration',
  [tokens.notifications.dossierNotFound]: 'Declaration not found',
  [tokens.notifications.types_declaration_status_changed]:
    'Declaration status updated',
  [tokens.notifications.types_declaration_comment_added]:
    '{{actor}} commented on the declaration',
  [tokens.notifications.types_declaration_sent_by_collaborator]:
    '{{actor}} sent the declaration',
  [tokens.notifications.types_declaration_returned_for_correction]:
    'Declaration returned for correction',
  [tokens.notifications.types_app_update]: 'New version {{version}} available',
  [tokens.notifications.types_app_update_generic]: 'New version available',
  [tokens.notifications.types_unknown]: 'Notification',
  [tokens.notifications.trackingMessage_toTreat]: 'The declaration is ready to process.',
  [tokens.notifications.trackingMessage_exportFailed]:
    'Sending the declaration failed.',
  [tokens.notifications.trackingMessage_error]:
    'Processing the declaration failed.',
  [tokens.notifications.statusChanged_mareva]:
    'Mareva status changed from {{from}} to {{to}}',
  [tokens.notifications.status_unknown]: 'Unknown status',
  [tokens.notifications.status_mareva_accepted]: 'Accepted',
  [tokens.notifications.status_mareva_processing]: 'Processing',
  [tokens.notifications.status_mareva_rejected]: 'Rejected',
  [tokens.notifications.systemActorCustoms]: 'Customs',
  [tokens.notifications.commentMessage]: 'commented: "{{preview}}"',
  [tokens.notifications.commentMessage_fallback]: 'commented on the declaration',
  [tokens.notifications.sentMessage]: 'sent the declaration to customs.',
  [tokens.notifications.invalidationRequestedMessage]:
    'asked customs to invalidate the declaration.',
  [tokens.notifications.invalidationRequestedMessage_fallback]:
    'Declaration invalidation requested from customs.',
  [tokens.notifications.statusMessage_mareva_accepted]:
    'Declaration accepted by customs.',
  [tokens.notifications.statusMessage_mareva_processing]:
    'Declaration is being processed by customs.',
  [tokens.notifications.statusMessage_mareva_rejected]:
    'Declaration rejected by customs.',

  [tokens.commandBar.searchPlaceholder]:
    'Search for a declaration, client, referential... or an action',
  [tokens.commandBar.sectionOnDeclaration]: 'On this declaration',
  [tokens.commandBar.sectionQuickActions]: 'Quick actions',
  [tokens.commandBar.sectionRecents]: 'Recents',
  [tokens.commandBar.sectionActions]: 'Actions',
  [tokens.commandBar.sectionDocuments]: 'Declarations',
  [tokens.commandBar.sectionClients]: 'Clients',
  [tokens.commandBar.sectionReferentials]: 'Referentials',
  [tokens.commandBar.sectionFlux]: 'Models',
  [tokens.commandBar.noResults]: 'No results',
  [tokens.commandBar.recentBadge]: 'Recent',
  [tokens.commandBar.footerSelect]: 'Select',
  [tokens.commandBar.footerOpen]: 'Open',
  [tokens.commandBar.footerClose]: 'Close',
  [tokens.commandBar.fieldAgency]: 'Agency',
  [tokens.commandBar.fieldConfiguration]: 'Configuration',
  [tokens.commandBar.actionApplyReferentialDeclaration]:
    'Add a referential to the declaration',
  [tokens.commandBar.actionRunAutomationDeclaration]: 'Run an automation',
  [tokens.commandBar.actionChangeModelDeclaration]: 'Change model',
  [tokens.commandBar.actionDuplicateFolder]: 'Duplicate declaration',
  [tokens.commandBar.actionCreateFolder]: 'Create a declaration',
  [tokens.commandBar.actionAddReferential]: 'Add a referential',
  [tokens.commandBar.actionAddModel]: 'Add a model',
  [tokens.commandBar.actionAddClient]: 'Add a client',
  [tokens.commandBar.actionCreateAutomation]: 'Create an automation',
  [tokens.commandBar.actionApplyAutomation]: 'Apply an automation',
  [tokens.commandBar.actionApplyModel]: 'Apply a model',
  [tokens.commandBar.actionGoDashboard]: 'Go to dashboard',
  [tokens.commandBar.actionViewAllDocuments]: 'View all declarations',
  [tokens.commandBar.actionOpenSettings]: 'Open settings',
  [tokens.commandBar.triggerPlaceholder]: 'Search',
  [tokens.commandBar.triggerTooltip]: 'Search ({{shortcut}})',
  [tokens.mcpOAuth.title]: 'Authorize an MCP server',
  [tokens.mcpOAuth.asksAccess]: 'is requesting access to your Nabu workspace.',
  [tokens.mcpOAuth.afterConfirm]:
    'After you confirm, you will be redirected to the MCP client. You can then close this window.',
  [tokens.mcpOAuth.allow]: 'Allow',
  [tokens.mcpOAuth.deny]: 'Deny',
  [tokens.mcpOAuth.invalidRequest]: 'The authorization request is invalid.',
  [tokens.mcpOAuth.expired]: 'The OAuth request has expired or is invalid.',
  [tokens.mcpOAuth.sessionExpired]:
    'Your Nabu session has expired. Sign in again.',
  [tokens.mcpOAuth.cannotComplete]: 'The authorization could not be completed.',
  [tokens.mcpOAuth.invalidRedirect]:
    'The OAuth response does not contain a valid redirect.',
  [tokens.dauSheet.europeanCommunity]: 'EUROPEAN UNION',
  [tokens.dauSheet.numberMark]: 'No',
  [tokens.dauSheet.box1]: 'DECLARATION',
  [tokens.dauSheet.boxA]: 'A OFFICE OF DISPATCH/EXPORT/ DESTINATION',
  [tokens.dauSheet.clearanceOffice]: 'Customs office of clearance:',
  [tokens.dauSheet.declarationOffice]: 'Customs office of declaration:',
  [tokens.dauSheet.exportDeclaration]: 'EXPORT DECLARATION',
  [tokens.dauSheet.box2]: 'Consignor/Exporter',
  [tokens.dauSheet.box3]: 'Forms',
  [tokens.dauSheet.box4]: 'Loading lists',
  [tokens.dauSheet.box5]: 'Items',
  [tokens.dauSheet.box6]: 'Total packages',
  [tokens.dauSheet.box7]: 'Reference number',
  [tokens.dauSheet.box8]: 'Consignee',
  [tokens.dauSheet.foreignConsignee]: 'FOREIGN',
  [tokens.dauSheet.box9]: 'Person responsible for financial settlement',
  [tokens.dauSheet.box10]: 'Ctry. 1st',
  [tokens.dauSheet.box10Sub]: 'dest./last cons.',
  [tokens.dauSheet.box11]: 'Trad./Prod.',
  [tokens.dauSheet.box11Sub]: 'country',
  [tokens.dauSheet.box12]: 'Value details',
  [tokens.dauSheet.box13]: 'C.A.P.',
  [tokens.dauSheet.box14]: 'Declarant/Representative',
  [tokens.dauSheet.representationMode]: 'Type of representation',
  [tokens.dauSheet.approvalNumber]: 'Authorisation No',
  [tokens.dauSheet.box15]: 'Country of dispatch/export',
  [tokens.dauSheet.box15Code]: 'C. disp./exp. Code',
  [tokens.dauSheet.box17Code]: 'C. dest. Code',
  [tokens.dauSheet.box16]: 'Country of origin',
  [tokens.dauSheet.box17]: 'Country of destination',
  [tokens.dauSheet.box20]: 'Delivery terms',
  [tokens.dauSheet.box18]: 'Identity and nationality of means of transport at departure/arrival',
  [tokens.dauSheet.box19]: 'Ctr.',
  [tokens.dauSheet.box21]: 'Identity and nationality of active means of transport crossing the border',
  [tokens.dauSheet.box22]: 'Currency and total amount invoiced',
  [tokens.dauSheet.box23]: 'Exchange rate',
  [tokens.dauSheet.box24]: 'Nature of transaction',
  [tokens.dauSheet.box25]: 'Mode of transport',
  [tokens.dauSheet.box25Sub]: 'at the border',
  [tokens.dauSheet.box26]: 'Inland mode',
  [tokens.dauSheet.box26Sub]: 'of transport',
  [tokens.dauSheet.box27]: 'Place of loading/unloading',
  [tokens.dauSheet.box28]: 'Financial and banking data',
  [tokens.dauSheet.box29]: 'Office of exit/entry',
  [tokens.dauSheet.box30]: 'Location of goods',
  [tokens.dauSheet.box31]: 'Packages and',
  [tokens.dauSheet.box31Sub]: 'description of goods',
  [tokens.dauSheet.box31Header]: 'Marks and numbers - Container No(s) - Number and kind',
  [tokens.dauSheet.numberAndKind]: 'Number and kind:',
  [tokens.dauSheet.marksAndNumbers]: 'Marks and numbers:',
  [tokens.dauSheet.containerNumber]: 'Container No:',
  [tokens.dauSheet.box32]: 'Item No',
  [tokens.dauSheet.box33]: 'Commodity code',
  [tokens.dauSheet.firstAdditionalCode]: '1st add. code',
  [tokens.dauSheet.secondAdditionalCode]: '2nd add. code',
  [tokens.dauSheet.box34]: 'Ctry. origin code',
  [tokens.dauSheet.box35]: 'Gross mass (kg)',
  [tokens.dauSheet.box36]: 'Preference',
  [tokens.dauSheet.box37]: 'Procedure',
  [tokens.dauSheet.box38]: 'Net mass (kg)',
  [tokens.dauSheet.box39]: 'Quota',
  [tokens.dauSheet.box40]: 'Summary declaration/Previous document',
  [tokens.dauSheet.box41]: 'Supplementary units',
  [tokens.dauSheet.box42]: 'Item price',
  [tokens.dauSheet.box43]: 'V.M. Code',
  [tokens.dauSheet.additionalInformationCode]: 'Add. info. code',
  [tokens.dauSheet.box44]: 'Additional',
  [tokens.dauSheet.box44Sub]: 'information/Documents\nproduced/Certificates\nand authorisations',
  [tokens.dauSheet.nationalAdditionalCodes]: 'National additional code(s):',
  [tokens.dauSheet.attachedDocuments]: 'Documents produced:',
  [tokens.dauSheet.box45]: 'Adjustment',
  [tokens.dauSheet.box46]: 'Statistical value',
  [tokens.dauSheet.box47]: 'Calculation',
  [tokens.dauSheet.box47Sub]: 'of taxes',
  [tokens.dauSheet.box47Full]: 'Calculation of taxes',
  [tokens.dauSheet.totalFirstItem]: 'Total first item:',
  [tokens.dauSheet.totalSecondItem]: 'Total second item:',
  [tokens.dauSheet.totalThirdItem]: 'Total third item:',
  [tokens.dauSheet.box48]: 'Deferred payment',
  [tokens.dauSheet.box49]: 'Identification of warehouse',
  [tokens.dauSheet.boxB]: 'B ACCOUNTING DETAILS',
  [tokens.dauSheet.guaranteedRisk]: 'Guaranteed risk',
  [tokens.dauSheet.totalAmountPayable]: 'Total amount payable (risk guaranteed in the EC)',
  [tokens.dauSheet.amountUsedEc]: 'Amount used in the EC:',
  [tokens.dauSheet.guaranteed]: 'guaranteed (C):',
  [tokens.dauSheet.notGuaranteed]: 'not guaranteed (NC):',
  [tokens.dauSheet.controlByOffice]: 'CONTROL BY OFFICE OF DEPARTURE/ DESTINATION',
  [tokens.dauSheet.stamp]: 'Stamp:',
  [tokens.dauSheet.controlResult]: 'Result:',
  [tokens.dauSheet.sealsAffixed]: 'Seals affixed:',
  [tokens.dauSheet.sealMarks]: 'Identity:',
  [tokens.dauSheet.timeLimit]: 'Time limit (date):',
  [tokens.dauSheet.signature]: 'Signature:',
  [tokens.dauSheet.box54]: 'Place and date:',
  [tokens.dauSheet.editionDate]: 'Date printed:',
  [tokens.dauSheet.validationDate]: 'Validation date:',
  [tokens.dauSheet.declarationStatus]: 'Declaration status:',
  [tokens.dauSheet.procedureType]: 'Procedure type:',
  [tokens.dauSheet.declarantSignature]: 'Signature and name of declarant/representative',
  [tokens.dauSheet.statusShort]: 'Status:',
  [tokens.dauSheet.printedOn]: 'Printed on {{date}} · C OFFICE OF DEPARTURE',
}
